export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: { input: any; output: any };
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any };
  /** An arbitrary-precision Decimal type */
  Decimal: { input: string; output: string };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  Json: { input: any; output: any };
};

export type Account = {
  __typename?: 'Account';
  Credentials?: Maybe<Array<Credential>>;
  User?: Maybe<User>;
  address?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  integrationId?: Maybe<Scalars['String']['output']>;
  manuallyLinkedCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['Int']['output']>;
};

export type AccountBalanceEntry = {
  __typename?: 'AccountBalanceEntry';
  account: Account;
  accountId: Scalars['Int']['output'];
  balance: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  usdValue?: Maybe<Scalars['Float']['output']>;
};

export type AccountBalanceMap = {
  __typename?: 'AccountBalanceMap';
  accountId: Scalars['Int']['output'];
  entries: Array<BalanceEntry>;
};

export type AccountBalancesInput = {
  accountIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  currencies?: InputMaybe<Array<Scalars['String']['input']>>;
  includeZeroBalances?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountsData = {
  __typename?: 'AccountsData';
  edges: Array<Account>;
};

export type Addon = {
  __typename?: 'Addon';
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  product: Scalars['String']['output'];
  sku: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AddressWithCurrencyInput = {
  address: Scalars['String']['input'];
  credentialType: Scalars['String']['input'];
};

export type AnalyticsProductData = {
  __typename?: 'AnalyticsProductData';
  is_upgrade?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  product_id: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  /** @deprecated This field is not used as of 2023-06-21. Use product_id instead. */
  sku: Scalars['String']['output'];
};

export type AnomalyComparisonWindow = {
  __typename?: 'AnomalyComparisonWindow';
  endDate: Scalars['String']['output'];
  referenceValue: Scalars['Float']['output'];
  startDate: Scalars['String']['output'];
  windowSizeMonths: Scalars['Int']['output'];
};

export type AnomalyMetadata = {
  __typename?: 'AnomalyMetadata';
  anomalyType: Scalars['String']['output'];
  comparisonWindow: AnomalyComparisonWindow;
  confidence: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  flaggedField: Scalars['String']['output'];
  transactionId: Scalars['String']['output'];
  usdValueOfDiscrepancy: Scalars['Float']['output'];
};

export type ApplyReconGuideTreatmentsResult = {
  __typename?: 'ApplyReconGuideTreatmentsResult';
  id: Scalars['String']['output'];
};

export type BalanceEntry = {
  __typename?: 'BalanceEntry';
  balance: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  date: Scalars['String']['output'];
  missingCostBasis: Scalars['Boolean']['output'];
  usedUnassignedBalance?: Maybe<Scalars['Boolean']['output']>;
};

export type BkpAccount = {
  __typename?: 'BkpAccount';
  active?: Maybe<Scalars['Boolean']['output']>;
  bkpIntegrationAccountType?: Maybe<Scalars['String']['output']>;
  bkpIntegrationAcctNum?: Maybe<Scalars['String']['output']>;
  bkpIntegrationClassification?: Maybe<Scalars['String']['output']>;
  bkpIntegrationId?: Maybe<Scalars['String']['output']>;
  bkpIntegrationParentRefId?: Maybe<Scalars['String']['output']>;
  bkpIntegrationSyncToken?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['Int']['output'];
};

export type BkpVendor = {
  __typename?: 'BkpVendor';
  active?: Maybe<Scalars['Boolean']['output']>;
  bkpIntegrationDisplayName?: Maybe<Scalars['String']['output']>;
  bkpIntegrationId?: Maybe<Scalars['String']['output']>;
  bkpIntegrationSyncToken?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['Int']['output'];
};

export enum BooleanCsvInReviewFilterTypes {
  isMargin = 'isMargin',
  isUrgent = 'isUrgent',
}

export type BooleanFilter = {
  key: BooleanFilterTypes;
  value: Scalars['Boolean']['input'];
};

export enum BooleanFilterTypes {
  automaticallyEdited = 'automaticallyEdited',
  hasAccount = 'hasAccount',
  hasComments = 'hasComments',
  hasMovement = 'hasMovement',
  isPricingAnomaly = 'isPricingAnomaly',
  isSpam = 'isSpam',
  manuallyEdited = 'manuallyEdited',
  missingCostBasis = 'missingCostBasis',
  missingPrice = 'missingPrice',
  reviewed = 'reviewed',
  zeroProceeds = 'zeroProceeds',
}

export type BulkUpdateCredentialInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['Int']['input']>;
  integrationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Int']['input']>;
};

export type BuyOrSellPrice = {
  __typename?: 'BuyOrSellPrice';
  buyPrice?: Maybe<Scalars['Float']['output']>;
  sellPrice?: Maybe<Scalars['Float']['output']>;
};

export type BuyProductsResponse = {
  __typename?: 'BuyProductsResponse';
  analyticsProducts: Array<AnalyticsProductData>;
  couponCode?: Maybe<Scalars['String']['output']>;
  couponPercentOff?: Maybe<Scalars['Int']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  invoiceId: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export enum CategoryInput {
  borrow = 'borrow',
  bridgeIn = 'bridgeIn',
  bridgeOut = 'bridgeOut',
  freeMint = 'freeMint',
  income = 'income',
  lost = 'lost',
  lpEntrance = 'lpEntrance',
  lpExit = 'lpExit',
  mint = 'mint',
  other = 'other',
  repay = 'repay',
  spam = 'spam',
  spend = 'spend',
  trade = 'trade',
  transferIn = 'transferIn',
  transferOut = 'transferOut',
}

export type Chain = {
  __typename?: 'Chain';
  credentialType: Array<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  ecosystem: Ecosystem;
  ecosystemId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  shortName: Scalars['String']['output'];
};

export type ChangeCredentialAccountJob = {
  __typename?: 'ChangeCredentialAccountJob';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  credentialId: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  status?: Maybe<EnumGenericJobStatus>;
};

export type CheckoutSession = {
  __typename?: 'CheckoutSession';
  activated: Scalars['Boolean']['output'];
  amountTotal: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  emailHasMatchingAccount: Scalars['Boolean']['output'];
  invoiceId?: Maybe<Scalars['String']['output']>;
  paymentCompleted: Scalars['Boolean']['output'];
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  plan: Scalars['String']['output'];
  userId?: Maybe<Scalars['Int']['output']>;
};

export type ClonedAccountResponse = {
  __typename?: 'ClonedAccountResponse';
  cloneUserJobId: Scalars['Int']['output'];
};

export type Coin = {
  __typename?: 'Coin';
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};

export type Comment = {
  __typename?: 'Comment';
  author: User;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  isPrivate: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['Int']['output'];
  userIdTopic: Scalars['Int']['output'];
};

export type ConsultationSubmitInput = {
  country: Scalars['String']['input'];
  cryptoTaxQuestions: Scalars['String']['input'];
  email: Scalars['String']['input'];
  hasPreviouslyFiled: Scalars['Boolean']['input'];
  howDidYouHear: Scalars['String']['input'];
  isCurrentUser: Scalars['Boolean']['input'];
  phone: Scalars['String']['input'];
  previousFilingsAccurate: Scalars['Boolean']['input'];
  property?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  taxHelpType: Scalars['String']['input'];
  transactionTypes: Scalars['String']['input'];
};

export type Country = {
  __typename?: 'Country';
  endDateDay: Scalars['Int']['output'];
  endDateMonth: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  methods: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  shorthand: Scalars['String']['output'];
  startDateDay: Scalars['Int']['output'];
  startDateMonth: Scalars['Int']['output'];
  taxMethods: Array<TaxMethod>;
};

export type CouponValidationResponse = {
  __typename?: 'CouponValidationResponse';
  percentOff?: Maybe<Scalars['Int']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type CreateCsvImportResponse = {
  __typename?: 'CreateCsvImportResponse';
  account: Account;
  credentialId: Scalars['Int']['output'];
  requestId: Scalars['String']['output'];
};

export type CreateMovementsJob = {
  __typename?: 'CreateMovementsJob';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  status?: Maybe<EnumGenericJobStatus>;
};

export type CreateTransferGroupInput = {
  bkpAccountCreditId?: InputMaybe<Scalars['Int']['input']>;
  bkpAccountDebitId?: InputMaybe<Scalars['Int']['input']>;
  bkpVendorId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  timestamp: Scalars['DateTime']['input'];
  transfers: Array<TransferInput>;
  type: EnumTransferGroupType;
};

export type CreateTrelloJobInput = {
  jobType: EnumTrelloJobType;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateWorkpaperInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  includeReviewed?: InputMaybe<Scalars['Boolean']['input']>;
  includeSpam?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

export type CreatedCredential = {
  __typename?: 'CreatedCredential';
  credential: Credential;
  exchangeServiceRequest: ExchangeServiceRequest;
};

export type CreatedCredentials = {
  __typename?: 'CreatedCredentials';
  credentials: Scalars['Int']['output'];
  duplicates: Scalars['Int']['output'];
  exchangeServiceRequests: Scalars['Int']['output'];
  missingWallets: Array<MissingWalletWithTxnValidation>;
};

export type CreatedTxnInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  buyCurrency: Scalars['String']['input'];
  buyQuantity: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  feeCurrency?: InputMaybe<Scalars['String']['input']>;
  feeQuantity?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  sellCurrency: Scalars['String']['input'];
  sellQuantity: Scalars['String']['input'];
  txnTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  txnType: TxnType;
};

export type Credential = {
  __typename?: 'Credential';
  account?: Maybe<Account>;
  accountId?: Maybe<Scalars['Int']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  coefficientPercent?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  credentialType: Scalars['String']['output'];
  credentials?: Maybe<Scalars['Json']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  earliestTransaction?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  ensAlias?: Maybe<Scalars['String']['output']>;
  errorRemediation?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  filterSpam?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  integrationId?: Maybe<Scalars['String']['output']>;
  /** Human-readable name for the integration/credential type */
  integrationName?: Maybe<Scalars['String']['output']>;
  isOauth: Scalars['Boolean']['output'];
  lastRefreshError?: Maybe<Scalars['String']['output']>;
  latestTransaction?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  otherIntegration?: Maybe<Scalars['Boolean']['output']>;
  reconcileOnSync?: Maybe<Scalars['Boolean']['output']>;
  requiresCredentialUpdate?: Maybe<Scalars['Boolean']['output']>;
  source: CredentialSource;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<EnumExchangeServiceRequestStatus>;
  txnCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uploads: Array<Upload>;
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
  variousIntegrations?: Maybe<Scalars['Boolean']['output']>;
  years?: Maybe<Array<Scalars['Int']['output']>>;
};

export type CredentialAccountCount = {
  __typename?: 'CredentialAccountCount';
  accountName: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type CredentialFilterQuery = {
  accountName?: InputMaybe<MultiSelectStringFilter>;
  address?: InputMaybe<CredentialSearchFilter>;
  label?: InputMaybe<CredentialSearchFilter>;
  location?: InputMaybe<MultiSelectStringFilter>;
  name?: InputMaybe<CredentialSearchFilter>;
  status?: InputMaybe<MultiSelectStringFilter>;
  type?: InputMaybe<MultiSelectStringFilter>;
  years?: InputMaybe<MultiSelectStringFilter>;
};

export type CredentialHistoryItem = {
  __typename?: 'CredentialHistoryItem';
  date: Scalars['DateTime']['output'];
  hardResync: Scalars['Boolean']['output'];
  performedBy?: Maybe<Scalars['String']['output']>;
};

export type CredentialLocationCount = {
  __typename?: 'CredentialLocationCount';
  count: Scalars['Int']['output'];
  location: Scalars['String']['output'];
};

export type CredentialSearchFilter = {
  key: CredentialSearchFilterKeys;
  operator: FilterOperatorTypes;
  value: Scalars['String']['input'];
};

export enum CredentialSearchFilterKeys {
  accountName = 'accountName',
  address = 'address',
  label = 'label',
  name = 'name',
}

export enum CredentialSortOptions {
  accountName = 'accountName',
  address = 'address',
  dateRange = 'dateRange',
  description = 'description',
  ensAlias = 'ensAlias',
  source = 'source',
  status = 'status',
  transactionCount = 'transactionCount',
  type = 'type',
  updatedAt = 'updatedAt',
}

export enum CredentialSource {
  api = 'api',
  csv = 'csv',
  externalMovement = 'externalMovement',
  form = 'form',
  unreconciled = 'unreconciled',
}

export type CredentialSourceCount = {
  __typename?: 'CredentialSourceCount';
  count: Scalars['Int']['output'];
  source: CredentialSource;
};

export type CredentialStatusCount = {
  __typename?: 'CredentialStatusCount';
  count: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type CredentialTableInput = {
  filterQuery: CredentialFilterQuery;
  hideExternalMovements?: InputMaybe<Scalars['Boolean']['input']>;
  isCSV?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationOptions>;
  sortBy: CredentialSortOptions;
  sortDirection: SortDirectionOptions;
};

export type CredentialTransactions = {
  __typename?: 'CredentialTransactions';
  count: Scalars['Int']['output'];
  rangeEnd?: Maybe<Scalars['String']['output']>;
  rangeStart?: Maybe<Scalars['String']['output']>;
};

export type Credentials = {
  __typename?: 'Credentials';
  csv?: Maybe<Scalars['String']['output']>;
  edges: Array<Credential>;
  pageInfo: PageInfo;
};

export type CredentialsCount = {
  __typename?: 'CredentialsCount';
  credentialAccountCounts: Array<CredentialAccountCount>;
  credentialLocationCounts: Array<CredentialLocationCount>;
  credentialSourceCounts: Array<CredentialSourceCount>;
  credentialStatusCounts: Array<CredentialStatusCount>;
  totalCount: Scalars['Int']['output'];
  transactionCountsPerYear: Array<TransactionCountPerYear>;
};

export type CreditCard = {
  __typename?: 'CreditCard';
  addressZip?: Maybe<Scalars['String']['output']>;
  brand: Scalars['String']['output'];
  expMonth: Scalars['Int']['output'];
  expYear: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  last4: Scalars['String']['output'];
};

export type CsvImportNewAccountInput = {
  /** null creates a custom account (no integration) */
  integrationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CsvInReview = {
  __typename?: 'CsvInReview';
  email: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  exchangeServiceRequestId: Scalars['Int']['output'];
  importName?: Maybe<Scalars['String']['output']>;
  integration?: Maybe<Scalars['String']['output']>;
  isMargin: Scalars['Boolean']['output'];
  isUrgent: Scalars['Boolean']['output'];
  linearIssueUrl?: Maybe<Scalars['String']['output']>;
  parser?: Maybe<Scalars['String']['output']>;
  slackUrl?: Maybe<Scalars['String']['output']>;
  uploadName: Scalars['String']['output'];
  uploadUrl?: Maybe<Scalars['String']['output']>;
  uploadedAt: Scalars['DateTime']['output'];
  userId: Scalars['Int']['output'];
};

export type CsvInReviewBooleanFilter = {
  key: BooleanCsvInReviewFilterTypes;
  value: Scalars['Boolean']['input'];
};

export enum CsvInReviewSearchFilterOperatorTypes {
  Ctns = 'Ctns',
  DNCtn = 'DNCtn',
  Is = 'Is',
  IsNot = 'IsNot',
}

export type CsvIntegrationDetection = {
  __typename?: 'CsvIntegrationDetection';
  /** The supported, enabled integration csv-service detected for the file; null when none was detected */
  integrationId?: Maybe<Scalars['String']['output']>;
  /** What csv-service calls the source of the file (e.g. "caleb and brown") whenever it recognized the file, even if the source has no supported integration; null when the file was not recognized, or is in TokenTax's own template, which says nothing about where its transactions are from */
  sourceName?: Maybe<Scalars['String']['output']>;
  /** Set when csv-service recognizes the file as an export it cannot import */
  unsupportedKnownCsv?: Maybe<UnsupportedKnownCsv>;
};

export type CsvUploadStatus = {
  __typename?: 'CsvUploadStatus';
  credentialId?: Maybe<Scalars['Int']['output']>;
  status: EnumExchangeServiceRequestStatus;
  unsupportedKnownCsv?: Maybe<UnsupportedKnownCsv>;
};

export type CsvsInReview = {
  __typename?: 'CsvsInReview';
  edges: Array<CsvInReview>;
  pageInfo: PageInfo;
};

export type CsvsInReviewErrorMessageFilter = {
  errorMessage: Scalars['String']['input'];
  operator: CsvInReviewSearchFilterOperatorTypes;
};

export type CsvsInReviewFileNameFilter = {
  fileName: Scalars['String']['input'];
  operator: CsvInReviewSearchFilterOperatorTypes;
};

export type CsvsInReviewFilterQuery = {
  boolean?: InputMaybe<Array<CsvInReviewBooleanFilter>>;
  date?: InputMaybe<DateRangeFilter>;
  errorMessage?: InputMaybe<CsvsInReviewErrorMessageFilter>;
  fileName?: InputMaybe<CsvsInReviewFileNameFilter>;
  integration?: InputMaybe<CsvsInReviewIntegrationFilter>;
  parser?: InputMaybe<CsvsInReviewParserFilter>;
  userId?: InputMaybe<CsvsInReviewUserIdFilter>;
};

export type CsvsInReviewIntegrationFilter = {
  integration: Scalars['String']['input'];
  operator: CsvInReviewSearchFilterOperatorTypes;
};

export type CsvsInReviewParserFilter = {
  operator: CsvInReviewSearchFilterOperatorTypes;
  parser: Scalars['String']['input'];
};

export type CsvsInReviewTableInput = {
  filterQuery?: InputMaybe<CsvsInReviewFilterQuery>;
  pagination?: InputMaybe<PaginationOptions>;
  sortDirection: SortDirectionOptions;
};

export type CsvsInReviewUserIdFilter = {
  operator: CsvInReviewSearchFilterOperatorTypes;
  userId: Scalars['String']['input'];
};

export type Currency = {
  __typename?: 'Currency';
  code: Scalars['String']['output'];
  countryId?: Maybe<Scalars['Int']['output']>;
};

export enum CurrencyFilterTypes {
  BuyCurrency = 'BuyCurrency',
  Currency = 'Currency',
  FeeCurrency = 'FeeCurrency',
  SellCurrency = 'SellCurrency',
}

export type DailyBalanceFilters = {
  __typename?: 'DailyBalanceFilters';
  currencies: Array<Scalars['String']['output']>;
};

export type DailyBalancesInput = {
  currency: Scalars['String']['input'];
};

export type DataModelV2UpgradeJob = {
  __typename?: 'DataModelV2UpgradeJob';
  createdAt: Scalars['DateTime']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  jobData?: Maybe<Scalars['Json']['output']>;
  stage?: Maybe<EnumDataModelV2UpgradeStage>;
  status: EnumGenericJobStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type DateObject = {
  day: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type DateRange = {
  __typename?: 'DateRange';
  endDate: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
};

export type DateRangeFilter = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type DocFilterQuery = {
  date?: InputMaybe<DateRangeFilter>;
};

export enum DocSortOptions {
  createdAt = 'createdAt',
  method = 'method',
  reportType = 'reportType',
  status = 'status',
  taxYear = 'taxYear',
}

export type DocTableInput = {
  filterQuery?: InputMaybe<DocFilterQuery>;
  pagination?: InputMaybe<PaginationOptions>;
  sortBy: DocSortOptions;
  sortDirection: SortDirectionOptions;
};

export type DocumentToggleVisibility = {
  __typename?: 'DocumentToggleVisibility';
  edges: Array<Report>;
};

export type DocumentUrl = {
  __typename?: 'DocumentUrl';
  id: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type DocumentUrls = {
  __typename?: 'DocumentUrls';
  edges: Array<DocumentUrl>;
};

export type Documents = {
  __typename?: 'Documents';
  edges: Array<Report>;
  pageInfo: PageInfo;
};

export type DocumentsCount = {
  __typename?: 'DocumentsCount';
  recommendedDocumentCounts: Array<YearCount>;
  totalCount: Scalars['Int']['output'];
  yearCounts: Array<YearCount>;
};

export type Draft = {
  __typename?: 'Draft';
  received?: Maybe<TransfersGroup>;
  sent?: Maybe<TransfersGroup>;
};

export type DraftInput = {
  received?: InputMaybe<TransfersGroupInput>;
  sent?: InputMaybe<TransfersGroupInput>;
};

export type Ecosystem = {
  __typename?: 'Ecosystem';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type EditWorkpaperRowInput = {
  completed: Scalars['Boolean']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export enum EnumCancellableJobStatus {
  cancelled = 'cancelled',
  cancelling = 'cancelling',
  created = 'created',
  failed = 'failed',
  running = 'running',
  successful = 'successful',
}

export enum EnumDataModelV2UpgradeStage {
  migrating_transactions = 'migrating_transactions',
  recalculating = 'recalculating',
  saving_version = 'saving_version',
}

export enum EnumDataModelV2UpgradeState {
  clicked_email = 'clicked_email',
  sent_email = 'sent_email',
  upgrade_acknowledged = 'upgrade_acknowledged',
  upgrade_completed = 'upgrade_completed',
  upgrade_started = 'upgrade_started',
}

export enum EnumExchangeServiceRequestStatus {
  aborted = 'aborted',
  canceled = 'canceled',
  changingAccount = 'changingAccount',
  completed = 'completed',
  created = 'created',
  failed = 'failed',
  fetchingPrices = 'fetchingPrices',
  inReview = 'inReview',
  reconciling = 'reconciling',
  running = 'running',
}

export enum EnumGenericJobStatus {
  created = 'created',
  failed = 'failed',
  running = 'running',
  successful = 'successful',
}

export enum EnumInviteStatus {
  accepted = 'accepted',
  failed = 'failed',
  invited = 'invited',
  revoked = 'revoked',
}

export enum EnumOrganizationStatus {
  active = 'active',
  inactive = 'inactive',
}

export enum EnumTaxMethod {
  AVERAGE_COST = 'AVERAGE_COST',
  FIFO = 'FIFO',
  LIFO = 'LIFO',
  MINIMIZATION = 'MINIMIZATION',
  MINIMIZATION_V2 = 'MINIMIZATION_V2',
}

export enum EnumTaxTreatment {
  capital_event = 'capital_event',
  fee = 'fee',
  income_event = 'income_event',
  migration_event = 'migration_event',
  non_taxable = 'non_taxable',
  transfer_event = 'transfer_event',
}

export enum EnumTransferDirection {
  fee = 'fee',
  in = 'in',
  out = 'out',
}

export enum EnumTransferGroupEditSource {
  mcp = 'mcp',
}

export enum EnumTransferGroupEditStatus {
  applied = 'applied',
  pending = 'pending',
  reverted = 'reverted',
}

export enum EnumTransferGroupType {
  addLiquidity = 'addLiquidity',
  approve = 'approve',
  borrow = 'borrow',
  bridge = 'bridge',
  gift = 'gift',
  income = 'income',
  incomeMining = 'incomeMining',
  incomeStaking = 'incomeStaking',
  incoming = 'incoming',
  lost = 'lost',
  movement = 'movement',
  outgoing = 'outgoing',
  removeLiquidity = 'removeLiquidity',
  repay = 'repay',
  spam = 'spam',
  spend = 'spend',
  stolen = 'stolen',
  trade = 'trade',
  uncategorized = 'uncategorized',
  wrap = 'wrap',
}

export enum EnumTransferType {
  borrow = 'borrow',
  chain_fee = 'chain_fee',
  gift = 'gift',
  income = 'income',
  lost = 'lost',
  migration_in = 'migration_in',
  migration_out = 'migration_out',
  mining_fee = 'mining_fee',
  protocol_fee = 'protocol_fee',
  repay = 'repay',
  spend = 'spend',
  stolen = 'stolen',
  trade_in = 'trade_in',
  trade_out = 'trade_out',
}

export enum EnumTrelloJobType {
  doubleVip = 'doubleVip',
  enterpriseLeads = 'enterpriseLeads',
  reconExport = 'reconExport',
}

export enum EnumTxnGroupComponent {
  deposit = 'deposit',
  income = 'income',
  movement = 'movement',
  spend = 'spend',
  withdrawal = 'withdrawal',
}

export enum EnumTxnReportMonth {
  april = 'april',
  august = 'august',
  december = 'december',
  february = 'february',
  january = 'january',
  july = 'july',
  june = 'june',
  march = 'march',
  may = 'may',
  november = 'november',
  october = 'october',
  september = 'september',
}

export type EvmContract = {
  __typename?: 'EvmContract';
  address: Scalars['String']['output'];
  chain?: Maybe<Chain>;
  chainId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  publicName?: Maybe<Scalars['String']['output']>;
  transactionCount?: Maybe<Scalars['Int']['output']>;
  undecodedCodeLength?: Maybe<Scalars['Int']['output']>;
  userCount?: Maybe<Scalars['Int']['output']>;
};

export type EvmGuideClientSummary = {
  __typename?: 'EvmGuideClientSummary';
  chainCounts: Array<EvmGuideClientSummaryChainCount>;
  edges: Array<EvmGuideClientSummaryEdge>;
  pageInfo: PageInfo;
  treatmentCounts: Array<EvmGuideClientSummaryTreatmentCount>;
};

export type EvmGuideClientSummaryChainCount = {
  __typename?: 'EvmGuideClientSummaryChainCount';
  chainDescription?: Maybe<Scalars['String']['output']>;
  chainName: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type EvmGuideClientSummaryChainFilter = {
  operator: FilterOperatorTypes;
  value: Scalars['String']['input'];
};

export type EvmGuideClientSummaryContractFilter = {
  operator: FilterOperatorTypes;
  value: Scalars['String']['input'];
};

export type EvmGuideClientSummaryEdge = {
  __typename?: 'EvmGuideClientSummaryEdge';
  contractAddress: Scalars['String']['output'];
  credentialType: Scalars['String']['output'];
  firstTxnDate: Scalars['DateTime']['output'];
  lastTxnDate: Scalars['DateTime']['output'];
  methodId: Scalars['String']['output'];
  methodName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  publicNotes?: Maybe<Scalars['String']['output']>;
  treatment?: Maybe<Treatment>;
  treatmentId?: Maybe<Scalars['Int']['output']>;
  txnCount: Scalars['Int']['output'];
};

export type EvmGuideClientSummaryFilterQuery = {
  chain?: InputMaybe<Array<InputMaybe<EvmGuideClientSummaryChainFilter>>>;
  contractAddress?: InputMaybe<Array<InputMaybe<EvmGuideClientSummaryContractFilter>>>;
  date?: InputMaybe<DateRangeFilter>;
  methodId?: InputMaybe<Array<InputMaybe<EvmGuideClientSummaryMethodFilter>>>;
  methodName?: InputMaybe<Array<InputMaybe<EvmGuideClientSummaryMethodNameFilter>>>;
  notes?: InputMaybe<Array<InputMaybe<EvmGuideClientSummaryNotesFilter>>>;
  treatment?: InputMaybe<Array<InputMaybe<EvmGuideClientSummaryTreatmentFilter>>>;
};

export type EvmGuideClientSummaryMethodFilter = {
  operator: FilterOperatorTypes;
  value: Scalars['String']['input'];
};

export type EvmGuideClientSummaryMethodNameFilter = {
  operator: FilterOperatorTypes;
  value: Scalars['String']['input'];
};

export type EvmGuideClientSummaryNotesFilter = {
  operator: FilterOperatorTypes;
  value: Scalars['String']['input'];
};

export type EvmGuideClientSummaryTableInput = {
  filterQuery?: InputMaybe<EvmGuideClientSummaryFilterQuery>;
  pagination?: InputMaybe<PaginationOptions>;
};

export type EvmGuideClientSummaryTreatmentCount = {
  __typename?: 'EvmGuideClientSummaryTreatmentCount';
  count: Scalars['Int']['output'];
  treatmentId: Scalars['Int']['output'];
  treatmentName: Scalars['String']['output'];
};

export type EvmGuideClientSummaryTreatmentFilter = {
  operator: FilterOperatorTypes;
  value: Scalars['String']['input'];
};

export type EvmInstruction = {
  __typename?: 'EvmInstruction';
  blockSvcMethodId: Scalars['Int']['output'];
  chain?: Maybe<Chain>;
  chainId?: Maybe<Scalars['Int']['output']>;
  contractId: Scalars['Int']['output'];
  evmContract?: Maybe<EvmContract>;
  evmMethod?: Maybe<EvmMethod>;
  id: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  pred1?: Maybe<Scalars['Int']['output']>;
  pred2?: Maybe<Scalars['Int']['output']>;
  proba1?: Maybe<Scalars['Float']['output']>;
  proba2?: Maybe<Scalars['Float']['output']>;
  publicNotes?: Maybe<Scalars['String']['output']>;
  reviews?: Maybe<Array<EvmReview>>;
  tokenParam1?: Maybe<Array<Scalars['String']['output']>>;
  tokenParam2?: Maybe<Array<Scalars['String']['output']>>;
  topicInstructions?: Maybe<Array<EvmTopicInstruction>>;
  treatment?: Maybe<Treatment>;
  treatmentId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EvmMethod = {
  __typename?: 'EvmMethod';
  hash: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type EvmReview = {
  __typename?: 'EvmReview';
  afterNotes?: Maybe<Scalars['String']['output']>;
  afterPublicNotes?: Maybe<Scalars['String']['output']>;
  afterTokenParam1?: Maybe<Array<Scalars['String']['output']>>;
  afterTokenParam2?: Maybe<Array<Scalars['String']['output']>>;
  afterTreatment?: Maybe<Treatment>;
  afterTreatmentId?: Maybe<Scalars['Int']['output']>;
  beforeNotes?: Maybe<Scalars['String']['output']>;
  beforePublicNotes?: Maybe<Scalars['String']['output']>;
  beforeTokenParam1?: Maybe<Array<Scalars['String']['output']>>;
  beforeTokenParam2?: Maybe<Array<Scalars['String']['output']>>;
  beforeTreatment?: Maybe<Treatment>;
  beforeTreatmentId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  instructionId: Scalars['Int']['output'];
  reconRep: ReconRep;
  reconRepId: Scalars['Int']['output'];
};

export type EvmTopicInstruction = {
  __typename?: 'EvmTopicInstruction';
  id: Scalars['Int']['output'];
  instructionId: Scalars['Int']['output'];
  topicInstruction?: Maybe<Scalars['Json']['output']>;
  txnTopicFingerprint?: Maybe<Scalars['String']['output']>;
};

export type ExchangeCredentials = {
  __typename?: 'ExchangeCredentials';
  id: Scalars['String']['output'];
  schema: Scalars['Json']['output'];
};

export type ExchangeNameCount = {
  __typename?: 'ExchangeNameCount';
  count: Scalars['Int']['output'];
  exchangeName: Scalars['String']['output'];
};

export type ExchangeServiceApiError = {
  __typename?: 'ExchangeServiceApiError';
  address?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  credentialId: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  exchangeServiceRequestId: Scalars['Int']['output'];
  importName?: Maybe<Scalars['String']['output']>;
  integration?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export enum ExchangeServiceApiErrorSearchFilterOperatorTypes {
  Ctns = 'Ctns',
  DNCtn = 'DNCtn',
  Is = 'Is',
  IsNot = 'IsNot',
}

export type ExchangeServiceApiErrors = {
  __typename?: 'ExchangeServiceApiErrors';
  credentialIds: Array<Scalars['Int']['output']>;
  edges: Array<ExchangeServiceApiError>;
  pageInfo: PageInfo;
};

export type ExchangeServiceApiErrorsErrorMessageFilter = {
  errorMessage: Scalars['String']['input'];
  operator: ExchangeServiceApiErrorSearchFilterOperatorTypes;
};

export type ExchangeServiceApiErrorsFilterQuery = {
  date?: InputMaybe<DateRangeFilter>;
  errorMessage?: InputMaybe<ExchangeServiceApiErrorsErrorMessageFilter>;
  integration?: InputMaybe<ExchangeServiceApiErrorsIntegrationFilter>;
  userId?: InputMaybe<ExchangeServiceApiErrorsUserIdFilter>;
};

export type ExchangeServiceApiErrorsIntegrationFilter = {
  integration: Scalars['String']['input'];
  operator: ExchangeServiceApiErrorSearchFilterOperatorTypes;
};

export type ExchangeServiceApiErrorsTableInput = {
  filterQuery?: InputMaybe<ExchangeServiceApiErrorsFilterQuery>;
  pagination?: InputMaybe<PaginationOptions>;
  sortDirection: SortDirectionOptions;
};

export type ExchangeServiceApiErrorsUserIdFilter = {
  operator: ExchangeServiceApiErrorSearchFilterOperatorTypes;
  userId: Scalars['String']['input'];
};

export type ExchangeServiceRequest = {
  __typename?: 'ExchangeServiceRequest';
  createdAt: Scalars['DateTime']['output'];
  credentialId: Scalars['Int']['output'];
  hardResync: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  requestId: Scalars['String']['output'];
  result?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EnumExchangeServiceRequestStatus>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['Int']['output'];
};

export type ExchangeServiceTxnPreview = {
  __typename?: 'ExchangeServiceTxnPreview';
  transactions: Array<ExchangeServiceTxnPreviewTransaction>;
};

export type ExchangeServiceTxnPreviewTransaction = {
  __typename?: 'ExchangeServiceTxnPreviewTransaction';
  blockSvcFromAddress?: Maybe<Scalars['String']['output']>;
  blockSvcGasAmount?: Maybe<Scalars['Float']['output']>;
  blockSvcGasPrice?: Maybe<Scalars['Float']['output']>;
  blockSvcHash: Scalars['String']['output'];
  blockSvcMethodID?: Maybe<Scalars['String']['output']>;
  blockSvcToAddress?: Maybe<Scalars['String']['output']>;
  buyAddress?: Maybe<Scalars['String']['output']>;
  buyAmount: Scalars['Float']['output'];
  buyCurrency: Scalars['String']['output'];
  exchangeName: Scalars['String']['output'];
  feeAmount: Scalars['Float']['output'];
  feeCurrency: Scalars['String']['output'];
  rawTxn: Scalars['String']['output'];
  relatedLogEventIndices?: Maybe<Array<Scalars['Int']['output']>>;
  requestId: Scalars['String']['output'];
  sellAddress?: Maybe<Scalars['String']['output']>;
  sellAmount: Scalars['Float']['output'];
  sellCurrency: Scalars['String']['output'];
  sourceLogEventIndex?: Maybe<Scalars['Int']['output']>;
  transactionTimestamp: Scalars['String']['output'];
  transferTopicFingerprint?: Maybe<Scalars['String']['output']>;
  txnTopicFingerprint?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  uniqueId: Scalars['String']['output'];
};

export type ExternalBalance = {
  __typename?: 'ExternalBalance';
  address: Scalars['String']['output'];
  balance?: Maybe<Scalars['Float']['output']>;
  date: Scalars['DateTime']['output'];
  integrationId: Scalars['String']['output'];
  tokenAddress?: Maybe<Scalars['String']['output']>;
  tokenSymbol: Scalars['String']['output'];
};

export type ExternalBalanceInput = {
  address: Scalars['String']['input'];
  date: Scalars['DateTime']['input'];
  integrationId: Scalars['String']['input'];
  tokenAddress?: InputMaybe<Scalars['String']['input']>;
  tokenSymbol: Scalars['String']['input'];
};

export type FailedTransactionUpdate = {
  __typename?: 'FailedTransactionUpdate';
  error: Scalars['String']['output'];
  transactionId: Scalars['String']['output'];
};

export enum FeatureType {
  csvErrorResolverKnownExchange = 'csvErrorResolverKnownExchange',
  csvErrorResolverTokenTaxFormat = 'csvErrorResolverTokenTaxFormat',
}

export type FederalTax = {
  __typename?: 'FederalTax';
  bracketMax?: Maybe<Scalars['Float']['output']>;
  bracketMin?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deduction?: Maybe<Scalars['Float']['output']>;
  filingStatus?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  personalExemption?: Maybe<Scalars['Float']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum FilingStatusOptions {
  headOfHousehold = 'headOfHousehold',
  marriedFilingJointly = 'marriedFilingJointly',
  single = 'single',
}

export enum FilterOperatorTypes {
  Ctns = 'Ctns',
  DNCtn = 'DNCtn',
  Is = 'Is',
  IsNot = 'IsNot',
}

export type Form1099Da = {
  __typename?: 'Form1099DA';
  createdAt: Scalars['String']['output'];
  extractionWarnings: Array<Scalars['String']['output']>;
  fileSizeBytes: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  integrationId?: Maybe<Scalars['String']['output']>;
  originalFilename: Scalars['String']['output'];
  taxYear?: Maybe<Scalars['Int']['output']>;
  transactionCount: Scalars['Int']['output'];
  transactions: Array<Form1099DaTransaction>;
};

export type Form1099DaComparisonEdge = {
  __typename?: 'Form1099DAComparisonEdge';
  exclusionRules: Array<Form1099DaComparisonExclusionRule>;
  form1099daProceeds?: Maybe<Scalars['Float']['output']>;
  form1099daTransactionCount?: Maybe<Scalars['Int']['output']>;
  form8949Proceeds?: Maybe<Scalars['Float']['output']>;
  form8949TransactionCount?: Maybe<Scalars['Int']['output']>;
  integration?: Maybe<Form1099DaIntegration>;
  isManualEntry: Scalars['Boolean']['output'];
  proceedsByAsset: Array<ProceedsComparisonByAsset>;
  trueUpItems: Array<Form1099DaTrueUpItem>;
  unadjustedForm1099daProceeds?: Maybe<Scalars['Float']['output']>;
  unadjustedForm1099daTransactionCount?: Maybe<Scalars['Int']['output']>;
  unadjustedForm8949Proceeds?: Maybe<Scalars['Float']['output']>;
  unadjustedForm8949TransactionCount?: Maybe<Scalars['Int']['output']>;
};

export type Form1099DaComparisonResult = {
  __typename?: 'Form1099DAComparisonResult';
  edges: Array<Form1099DaComparisonEdge>;
};

export type Form1099DaListResponse = {
  __typename?: 'Form1099DAListResponse';
  documents: Array<Form1099Da>;
  totalCount: Scalars['Int']['output'];
};

export type Form1099DaManualEntry = {
  __typename?: 'Form1099DAManualEntry';
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  integrationId: Scalars['String']['output'];
  rows: Array<Form1099DaManualEntryRow>;
  taxYear: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

export type Form1099DaManualEntryRow = {
  __typename?: 'Form1099DAManualEntryRow';
  assetName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  proceeds: Scalars['Float']['output'];
};

export type Form1099DaManualEntryRowInput = {
  assetName: Scalars['String']['input'];
  proceeds: Scalars['Float']['input'];
};

export type Form1099DaTransaction = {
  __typename?: 'Form1099DATransaction';
  assetCode?: Maybe<Scalars['String']['output']>;
  assetName?: Maybe<Scalars['String']['output']>;
  costBasis?: Maybe<Scalars['Float']['output']>;
  dateAcquired?: Maybe<Scalars['String']['output']>;
  dateSold?: Maybe<Scalars['String']['output']>;
  gainOrLoss?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  isLongTerm?: Maybe<Scalars['Boolean']['output']>;
  isNoncovered?: Maybe<Scalars['Boolean']['output']>;
  proceeds?: Maybe<Scalars['Float']['output']>;
  units?: Maybe<Scalars['Float']['output']>;
};

export type Form1099DaUploadUrlData = {
  __typename?: 'Form1099DAUploadUrlData';
  Key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Form1099DaComparisonExclusionRule = {
  __typename?: 'Form1099DaComparisonExclusionRule';
  currency: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Form1099DaIntegration = {
  __typename?: 'Form1099DaIntegration';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Form1099DaTrueUpItem = {
  __typename?: 'Form1099DaTrueUpItem';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type GenerateAccountsJob = {
  __typename?: 'GenerateAccountsJob';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  status?: Maybe<EnumGenericJobStatus>;
};

export type GenerateReportResult = {
  __typename?: 'GenerateReportResult';
  jobId?: Maybe<Scalars['String']['output']>;
  report?: Maybe<Report>;
};

export type GoogleLoginOrSignupResponse = {
  __typename?: 'GoogleLoginOrSignupResponse';
  isSignup: Scalars['Boolean']['output'];
  user: User;
  userHash: Scalars['String']['output'];
};

export type HoldingsReportMetadata = {
  __typename?: 'HoldingsReportMetadata';
  calculatedAt: Scalars['DateTime']['output'];
  method: Scalars['String']['output'];
  taxYear: Scalars['Int']['output'];
};

export type IbcGuideClientSummary = {
  __typename?: 'IbcGuideClientSummary';
  edges: Array<IbcGuideClientSummaryEdge>;
  pageInfo: PageInfo;
  treatmentCounts: Array<IbcGuideClientSummaryTreatmentCount>;
};

export type IbcGuideClientSummaryEdge = {
  __typename?: 'IbcGuideClientSummaryEdge';
  firstTxnDate: Scalars['DateTime']['output'];
  identifier: Scalars['String']['output'];
  lastTxnDate: Scalars['DateTime']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  publicNotes?: Maybe<Scalars['String']['output']>;
  treatment?: Maybe<Treatment>;
  treatmentId?: Maybe<Scalars['Int']['output']>;
  txnCount: Scalars['Int']['output'];
};

export type IbcGuideClientSummaryFilterQuery = {
  date?: InputMaybe<DateRangeFilter>;
  identifier?: InputMaybe<Array<InputMaybe<IbcGuideClientSummaryIdentifierFilter>>>;
  notes?: InputMaybe<Array<InputMaybe<IbcGuideClientSummaryNotesFilter>>>;
  treatment?: InputMaybe<Array<InputMaybe<IbcGuideClientSummaryTreatmentFilter>>>;
};

export type IbcGuideClientSummaryIdentifierFilter = {
  operator: FilterOperatorTypes;
  value: Scalars['String']['input'];
};

export type IbcGuideClientSummaryNotesFilter = {
  operator: FilterOperatorTypes;
  value: Scalars['String']['input'];
};

export type IbcGuideClientSummaryTableInput = {
  filterQuery?: InputMaybe<IbcGuideClientSummaryFilterQuery>;
  pagination?: InputMaybe<PaginationOptions>;
};

export type IbcGuideClientSummaryTreatmentCount = {
  __typename?: 'IbcGuideClientSummaryTreatmentCount';
  count: Scalars['Int']['output'];
  treatmentId: Scalars['Int']['output'];
  treatmentName: Scalars['String']['output'];
};

export type IbcGuideClientSummaryTreatmentFilter = {
  operator: FilterOperatorTypes;
  value: Scalars['String']['input'];
};

export type IbcReview = {
  __typename?: 'IbcReview';
  afterNotes?: Maybe<Scalars['String']['output']>;
  afterPublicNotes?: Maybe<Scalars['String']['output']>;
  afterTokenParam1?: Maybe<Array<Scalars['String']['output']>>;
  afterTokenParam2?: Maybe<Array<Scalars['String']['output']>>;
  afterTreatment?: Maybe<Treatment>;
  afterTreatmentId?: Maybe<Scalars['Int']['output']>;
  beforeNotes?: Maybe<Scalars['String']['output']>;
  beforePublicNotes?: Maybe<Scalars['String']['output']>;
  beforeTokenParam1?: Maybe<Array<Scalars['String']['output']>>;
  beforeTokenParam2?: Maybe<Array<Scalars['String']['output']>>;
  beforeTreatment?: Maybe<Treatment>;
  beforeTreatmentId?: Maybe<Scalars['Int']['output']>;
  chainId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  instructionId: Scalars['Int']['output'];
  reconRep: ReconRep;
  reconRepId: Scalars['Int']['output'];
  transactionHash?: Maybe<Scalars['String']['output']>;
};

export type IdentifierBasedInstruction = {
  __typename?: 'IdentifierBasedInstruction';
  ecosystem?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  identifier: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  publicName?: Maybe<Scalars['String']['output']>;
  publicNotes?: Maybe<Scalars['String']['output']>;
  reviews?: Maybe<Array<IdentifierBasedReview>>;
  tokenParam1?: Maybe<Array<Scalars['String']['output']>>;
  tokenParam2?: Maybe<Array<Scalars['String']['output']>>;
  treatment?: Maybe<Treatment>;
  treatmentId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IdentifierBasedReview = IbcReview | SolanaReview;

export type Instruction = EvmInstruction | IdentifierBasedInstruction;

export type IntegrationMetadata = {
  __typename?: 'IntegrationMetadata';
  iconUrl?: Maybe<Scalars['String']['output']>;
  integrationId: Scalars['String']['output'];
};

export type Invite = {
  __typename?: 'Invite';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  referredBy: Scalars['Int']['output'];
  signedUp: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Invoice = {
  __typename?: 'Invoice';
  amountDue: Scalars['Float']['output'];
  amountRemaining: Scalars['Float']['output'];
  created: Scalars['Int']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  cryptocurrency?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  customerEmail?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['Int']['output']>;
  hideDefaultCrypto: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  lines: Array<Line>;
  newUser?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  paid: Scalars['Boolean']['output'];
  paidAt?: Maybe<Scalars['Int']['output']>;
  paymentMethod?: Maybe<InvoicePaymentMethod>;
  products?: Maybe<Products>;
  txnHash?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
  voided: Scalars['Boolean']['output'];
};

export type InvoiceEvent = {
  __typename?: 'InvoiceEvent';
  timestamp: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type InvoiceEvents = {
  __typename?: 'InvoiceEvents';
  invoiceEvents: Array<InvoiceEvent>;
};

export type InvoiceLine = {
  description: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  unitAmount: Scalars['Int']['input'];
};

export enum InvoicePaymentMethod {
  bank = 'bank',
  card = 'card',
  crypto = 'crypto',
}

export type InvoicePlanInput = {
  planId: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};

export type InvoiceProductsInput = {
  cryptoOnlyPlans: Array<InvoicePlanInput>;
  fullFilingPlans: Array<InvoicePlanInput>;
};

export type Invoices = {
  __typename?: 'Invoices';
  edges: Array<Invoice>;
  userId: Scalars['Int']['output'];
};

export type LatestCreateMovementsJob = {
  __typename?: 'LatestCreateMovementsJob';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  modifiedTxnsLength?: Maybe<Scalars['Int']['output']>;
  status: EnumGenericJobStatus;
};

export type LatestExchangeServiceRequestJob = {
  __typename?: 'LatestExchangeServiceRequestJob';
  id: Scalars['String']['output'];
  logUrl: Scalars['String']['output'];
  status: EnumExchangeServiceRequestStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type LatestJob = {
  __typename?: 'LatestJob';
  id: Scalars['String']['output'];
  logUrl: Scalars['String']['output'];
  status: EnumGenericJobStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type LatestJobs = {
  __typename?: 'LatestJobs';
  changeCredentialAccountJob?: Maybe<LatestJob>;
  cloneUserJob?: Maybe<LatestJob>;
  createMovementsJob?: Maybe<LatestJob>;
  exchangeServiceRequestJob?: Maybe<LatestExchangeServiceRequestJob>;
  generateAccountsJob?: Maybe<LatestJob>;
  missingPricesJob?: Maybe<LatestJob>;
  pricingAnomalyJob?: Maybe<LatestJob>;
  reconGuideTreatmentsJob?: Maybe<LatestJob>;
  snapshotJob?: Maybe<LatestJob>;
  txnBatchDeleteJob?: Maybe<LatestJob>;
  versionJob?: Maybe<LatestJob>;
};

export type LatestMissingPricesJob = {
  __typename?: 'LatestMissingPricesJob';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  modifiedTxnDetails?: Maybe<Array<ModifiedTxnDetail>>;
  modifiedTxnsLength?: Maybe<Scalars['Int']['output']>;
  status: EnumGenericJobStatus;
};

export type LatestPricingAnomalyJob = {
  __typename?: 'LatestPricingAnomalyJob';
  anomaliesAboveThreshold?: Maybe<Scalars['Int']['output']>;
  anomalyMetadata?: Maybe<Array<AnomalyMetadata>>;
  createdAt: Scalars['DateTime']['output'];
  highestUsdDiscrepancy?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  modifiedTxnsLength?: Maybe<Scalars['Int']['output']>;
  status: EnumGenericJobStatus;
  totalUsdImpact?: Maybe<Scalars['Float']['output']>;
};

export type LatestRefetchTransferGroupPricesJob = {
  __typename?: 'LatestRefetchTransferGroupPricesJob';
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifiedCount: Scalars['Int']['output'];
  status: EnumCancellableJobStatus;
};

export type LatestTxnReport = {
  __typename?: 'LatestTxnReport';
  lineItemCount: Scalars['Int']['output'];
  missingCostBasisCount: Scalars['Int']['output'];
  report: LatestTxnReportObject;
  values: TxnReportValues;
  zeroProceedsCount: Scalars['Int']['output'];
};

export type LatestTxnReportObject = {
  __typename?: 'LatestTxnReportObject';
  endDate?: Maybe<Scalars['DateTime']['output']>;
  fiatCurrency?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  method: Scalars['String']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  taxMethod: TaxMethod;
  userTaxDetailId: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type LatestTxnReports = {
  __typename?: 'LatestTxnReports';
  hasData: Scalars['Boolean']['output'];
  latestTxnReportsByYear: Array<LatestTxnReportsByYear>;
};

export type LatestTxnReportsByYear = {
  __typename?: 'LatestTxnReportsByYear';
  hasNoPlan: Scalars['Boolean']['output'];
  isOverTxnLimit: Scalars['Boolean']['output'];
  reports?: Maybe<Array<LatestTxnReport>>;
  taxDetail: UserTaxDetail;
  year: Scalars['Int']['output'];
};

export type Line = {
  __typename?: 'Line';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Float']['output']>;
  unitAmount?: Maybe<Scalars['Float']['output']>;
};

export type LineItem = {
  __typename?: 'LineItem';
  account?: Maybe<Account>;
  accountId?: Maybe<Scalars['Int']['output']>;
  buyCurrency?: Maybe<Scalars['String']['output']>;
  buyDate?: Maybe<Scalars['DateTime']['output']>;
  buyId?: Maybe<Scalars['String']['output']>;
  costBasis?: Maybe<Scalars['Float']['output']>;
  costBasisFeeAddition?: Maybe<Scalars['Float']['output']>;
  costBasisIncludingFees: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  deductibleAmount?: Maybe<Scalars['Float']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  feeCurrency?: Maybe<Scalars['String']['output']>;
  feeUnitsSold?: Maybe<Scalars['Float']['output']>;
  gainLoss?: Maybe<Scalars['Float']['output']>;
  gainLossIncludingFees: Scalars['Float']['output'];
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['BigInt']['output'];
  isFee?: Maybe<Scalars['Boolean']['output']>;
  isMovementFromUnassigned: Scalars['Boolean']['output'];
  likeKindCryptoBuyDate?: Maybe<Scalars['DateTime']['output']>;
  likeKindCryptoTrade?: Maybe<Scalars['Boolean']['output']>;
  likeKindForwardedBuyId?: Maybe<Scalars['String']['output']>;
  lineItemType: Scalars['String']['output'];
  missingCostBasis?: Maybe<Scalars['Boolean']['output']>;
  movementFromAccount?: Maybe<Account>;
  proceeds?: Maybe<Scalars['Float']['output']>;
  proceedsFeeDeduction?: Maybe<Scalars['Float']['output']>;
  proceedsIncludingFees: Scalars['Float']['output'];
  sellCurrency?: Maybe<Scalars['String']['output']>;
  sellDate?: Maybe<Scalars['DateTime']['output']>;
  sellId?: Maybe<Scalars['String']['output']>;
  splitBuyId?: Maybe<Scalars['String']['output']>;
  term?: Maybe<Scalars['String']['output']>;
  txnLineItemBuyIdTotxn?: Maybe<Txn>;
  txnLineItemLikeKindForwardedBuyIdTotxn?: Maybe<Txn>;
  txnLineItemSellIdTotxn?: Maybe<Txn>;
  txnReport: TxnReport;
  txnReportId: Scalars['Int']['output'];
  unitsBought?: Maybe<Scalars['Float']['output']>;
  unitsSold?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['Int']['output'];
};

export type LineItemAuditDetail = {
  __typename?: 'LineItemAuditDetail';
  boughtAmount: Scalars['Float']['output'];
  boughtCurrency: Scalars['String']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  feeAmount: Scalars['Float']['output'];
  feeCurrency: Scalars['String']['output'];
  fromAccount?: Maybe<Account>;
  isMovementFromUnassigned: Scalars['Boolean']['output'];
  location: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  soldAmount: Scalars['Float']['output'];
  soldCurrency: Scalars['String']['output'];
  toAccount?: Maybe<Account>;
  txn?: Maybe<Txn>;
  txnType: TxnType;
};

export type LineItemDetail = {
  __typename?: 'LineItemDetail';
  averageCost?: Maybe<Scalars['Float']['output']>;
  bnbMatchType?: Maybe<Scalars['String']['output']>;
  coefficientPercent?: Maybe<Scalars['Float']['output']>;
  costBasis: Scalars['Float']['output'];
  costBasisFeeAddition: Scalars['Float']['output'];
  costBasisFeeAdditionCurrency: Scalars['String']['output'];
  costBasisFeeAdditionUnits: Scalars['Float']['output'];
  costBasisFlat: Scalars['Float']['output'];
  costBasisFromSellFee: Scalars['Float']['output'];
  exitDetail?: Maybe<LineItemAuditDetail>;
  gainLoss: Scalars['Float']['output'];
  lineItemTrace: Array<LineItem>;
  migrationDetail?: Maybe<LineItemAuditDetail>;
  missingCostBasis: Scalars['Boolean']['output'];
  missingCostBasisDetail?: Maybe<LineItemMissingCostBasisDetail>;
  originDetail?: Maybe<LineItemAuditDetail>;
  proceeds: Scalars['Float']['output'];
  proceedsFeeDeduction: Scalars['Float']['output'];
  proceedsFeeDeductionCurrency: Scalars['String']['output'];
  proceedsFeeDeductionUnits: Scalars['Float']['output'];
  proceedsFlat: Scalars['Float']['output'];
  proceedsFromSellFee: Scalars['Float']['output'];
  soldAmountFlat: Scalars['Float']['output'];
  specIdMatch?: Maybe<Scalars['Boolean']['output']>;
  term?: Maybe<Scalars['String']['output']>;
};

export type LineItemDetailInput = {
  lineItemId: Scalars['BigInt']['input'];
};

export type LineItemInput = {
  filterDust?: Scalars['Boolean']['input'];
  filterQuery?: InputMaybe<LineItemsFilterQuery>;
  pagination: PaginationOptions;
  sortBy: LineItemSortOptions;
  sortDirection: SortDirectionOptions;
  txnReportId: Scalars['Int']['input'];
};

export type LineItemMissingCostBasisDetail = {
  __typename?: 'LineItemMissingCostBasisDetail';
  missingAmount: Scalars['Float']['output'];
  missingCurrency: Scalars['String']['output'];
};

export enum LineItemSortOptions {
  accountId = 'accountId',
  buyCurrency = 'buyCurrency',
  buyDate = 'buyDate',
  costBasisIncludingFees = 'costBasisIncludingFees',
  gainLossIncludingFees = 'gainLossIncludingFees',
  proceedsIncludingFees = 'proceedsIncludingFees',
  sellCurrency = 'sellCurrency',
  sellDate = 'sellDate',
  term = 'term',
  unitsSold = 'unitsSold',
}

export type LineItemV2 = {
  __typename?: 'LineItemV2';
  accountId?: Maybe<Scalars['Int']['output']>;
  bnbMatchType?: Maybe<Scalars['String']['output']>;
  buyCurrencies: Array<Scalars['String']['output']>;
  buyDate?: Maybe<Scalars['DateTime']['output']>;
  costBasis: Scalars['Float']['output'];
  costBasisFeeAddition: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  deductibleAmount: Scalars['Float']['output'];
  feeCurrencies?: Maybe<Array<Scalars['String']['output']>>;
  feeUnitsSold: Scalars['Float']['output'];
  fromAccount?: Maybe<Account>;
  gainLoss: Scalars['Float']['output'];
  group: Scalars['String']['output'];
  id: Scalars['BigInt']['output'];
  incomingId?: Maybe<Scalars['String']['output']>;
  isFee: Scalars['Boolean']['output'];
  isMovementFromUnassigned: Scalars['Boolean']['output'];
  likeKindCryptoBuyDate?: Maybe<Scalars['DateTime']['output']>;
  likeKindCryptoTrade?: Maybe<Scalars['Boolean']['output']>;
  lineItemType: Scalars['String']['output'];
  missingCostBasis?: Maybe<Scalars['Boolean']['output']>;
  outgoingId?: Maybe<Scalars['String']['output']>;
  proceeds: Scalars['Float']['output'];
  proceedsFeeDeduction: Scalars['Float']['output'];
  sellCurrency: Scalars['String']['output'];
  sellDate?: Maybe<Scalars['DateTime']['output']>;
  specIdMatch?: Maybe<Scalars['Boolean']['output']>;
  term: Scalars['String']['output'];
  toAccount?: Maybe<Account>;
  txnHash?: Maybe<Scalars['String']['output']>;
  txnReport: TxnReport;
  txnReportId: Scalars['Int']['output'];
  unitsSold: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['Int']['output'];
};

export type LineItemV2AuditDetail = {
  __typename?: 'LineItemV2AuditDetail';
  boughtCurrencies: Array<LineItemV2Currency>;
  date?: Maybe<Scalars['DateTime']['output']>;
  feeCurrencies: Array<LineItemV2Currency>;
  fromAccount?: Maybe<Account>;
  incomingTransferGroupId?: Maybe<Scalars['String']['output']>;
  incomingTransferId?: Maybe<Scalars['String']['output']>;
  isMovement: Scalars['Boolean']['output'];
  isMovementFromUnassigned: Scalars['Boolean']['output'];
  location: Scalars['String']['output'];
  outgoingTransferGroupId?: Maybe<Scalars['String']['output']>;
  outgoingTransferId?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  soldAmount: Scalars['Float']['output'];
  soldCurrency: Scalars['String']['output'];
  toAccount?: Maybe<Account>;
  txnType: EnumTransferType;
};

export type LineItemV2Currency = {
  __typename?: 'LineItemV2Currency';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
};

export type LineItemV2Detail = {
  __typename?: 'LineItemV2Detail';
  averageCost?: Maybe<Scalars['Float']['output']>;
  bnbMatchType?: Maybe<Scalars['String']['output']>;
  costBasis: Scalars['Float']['output'];
  costBasisFeeAddition: Scalars['Float']['output'];
  costBasisFeeAdditions: Array<LineItemV2Fee>;
  costBasisFlat: Scalars['Float']['output'];
  costBasisFromSellFee: Scalars['Float']['output'];
  exitDetail?: Maybe<LineItemV2AuditDetail>;
  feeUnitsSold: Scalars['Float']['output'];
  gainLoss: Scalars['Float']['output'];
  lineItemTrace: Array<LineItemV2>;
  migrationDetail?: Maybe<LineItemV2AuditDetail>;
  missingCostBasis: Scalars['Boolean']['output'];
  missingCostBasisDetail?: Maybe<LineItemV2MissingCostBasisDetail>;
  originDetail?: Maybe<LineItemV2AuditDetail>;
  proceeds: Scalars['Float']['output'];
  proceedsFeeDeduction: Scalars['Float']['output'];
  proceedsFeeDeductions: Array<LineItemV2Fee>;
  proceedsFlat: Scalars['Float']['output'];
  proceedsFromSellFee: Scalars['Float']['output'];
  soldAmountFlat: Scalars['Float']['output'];
  term?: Maybe<Scalars['String']['output']>;
};

export type LineItemV2DetailInput = {
  lineItemId: Scalars['BigInt']['input'];
};

export type LineItemV2Fee = {
  __typename?: 'LineItemV2Fee';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type LineItemV2FilterQuery = {
  account?: InputMaybe<MultiSelectIntFilter>;
  boolean?: InputMaybe<Array<BooleanFilter>>;
  currency?: InputMaybe<Array<TxnCurrencyFilter>>;
  date?: InputMaybe<DateRangeFilter>;
  dateAcquired?: InputMaybe<DateRangeFilter>;
};

export type LineItemV2Input = {
  filterDust?: Scalars['Boolean']['input'];
  filterQuery?: InputMaybe<LineItemV2FilterQuery>;
  pagination: PaginationOptions;
  sortBy: LineItemV2SortOptions;
  sortDirection: SortDirectionOptions;
  txnReportId: Scalars['Int']['input'];
};

export type LineItemV2MissingCostBasisDetail = {
  __typename?: 'LineItemV2MissingCostBasisDetail';
  missingAmount: Scalars['Float']['output'];
  missingCurrency: Scalars['String']['output'];
};

export enum LineItemV2SortOptions {
  accountId = 'accountId',
  buyCurrency = 'buyCurrency',
  buyDate = 'buyDate',
  costBasisIncludingFees = 'costBasisIncludingFees',
  gainLossIncludingFees = 'gainLossIncludingFees',
  proceedsIncludingFees = 'proceedsIncludingFees',
  sellCurrency = 'sellCurrency',
  sellDate = 'sellDate',
  term = 'term',
  unitsSold = 'unitsSold',
}

export type LineItems = {
  __typename?: 'LineItems';
  edges: Array<LineItem>;
  pageInfo: PageInfo;
};

export type LineItemsFilterQuery = {
  account?: InputMaybe<MultiSelectIntFilter>;
  boolean?: InputMaybe<Array<BooleanFilter>>;
  currency?: InputMaybe<Array<TxnCurrencyFilter>>;
  date?: InputMaybe<DateRangeFilter>;
  dateAcquired?: InputMaybe<DateRangeFilter>;
};

export type LineItemsV2 = {
  __typename?: 'LineItemsV2';
  edges: Array<LineItemV2>;
  pageInfo: PageInfo;
};

export type Link = {
  __typename?: 'Link';
  path: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type Location = {
  __typename?: 'Location';
  contractAddress?: Maybe<Scalars['String']['output']>;
  integrationId: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type LoginOrSignupResponse = {
  __typename?: 'LoginOrSignupResponse';
  user: User;
  userHash: Scalars['String']['output'];
};

export type LpToken = {
  __typename?: 'LpToken';
  address: Scalars['String']['output'];
  ticker: Scalars['String']['output'];
};

export type McpIntegration = {
  __typename?: 'McpIntegration';
  authorizedAt: Scalars['Float']['output'];
  clientId: Scalars['String']['output'];
  clientName?: Maybe<Scalars['String']['output']>;
  lastRefreshedAt: Scalars['Float']['output'];
};

export type MissingExchange = {
  __typename?: 'MissingExchange';
  name: Scalars['String']['output'];
  transactions: Array<MissingExchangeTransaction>;
};

export type MissingExchangeTransaction = {
  __typename?: 'MissingExchangeTransaction';
  credentialType: Scalars['String']['output'];
  fromAddress?: Maybe<Scalars['String']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  toAddress?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type MissingExchanges = {
  __typename?: 'MissingExchanges';
  edges: Array<MissingExchange>;
};

export type MissingPricesDetail = {
  __typename?: 'MissingPricesDetail';
  count: Scalars['Int']['output'];
  type: TxnType;
};

export type MissingWallet = {
  __typename?: 'MissingWallet';
  address: Scalars['String']['output'];
  chain: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type MissingWalletValidationInput = {
  address: Scalars['String']['input'];
  chain: Scalars['String']['input'];
};

export type MissingWalletWithTxnValidation = {
  __typename?: 'MissingWalletWithTxnValidation';
  address: Scalars['String']['output'];
  chain: Scalars['String']['output'];
  hasTransactions: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
};

export type MissingWallets = {
  __typename?: 'MissingWallets';
  edges: Array<MissingWallet>;
};

export type ModifiedTxnDetail = {
  __typename?: 'ModifiedTxnDetail';
  count: Scalars['Int']['output'];
  token: Scalars['String']['output'];
};

export type Movement = {
  __typename?: 'Movement';
  deposits: Array<MovementComponent>;
  id: Scalars['Int']['output'];
  income: Array<MovementComponent>;
  movements: Array<MovementComponent>;
  spend: Array<MovementComponent>;
  withdrawals: Array<MovementComponent>;
};

export type MovementComponent = {
  __typename?: 'MovementComponent';
  component: EnumTxnGroupComponent;
  credential: Credential;
  currency?: Maybe<Scalars['String']['output']>;
  fromAccount?: Maybe<Account>;
  id: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Float']['output']>;
  soldCurrency?: Maybe<Scalars['String']['output']>;
  soldQuantity?: Maybe<Scalars['Float']['output']>;
  toAccount?: Maybe<Account>;
  txnHash?: Maybe<Scalars['String']['output']>;
  txnId: Scalars['String']['output'];
  txnTimestamp: Scalars['DateTime']['output'];
};

export type MovementCurrencyFilter = {
  operator: FilterOperatorTypes;
  side: MovementCurrencyFilterTypes;
  symbols: Array<Scalars['String']['input']>;
};

export enum MovementCurrencyFilterTypes {
  Currency = 'Currency',
}

export type MovementFilterQuery = {
  accounts?: InputMaybe<MultiSelectIntFilter>;
  currency?: InputMaybe<Array<MovementCurrencyFilter>>;
  date?: InputMaybe<DateRangeFilter>;
};

export type MovementMatchConstraint = {
  __typename?: 'MovementMatchConstraint';
  quantityLeewayPercentage: Scalars['Int']['output'];
  timestampLeewayDays: Scalars['Int']['output'];
};

export type MovementMergeCandidate = {
  __typename?: 'MovementMergeCandidate';
  account?: Maybe<Account>;
  blocksvcToAddress?: Maybe<Scalars['String']['output']>;
  credential: Credential;
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Float']['output']>;
  soldCurrency?: Maybe<Scalars['String']['output']>;
  soldQuantity?: Maybe<Scalars['Float']['output']>;
  txnHash?: Maybe<Scalars['String']['output']>;
  txnTimestamp: Scalars['DateTime']['output'];
  txnType: Scalars['String']['output'];
};

export type MovementMergeCandidates = {
  __typename?: 'MovementMergeCandidates';
  edges: Array<MovementMergeCandidate>;
  pageInfo: PageInfo;
};

export type MovementTableInput = {
  filterQuery?: InputMaybe<MovementFilterQuery>;
  pagination?: InputMaybe<PaginationOptions>;
  sortDirection: SortDirectionOptions;
};

export type Movements = {
  __typename?: 'Movements';
  edges: Array<Movement>;
  pageInfo: PageInfo;
};

export type MultiSelectIntFilter = {
  operator: FilterOperatorTypes;
  values: Array<Scalars['Int']['input']>;
};

export type MultiSelectStringFilter = {
  operator: FilterOperatorTypes;
  values: Array<Scalars['String']['input']>;
};

export type MultiSelectTransferGroupEditStatusFilter = {
  /** Supports Is and IsNot. */
  operator: FilterOperatorTypes;
  values: Array<EnumTransferGroupEditStatus>;
};

export type MultiSelectTransferGroupTypeFilter = {
  operator: FilterOperatorTypes;
  values: Array<EnumTransferGroupType>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acknowledgeV2Upgrade: Scalars['Boolean']['output'];
  activateAccount: LoginOrSignupResponse;
  activatePlanFromCheckout: PlanActivationData;
  addApiIntegration: CreatedCredential;
  addComment: Scalars['Boolean']['output'];
  addMissingPrices: Scalars['String']['output'];
  addOauthIntegration: CreatedCredential;
  addTransactions: CreatedCredential;
  addUserProfile: Scalars['Boolean']['output'];
  addWallets: CreatedCredentials;
  applyReconGuideTreatments: ApplyReconGuideTreatmentsResult;
  approveTransferGroupEdit: TransferGroupEdit;
  batchDeleteTxns: Scalars['Boolean']['output'];
  batchSaveVersionForUsers?: Maybe<Scalars['Boolean']['output']>;
  batchUpdateTxns: Scalars['Boolean']['output'];
  beginTwoFactorSetup: TwoFactorSetup;
  blockUser: User;
  bulkCreateUsers: Scalars['Boolean']['output'];
  bulkEnableRecalcByAccount: Scalars['Boolean']['output'];
  bulkResyncCredentials: Scalars['Boolean']['output'];
  bulkUpdateCredentials: UpdatedCredentials;
  bulkUpdateTransferGroups: UpdatedTransferGroupsResponse;
  buyProducts: BuyProductsResponse;
  cancelCredentialSync: Scalars['Boolean']['output'];
  cancelRefetchTransferGroupPricesJob: Scalars['Boolean']['output'];
  changePassword: Scalars['Boolean']['output'];
  changeUserData: Scalars['Boolean']['output'];
  cloneUser: ClonedAccountResponse;
  confirmTwoFactorSetup: Array<Scalars['String']['output']>;
  consultationSubmit: Scalars['Boolean']['output'];
  createAccount: Account;
  /** Imports a file uploaded through getUploadURL into an existing account (accountId) or into a new account created atomically with the import (newAccount). Exactly one of accountId and newAccount is required. Calling it again for the same Bucket and Key returns the import already created for that file. */
  createCsvImport: CreateCsvImportResponse;
  createForm1099DaTrueUpTxn: Scalars['Boolean']['output'];
  createInvoice: Scalars['String']['output'];
  createMovement: Scalars['Boolean']['output'];
  createOneSidedMovement: Scalars['Boolean']['output'];
  createOneSidedMovementGroup: TransferGroup;
  createTransferGroup: TransferGroup;
  createTrelloJob: TrelloJob;
  createWorkpaper: Workpaper;
  deleteAccount: Scalars['Boolean']['output'];
  deleteAllForm1099DAs: Scalars['Boolean']['output'];
  deleteComment: Scalars['Boolean']['output'];
  deleteCredentials: Scalars['Int']['output'];
  deleteDocuments: Scalars['Boolean']['output'];
  deleteForm1099DA: Scalars['Boolean']['output'];
  deleteForm1099DAManualEntry: Scalars['Boolean']['output'];
  deleteForm1099DaTrueUpTxn: Scalars['Boolean']['output'];
  deleteSpecIdV2Group: Scalars['Boolean']['output'];
  deleteSpecIdV2MatchesForTransfer: Array<SpecIdV2Group>;
  deleteTransferGroups: Scalars['Int']['output'];
  deleteTxns: Scalars['Int']['output'];
  deleteUpload: Scalars['Boolean']['output'];
  deleteUser: Scalars['Boolean']['output'];
  delinkSpecIds: Scalars['Boolean']['output'];
  detectPricingAnomalies: Scalars['String']['output'];
  disableTwoFactor: Scalars['Boolean']['output'];
  discardTransferGroupEdit: Scalars['Boolean']['output'];
  downloadWorkpaperCsv?: Maybe<Scalars['String']['output']>;
  duplicateTxns: Scalars['Boolean']['output'];
  editAccount: Account;
  editCredential: UpdatedCredential;
  editTopicInstruction: Scalars['Boolean']['output'];
  editWorkpaperRow: WorkpaperRow;
  enqueueTransferAddressBackfill: Scalars['Int']['output'];
  evmGuideEditInstruction: Scalars['Boolean']['output'];
  evmGuideNewInstruction: Scalars['Boolean']['output'];
  exportTransferGroups?: Maybe<Scalars['String']['output']>;
  exportTxns?: Maybe<Scalars['String']['output']>;
  generateReport: GenerateReportResult;
  generateTaxDetail: Scalars['Boolean']['output'];
  getForm1099DAUploadURL: Form1099DaUploadUrlData;
  getUploadURL: UploadUrlData;
  ibcGuideEditInstruction: Scalars['Boolean']['output'];
  ibcGuideNewInstruction: Scalars['Boolean']['output'];
  inviteUser: Scalars['Boolean']['output'];
  lockUser: User;
  login: LoginOrSignupResponse;
  loginOrSignupWithGoogle: GoogleLoginOrSignupResponse;
  logout: Scalars['Boolean']['output'];
  markAssetLost: CreatedCredential;
  markInvoiceAsPaid: Scalars['Boolean']['output'];
  markInvoiceAsVoid: Scalars['Boolean']['output'];
  markTransferGroupsSpam: UpdatedTransferGroupsResponse;
  markTxnsSpam: UpdatedTxnResponse;
  mergeToMovementAndTrade: Scalars['Boolean']['output'];
  mergeTransferGroupsIntoMovement: TransferGroup;
  mergeTxns: Scalars['Boolean']['output'];
  passwordForgot: Scalars['Boolean']['output'];
  passwordReset: Scalars['Boolean']['output'];
  payInvoice: Scalars['Boolean']['output'];
  portToTransfers: Scalars['Boolean']['output'];
  processForm1099DA: ProcessForm1099DaResponse;
  processUpload: ProcessUploadResponse;
  quickbooksDisconnect: Scalars['Boolean']['output'];
  quickbooksOauth: Scalars['Boolean']['output'];
  quickbooksSyncData: Scalars['Boolean']['output'];
  recalculateTxnReports?: Maybe<TxnReportJob>;
  recordCheckoutConversion: Scalars['Boolean']['output'];
  refetchTransferGroupPrices: Scalars['String']['output'];
  refreshStripeDispute: StripeDispute;
  refreshToken: Scalars['Boolean']['output'];
  regenCoinbaseCredentials: Scalars['Boolean']['output'];
  regenerateStripeDisputeEvidence: StripeDispute;
  regenerateTwoFactorRecoveryCodes: Array<Scalars['String']['output']>;
  repairGroupTxnRefs: Scalars['Boolean']['output'];
  reprocessAllForm1099DAs: ReprocessAllForm1099DAsResponse;
  resolveUnreconciledTransactions: ResolveUnreconciledTransactionResponse;
  restoreSnapshots: Scalars['Boolean']['output'];
  restoreVersion?: Maybe<Scalars['Boolean']['output']>;
  resyncCredentials: Scalars['Boolean']['output'];
  retryCsvImport: Scalars['Boolean']['output'];
  revertMissingPricesJob: Scalars['Boolean']['output'];
  revertTransactionReconciliation: RevertTransactionReconciliationResponse;
  reviewTransferGroups: UpdatedTransferGroupsResponse;
  reviewTxns: UpdatedTxnResponse;
  revokeMcpIntegration: Scalars['Boolean']['output'];
  runCreateAccountsJob: GenerateAccountsJob;
  runCreateMovementsJob: CreateMovementsJob;
  runDataModelV2UpgradeJob: DataModelV2UpgradeJob;
  saveCurrentVersion?: Maybe<Scalars['Boolean']['output']>;
  saveSnapshots: Scalars['Boolean']['output'];
  saveSpecId: Scalars['Boolean']['output'];
  saveSpecIdV2Group: SpecIdV2Group;
  sendEmailVerification: Scalars['Boolean']['output'];
  sendSupportEmail: Scalars['Boolean']['output'];
  setBusinessUser: Scalars['Boolean']['output'];
  setClientPassword: Scalars['Boolean']['output'];
  setTransferGroupsAmount: UpdatedTransferGroupsResponse;
  setTransferGroupsCurrency: UpdatedTransferGroupsResponse;
  setTransferGroupsDescription: UpdatedTransferGroupsResponse;
  setTransferGroupsPrice: UpdatedTransferGroupsResponse;
  setUserLockedThroughYear: User;
  shiftCsvTimezone: Scalars['Int']['output'];
  shiftTransferGroupsTimezone: UpdatedTransferGroupsResponse;
  signup: LoginOrSignupResponse;
  solanaGuideEditInstruction: Scalars['Boolean']['output'];
  solanaGuideNewInstruction: Scalars['Boolean']['output'];
  submitStripeDisputeEvidence: StripeDispute;
  syncCovalentWallets: CreatedCredentials;
  toggleDocumentVisibility?: Maybe<DocumentToggleVisibility>;
  undoMovements: Scalars['Boolean']['output'];
  undoPortToTransfers: Scalars['Boolean']['output'];
  unmergeMovement: TransferGroup;
  updateComment: Scalars['Boolean']['output'];
  updateCredentialSecrets: UpdatedCredential;
  updateCsvLabels: Scalars['Boolean']['output'];
  updateOauthIntegration: Credential;
  updateReportDetail: UserTaxDetail;
  updateTaxDetails: Scalars['Boolean']['output'];
  updateTransferGroup: TransferGroup;
  updateTxns: UpdatedTxnResponse;
  updateUserTaxDetail: UserTaxDetail;
  updateVersion?: Maybe<UpdateVersionResponse>;
  upsertForm1099DAManualEntry: Form1099DaManualEntry;
  validateCoupon: CouponValidationResponse;
  verifyEmail: Scalars['Boolean']['output'];
  verifyTwoFactorLogin: LoginOrSignupResponse;
};

export type MutationActivateAccountArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type MutationActivatePlanFromCheckoutArgs = {
  attributionCampaign?: InputMaybe<Scalars['String']['input']>;
  attributionMedium?: InputMaybe<Scalars['String']['input']>;
  attributionSource?: InputMaybe<Scalars['String']['input']>;
  checkoutSessionId: Scalars['String']['input'];
  fbclid?: InputMaybe<Scalars['String']['input']>;
  gbraid?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  marketingAnonymousId?: InputMaybe<Scalars['String']['input']>;
  wbraid?: InputMaybe<Scalars['String']['input']>;
};

export type MutationAddApiIntegrationArgs = {
  api: Scalars['String']['input'];
  credentials: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationAddCommentArgs = {
  content: Scalars['String']['input'];
  isPrivate?: Scalars['Boolean']['input'];
  userId: Scalars['Int']['input'];
};

export type MutationAddMissingPricesArgs = {
  credentialIds: Array<Scalars['Int']['input']>;
  plusOrMinusDays?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationAddOauthIntegrationArgs = {
  api: Scalars['String']['input'];
  code: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
};

export type MutationAddTransactionsArgs = {
  forceCreateNewCredential?: InputMaybe<Scalars['Boolean']['input']>;
  txns: Array<CreatedTxnInput>;
};

export type MutationAddUserProfileArgs = {
  userProfileInputData: UserProfileInputData;
};

export type MutationAddWalletsArgs = {
  addresses: Array<AddressWithCurrencyInput>;
  btcFundingWallet?: InputMaybe<Scalars['String']['input']>;
  checkMissingWallets?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['Int']['input']>;
  filterSpam?: InputMaybe<Scalars['Boolean']['input']>;
  incomingType?: InputMaybe<TxnType>;
  name?: InputMaybe<Scalars['String']['input']>;
  outgoingType?: InputMaybe<TxnType>;
  reconcileOnSync?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationApproveTransferGroupEditArgs = {
  editId: Scalars['String']['input'];
};

export type MutationBatchDeleteTxnsArgs = {
  filterQuery?: InputMaybe<TxnFilterQuery>;
};

export type MutationBatchSaveVersionForUsersArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  userIds: Array<Scalars['Int']['input']>;
};

export type MutationBatchUpdateTxnsArgs = {
  filterQuery?: InputMaybe<TxnFilterQuery>;
  txnInput: PartialTxnInput;
};

export type MutationBlockUserArgs = {
  block: Scalars['Boolean']['input'];
  userId: Scalars['Int']['input'];
};

export type MutationBulkCreateUsersArgs = {
  countryId: Scalars['Int']['input'];
  cryptoOnlyPlan?: InputMaybe<Scalars['String']['input']>;
  fullFilingPlan?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  useDataModelV1?: InputMaybe<Scalars['Boolean']['input']>;
  usernames: Array<Scalars['String']['input']>;
};

export type MutationBulkEnableRecalcByAccountArgs = {
  generateAccounts: Scalars['Boolean']['input'];
  generateMovements: Scalars['Boolean']['input'];
  userIds: Array<Scalars['Int']['input']>;
};

export type MutationBulkResyncCredentialsArgs = {
  credentialIds: Array<Scalars['Int']['input']>;
  hardResync?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationBulkUpdateCredentialsArgs = {
  credentialIds: Array<Scalars['Int']['input']>;
  updateData: BulkUpdateCredentialInput;
};

export type MutationBulkUpdateTransferGroupsArgs = {
  inputs: Array<UpdateTransferGroupInput>;
};

export type MutationBuyProductsArgs = {
  addons: Array<ProductInput>;
  attributionCampaign?: InputMaybe<Scalars['String']['input']>;
  attributionMedium?: InputMaybe<Scalars['String']['input']>;
  attributionSource?: InputMaybe<Scalars['String']['input']>;
  cardHolderName?: InputMaybe<Scalars['String']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  cryptoOnlyPlans: Array<ProductInput>;
  existingSourceId?: InputMaybe<Scalars['String']['input']>;
  fbclid?: InputMaybe<Scalars['String']['input']>;
  fpTrackId?: InputMaybe<Scalars['String']['input']>;
  fullFilingPlans: Array<ProductInput>;
  gbraid?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  marketingAnonymousId?: InputMaybe<Scalars['String']['input']>;
  newSourceTokenId?: InputMaybe<Scalars['String']['input']>;
  subTotal: Scalars['Int']['input'];
  wbraid?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCancelCredentialSyncArgs = {
  credentialIds: Array<Scalars['Int']['input']>;
};

export type MutationCancelRefetchTransferGroupPricesJobArgs = {
  jobId: Scalars['String']['input'];
};

export type MutationChangePasswordArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};

export type MutationChangeUserDataArgs = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  hideSpam?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  recalcByAccount?: InputMaybe<Scalars['Boolean']['input']>;
  recalcByAccountStartYear?: InputMaybe<Scalars['Int']['input']>;
  reconMode?: InputMaybe<Scalars['Boolean']['input']>;
  removeInvalidatedSpecIdGroups?: InputMaybe<Scalars['Boolean']['input']>;
  secretMode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCloneUserArgs = {
  userId: Scalars['Int']['input'];
};

export type MutationConfirmTwoFactorSetupArgs = {
  code: Scalars['String']['input'];
};

export type MutationConsultationSubmitArgs = {
  consultFormInput: ConsultationSubmitInput;
};

export type MutationCreateAccountArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  external?: InputMaybe<Scalars['Boolean']['input']>;
  integrationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type MutationCreateCsvImportArgs = {
  Bucket: Scalars['String']['input'];
  Key: Scalars['String']['input'];
  accountId?: InputMaybe<Scalars['Int']['input']>;
  fileName: Scalars['String']['input'];
  newAccount?: InputMaybe<CsvImportNewAccountInput>;
  timezone: Scalars['String']['input'];
};

export type MutationCreateForm1099DaTrueUpTxnArgs = {
  amount: Scalars['Float']['input'];
  integrationId: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
};

export type MutationCreateInvoiceArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate: Scalars['Int']['input'];
  fbclid?: InputMaybe<Scalars['String']['input']>;
  gbraid?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  hideDefaultCrypto?: InputMaybe<Scalars['Boolean']['input']>;
  lines: Array<InvoiceLine>;
  marketingAnonymousId?: InputMaybe<Scalars['String']['input']>;
  newUserEmail?: InputMaybe<Scalars['String']['input']>;
  products: InvoiceProductsInput;
  userId?: InputMaybe<Scalars['Int']['input']>;
  wbraid?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateMovementArgs = {
  date: Scalars['DateTime']['input'];
  fromAccountId: Scalars['Int']['input'];
  toAccountId: Scalars['Int']['input'];
  txnIds: Array<Scalars['String']['input']>;
};

export type MutationCreateOneSidedMovementArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  fromAccountId: Scalars['Int']['input'];
  toAccountId: Scalars['Int']['input'];
  txnIds: Array<Scalars['String']['input']>;
};

export type MutationCreateOneSidedMovementGroupArgs = {
  accountId: Scalars['Int']['input'];
  transferGroupId: Scalars['String']['input'];
};

export type MutationCreateTransferGroupArgs = {
  input: CreateTransferGroupInput;
};

export type MutationCreateTrelloJobArgs = {
  input: CreateTrelloJobInput;
};

export type MutationCreateWorkpaperArgs = {
  input: CreateWorkpaperInput;
};

export type MutationDeleteAccountArgs = {
  id: Scalars['Int']['input'];
};

export type MutationDeleteCommentArgs = {
  id: Scalars['Int']['input'];
};

export type MutationDeleteCredentialsArgs = {
  ids: Array<Scalars['Int']['input']>;
};

export type MutationDeleteDocumentsArgs = {
  documentIds: Array<Scalars['Int']['input']>;
};

export type MutationDeleteForm1099DaArgs = {
  id: Scalars['Int']['input'];
};

export type MutationDeleteForm1099DaManualEntryArgs = {
  integrationId: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
};

export type MutationDeleteForm1099DaTrueUpTxnArgs = {
  integrationId: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
};

export type MutationDeleteSpecIdV2GroupArgs = {
  deleteChildGroups: Scalars['Boolean']['input'];
  groupId: Scalars['String']['input'];
};

export type MutationDeleteSpecIdV2MatchesForTransferArgs = {
  deleteChildGroups: Scalars['Boolean']['input'];
  transferId: Scalars['String']['input'];
};

export type MutationDeleteTransferGroupsArgs = {
  filterQuery?: InputMaybe<TransferGroupFilterQuery>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MutationDeleteTxnsArgs = {
  ids: Array<Scalars['String']['input']>;
};

export type MutationDeleteUploadArgs = {
  uploadId: Scalars['Int']['input'];
};

export type MutationDeleteUserArgs = {
  userId: Scalars['Int']['input'];
};

export type MutationDelinkSpecIdsArgs = {
  componentId?: InputMaybe<Scalars['String']['input']>;
  sellId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationDetectPricingAnomaliesArgs = {
  credentialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  minUsdThreshold?: InputMaybe<Scalars['Float']['input']>;
  windowSizeMonths?: InputMaybe<Scalars['Int']['input']>;
  zScoreThreshold?: InputMaybe<Scalars['Float']['input']>;
};

export type MutationDisableTwoFactorArgs = {
  code: Scalars['String']['input'];
};

export type MutationDiscardTransferGroupEditArgs = {
  editId: Scalars['String']['input'];
};

export type MutationDownloadWorkpaperCsvArgs = {
  workpaperId: Scalars['String']['input'];
};

export type MutationDuplicateTxnsArgs = {
  count?: Scalars['Int']['input'];
  ids: Array<Scalars['String']['input']>;
};

export type MutationEditAccountArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  integrationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MutationEditCredentialArgs = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  credentials?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Int']['input']>;
  filterSpam?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  reconcileOnSync?: InputMaybe<Scalars['Boolean']['input']>;
  skipResync?: InputMaybe<Scalars['Boolean']['input']>;
  skipUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationEditTopicInstructionArgs = {
  id: Scalars['Int']['input'];
  topicInstruction: Scalars['String']['input'];
};

export type MutationEditWorkpaperRowArgs = {
  input: EditWorkpaperRowInput;
  rowId: Scalars['Int']['input'];
};

export type MutationEnqueueTransferAddressBackfillArgs = {
  afterUserId?: InputMaybe<Scalars['Int']['input']>;
  limit?: Scalars['Int']['input'];
};

export type MutationEvmGuideEditInstructionArgs = {
  instructionId: Scalars['Int']['input'];
  newContractPublicName?: InputMaybe<Scalars['String']['input']>;
  newNotes?: InputMaybe<Scalars['String']['input']>;
  newPublicNotes?: InputMaybe<Scalars['String']['input']>;
  newTokenParam1?: InputMaybe<Array<Scalars['String']['input']>>;
  newTokenParam2?: InputMaybe<Array<Scalars['String']['input']>>;
  newTreatmentId: Scalars['Int']['input'];
};

export type MutationEvmGuideNewInstructionArgs = {
  chain: Scalars['String']['input'];
  contractAddress: Scalars['String']['input'];
  methodId: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  treatmentId: Scalars['Int']['input'];
};

export type MutationExportTransferGroupsArgs = {
  transferGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  transferGroupTableInput: TransferGroupTableInput;
};

export type MutationExportTxnsArgs = {
  txnIds?: InputMaybe<Array<Scalars['String']['input']>>;
  txnTableInput: TxnTableInput;
};

export type MutationGenerateReportArgs = {
  report: ReportCreateInput;
};

export type MutationGenerateTaxDetailArgs = {
  baseCurrency: Scalars['String']['input'];
  countryId: Scalars['Int']['input'];
  filingStatus?: InputMaybe<FilingStatusOptions>;
  grossIncome?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<StateOptions>;
  taxYear: Scalars['Int']['input'];
};

export type MutationGetForm1099DaUploadUrlArgs = {
  fileName: Scalars['String']['input'];
};

export type MutationGetUploadUrlArgs = {
  fileName: Scalars['String']['input'];
};

export type MutationIbcGuideEditInstructionArgs = {
  credentialType: Scalars['String']['input'];
  instructionId: Scalars['Int']['input'];
  newNotes?: InputMaybe<Scalars['String']['input']>;
  newPublicName?: InputMaybe<Scalars['String']['input']>;
  newPublicNotes?: InputMaybe<Scalars['String']['input']>;
  newTokenParam1?: InputMaybe<Array<Scalars['String']['input']>>;
  newTokenParam2?: InputMaybe<Array<Scalars['String']['input']>>;
  newTreatmentId: Scalars['Int']['input'];
  transactionHash?: InputMaybe<Scalars['String']['input']>;
};

export type MutationIbcGuideNewInstructionArgs = {
  credentialType: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  transactionHash: Scalars['String']['input'];
  treatmentId: Scalars['Int']['input'];
};

export type MutationInviteUserArgs = {
  email: Scalars['String']['input'];
};

export type MutationLockUserArgs = {
  lockedThroughYear?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};

export type MutationLoginArgs = {
  captchaResponse: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type MutationLoginOrSignupWithGoogleArgs = {
  token: Scalars['String']['input'];
};

export type MutationMarkAssetLostArgs = {
  nftAddress?: InputMaybe<Scalars['String']['input']>;
  unsoldBuyReportId?: InputMaybe<Scalars['BigInt']['input']>;
};

export type MutationMarkInvoiceAsPaidArgs = {
  cryptocurrency?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['String']['input'];
  method: InvoicePaymentMethod;
  txnHash?: InputMaybe<Scalars['String']['input']>;
};

export type MutationMarkInvoiceAsVoidArgs = {
  invoiceId: Scalars['String']['input'];
};

export type MutationMarkTransferGroupsSpamArgs = {
  filterQuery?: InputMaybe<TransferGroupFilterQuery>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  spam: Scalars['Boolean']['input'];
};

export type MutationMarkTxnsSpamArgs = {
  ids: Array<Scalars['String']['input']>;
  isSpam: Scalars['Boolean']['input'];
};

export type MutationMergeToMovementAndTradeArgs = {
  priceFetchingSide?: InputMaybe<PriceFetchingSide>;
  txnIds: Array<Scalars['String']['input']>;
};

export type MutationMergeTransferGroupsIntoMovementArgs = {
  transferGroupIds: Array<Scalars['String']['input']>;
};

export type MutationMergeTxnsArgs = {
  txnIds: Array<Scalars['String']['input']>;
};

export type MutationPasswordForgotArgs = {
  captchaResponse: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type MutationPasswordResetArgs = {
  captchaResponse: Scalars['String']['input'];
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type MutationPayInvoiceArgs = {
  fbclid?: InputMaybe<Scalars['String']['input']>;
  gbraid?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['String']['input'];
  marketingAnonymousId?: InputMaybe<Scalars['String']['input']>;
  method: InvoicePaymentMethod;
  stripeToken: Scalars['String']['input'];
  wbraid?: InputMaybe<Scalars['String']['input']>;
};

export type MutationPortToTransfersArgs = {
  userId: Scalars['Int']['input'];
};

export type MutationProcessForm1099DaArgs = {
  Key: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  taxYear?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationProcessUploadArgs = {
  Bucket: Scalars['String']['input'];
  Key: Scalars['String']['input'];
  accountId?: InputMaybe<Scalars['Int']['input']>;
  fileName: Scalars['String']['input'];
  integrationId?: InputMaybe<Scalars['String']['input']>;
  otherIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  replacedFileId?: InputMaybe<Scalars['Int']['input']>;
  timezone: Scalars['String']['input'];
  variousIntegrations?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationQuickbooksOauthArgs = {
  code: Scalars['String']['input'];
  realmId: Scalars['String']['input'];
  redirectPath?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
};

export type MutationRecalculateTxnReportsArgs = {
  options?: InputMaybe<RecalculateOptions>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationRecordCheckoutConversionArgs = {
  checkoutSessionId: Scalars['String']['input'];
  fbclid?: InputMaybe<Scalars['String']['input']>;
  gbraid?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  marketingAnonymousId?: InputMaybe<Scalars['String']['input']>;
  wbraid?: InputMaybe<Scalars['String']['input']>;
};

export type MutationRefetchTransferGroupPricesArgs = {
  currency: Scalars['String']['input'];
  filterQuery?: InputMaybe<TransferGroupFilterQuery>;
  groupIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MutationRefreshStripeDisputeArgs = {
  disputeId: Scalars['String']['input'];
};

export type MutationRegenCoinbaseCredentialsArgs = {
  credentialId: Scalars['Int']['input'];
};

export type MutationRegenerateStripeDisputeEvidenceArgs = {
  disputeId: Scalars['String']['input'];
};

export type MutationRegenerateTwoFactorRecoveryCodesArgs = {
  code: Scalars['String']['input'];
};

export type MutationRepairGroupTxnRefsArgs = {
  userIds: Array<Scalars['Int']['input']>;
};

export type MutationReprocessAllForm1099DAsArgs = {
  documentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  integrationId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  taxYear?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationResolveUnreconciledTransactionsArgs = {
  unreconciledTransactionInputs: Array<UnreconciledTransactionInput>;
};

export type MutationRestoreSnapshotsArgs = {
  txnReportIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type MutationRestoreVersionArgs = {
  adminNotes?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  versionId: Scalars['String']['input'];
};

export type MutationResyncCredentialsArgs = {
  credentialIds: Array<Scalars['Int']['input']>;
  hardResync?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationRetryCsvImportArgs = {
  exchangeServiceRequestId: Scalars['Int']['input'];
};

export type MutationRevertMissingPricesJobArgs = {
  missingPricesJobId: Scalars['String']['input'];
};

export type MutationRevertTransactionReconciliationArgs = {
  reconciliationId: Scalars['Int']['input'];
};

export type MutationReviewTransferGroupsArgs = {
  filterQuery?: InputMaybe<TransferGroupFilterQuery>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  reviewed: Scalars['Boolean']['input'];
};

export type MutationReviewTxnsArgs = {
  ids: Array<Scalars['String']['input']>;
  reviewed: Scalars['Boolean']['input'];
};

export type MutationRevokeMcpIntegrationArgs = {
  clientId: Scalars['String']['input'];
};

export type MutationSaveCurrentVersionArgs = {
  adminNotes?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type MutationSaveSnapshotsArgs = {
  chained?: InputMaybe<Scalars['Boolean']['input']>;
  purgeReportsWhenDone?: InputMaybe<Scalars['Boolean']['input']>;
  txnReportIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type MutationSaveSpecIdArgs = {
  componentIds: Array<Scalars['String']['input']>;
  sellId: Scalars['String']['input'];
};

export type MutationSaveSpecIdV2GroupArgs = {
  groupId?: InputMaybe<Scalars['String']['input']>;
  incomingTransferIds: Array<Scalars['String']['input']>;
  outgoingTransferIds: Array<Scalars['String']['input']>;
};

export type MutationSendSupportEmailArgs = {
  exchanges: Array<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  hasStaking?: InputMaybe<Scalars['Boolean']['input']>;
  hasWallet?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['Int']['input'];
};

export type MutationSetBusinessUserArgs = {
  businessUser: Scalars['Boolean']['input'];
  userId: Scalars['Int']['input'];
};

export type MutationSetClientPasswordArgs = {
  clientId: Scalars['Int']['input'];
  organizationId: Scalars['Int']['input'];
  password: Scalars['String']['input'];
};

export type MutationSetTransferGroupsAmountArgs = {
  currency: Scalars['String']['input'];
  direction: EnumTransferDirection;
  filterQuery?: InputMaybe<TransferGroupFilterQuery>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  quantity: Scalars['String']['input'];
};

export type MutationSetTransferGroupsCurrencyArgs = {
  direction: EnumTransferDirection;
  filterQuery?: InputMaybe<TransferGroupFilterQuery>;
  fromCurrency: Scalars['String']['input'];
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  toCurrency: Scalars['String']['input'];
  tokenId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationSetTransferGroupsDescriptionArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  filterQuery?: InputMaybe<TransferGroupFilterQuery>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MutationSetTransferGroupsPriceArgs = {
  currency: Scalars['String']['input'];
  direction: EnumTransferDirection;
  filterQuery?: InputMaybe<TransferGroupFilterQuery>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  price: Scalars['String']['input'];
};

export type MutationSetUserLockedThroughYearArgs = {
  lockedThroughYear?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationShiftCsvTimezoneArgs = {
  credentialId: Scalars['Int']['input'];
  timezone: Scalars['String']['input'];
};

export type MutationShiftTransferGroupsTimezoneArgs = {
  filterQuery?: InputMaybe<TransferGroupFilterQuery>;
  hours: Scalars['Int']['input'];
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MutationSignupArgs = {
  captchaResponse: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type MutationSolanaGuideEditInstructionArgs = {
  instructionId: Scalars['Int']['input'];
  newNotes?: InputMaybe<Scalars['String']['input']>;
  newPublicName?: InputMaybe<Scalars['String']['input']>;
  newPublicNotes?: InputMaybe<Scalars['String']['input']>;
  newTokenParam1?: InputMaybe<Array<Scalars['String']['input']>>;
  newTokenParam2?: InputMaybe<Array<Scalars['String']['input']>>;
  newTreatmentId: Scalars['Int']['input'];
  transactionHash?: InputMaybe<Scalars['String']['input']>;
};

export type MutationSolanaGuideNewInstructionArgs = {
  identifier: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  transactionHash: Scalars['String']['input'];
  treatmentId: Scalars['Int']['input'];
};

export type MutationSubmitStripeDisputeEvidenceArgs = {
  disputeId: Scalars['String']['input'];
};

export type MutationSyncCovalentWalletsArgs = {
  addresses: Array<Scalars['String']['input']>;
  chainIds: Array<Scalars['String']['input']>;
};

export type MutationToggleDocumentVisibilityArgs = {
  documentIds: Array<Scalars['Int']['input']>;
  hidden: Scalars['Boolean']['input'];
};

export type MutationUndoMovementsArgs = {
  txnGroupIds: Array<Scalars['Int']['input']>;
};

export type MutationUndoPortToTransfersArgs = {
  force?: Scalars['Boolean']['input'];
  userId: Scalars['Int']['input'];
};

export type MutationUnmergeMovementArgs = {
  accountId: Scalars['Int']['input'];
  transferGroupId: Scalars['String']['input'];
};

export type MutationUpdateCommentArgs = {
  content: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  isPrivate?: Scalars['Boolean']['input'];
};

export type MutationUpdateCredentialSecretsArgs = {
  credentialId: Scalars['Int']['input'];
  credentials: Scalars['String']['input'];
  skipResync?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationUpdateCsvLabelsArgs = {
  exchangeServiceRequestId: Scalars['Int']['input'];
  isMargin: Scalars['Boolean']['input'];
  isUrgent: Scalars['Boolean']['input'];
};

export type MutationUpdateOauthIntegrationArgs = {
  code: Scalars['String']['input'];
  credentialId: Scalars['Int']['input'];
  redirectUri: Scalars['String']['input'];
};

export type MutationUpdateReportDetailArgs = {
  id: Scalars['Int']['input'];
  settings: Settings;
};

export type MutationUpdateTaxDetailsArgs = {
  taxDetails: Array<UpdateTaxDetailsInput>;
  userId: Scalars['Int']['input'];
};

export type MutationUpdateTransferGroupArgs = {
  input: UpdateTransferGroupInput;
};

export type MutationUpdateTxnsArgs = {
  txns: Array<TxnInput>;
};

export type MutationUpdateUserTaxDetailArgs = {
  countryId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  longTermCapitalGainsRate: Scalars['Float']['input'];
  marginalTaxRate: Scalars['Float']['input'];
  method?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateVersionArgs = {
  adminNotes?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  versionId: Scalars['String']['input'];
};

export type MutationUpsertForm1099DaManualEntryArgs = {
  integrationId: Scalars['String']['input'];
  rows: Array<Form1099DaManualEntryRowInput>;
  taxYear: Scalars['Int']['input'];
};

export type MutationValidateCouponArgs = {
  code: Scalars['String']['input'];
};

export type MutationVerifyEmailArgs = {
  token: Scalars['String']['input'];
};

export type MutationVerifyTwoFactorLoginArgs = {
  code: Scalars['String']['input'];
};

export type OpenAiResponse = {
  __typename?: 'OpenAIResponse';
  email: Scalars['String']['output'];
  featureType: FeatureType;
  response: ResponseDetails;
  userId: Scalars['Int']['output'];
};

export type OpenAiResponseOutput = {
  __typename?: 'OpenAIResponseOutput';
  content?: Maybe<OpenAiResponseOutputContent>;
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type OpenAiResponseOutputContent = {
  __typename?: 'OpenAIResponseOutputContent';
  annotations?: Maybe<Scalars['Json']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type Organization = {
  __typename?: 'Organization';
  colorLink?: Maybe<Scalars['String']['output']>;
  colorPrimary?: Maybe<Scalars['String']['output']>;
  colorSecondary?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  credentials: Array<Credential>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  includeDemoUser?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EnumOrganizationStatus>;
  txnReports: Array<TxnReport>;
  updatedAt: Scalars['DateTime']['output'];
  userOrgRoles: Array<UserOrgRole>;
  users: Array<User>;
};

export enum OtherFilters {
  automaticallyEdited = 'automaticallyEdited',
  hasComments = 'hasComments',
  isSpam = 'isSpam',
  manuallyEdited = 'manuallyEdited',
  missingPrice = 'missingPrice',
}

export type OverlappingContract = {
  __typename?: 'OverlappingContract';
  blockSvcMethodId: Scalars['Int']['output'];
  chainCredentialType: Array<Scalars['String']['output']>;
  chainName: Scalars['String']['output'];
  contractAddress: Scalars['String']['output'];
  contractId: Scalars['Int']['output'];
  distance?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  methodHash?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  treatment?: Maybe<Treatment>;
  treatmentId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OverlappingContracts = {
  __typename?: 'OverlappingContracts';
  chainCounts: Array<OverlappingContractsChainCount>;
  edges: Array<OverlappingContract>;
  pageInfo: PageInfo;
  treatmentCounts: Array<OverlappingContractsTreatmentCount>;
};

export type OverlappingContractsChainCount = {
  __typename?: 'OverlappingContractsChainCount';
  chainDescription?: Maybe<Scalars['String']['output']>;
  chainName: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type OverlappingContractsChainFilter = {
  operator: FilterOperatorTypes;
  value: Scalars['String']['input'];
};

export type OverlappingContractsContractFilter = {
  operator: FilterOperatorTypes;
  value: Scalars['String']['input'];
};

export type OverlappingContractsFilterQuery = {
  chain?: InputMaybe<Array<InputMaybe<OverlappingContractsChainFilter>>>;
  contractAddress?: InputMaybe<Array<InputMaybe<OverlappingContractsContractFilter>>>;
  notes?: InputMaybe<Array<InputMaybe<OverlappingContractsNotesFilter>>>;
  treatment?: InputMaybe<Array<InputMaybe<OverlappingContractsTreatmentFilter>>>;
};

export type OverlappingContractsNotesFilter = {
  operator: FilterOperatorTypes;
  value: Scalars['String']['input'];
};

export type OverlappingContractsTableInput = {
  filterQuery?: InputMaybe<OverlappingContractsFilterQuery>;
  pagination?: InputMaybe<PaginationOptions>;
};

export type OverlappingContractsTreatmentCount = {
  __typename?: 'OverlappingContractsTreatmentCount';
  count: Scalars['Int']['output'];
  treatmentId: Scalars['Int']['output'];
  treatmentName: Scalars['String']['output'];
};

export type OverlappingContractsTreatmentFilter = {
  operator: FilterOperatorTypes;
  value: Scalars['String']['input'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  filteredCount?: Maybe<Scalars['Int']['output']>;
  hasNext?: Maybe<Scalars['Boolean']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type PaginationOptions = {
  first: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
};

export type PartialTxnInput = {
  accountCredentialId?: InputMaybe<Scalars['Int']['input']>;
  accountId?: InputMaybe<Scalars['Int']['input']>;
  bkpAccountCreditId?: InputMaybe<Scalars['Int']['input']>;
  bkpAccountDebitId?: InputMaybe<Scalars['Int']['input']>;
  bkpVendorId?: InputMaybe<Scalars['Int']['input']>;
  buyAddress?: InputMaybe<Scalars['String']['input']>;
  buyCurrency?: InputMaybe<Scalars['String']['input']>;
  buyPrice?: InputMaybe<Scalars['String']['input']>;
  buyQuantity?: InputMaybe<Scalars['String']['input']>;
  buyTokenId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  feeCurrency?: InputMaybe<Scalars['String']['input']>;
  feePrice?: InputMaybe<Scalars['String']['input']>;
  feeQuantity?: InputMaybe<Scalars['String']['input']>;
  feeTokenId?: InputMaybe<Scalars['String']['input']>;
  isSpam?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  priceFetchingSide?: InputMaybe<PriceFetchingSide>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  sellAddress?: InputMaybe<Scalars['String']['input']>;
  sellCurrency?: InputMaybe<Scalars['String']['input']>;
  sellPrice?: InputMaybe<Scalars['String']['input']>;
  sellQuantity?: InputMaybe<Scalars['String']['input']>;
  sellTokenId?: InputMaybe<Scalars['String']['input']>;
  toAccountId?: InputMaybe<Scalars['Int']['input']>;
  toCredentialId?: InputMaybe<Scalars['Int']['input']>;
  txnTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  txnType?: InputMaybe<TxnType>;
};

export type Payment = {
  __typename?: 'Payment';
  amount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  products: Products;
  timestamp: Scalars['DateTime']['output'];
};

export type Payments = {
  __typename?: 'Payments';
  edges: Array<Payment>;
  userId: Scalars['Int']['output'];
};

export type Plan = {
  __typename?: 'Plan';
  planId: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export type PlanActivationData = {
  __typename?: 'PlanActivationData';
  plan: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type PortfolioAsset = {
  __typename?: 'PortfolioAsset';
  accountId?: Maybe<Scalars['Int']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  allocation: Scalars['Float']['output'];
  amount: Scalars['Float']['output'];
  costBasis: Scalars['Float']['output'];
  costBasisPerUnit: Scalars['Float']['output'];
  currentPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  marketValue?: Maybe<Scalars['Float']['output']>;
  priceChange24h?: Maybe<Scalars['Float']['output']>;
  priceChangePercent24h?: Maybe<Scalars['Float']['output']>;
  sparklineData?: Maybe<Array<Scalars['Float']['output']>>;
  symbol: Scalars['String']['output'];
  unrealizedReturn?: Maybe<Scalars['Float']['output']>;
  unrealizedReturnPercent?: Maybe<Scalars['Float']['output']>;
};

export type PortfolioAssetsInput = {
  credentialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  pagination?: InputMaybe<PaginationOptions>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy: PortfolioAssetsSortOptions;
  sortDirection: SortDirectionOptions;
};

export type PortfolioAssetsResponse = {
  __typename?: 'PortfolioAssetsResponse';
  assets: Array<PortfolioAsset>;
  pageInfo: PageInfo;
  summary: PortfolioSummary;
};

export enum PortfolioAssetsSortOptions {
  allocation = 'allocation',
  amount = 'amount',
  costBasis = 'costBasis',
  currentPrice = 'currentPrice',
  marketValue = 'marketValue',
  priceChangePercent24h = 'priceChangePercent24h',
  symbol = 'symbol',
  unrealizedReturn = 'unrealizedReturn',
}

export type PortfolioHistoryDataPoint = {
  __typename?: 'PortfolioHistoryDataPoint';
  costBasis: Scalars['Float']['output'];
  date: Scalars['String']['output'];
  marketValue: Scalars['Float']['output'];
};

export type PortfolioHistoryInput = {
  credentialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  timeRange: PortfolioTimeRange;
};

export type PortfolioHistoryResponse = {
  __typename?: 'PortfolioHistoryResponse';
  changePercent?: Maybe<Scalars['Float']['output']>;
  dataPoints: Array<PortfolioHistoryDataPoint>;
  endValue?: Maybe<Scalars['Float']['output']>;
  startValue?: Maybe<Scalars['Float']['output']>;
};

export type PortfolioSummary = {
  __typename?: 'PortfolioSummary';
  marketValueChange24h?: Maybe<Scalars['Float']['output']>;
  marketValueChangePercent24h?: Maybe<Scalars['Float']['output']>;
  totalCostBasis: Scalars['Float']['output'];
  totalMarketValue: Scalars['Float']['output'];
  totalUnrealizedReturn: Scalars['Float']['output'];
  totalUnrealizedReturnPercent?: Maybe<Scalars['Float']['output']>;
};

export enum PortfolioTimeRange {
  ALL = 'ALL',
  ONE_MONTH = 'ONE_MONTH',
  ONE_WEEK = 'ONE_WEEK',
  ONE_YEAR = 'ONE_YEAR',
}

export enum PriceFetchingSide {
  buy = 'buy',
  sell = 'sell',
}

export type ProceedsComparisonByAsset = {
  __typename?: 'ProceedsComparisonByAsset';
  assetName: Scalars['String']['output'];
  excluded: Scalars['Boolean']['output'];
  form1099daProceeds?: Maybe<Scalars['Float']['output']>;
  form1099daTransactionCount?: Maybe<Scalars['Int']['output']>;
  form8949Proceeds?: Maybe<Scalars['Float']['output']>;
  form8949TransactionCount?: Maybe<Scalars['Int']['output']>;
};

export type ProcessForm1099DaResponse = {
  __typename?: 'ProcessForm1099DAResponse';
  createdAt: Scalars['String']['output'];
  extractionWarnings: Array<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  integrationId?: Maybe<Scalars['String']['output']>;
  originalFilename: Scalars['String']['output'];
  taxYear?: Maybe<Scalars['Int']['output']>;
  transactionCount: Scalars['Int']['output'];
};

export type ProcessUploadResponse = {
  __typename?: 'ProcessUploadResponse';
  requestId: Scalars['String']['output'];
};

export type ProductInput = {
  planId: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};

export type Products = {
  __typename?: 'Products';
  addons?: Maybe<Array<Plan>>;
  cryptoOnlyPlans?: Maybe<Array<Plan>>;
  fullFilingPlans?: Maybe<Array<Plan>>;
};

export type Query = {
  __typename?: 'Query';
  accountBalances: Array<AccountBalanceEntry>;
  accounts: AccountsData;
  available8949PdfYears: Array<Scalars['Int']['output']>;
  bkpAccounts: Array<BkpAccount>;
  bkpVendors: Array<BkpVendor>;
  clients: Array<User>;
  comments: Array<Comment>;
  countries: Array<Country>;
  credential: Credential;
  credentialDownloadUrl: Scalars['String']['output'];
  credentialHistory: Array<CredentialHistoryItem>;
  credentials: Credentials;
  credentialsBeingReconciled: Array<Credential>;
  credentialsById: Array<Credential>;
  credentialsCount: CredentialsCount;
  credentialsHaveLockedYearTxns: Scalars['Boolean']['output'];
  csvUploadStatus: CsvUploadStatus;
  csvsInReview: CsvsInReview;
  currencies: Array<Currency>;
  dailyBalanceFilters: DailyBalanceFilters;
  dailyBalances: Array<AccountBalanceMap>;
  /** Asks csv-service which integration a file uploaded through getUploadURL belongs to, without importing it. Detection only guides the choice of account: a file it cannot identify can still be imported. */
  detectCsvIntegration: CsvIntegrationDetection;
  documentDownloadUrls: DocumentUrls;
  documents: Documents;
  documentsCount: DocumentsCount;
  downloadForm1099DA: Scalars['String']['output'];
  evmGuideChains: Array<Chain>;
  evmGuideClientSummary: EvmGuideClientSummary;
  evmGuideInstruction?: Maybe<EvmInstruction>;
  exchangeServiceApiErrors: ExchangeServiceApiErrors;
  exchangeServiceTxnPreview: ExchangeServiceTxnPreview;
  externalBalance: ExternalBalance;
  findUsers: Array<User>;
  form1099DAs: Form1099DaListResponse;
  form1099daComparison: Form1099DaComparisonResult;
  form1099daManualEntry?: Maybe<Form1099DaManualEntry>;
  getLatestUserProfile?: Maybe<UserProfileData>;
  getLpTokens: Array<LpToken>;
  getV2ReportTypes: Array<Scalars['String']['output']>;
  hasMovementTxns: Scalars['Boolean']['output'];
  hasUnlockedSpecIdV1Data: Scalars['Boolean']['output'];
  hijackerUser?: Maybe<User>;
  ibcGuideClientSummary: IbcGuideClientSummary;
  ibcGuideInstruction?: Maybe<IdentifierBasedInstruction>;
  incomeDashboard?: Maybe<Txns>;
  invoice: Invoice;
  invoiceEvents: InvoiceEvents;
  invoices: Invoices;
  isPasswordResetTokenValid: Scalars['Boolean']['output'];
  latestBatchDeleteTxnsJobStatus?: Maybe<EnumGenericJobStatus>;
  latestBatchUpdateTxnsJobStatus?: Maybe<EnumGenericJobStatus>;
  latestChangeCredentialAccountJobs: Array<ChangeCredentialAccountJob>;
  latestCloneUserJob?: Maybe<CloneUserJob>;
  latestCreateMovementsJob?: Maybe<LatestCreateMovementsJob>;
  latestDataModelV2UpgradeJob?: Maybe<DataModelV2UpgradeJob>;
  latestGenerateAccountsJob?: Maybe<GenerateAccountsJob>;
  latestJobs?: Maybe<LatestJobs>;
  latestMissingPricesJob?: Maybe<LatestMissingPricesJob>;
  latestPricingAnomalyJob?: Maybe<LatestPricingAnomalyJob>;
  latestReconGuideTreatmentsJob?: Maybe<ReconGuideTreatmentsJob>;
  latestRefetchTransferGroupPricesJob?: Maybe<LatestRefetchTransferGroupPricesJob>;
  latestSnapshotJob?: Maybe<SnapshotJob>;
  latestTxnReportJob?: Maybe<TxnReportJob>;
  latestTxnReports?: Maybe<LatestTxnReports>;
  lineItemDetails: LineItemDetail;
  lineItemDetailsV2: LineItemV2Detail;
  lineItems: LineItems;
  lineItemsV2: LineItemsV2;
  mcpIntegrations: Array<McpIntegration>;
  migrationOutSiblingsForTransfer: Array<Transfer>;
  missingExchanges: MissingExchanges;
  missingPricesData: Array<MissingPricesDetail>;
  missingWalletTxnCount?: Maybe<Array<WalletTxnCount>>;
  missingWallets: MissingWallets;
  movementMatchConstraints: MovementMatchConstraint;
  movementMergeCandidates: MovementMergeCandidates;
  movements: Movements;
  needsRecalc: Scalars['Boolean']['output'];
  openAIResponse: OpenAiResponse;
  overlappingContracts: OverlappingContracts;
  paymentSources: Array<CreditCard>;
  payments: Payments;
  portfolioAssets: PortfolioAssetsResponse;
  portfolioHistory: PortfolioHistoryResponse;
  price?: Maybe<Scalars['Float']['output']>;
  priceForTxn?: Maybe<BuyOrSellPrice>;
  quickbooksAuthUrl: Scalars['String']['output'];
  quickbooksConnected: Scalars['Boolean']['output'];
  reconGuideTreatmentGroupTypes: Array<TreatmentGroupType>;
  reconGuideTreatments: Array<Treatment>;
  report?: Maybe<Report>;
  retrieveCheckout?: Maybe<CheckoutSession>;
  solanaGuideClientSummary: SolanaGuideClientSummary;
  solanaGuideInstruction?: Maybe<IdentifierBasedInstruction>;
  specIdGroupsInvalidatedByRecalcByAccount: Scalars['Int']['output'];
  specIdOriginCostBasisForTransfers: Array<SpecIdOriginCostBasis>;
  specIdV2Group: SpecIdV2Group;
  specIdV2GroupsForTransfers: Array<SpecIdV2Group>;
  stripeDispute?: Maybe<StripeDispute>;
  stripeDisputeEvidencePreview: StripeDisputeEvidencePreview;
  stripeDisputeStats: StripeDisputeStats;
  stripeDisputeSyncCache?: Maybe<StripeDisputeSyncCache>;
  stripeDisputes: StripeDisputeList;
  supportedCredentials: SupportedCredentials;
  supportedIntegrationIds: SupportedIntegrationIds;
  supportedSelfReconCredentialsCount: SupportedSelfReconCredentialCount;
  symbols: Array<Coin>;
  taxLossHarvestingAssets: TaxLossHarvestingAssets;
  taxLossHarvestingTaxLots: TaxLossHarvestingTaxLots;
  tokenOverridesList: Array<TokenOverrideConf>;
  /** Counts transfer groups by UTC year of timestampMin and stored location, matching the table filters. */
  transferExchangeNameCount: Array<TxnExchangeNameCount>;
  transferGroupCounts: TransferCount;
  /** Edit history for the currently selected user, including all statuses unless filtered. Admin-only. */
  transferGroupEdits: TransferGroupEdits;
  transferGroupPage?: Maybe<Scalars['Int']['output']>;
  transferGroupSchemas: Array<TransferGroupSchema>;
  transferGroups: TransferGroups;
  trelloCardSearch: TrelloCards;
  trelloJobs: TrelloJobs;
  txn?: Maybe<Txn>;
  txnAllowanceForYear: TxnAllowanceForYear;
  txnExchangeNameCount: Array<TxnExchangeNameCount>;
  txns: Txns;
  txnsInMovementGroups: Array<Scalars['String']['output']>;
  unbusyCredentials: Array<Credential>;
  /** @deprecated This query is deprecated. Use `/user/unreconciledTransactions` instead. */
  unreconciledTransactions: UnreconciledTransactions;
  unreconciledTxnsData: Array<UnreconciledTxnsData>;
  uploadDownloadUrl: Scalars['String']['output'];
  /** Files uploaded by the current user across all years. */
  uploads: Uploads;
  user?: Maybe<User>;
  userStripeDisputes: StripeDisputeList;
  userTaxMethods: UserTaxMethods;
  userTxnCount: TxnCount;
  validateMissingWallets: ValidatedMissingWallets;
  versions: VersionsResponse;
  /** Admin-only exact, case-insensitive wallet address lookup across all users. Includes soft-deleted credentials, regardless of sync status. Each user appears once, with only their matching credentials and deletion dates. */
  walletLookup: Array<WalletLookupUser>;
  workpaper: WorkpaperRows;
  workpapers: Array<Workpaper>;
};

export type QueryAccountBalancesArgs = {
  input?: InputMaybe<AccountBalancesInput>;
};

export type QueryClientsArgs = {
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryCommentsArgs = {
  userId: Scalars['Int']['input'];
};

export type QueryCredentialArgs = {
  id: Scalars['Int']['input'];
};

export type QueryCredentialDownloadUrlArgs = {
  credentialId: Scalars['Int']['input'];
};

export type QueryCredentialHistoryArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  credentialId: Scalars['Int']['input'];
};

export type QueryCredentialsArgs = {
  credentialIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  credentialTableInput: CredentialTableInput;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryCredentialsByIdArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type QueryCredentialsHaveLockedYearTxnsArgs = {
  credentialIds: Array<Scalars['Int']['input']>;
};

export type QueryCsvUploadStatusArgs = {
  requestId: Scalars['String']['input'];
};

export type QueryCsvsInReviewArgs = {
  csvTableInput: CsvsInReviewTableInput;
};

export type QueryDailyBalancesArgs = {
  input: DailyBalancesInput;
};

export type QueryDetectCsvIntegrationArgs = {
  Bucket: Scalars['String']['input'];
  Key: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type QueryDocumentDownloadUrlsArgs = {
  documentIds: Array<Scalars['Int']['input']>;
};

export type QueryDocumentsArgs = {
  docTableInput: DocTableInput;
};

export type QueryDownloadForm1099DaArgs = {
  id: Scalars['Int']['input'];
};

export type QueryEvmGuideClientSummaryArgs = {
  evmGuideClientSummaryTableInput: EvmGuideClientSummaryTableInput;
  userId: Scalars['Int']['input'];
};

export type QueryEvmGuideInstructionArgs = {
  chain: Scalars['String']['input'];
  contractAddress: Scalars['String']['input'];
  methodId: Scalars['String']['input'];
};

export type QueryExchangeServiceApiErrorsArgs = {
  exchangeServiceApiErrorsTableInput: ExchangeServiceApiErrorsTableInput;
};

export type QueryExchangeServiceTxnPreviewArgs = {
  integrationId: Scalars['String']['input'];
  txnHash: Scalars['String']['input'];
  userWallet: Scalars['String']['input'];
};

export type QueryExternalBalanceArgs = {
  input: ExternalBalanceInput;
};

export type QueryFindUsersArgs = {
  input: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryForm1099daComparisonArgs = {
  taxYear: Scalars['Int']['input'];
};

export type QueryForm1099daManualEntryArgs = {
  integrationId: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
};

export type QueryHasMovementTxnsArgs = {
  credentialIds: Array<Scalars['Int']['input']>;
};

export type QueryIbcGuideClientSummaryArgs = {
  ibcGuideClientSummaryTableInput: IbcGuideClientSummaryTableInput;
  userId: Scalars['Int']['input'];
};

export type QueryIbcGuideInstructionArgs = {
  identifier: Scalars['String']['input'];
};

export type QueryInvoiceArgs = {
  invoiceId: Scalars['String']['input'];
};

export type QueryInvoiceEventsArgs = {
  invoiceId: Scalars['String']['input'];
};

export type QueryInvoicesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};

export type QueryIsPasswordResetTokenValidArgs = {
  token: Scalars['String']['input'];
};

export type QueryLatestChangeCredentialAccountJobsArgs = {
  credentialIds: Array<Scalars['Int']['input']>;
};

export type QueryLatestJobsArgs = {
  userId: Scalars['Int']['input'];
};

export type QueryLineItemDetailsArgs = {
  lineItemDetailInput: LineItemDetailInput;
};

export type QueryLineItemDetailsV2Args = {
  lineItemV2DetailInput: LineItemV2DetailInput;
};

export type QueryLineItemsArgs = {
  lineItemInput: LineItemInput;
};

export type QueryLineItemsV2Args = {
  lineItemV2Input: LineItemV2Input;
};

export type QueryMigrationOutSiblingsForTransferArgs = {
  transferId: Scalars['String']['input'];
};

export type QueryMissingWalletTxnCountArgs = {
  wallets: Array<WalletTxnCountInput>;
};

export type QueryMovementMergeCandidatesArgs = {
  movementTableInput: MovementTableInput;
};

export type QueryMovementsArgs = {
  movementTableInput: MovementTableInput;
};

export type QueryOpenAiResponseArgs = {
  responseId: Scalars['String']['input'];
};

export type QueryOverlappingContractsArgs = {
  chain: Scalars['String']['input'];
  contractAddress: Scalars['String']['input'];
  methodId: Scalars['String']['input'];
  overlappingContractsTableInput: OverlappingContractsTableInput;
};

export type QueryPaymentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};

export type QueryPortfolioAssetsArgs = {
  input: PortfolioAssetsInput;
};

export type QueryPortfolioHistoryArgs = {
  input: PortfolioHistoryInput;
};

export type QueryPriceArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  credentialType?: InputMaybe<Scalars['String']['input']>;
  date: DateObject;
  symbol: Scalars['String']['input'];
  tokenId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPriceForTxnArgs = {
  buyAddress?: InputMaybe<Scalars['String']['input']>;
  buyTokenId?: InputMaybe<Scalars['String']['input']>;
  credentialType: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  date: DateObject;
  priceFetchingSide?: InputMaybe<PriceFetchingSide>;
  sellAddress?: InputMaybe<Scalars['String']['input']>;
  sellTokenId?: InputMaybe<Scalars['String']['input']>;
  soldCurrency: Scalars['String']['input'];
};

export type QueryQuickbooksAuthUrlArgs = {
  redirectPath?: InputMaybe<Scalars['String']['input']>;
};

export type QueryReportArgs = {
  id: Scalars['Int']['input'];
};

export type QueryRetrieveCheckoutArgs = {
  checkoutSessionId: Scalars['String']['input'];
};

export type QuerySolanaGuideClientSummaryArgs = {
  solanaGuideClientSummaryTableInput: SolanaGuideClientSummaryTableInput;
  userId: Scalars['Int']['input'];
};

export type QuerySolanaGuideInstructionArgs = {
  identifier: Scalars['String']['input'];
};

export type QuerySpecIdGroupsInvalidatedByRecalcByAccountArgs = {
  recalcByAccount: Scalars['Boolean']['input'];
  recalcByAccountStartYear: Scalars['Int']['input'];
};

export type QuerySpecIdOriginCostBasisForTransfersArgs = {
  transferIds: Array<Scalars['String']['input']>;
};

export type QuerySpecIdV2GroupArgs = {
  groupId: Scalars['String']['input'];
};

export type QuerySpecIdV2GroupsForTransfersArgs = {
  transferIds: Array<Scalars['String']['input']>;
};

export type QueryStripeDisputeArgs = {
  disputeId: Scalars['String']['input'];
};

export type QueryStripeDisputeEvidencePreviewArgs = {
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryStripeDisputesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryTaxLossHarvestingAssetsArgs = {
  taxLossHarvestingAssetsInput: TaxLossHarvestingAssetsInput;
};

export type QueryTaxLossHarvestingTaxLotsArgs = {
  taxLossHarvestingTaxLotsInput: TaxLossHarvestingTaxLotsInput;
};

export type QueryTransferExchangeNameCountArgs = {
  filterQuery?: InputMaybe<TransferGroupFilterQuery>;
};

export type QueryTransferGroupEditsArgs = {
  transferGroupEditTableInput: TransferGroupEditTableInput;
};

export type QueryTransferGroupPageArgs = {
  transferGroupId: Scalars['String']['input'];
  transferGroupTableInput: TransferGroupTableInput;
};

export type QueryTransferGroupsArgs = {
  transferGroupTableInput: TransferGroupTableInput;
};

export type QueryTrelloCardSearchArgs = {
  enterpriseBoard: Scalars['Boolean']['input'];
  includeArchivedLists: Scalars['Boolean']['input'];
  query: Scalars['String']['input'];
  reconBoard: Scalars['Boolean']['input'];
  taxBoard: Scalars['Boolean']['input'];
};

export type QueryTrelloJobsArgs = {
  trelloJobsTableInput: TrelloJobsTableInput;
};

export type QueryTxnArgs = {
  txnId: Scalars['String']['input'];
};

export type QueryTxnAllowanceForYearArgs = {
  year: Scalars['Int']['input'];
};

export type QueryTxnExchangeNameCountArgs = {
  filterQuery?: InputMaybe<TxnFilterQuery>;
};

export type QueryTxnsArgs = {
  txnTableInput: TxnTableInput;
};

export type QueryTxnsInMovementGroupsArgs = {
  txnIds: Array<Scalars['String']['input']>;
};

export type QueryUnreconciledTransactionsArgs = {
  hashes?: InputMaybe<Array<Scalars['String']['input']>>;
  unreconciledTransactionsTableInput?: InputMaybe<UnreconciledTransactionsTableInput>;
};

export type QueryUnreconciledTxnsDataArgs = {
  credentialType: Scalars['String']['input'];
  txnHashes: Array<Scalars['String']['input']>;
};

export type QueryUploadDownloadUrlArgs = {
  id: Scalars['Int']['input'];
};

export type QueryUploadsArgs = {
  csvOnly?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  uploadTableInput: UploadTableInput;
};

export type QueryUserArgs = {
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryUserStripeDisputesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};

export type QueryValidateMissingWalletsArgs = {
  missingWallets: Array<MissingWalletValidationInput>;
};

export type QueryWalletLookupArgs = {
  address: Scalars['String']['input'];
};

export type QueryWorkpaperArgs = {
  workpaperId: Scalars['String']['input'];
  workpaperRowTableInput: WorkpaperRowTableInput;
};

export type QueryWorkpapersArgs = {
  userId: Scalars['Int']['input'];
};

export type RecalculateOptions = {
  allYearOverride?: InputMaybe<Scalars['Boolean']['input']>;
  portfolioOverride?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReconGuideTreatmentsJob = {
  __typename?: 'ReconGuideTreatmentsJob';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['Int']['output'];
  creator: User;
  id: Scalars['String']['output'];
  jobData?: Maybe<ReconGuideTreatmentsJobResults>;
  status: EnumGenericJobStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['Int']['output'];
};

export type ReconGuideTreatmentsJobData = {
  __typename?: 'ReconGuideTreatmentsJobData';
  count: Scalars['Int']['output'];
  treatmentId: Scalars['Int']['output'];
  treatmentName: Scalars['String']['output'];
};

export type ReconGuideTreatmentsJobResults = {
  __typename?: 'ReconGuideTreatmentsJobResults';
  appliedTreatments: Array<ReconGuideTreatmentsJobData>;
  summary?: Maybe<ReconGuideTreatmentsJobResultsSummary>;
};

export type ReconGuideTreatmentsJobResultsSummary = {
  __typename?: 'ReconGuideTreatmentsJobResultsSummary';
  duration: Scalars['Int']['output'];
  txnTotal: Scalars['Int']['output'];
  txnsReconciled: Scalars['Int']['output'];
};

export type ReconRep = {
  __typename?: 'ReconRep';
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  trelloId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type ReconTransferInput = {
  currency: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['String']['input'];
  tokenId?: InputMaybe<Scalars['String']['input']>;
  type: TransferType;
};

export type Report = {
  __typename?: 'Report';
  createdAt: Scalars['DateTime']['output'];
  createdByAdmin?: Maybe<Scalars['Boolean']['output']>;
  createdById?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  errorDetails?: Maybe<ReportErrorDetails>;
  extraCols?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use errorDetails instead */
  failedReason?: Maybe<Scalars['String']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  margin?: Maybe<Scalars['Boolean']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  reportType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  taxYear?: Maybe<Scalars['String']['output']>;
  txnReport?: Maybe<TxnReport>;
  txnReportId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type ReportCreateInput = {
  aggregated?: InputMaybe<Scalars['Boolean']['input']>;
  byAccount?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  extraCols?: InputMaybe<Scalars['Boolean']['input']>;
  fiatCurrency?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  includeAddresses?: InputMaybe<Scalars['Boolean']['input']>;
  includeUsd?: InputMaybe<Scalars['Boolean']['input']>;
  margin?: InputMaybe<Scalars['Boolean']['input']>;
  method?: InputMaybe<EnumTaxMethod>;
  reportType: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  taxYear?: InputMaybe<Scalars['Int']['input']>;
  useExchangeNames?: InputMaybe<Scalars['Boolean']['input']>;
  useXlsx?: InputMaybe<Scalars['Boolean']['input']>;
  withCurrencies?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReportErrorDetails = {
  __typename?: 'ReportErrorDetails';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  severity: Scalars['String']['output'];
};

export type ReprocessAllForm1099DAsResponse = {
  __typename?: 'ReprocessAllForm1099DAsResponse';
  failed: Scalars['Int']['output'];
  processed: Scalars['Int']['output'];
  results: Array<ReprocessForm1099DaResultItem>;
  succeeded: Scalars['Int']['output'];
  totalFound: Scalars['Int']['output'];
};

export type ReprocessForm1099DaResultItem = {
  __typename?: 'ReprocessForm1099DAResultItem';
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  newIntegrationId?: Maybe<Scalars['String']['output']>;
  newTransactionCount: Scalars['Int']['output'];
  originalFilename: Scalars['String']['output'];
  previousIntegrationId?: Maybe<Scalars['String']['output']>;
  previousTransactionCount: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  userId: Scalars['Int']['output'];
};

export type ResolutionError = {
  __typename?: 'ResolutionError';
  message: Scalars['String']['output'];
  unreconciledTransactionId: Scalars['String']['output'];
};

export type ResolveUnreconciledTransactionResponse = {
  __typename?: 'ResolveUnreconciledTransactionResponse';
  errors: Array<ResolutionError>;
  resolutions: Array<UnreconciledTransactionResolution>;
};

export type ResponseDetails = {
  __typename?: 'ResponseDetails';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  instructions?: Maybe<Scalars['Json']['output']>;
  output: Array<OpenAiResponseOutput>;
  previous_response_id?: Maybe<Scalars['String']['output']>;
};

export type RevertTransactionReconciliationResponse = {
  __typename?: 'RevertTransactionReconciliationResponse';
  txns: Array<Txn>;
};

export type Role = {
  __typename?: 'Role';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  roleType: Scalars['String']['output'];
};

export type SelfReconTransfer = {
  __typename?: 'SelfReconTransfer';
  currency: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['String']['output'];
  tokenId?: Maybe<Scalars['String']['output']>;
  type: TransferType;
};

export type Settings = {
  baseCurrency?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['Int']['input']>;
  filingStatus?: InputMaybe<Scalars['String']['input']>;
  longTermCapitalGainsRate?: InputMaybe<Scalars['Float']['input']>;
  marginalTaxRate?: InputMaybe<Scalars['Float']['input']>;
  method?: InputMaybe<EnumTaxMethod>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type SnapshotJob = {
  __typename?: 'SnapshotJob';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  status: EnumGenericJobStatus;
  txnReportIds: Array<Scalars['Int']['output']>;
  type: SnapshotJobType;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['Int']['output'];
};

export enum SnapshotJobType {
  restore = 'restore',
  save = 'save',
}

export type SolanaGuideClientSummary = {
  __typename?: 'SolanaGuideClientSummary';
  edges: Array<SolanaGuideClientSummaryEdge>;
  pageInfo: PageInfo;
  treatmentCounts: Array<SolanaGuideClientSummaryTreatmentCount>;
};

export type SolanaGuideClientSummaryEdge = {
  __typename?: 'SolanaGuideClientSummaryEdge';
  firstTxnDate: Scalars['DateTime']['output'];
  identifier: Scalars['String']['output'];
  lastTxnDate: Scalars['DateTime']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  publicNotes?: Maybe<Scalars['String']['output']>;
  treatment?: Maybe<Treatment>;
  treatmentId?: Maybe<Scalars['Int']['output']>;
  txnCount: Scalars['Int']['output'];
};

export type SolanaGuideClientSummaryFilterQuery = {
  date?: InputMaybe<DateRangeFilter>;
  identifier?: InputMaybe<Array<InputMaybe<SolanaGuideClientSummaryIdentifierFilter>>>;
  notes?: InputMaybe<Array<InputMaybe<SolanaGuideClientSummaryNotesFilter>>>;
  treatment?: InputMaybe<Array<InputMaybe<SolanaGuideClientSummaryTreatmentFilter>>>;
};

export type SolanaGuideClientSummaryIdentifierFilter = {
  operator: FilterOperatorTypes;
  value: Scalars['String']['input'];
};

export type SolanaGuideClientSummaryNotesFilter = {
  operator: FilterOperatorTypes;
  value: Scalars['String']['input'];
};

export type SolanaGuideClientSummaryTableInput = {
  filterQuery?: InputMaybe<SolanaGuideClientSummaryFilterQuery>;
  pagination?: InputMaybe<PaginationOptions>;
};

export type SolanaGuideClientSummaryTreatmentCount = {
  __typename?: 'SolanaGuideClientSummaryTreatmentCount';
  count: Scalars['Int']['output'];
  treatmentId: Scalars['Int']['output'];
  treatmentName: Scalars['String']['output'];
};

export type SolanaGuideClientSummaryTreatmentFilter = {
  operator: FilterOperatorTypes;
  value: Scalars['String']['input'];
};

export type SolanaReview = {
  __typename?: 'SolanaReview';
  afterNotes?: Maybe<Scalars['String']['output']>;
  afterPublicNotes?: Maybe<Scalars['String']['output']>;
  afterTokenParam1?: Maybe<Array<Scalars['String']['output']>>;
  afterTokenParam2?: Maybe<Array<Scalars['String']['output']>>;
  afterTreatment?: Maybe<Treatment>;
  afterTreatmentId?: Maybe<Scalars['Int']['output']>;
  beforeNotes?: Maybe<Scalars['String']['output']>;
  beforePublicNotes?: Maybe<Scalars['String']['output']>;
  beforeTokenParam1?: Maybe<Array<Scalars['String']['output']>>;
  beforeTokenParam2?: Maybe<Array<Scalars['String']['output']>>;
  beforeTreatment?: Maybe<Treatment>;
  beforeTreatmentId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  instructionId: Scalars['Int']['output'];
  reconRep?: Maybe<ReconRep>;
  reconRepId?: Maybe<Scalars['Int']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
};

export enum SortDirectionOptions {
  asc = 'asc',
  desc = 'desc',
}

export type SpecIdFilter = {
  sellId?: InputMaybe<Scalars['String']['input']>;
  side?: InputMaybe<SpecIdMatchSide>;
};

export type SpecIdMatch = {
  __typename?: 'SpecIdMatch';
  component: Txn;
  componentId: Scalars['String']['output'];
  componentOrder: Scalars['Int']['output'];
  componentQuantity: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  sell: Txn;
  sellId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['Int']['output'];
};

export enum SpecIdMatchSide {
  buy = 'buy',
  either = 'either',
  sell = 'sell',
}

export type SpecIdModeFilter = {
  currency: Scalars['String']['input'];
  incomingOnly?: InputMaybe<Scalars['Boolean']['input']>;
  incomingTransferIds?: InputMaybe<Array<Scalars['String']['input']>>;
  outgoingTransferIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tokenAddress?: InputMaybe<Scalars['String']['input']>;
  tokenId?: InputMaybe<Scalars['String']['input']>;
};

export type SpecIdOriginCostBasis = {
  __typename?: 'SpecIdOriginCostBasis';
  costBasis?: Maybe<Scalars['Float']['output']>;
  transferId: Scalars['String']['output'];
};

export type SpecIdV2Group = {
  __typename?: 'SpecIdV2Group';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  matches: Array<SpecIdV2Match>;
  members: Array<SpecIdV2Member>;
  parentMatches: Array<SpecIdV2Match>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['Int']['output'];
};

export type SpecIdV2Match = {
  __typename?: 'SpecIdV2Match';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  incoming: Transfer;
  incomingId: Scalars['String']['output'];
  outgoing: Transfer;
  outgoingId: Scalars['String']['output'];
  quantity: Scalars['Decimal']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['Int']['output'];
};

export type SpecIdV2Member = {
  __typename?: 'SpecIdV2Member';
  createdAt: Scalars['DateTime']['output'];
  direction: Scalars['String']['output'];
  groupId: Scalars['String']['output'];
  groupIndex: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  transfer: Transfer;
  transferId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['Int']['output'];
};

export enum StateOptions {
  AK = 'AK',
  AL = 'AL',
  AR = 'AR',
  AZ = 'AZ',
  CA = 'CA',
  CO = 'CO',
  CT = 'CT',
  DE = 'DE',
  FL = 'FL',
  GA = 'GA',
  HI = 'HI',
  IA = 'IA',
  ID = 'ID',
  IL = 'IL',
  IN = 'IN',
  KS = 'KS',
  KY = 'KY',
  LA = 'LA',
  MA = 'MA',
  MD = 'MD',
  ME = 'ME',
  MI = 'MI',
  MN = 'MN',
  MO = 'MO',
  MS = 'MS',
  MT = 'MT',
  NC = 'NC',
  ND = 'ND',
  NE = 'NE',
  NH = 'NH',
  NJ = 'NJ',
  NM = 'NM',
  NV = 'NV',
  NY = 'NY',
  NYC = 'NYC',
  OH = 'OH',
  OK = 'OK',
  OR = 'OR',
  PA = 'PA',
  RI = 'RI',
  SC = 'SC',
  SD = 'SD',
  TN = 'TN',
  TX = 'TX',
  UT = 'UT',
  VA = 'VA',
  VT = 'VT',
  WA = 'WA',
  WI = 'WI',
  WV = 'WV',
  WY = 'WY',
}

export type StateTax = {
  __typename?: 'StateTax';
  bracketMax?: Maybe<Scalars['Float']['output']>;
  bracketMin?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deduction?: Maybe<Scalars['Float']['output']>;
  filingStatus?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  personalExemption?: Maybe<Scalars['Float']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type StripeDispute = {
  __typename?: 'StripeDispute';
  amount: Scalars['Int']['output'];
  chargeId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  disputeId: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  evidenceDueBy?: Maybe<Scalars['DateTime']['output']>;
  evidenceError?: Maybe<Scalars['String']['output']>;
  evidenceJson?: Maybe<Scalars['Json']['output']>;
  evidenceRegeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  evidenceState: Scalars['String']['output'];
  evidenceSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  invoiceId?: Maybe<Scalars['String']['output']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  outcomeReason?: Maybe<Scalars['String']['output']>;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  receiptDownloadUrl?: Maybe<Scalars['String']['output']>;
  receiptUrl?: Maybe<Scalars['String']['output']>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  serviceDocumentationDownloadUrl?: Maybe<Scalars['String']['output']>;
  serviceDocumentationUrl?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  stripeCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripeDashboardUrl: Scalars['String']['output'];
  stripeResponse?: Maybe<Scalars['Json']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['Int']['output']>;
};

export type StripeDisputeEvidencePreview = {
  __typename?: 'StripeDisputeEvidencePreview';
  snapshot: Scalars['Json']['output'];
  stripeEvidence: Scalars['Json']['output'];
};

export type StripeDisputeList = {
  __typename?: 'StripeDisputeList';
  edges: Array<StripeDispute>;
  totalCount: Scalars['Int']['output'];
};

export type StripeDisputeStats = {
  __typename?: 'StripeDisputeStats';
  last12MonthsAmount: Scalars['Int']['output'];
  last12MonthsCount: Scalars['Int']['output'];
  last30DaysAmount: Scalars['Int']['output'];
  last30DaysCount: Scalars['Int']['output'];
  lostCount: Scalars['Int']['output'];
  pendingCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalDisputedAmount: Scalars['Int']['output'];
  wonCount: Scalars['Int']['output'];
};

export type StripeDisputeSyncCache = {
  __typename?: 'StripeDisputeSyncCache';
  errors: Scalars['Json']['output'];
  failedCount: Scalars['Int']['output'];
  submittedCount: Scalars['Int']['output'];
  syncedAt: Scalars['String']['output'];
  totalDisputes: Scalars['Int']['output'];
};

export type SupportedCredentials = {
  __typename?: 'SupportedCredentials';
  evmCredentialTypes: Array<Scalars['String']['output']>;
  exchangeCredentials: Array<ExchangeCredentials>;
  metadata: Array<IntegrationMetadata>;
  reconCredentialTypes: Array<Scalars['String']['output']>;
  solanaCredentialTypes: Array<Scalars['String']['output']>;
  supportedWallets: Array<Scalars['String']['output']>;
};

export enum SupportedEcosystem {
  EVM = 'EVM',
  IBC = 'IBC',
  Solana = 'Solana',
}

export type SupportedIntegrationIds = {
  __typename?: 'SupportedIntegrationIds';
  integrationIds: Array<Scalars['String']['output']>;
};

export type SupportedSelfReconCredentialCount = {
  __typename?: 'SupportedSelfReconCredentialCount';
  count: Scalars['Int']['output'];
};

export type TaxLossHarvestingAsset = {
  __typename?: 'TaxLossHarvestingAsset';
  address?: Maybe<Scalars['String']['output']>;
  amount: Scalars['Float']['output'];
  balanceAtDate?: Maybe<Scalars['Float']['output']>;
  costBasis: Scalars['Float']['output'];
  currentUnitPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['BigInt']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isNft: Scalars['Boolean']['output'];
  lossesAmount?: Maybe<Scalars['Float']['output']>;
  marketValueAtDate?: Maybe<Scalars['Float']['output']>;
  priceAtDate?: Maybe<Scalars['Float']['output']>;
  pricePaidPerUnit: Scalars['Float']['output'];
  taxLots: Scalars['Float']['output'];
  token: Scalars['String']['output'];
  totalMarketValue?: Maybe<Scalars['Float']['output']>;
  unrealizedGainLoss?: Maybe<Scalars['Float']['output']>;
};

export type TaxLossHarvestingAssets = {
  __typename?: 'TaxLossHarvestingAssets';
  csv?: Maybe<Scalars['String']['output']>;
  edges: Array<TaxLossHarvestingAsset>;
  pageInfo: PageInfo;
  report: HoldingsReportMetadata;
};

export type TaxLossHarvestingAssetsInput = {
  /** 'YYYY-MM-DD'. Lists the tokens held at the end of that day (UTC) or now, with their units on that day as on the Running balance page, and that day's price and market value. Transfer model only. */
  balanceDate?: InputMaybe<Scalars['String']['input']>;
  customLinkedNftAddresses?: InputMaybe<Scalars['Json']['input']>;
  customLinkedSymbols?: InputMaybe<Scalars['Json']['input']>;
  customNftPrices?: InputMaybe<Scalars['Json']['input']>;
  customPrices?: InputMaybe<Scalars['Json']['input']>;
  filterQuery?: InputMaybe<TaxLossHarvestingFilterQuery>;
  isCSV?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationOptions>;
  sortBy: TaxLossHarvestingAssetsSortOptions;
  sortDirection: SortDirectionOptions;
};

export enum TaxLossHarvestingAssetsSortOptions {
  amount = 'amount',
  balanceAtDate = 'balanceAtDate',
  costBasis = 'costBasis',
  currentUnitPrice = 'currentUnitPrice',
  lossesAmount = 'lossesAmount',
  marketValueAtDate = 'marketValueAtDate',
  priceAtDate = 'priceAtDate',
  pricePaidPerUnit = 'pricePaidPerUnit',
  taxLots = 'taxLots',
  token = 'token',
  totalMarketValue = 'totalMarketValue',
  unrealizedGainLoss = 'unrealizedGainLoss',
}

export type TaxLossHarvestingFilterQuery = {
  accounts?: InputMaybe<MultiSelectIntFilter>;
  gainLoss?: InputMaybe<TaxLossHarvestingGainLossFilterOptions>;
  longShort?: InputMaybe<TaxLossHarvestingLongShortFilterOptions>;
  token?: InputMaybe<Array<TlhSearchFilter>>;
};

export enum TaxLossHarvestingGainLossFilterOptions {
  gain = 'gain',
  loss = 'loss',
}

export enum TaxLossHarvestingLongShortFilterOptions {
  long = 'long',
  short = 'short',
}

export type TaxLossHarvestingTaxLot = {
  __typename?: 'TaxLossHarvestingTaxLot';
  account?: Maybe<Account>;
  amount: Scalars['Float']['output'];
  costBasis: Scalars['Float']['output'];
  currentUnitPrice?: Maybe<Scalars['Float']['output']>;
  dateAcquired: Scalars['DateTime']['output'];
  id: Scalars['BigInt']['output'];
  potentialSavings?: Maybe<Scalars['Float']['output']>;
  timeToLongTerm?: Maybe<Scalars['Float']['output']>;
  token: Scalars['String']['output'];
  unrealizedGainLoss?: Maybe<Scalars['Float']['output']>;
};

export type TaxLossHarvestingTaxLots = {
  __typename?: 'TaxLossHarvestingTaxLots';
  csv?: Maybe<Scalars['String']['output']>;
  edges: Array<TaxLossHarvestingTaxLot>;
  filteredTotals: TaxLossHarvestingTaxLotsFilteredTotals;
  pageInfo: PageInfo;
  report: HoldingsReportMetadata;
  totals: TaxLossHarvestingTaxLotsTotals;
};

export type TaxLossHarvestingTaxLotsFilteredTotals = {
  __typename?: 'TaxLossHarvestingTaxLotsFilteredTotals';
  costBasis?: Maybe<Scalars['Float']['output']>;
  potentialSavings?: Maybe<Scalars['Float']['output']>;
  unrealizedGainLoss?: Maybe<Scalars['Float']['output']>;
};

export type TaxLossHarvestingTaxLotsFilters = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  accounts?: InputMaybe<MultiSelectIntFilter>;
  currency?: InputMaybe<Scalars['String']['input']>;
  gainLoss?: InputMaybe<TaxLossHarvestingGainLossFilterOptions>;
  longShort?: InputMaybe<TaxLossHarvestingLongShortFilterOptions>;
};

export type TaxLossHarvestingTaxLotsInput = {
  customLinkedToken?: InputMaybe<Scalars['String']['input']>;
  customPrice?: InputMaybe<Scalars['Float']['input']>;
  filters?: InputMaybe<TaxLossHarvestingTaxLotsFilters>;
  isCSV?: InputMaybe<Scalars['Boolean']['input']>;
  nftAddress?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationOptions>;
  sortBy: TaxLossHarvestingTaxLotsSortOptions;
  sortDirection: SortDirectionOptions;
  unsoldBuyReportId?: InputMaybe<Scalars['BigInt']['input']>;
};

export enum TaxLossHarvestingTaxLotsSortOptions {
  account = 'account',
  amount = 'amount',
  costBasis = 'costBasis',
  currentUnitPrice = 'currentUnitPrice',
  dateAcquired = 'dateAcquired',
  potentialSavings = 'potentialSavings',
  timeToLongTerm = 'timeToLongTerm',
  token = 'token',
  unrealizedGainLoss = 'unrealizedGainLoss',
}

export type TaxLossHarvestingTaxLotsTotals = {
  __typename?: 'TaxLossHarvestingTaxLotsTotals';
  currentUnitPrice?: Maybe<Scalars['Float']['output']>;
  totalCostBasis?: Maybe<Scalars['Float']['output']>;
  totalMarketValue?: Maybe<Scalars['Float']['output']>;
  totalUnrealizedGainLoss?: Maybe<Scalars['Float']['output']>;
};

export type TaxMethod = {
  __typename?: 'TaxMethod';
  id: EnumTaxMethod;
  label: Scalars['String']['output'];
};

export type TlhSearchFilter = {
  key: TlhSearchFilterKeys;
  operator: FilterOperatorTypes;
  value: Scalars['String']['input'];
};

export enum TlhSearchFilterKeys {
  token = 'token',
}

export type TokenOverrideConf = {
  __typename?: 'TokenOverrideConf';
  id: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};

export type TransactionCountPerYear = {
  __typename?: 'TransactionCountPerYear';
  count: Scalars['Int']['output'];
  year: Scalars['String']['output'];
};

export type Transfer = {
  __typename?: 'Transfer';
  account?: Maybe<Account>;
  accountId?: Maybe<Scalars['Int']['output']>;
  contractAddress?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  credential: Credential;
  credentialId: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  direction: EnumTransferDirection;
  exchangeId?: Maybe<Scalars['String']['output']>;
  fromAddress?: Maybe<Scalars['String']['output']>;
  groupId: Scalars['String']['output'];
  groupTimestampMax: Scalars['DateTime']['output'];
  hash?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  inDateRange: Scalars['Boolean']['output'];
  integrationId?: Maybe<Scalars['String']['output']>;
  methodId?: Maybe<Scalars['String']['output']>;
  methodName?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Decimal']['output']>;
  quantity: Scalars['Decimal']['output'];
  specIdAvailableQuantity?: Maybe<Scalars['Decimal']['output']>;
  specIdGroupsV2: Array<SpecIdV2Group>;
  specIdIncomingMatchesV2?: Maybe<Array<SpecIdV2Match>>;
  specIdOutgoingMatchesV2?: Maybe<Array<SpecIdV2Match>>;
  specIdTotalQuantity?: Maybe<Scalars['Decimal']['output']>;
  specIdViable?: Maybe<Scalars['Boolean']['output']>;
  synthetic: Scalars['Boolean']['output'];
  taxTreatment?: Maybe<EnumTaxTreatment>;
  timestamp: Scalars['DateTime']['output'];
  toAddress?: Maybe<Scalars['String']['output']>;
  tokenAddress?: Maybe<Scalars['String']['output']>;
  tokenId?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  transferTopicFingerprint?: Maybe<Scalars['String']['output']>;
  txnTopicFingerprint?: Maybe<Scalars['String']['output']>;
  type?: Maybe<EnumTransferType>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['Int']['output'];
  valueUsd?: Maybe<Scalars['Decimal']['output']>;
};

export type TransferAddressFilter = {
  direction?: InputMaybe<EnumTransferDirection>;
  operator: FilterOperatorTypes;
  value: Scalars['String']['input'];
};

export type TransferCount = {
  __typename?: 'TransferCount';
  totalCount: Scalars['Int']['output'];
  typeCounts: Array<TransferGroupTypeCount>;
};

export type TransferCurrencyFilter = {
  currency: Scalars['String']['input'];
  direction?: InputMaybe<EnumTransferDirection>;
  operator: FilterOperatorTypes;
};

export type TransferData = {
  __typename?: 'TransferData';
  amount: Scalars['String']['output'];
  contractAddress?: Maybe<Scalars['String']['output']>;
  from: Scalars['String']['output'];
  to: Scalars['String']['output'];
  tokenLogoUrl?: Maybe<Scalars['String']['output']>;
  tokenName?: Maybe<Scalars['String']['output']>;
  tokenSymbol: Scalars['String']['output'];
};

export type TransferGroup = {
  __typename?: 'TransferGroup';
  bkpAccountCreditId?: Maybe<Scalars['Int']['output']>;
  bkpAccountDebitId?: Maybe<Scalars['Int']['output']>;
  bkpVendorId?: Maybe<Scalars['Int']['output']>;
  contractAddresses: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  credentialIds: Array<Scalars['Int']['output']>;
  credentials: Array<Credential>;
  currenciesFee: Array<Scalars['String']['output']>;
  currenciesIn: Array<Scalars['String']['output']>;
  currenciesOut: Array<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hashes: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** @deprecated Raw DB value. For display purposes, use `locations` which includes resolved names and contract addresses. */
  location?: Maybe<Scalars['String']['output']>;
  locations: Array<Location>;
  methodIds: Array<Scalars['String']['output']>;
  /** The pending edit proposal for this transfer group, if any. Admin-only. */
  pendingEdit?: Maybe<TransferGroupEdit>;
  reconIdentifiers: Array<Scalars['String']['output']>;
  reviewed: Scalars['Boolean']['output'];
  suggestedInstruction?: Maybe<Instruction>;
  timestampMax: Scalars['DateTime']['output'];
  timestampMin: Scalars['DateTime']['output'];
  toAddresses: Array<Scalars['String']['output']>;
  transfers: Array<Transfer>;
  type: EnumTransferGroupType;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['Int']['output'];
  value?: Maybe<Scalars['Decimal']['output']>;
  valueFee?: Maybe<Scalars['Decimal']['output']>;
  valueIn?: Maybe<Scalars['Decimal']['output']>;
  valueOut?: Maybe<Scalars['Decimal']['output']>;
};

export type TransferGroupAccountRule = {
  __typename?: 'TransferGroupAccountRule';
  directions: Array<EnumTransferDirection>;
  uniqueCount: Scalars['Int']['output'];
};

export type TransferGroupEdit = {
  __typename?: 'TransferGroupEdit';
  afterState: Scalars['Json']['output'];
  appliedAt?: Maybe<Scalars['DateTime']['output']>;
  appliedBy?: Maybe<Scalars['Int']['output']>;
  beforeState: Scalars['Json']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['Int']['output'];
  createdByEmail?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastUpdatedAt: Scalars['DateTime']['output'];
  lastUpdatedBy: Scalars['Int']['output'];
  proposedEdit: Scalars['Json']['output'];
  source: EnumTransferGroupEditSource;
  status: EnumTransferGroupEditStatus;
  transferGroupId: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type TransferGroupEditFilterQuery = {
  /** Filter by application date, including both endpoints. Excludes edits that have not been applied. */
  appliedAt?: InputMaybe<DateRangeFilter>;
  /** Filter by creation date, including both endpoints. */
  date?: InputMaybe<DateRangeFilter>;
  status?: InputMaybe<MultiSelectTransferGroupEditStatusFilter>;
  /** Group UUIDs. Supports Is and IsNot. */
  transferGroupId?: InputMaybe<MultiSelectStringFilter>;
};

export enum TransferGroupEditSortOptions {
  appliedAt = 'appliedAt',
  createdAt = 'createdAt',
  status = 'status',
}

export type TransferGroupEditStatusCount = {
  __typename?: 'TransferGroupEditStatusCount';
  count: Scalars['Int']['output'];
  status: EnumTransferGroupEditStatus;
};

export type TransferGroupEditTableInput = {
  filterQuery?: InputMaybe<TransferGroupEditFilterQuery>;
  /** Defaults to 25 rows. Maximum page size is 100. */
  pagination?: InputMaybe<PaginationOptions>;
  sortBy?: TransferGroupEditSortOptions;
  sortDirection?: SortDirectionOptions;
};

export type TransferGroupEdits = {
  __typename?: 'TransferGroupEdits';
  edges: Array<TransferGroupEdit>;
  pageInfo: PageInfo;
  /** Counts for each status, scoped to this user and the date/group filters, before status filtering. */
  statusCounts: Array<TransferGroupEditStatusCount>;
};

export type TransferGroupFilterQuery = {
  accounts?: InputMaybe<MultiSelectIntFilter>;
  contractAddress?: InputMaybe<Array<TransferGroupSearchFilter>>;
  currency?: InputMaybe<Array<TransferCurrencyFilter>>;
  date?: InputMaybe<DateRangeFilter>;
  description?: InputMaybe<Array<TransferGroupSearchFilter>>;
  hash?: InputMaybe<Array<TransferGroupSearchFilter>>;
  imports?: InputMaybe<MultiSelectIntFilter>;
  methodId?: InputMaybe<Array<TransferGroupSearchFilter>>;
  missingPrice?: InputMaybe<Scalars['Boolean']['input']>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  showSpam?: InputMaybe<Scalars['Boolean']['input']>;
  specId?: InputMaybe<SpecIdModeFilter>;
  transferAddress?: InputMaybe<Array<TransferAddressFilter>>;
  type?: InputMaybe<MultiSelectTransferGroupTypeFilter>;
};

export type TransferGroupSchema = {
  __typename?: 'TransferGroupSchema';
  accountRules: Array<TransferGroupAccountRule>;
  rules: Array<Array<TransferGroupSchemaRule>>;
  type: EnumTransferGroupType;
};

export type TransferGroupSchemaRule = {
  __typename?: 'TransferGroupSchemaRule';
  direction: Scalars['String']['output'];
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type TransferGroupSearchFilter = {
  operator: FilterOperatorTypes;
  value: Scalars['String']['input'];
};

export enum TransferGroupSortOptions {
  createdAt = 'createdAt',
  timestampMax = 'timestampMax',
  timestampMin = 'timestampMin',
  type = 'type',
  updatedAt = 'updatedAt',
  value = 'value',
}

export type TransferGroupTableInput = {
  filterQuery?: InputMaybe<TransferGroupFilterQuery>;
  pagination?: InputMaybe<PaginationOptions>;
  sortBy: TransferGroupSortOptions;
  sortDirection: SortDirectionOptions;
};

export type TransferGroupTypeCount = {
  __typename?: 'TransferGroupTypeCount';
  count: Scalars['Int']['output'];
  type: EnumTransferGroupType;
};

export type TransferGroups = {
  __typename?: 'TransferGroups';
  csv?: Maybe<Scalars['String']['output']>;
  edges: Array<TransferGroup>;
  pageInfo: PageInfo;
};

export type TransferInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  currency: Scalars['String']['input'];
  direction: EnumTransferDirection;
  hash?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  price?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['String']['input'];
  tokenAddress?: InputMaybe<Scalars['String']['input']>;
  tokenId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumTransferType>;
};

export enum TransferType {
  borrowed = 'borrowed',
  bought = 'bought',
  bridgedIn = 'bridgedIn',
  bridgedOut = 'bridgedOut',
  earned = 'earned',
  lost = 'lost',
  lpContribution = 'lpContribution',
  lpDistribution = 'lpDistribution',
  lpReceived = 'lpReceived',
  lpWithdrawn = 'lpWithdrawn',
  minted = 'minted',
  paid = 'paid',
  received = 'received',
  repaid = 'repaid',
  sent = 'sent',
  sold = 'sold',
  spam = 'spam',
  spent = 'spent',
}

export type TransfersGroup = {
  __typename?: 'TransfersGroup';
  txns: Array<Maybe<SelfReconTransfer>>;
};

export type TransfersGroupInput = {
  txns: Array<InputMaybe<ReconTransferInput>>;
};

export type Treatment = {
  __typename?: 'Treatment';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  reconOrder?: Maybe<Scalars['Int']['output']>;
};

export type TreatmentGroupType = {
  __typename?: 'TreatmentGroupType';
  groupType?: Maybe<EnumTransferGroupType>;
  treatmentId: Scalars['Int']['output'];
};

export type TrelloCard = {
  __typename?: 'TrelloCard';
  boardName: Scalars['String']['output'];
  closed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  idBoard: Scalars['String']['output'];
  idList: Scalars['String']['output'];
  listName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type TrelloCards = {
  __typename?: 'TrelloCards';
  edges: Array<TrelloCard>;
};

export type TrelloJob = {
  __typename?: 'TrelloJob';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  jobType: EnumTrelloJobType;
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type TrelloJobs = {
  __typename?: 'TrelloJobs';
  edges: Array<TrelloJob>;
  pageInfo: PageInfo;
};

export type TrelloJobsTableInput = {
  pagination?: InputMaybe<PaginationOptions>;
};

export type TwoFactorSetup = {
  __typename?: 'TwoFactorSetup';
  manualEntryKey: Scalars['String']['output'];
  otpauthUrl: Scalars['String']['output'];
  qrCodeDataUrl: Scalars['String']['output'];
};

export type Txn = {
  __typename?: 'Txn';
  accountCredentialId?: Maybe<Scalars['Int']['output']>;
  accountId?: Maybe<Scalars['Int']['output']>;
  associatedExchangeAddress?: Maybe<Scalars['String']['output']>;
  bkpAccountCredit?: Maybe<BkpAccount>;
  bkpAccountCreditId?: Maybe<Scalars['Int']['output']>;
  bkpAccountDebit?: Maybe<BkpAccount>;
  bkpAccountDebitId?: Maybe<Scalars['Int']['output']>;
  bkpVendor?: Maybe<BkpVendor>;
  bkpVendorId?: Maybe<Scalars['Int']['output']>;
  blocksvcFromAddress?: Maybe<Scalars['String']['output']>;
  blocksvcHash?: Maybe<Scalars['String']['output']>;
  blocksvcMethodId?: Maybe<Scalars['String']['output']>;
  blocksvcProtocol?: Maybe<Scalars['String']['output']>;
  blocksvcToAddress?: Maybe<Scalars['String']['output']>;
  blocksvcWallet?: Maybe<Scalars['String']['output']>;
  buyAddress?: Maybe<Scalars['String']['output']>;
  buyCurrency: Scalars['String']['output'];
  buyNftId?: Maybe<Scalars['String']['output']>;
  buyPrice: Scalars['String']['output'];
  buyQuantity: Scalars['String']['output'];
  buyTokenId?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  credential: Credential;
  credentialId?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  editedByReconGuideJob: Scalars['Boolean']['output'];
  exchangeId?: Maybe<Scalars['String']['output']>;
  exchangeName?: Maybe<Scalars['String']['output']>;
  feeAddress?: Maybe<Scalars['String']['output']>;
  feeCurrency?: Maybe<Scalars['String']['output']>;
  feePrice: Scalars['String']['output'];
  feeQuantity?: Maybe<Scalars['Float']['output']>;
  feeTokenId?: Maybe<Scalars['String']['output']>;
  groupComponentType?: Maybe<TxnGroupComponentType>;
  groupId?: Maybe<Scalars['Int']['output']>;
  /** @deprecated This is only here to serve the version of the UI which fetches this prop for each transaction. The next version will who groups instead, and the UI will check group.type === "movement". */
  hasMovement?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  isEdited?: Maybe<Scalars['Boolean']['output']>;
  isPricingAnomaly: Scalars['Boolean']['output'];
  isSpam: Scalars['Boolean']['output'];
  lastUpdatedBy?: Maybe<Scalars['Int']['output']>;
  marginTrade?: Maybe<Scalars['Boolean']['output']>;
  priceFetchingSide?: Maybe<PriceFetchingSide>;
  quantity?: Maybe<Scalars['Float']['output']>;
  reconIdentifier?: Maybe<Scalars['String']['output']>;
  reviewed?: Maybe<Scalars['Boolean']['output']>;
  sellAddress?: Maybe<Scalars['String']['output']>;
  sellCurrency: Scalars['String']['output'];
  sellNftId?: Maybe<Scalars['String']['output']>;
  sellPrice: Scalars['String']['output'];
  sellQuantity: Scalars['String']['output'];
  sellTokenId?: Maybe<Scalars['String']['output']>;
  soldCurrency?: Maybe<Scalars['String']['output']>;
  soldQuantity?: Maybe<Scalars['Float']['output']>;
  specIdMatchesAsComponent: Array<SpecIdMatch>;
  specIdMatchesAsSell: Array<SpecIdMatch>;
  toAccountId?: Maybe<Scalars['Int']['output']>;
  toCredentialId?: Maybe<Scalars['Int']['output']>;
  transferTopicFingerprint?: Maybe<Scalars['String']['output']>;
  txnTimestamp: Scalars['DateTime']['output'];
  txnTopicFingerprint?: Maybe<Scalars['String']['output']>;
  txnType: TxnType;
  unitPrice?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  usdSpotPrice?: Maybe<Scalars['Float']['output']>;
  userId: Scalars['Int']['output'];
};

export type TxnAllowanceForYear = {
  __typename?: 'TxnAllowanceForYear';
  allowed: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
};

export type TxnCount = {
  __typename?: 'TxnCount';
  reviewedCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  txnImportTypeCounts: Array<TxnImportTypeCount>;
  txnOtherFiltersCounts: Array<TxnOtherFiltersCount>;
  txnTypeCounts: Array<TxnTypeCount>;
};

export type TxnCurrencyFilter = {
  operator: FilterOperatorTypes;
  side: CurrencyFilterTypes;
  symbols: Array<Scalars['String']['input']>;
};

export type TxnExchangeNameCount = {
  __typename?: 'TxnExchangeNameCount';
  counts: Array<ExchangeNameCount>;
  total: Scalars['Int']['output'];
  year: Scalars['String']['output'];
};

export type TxnFilterQuery = {
  accountCredits?: InputMaybe<MultiSelectIntFilter>;
  accountDebits?: InputMaybe<MultiSelectIntFilter>;
  accounts?: InputMaybe<MultiSelectIntFilter>;
  boolean?: InputMaybe<Array<BooleanFilter>>;
  currency?: InputMaybe<Array<TxnCurrencyFilter>>;
  date?: InputMaybe<DateRangeFilter>;
  description?: InputMaybe<Array<TxnSearchFilter>>;
  editedAt?: InputMaybe<DateRangeFilter>;
  fromAddress?: InputMaybe<Array<TxnSearchFilter>>;
  importType?: InputMaybe<MultiSelectStringFilter>;
  imports?: InputMaybe<MultiSelectIntFilter>;
  location?: InputMaybe<Array<TxnSearchFilter>>;
  methodId?: InputMaybe<Array<TxnSearchFilter>>;
  reconIdentifier?: InputMaybe<Array<TxnSearchFilter>>;
  specId?: InputMaybe<SpecIdFilter>;
  toAddress?: InputMaybe<Array<TxnSearchFilter>>;
  transferTopicFingerprint?: InputMaybe<Array<TxnSearchFilter>>;
  txnHash?: InputMaybe<Array<TxnSearchFilter>>;
  txnTopicFingerprint?: InputMaybe<Array<TxnSearchFilter>>;
  txnType?: InputMaybe<MultiSelectStringFilter>;
  vendors?: InputMaybe<MultiSelectIntFilter>;
};

export enum TxnGroupComponentType {
  deposit = 'deposit',
  income = 'income',
  movement = 'movement',
  spend = 'spend',
  withdrawal = 'withdrawal',
}

export type TxnImportTypeCount = {
  __typename?: 'TxnImportTypeCount';
  count: Scalars['Int']['output'];
  importType: Scalars['String']['output'];
};

export type TxnInput = {
  accountCredentialId?: InputMaybe<Scalars['Int']['input']>;
  accountId?: InputMaybe<Scalars['Int']['input']>;
  bkpAccountCreditId?: InputMaybe<Scalars['Int']['input']>;
  bkpAccountDebitId?: InputMaybe<Scalars['Int']['input']>;
  bkpVendorId?: InputMaybe<Scalars['Int']['input']>;
  buyAddress?: InputMaybe<Scalars['String']['input']>;
  buyCurrency: Scalars['String']['input'];
  buyPrice?: InputMaybe<Scalars['String']['input']>;
  buyQuantity: Scalars['String']['input'];
  buyTokenId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  feeCurrency?: InputMaybe<Scalars['String']['input']>;
  feePrice?: InputMaybe<Scalars['String']['input']>;
  feeQuantity?: InputMaybe<Scalars['String']['input']>;
  feeTokenId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isSpam?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  priceFetchingSide?: InputMaybe<PriceFetchingSide>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  sellAddress?: InputMaybe<Scalars['String']['input']>;
  sellCurrency: Scalars['String']['input'];
  sellPrice?: InputMaybe<Scalars['String']['input']>;
  sellQuantity: Scalars['String']['input'];
  sellTokenId?: InputMaybe<Scalars['String']['input']>;
  toAccountId?: InputMaybe<Scalars['Int']['input']>;
  toCredentialId?: InputMaybe<Scalars['Int']['input']>;
  txnTimestamp: Scalars['DateTime']['input'];
  txnType: TxnType;
};

export type TxnOtherFiltersCount = {
  __typename?: 'TxnOtherFiltersCount';
  count: Scalars['Int']['output'];
  type: OtherFilters;
};

export type TxnReport = {
  __typename?: 'TxnReport';
  costBasisFeeAdditionsLongTerm?: Maybe<Scalars['Float']['output']>;
  costBasisFeeAdditionsShortTerm?: Maybe<Scalars['Float']['output']>;
  costBasisLongTerm?: Maybe<Scalars['Float']['output']>;
  costBasisShortTerm?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  credential?: Maybe<Credential>;
  credentialId?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  enterpriseUserId?: Maybe<Scalars['Int']['output']>;
  exchangeCount?: Maybe<Scalars['Json']['output']>;
  extra?: Maybe<Scalars['Json']['output']>;
  fiatCurrency?: Maybe<Scalars['String']['output']>;
  gainLossIncludingFeesLongTerm?: Maybe<Scalars['Float']['output']>;
  gainLossIncludingFeesShortTerm?: Maybe<Scalars['Float']['output']>;
  gainLossLongTerm?: Maybe<Scalars['Float']['output']>;
  gainLossShortTerm?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  isMargin?: Maybe<Scalars['Boolean']['output']>;
  jobErrorMessage?: Maybe<Scalars['String']['output']>;
  jobProgress?: Maybe<Scalars['Int']['output']>;
  jobStatus?: Maybe<Scalars['String']['output']>;
  likeKind?: Maybe<Scalars['Boolean']['output']>;
  lineItems: Array<LineItem>;
  method: Scalars['String']['output'];
  miningIncome?: Maybe<Scalars['Float']['output']>;
  month?: Maybe<EnumTxnReportMonth>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']['output']>;
  proceedsFeeDeductionsLongTerm?: Maybe<Scalars['Float']['output']>;
  proceedsFeeDeductionsShortTerm?: Maybe<Scalars['Float']['output']>;
  proceedsLongTerm?: Maybe<Scalars['Float']['output']>;
  proceedsShortTerm?: Maybe<Scalars['Float']['output']>;
  reportType?: Maybe<Scalars['String']['output']>;
  reports: Array<Report>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  taxMethod: TaxMethod;
  txnCount?: Maybe<Scalars['Int']['output']>;
  txnReportJob?: Maybe<TxnReportJob>;
  txnReportJobId?: Maybe<Scalars['Int']['output']>;
  txnReportTxnReportJobs: Array<TxnReportTxnReportJob>;
  unsoldBuySequence?: Maybe<UnsoldBuySequence>;
  unsoldBuys: Array<UnsoldBuy>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  userTaxDetail?: Maybe<UserTaxDetail>;
  userTaxDetailId: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type TxnReportJob = {
  __typename?: 'TxnReportJob';
  createdAt: Scalars['DateTime']['output'];
  credential?: Maybe<Credential>;
  credentialId?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  enterpriseUserId?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  exchangeCount?: Maybe<Scalars['Json']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  includesDailyUnsoldBuyReport?: Maybe<Scalars['Boolean']['output']>;
  isV2DataModel: Scalars['Boolean']['output'];
  jobStatus: TxnReportJobStatus;
  status?: Maybe<Scalars['String']['output']>;
  txnCount?: Maybe<Scalars['Int']['output']>;
  txnReportTxnReportJobs: Array<TxnReportTxnReportJob>;
  txnReports: Array<TxnReport>;
  unsoldBuySequences: Array<UnsoldBuySequence>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  v2TransitionProgress?: Maybe<EnumGenericJobStatus>;
};

export enum TxnReportJobStatus {
  completed = 'completed',
  created = 'created',
  failed = 'failed',
}

export type TxnReportTxnReportJob = {
  __typename?: 'TxnReportTxnReportJob';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  txnReport: TxnReport;
  txnReportId: Scalars['Int']['output'];
  txnReportJob: TxnReportJob;
  txnReportJobId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TxnReportValues = {
  __typename?: 'TxnReportValues';
  gainLoss: Scalars['Float']['output'];
  income: Scalars['Float']['output'];
  longTermGainLoss: Scalars['Float']['output'];
  shortTermGainLoss: Scalars['Float']['output'];
  taxLiability: Scalars['Float']['output'];
};

export type TxnSearchFilter = {
  key: TxnSearchFilterKeys;
  operator: FilterOperatorTypes;
  value: Scalars['String']['input'];
};

export enum TxnSearchFilterKeys {
  description = 'description',
  fromAddress = 'fromAddress',
  location = 'location',
  methodId = 'methodId',
  reconIdentifier = 'reconIdentifier',
  toAddress = 'toAddress',
  transferTopicFingerprint = 'transferTopicFingerprint',
  txnHash = 'txnHash',
  txnTopicFingerprint = 'txnTopicFingerprint',
}

export enum TxnSortOptions {
  blocksvcHash = 'blocksvcHash',
  blocksvcMethodId = 'blocksvcMethodId',
  blocksvcToAddress = 'blocksvcToAddress',
  credentialName = 'credentialName',
  currency = 'currency',
  description = 'description',
  exchangeName = 'exchangeName',
  feeCurrency = 'feeCurrency',
  feePrice = 'feePrice',
  feeQuantity = 'feeQuantity',
  quantity = 'quantity',
  reconIdentifier = 'reconIdentifier',
  soldCurrency = 'soldCurrency',
  soldQuantity = 'soldQuantity',
  transferTopicFingerprint = 'transferTopicFingerprint',
  txnTimestamp = 'txnTimestamp',
  txnTopicFingerprint = 'txnTopicFingerprint',
  txnType = 'txnType',
  unitPrice = 'unitPrice',
  updatedAt = 'updatedAt',
  usdSpotPrice = 'usdSpotPrice',
}

export type TxnTableInput = {
  filterQuery?: InputMaybe<TxnFilterQuery>;
  pagination?: InputMaybe<PaginationOptions>;
  sortBy: TxnSortOptions;
  sortDirection: SortDirectionOptions;
};

export enum TxnType {
  airdrop = 'airdrop',
  borrow = 'borrow',
  deposit = 'deposit',
  fork = 'fork',
  gift = 'gift',
  income = 'income',
  lost = 'lost',
  migration = 'migration',
  mining = 'mining',
  movement = 'movement',
  repay = 'repay',
  spend = 'spend',
  staking = 'staking',
  stolen = 'stolen',
  trade = 'trade',
  withdrawal = 'withdrawal',
}

export type TxnTypeCount = {
  __typename?: 'TxnTypeCount';
  count: Scalars['Int']['output'];
  type: TxnType;
};

export type Txns = {
  __typename?: 'Txns';
  csv?: Maybe<Scalars['String']['output']>;
  edges: Array<Txn>;
  pageInfo: PageInfo;
};

export type UnreconciledTransaction = {
  __typename?: 'UnreconciledTransaction';
  contractPublicName?: Maybe<Scalars['String']['output']>;
  credentials: Array<UnreconciledTxnCredential>;
  ecosystem: SupportedEcosystem;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  hash: Scalars['String']['output'];
  id: Scalars['String']['output'];
  instruction?: Maybe<Instruction>;
  invalidated: Scalars['Boolean']['output'];
  method: UnreconciledTransactionMethod;
  receivedTxnsCount: Scalars['Int']['output'];
  reconIdentifier?: Maybe<Scalars['String']['output']>;
  resolutionCategory?: Maybe<Scalars['String']['output']>;
  resolutionId?: Maybe<Scalars['Int']['output']>;
  resolved: Scalars['Boolean']['output'];
  sentTxnsCount: Scalars['Int']['output'];
  timestamp: Scalars['DateTime']['output'];
  to?: Maybe<Scalars['String']['output']>;
  transfers?: Maybe<Array<TransferData>>;
};

export type UnreconciledTransactionInput = {
  blocksvcHash: Scalars['String']['input'];
  category: CategoryInput;
  credentialType: Scalars['String']['input'];
  drafts: Array<DraftInput>;
  edited: Scalars['Boolean']['input'];
};

export type UnreconciledTransactionMethod = {
  __typename?: 'UnreconciledTransactionMethod';
  hash: Scalars['String']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type UnreconciledTransactionResolution = {
  __typename?: 'UnreconciledTransactionResolution';
  appliedAt: Scalars['DateTime']['output'];
  blocksvcHash: Scalars['String']['output'];
  category: Scalars['String']['output'];
  credentialType: Scalars['String']['output'];
  drafts: Array<Draft>;
  edited: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  invalidatedAt?: Maybe<Scalars['DateTime']['output']>;
  revertedAt?: Maybe<Scalars['DateTime']['output']>;
  unreconciledTransactionId: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type UnreconciledTransactions = {
  __typename?: 'UnreconciledTransactions';
  edges: Array<UnreconciledTransaction>;
  pageInfo: PageInfo;
};

export enum UnreconciledTransactionsSortOptions {
  credential = 'credential',
  editedAt = 'editedAt',
  hash = 'hash',
  priority = 'priority',
  status = 'status',
  timestamp = 'timestamp',
  wallet = 'wallet',
}

export type UnreconciledTransactionsTableInput = {
  filterQuery?: InputMaybe<UnreconciledTxnsFiltersQuery>;
  pagination?: InputMaybe<PaginationOptions>;
  sortBy: UnreconciledTransactionsSortOptions;
  sortDirection: SortDirectionOptions;
};

export type UnreconciledTxnCredential = {
  __typename?: 'UnreconciledTxnCredential';
  address?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  source: CredentialSource;
  type: Scalars['String']['output'];
};

export type UnreconciledTxnsData = {
  __typename?: 'UnreconciledTxnsData';
  ecosystem: SupportedEcosystem;
  txnHash: Scalars['String']['output'];
  txns: Array<Txn>;
};

export type UnreconciledTxnsFiltersQuery = {
  date?: InputMaybe<DateRangeFilter>;
  imports?: InputMaybe<MultiSelectIntFilter>;
  status?: InputMaybe<MultiSelectStringFilter>;
};

export type UnsoldBuy = {
  __typename?: 'UnsoldBuy';
  buyDate: Scalars['DateTime']['output'];
  buyId: Scalars['String']['output'];
  coefficientPercent?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['BigInt']['output'];
  txn: Txn;
  txnReport?: Maybe<TxnReport>;
  txnReportId?: Maybe<Scalars['Int']['output']>;
  unitsRemaining: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  usdEquivalentRemaining: Scalars['Float']['output'];
};

export type UnsoldBuyReport = {
  __typename?: 'UnsoldBuyReport';
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  unsoldBuySequence?: Maybe<UnsoldBuySequence>;
  unsoldBuySequenceId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type UnsoldBuySequence = {
  __typename?: 'UnsoldBuySequence';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  marginTradeAccount?: Maybe<Scalars['Boolean']['output']>;
  method: Scalars['String']['output'];
  txnReport: TxnReport;
  txnReportId: Scalars['Int']['output'];
  txnReportJob: TxnReportJob;
  txnReportJobId: Scalars['Int']['output'];
  unsoldBuyReports: Array<UnsoldBuyReport>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UnsupportedKnownCsv = {
  __typename?: 'UnsupportedKnownCsv';
  exchange: Scalars['String']['output'];
  expectedFile: Scalars['String']['output'];
  link?: Maybe<Link>;
  message: Scalars['String']['output'];
};

export type UpdateTaxDetailsInput = {
  calculateAsMargin?: InputMaybe<Scalars['Boolean']['input']>;
  fullFilingPlan?: InputMaybe<Scalars['String']['input']>;
  isEngaged?: InputMaybe<Scalars['Boolean']['input']>;
  likeKind?: InputMaybe<Scalars['Boolean']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
  taxYear: Scalars['Int']['input'];
  useHoursMinsComparison?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTransferGroupInput = {
  bkpAccountCreditId?: InputMaybe<Scalars['Int']['input']>;
  bkpAccountDebitId?: InputMaybe<Scalars['Int']['input']>;
  bkpVendorId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['String']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  reviewed?: InputMaybe<Scalars['Boolean']['input']>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  transfers: Array<TransferInput>;
  type?: InputMaybe<EnumTransferGroupType>;
};

export type UpdateVersionResponse = {
  __typename?: 'UpdateVersionResponse';
  items: Array<Version>;
};

export type UpdatedCredential = {
  __typename?: 'UpdatedCredential';
  credential: Credential;
  exchangeServiceRequest?: Maybe<ExchangeServiceRequest>;
};

export type UpdatedCredentials = {
  __typename?: 'UpdatedCredentials';
  count: Scalars['Int']['output'];
  credentials: Array<Credential>;
};

export type UpdatedTransferGroupsResponse = {
  __typename?: 'UpdatedTransferGroupsResponse';
  count: Scalars['Int']['output'];
  groupIds?: Maybe<Array<Scalars['String']['output']>>;
  transferGroups: Array<TransferGroup>;
};

export type UpdatedTxnResponse = {
  __typename?: 'UpdatedTxnResponse';
  count: Scalars['Int']['output'];
  errors: Array<FailedTransactionUpdate>;
  updatedTxns: Array<Txn>;
};

export type Upload = {
  __typename?: 'Upload';
  createdAt: Scalars['DateTime']['output'];
  credential?: Maybe<Credential>;
  credentialId?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isHidden: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uploadType?: Maybe<Scalars['String']['output']>;
  /** Email of the original uploader, when retained import history identifies them. */
  uploadedByEmail?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UploadFilterQuery = {
  /** Filter by upload date, including both endpoints. */
  date?: InputMaybe<DateRangeFilter>;
};

export enum UploadSortOptions {
  createdAt = 'createdAt',
  name = 'name',
}

export type UploadTableInput = {
  filterQuery?: InputMaybe<UploadFilterQuery>;
  pagination?: InputMaybe<PaginationOptions>;
  sortBy: UploadSortOptions;
  sortDirection: SortDirectionOptions;
};

export type UploadUrlData = {
  __typename?: 'UploadUrlData';
  Bucket: Scalars['String']['output'];
  Key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Uploads = {
  __typename?: 'Uploads';
  csv?: Maybe<Scalars['String']['output']>;
  edges: Array<Upload>;
  pageInfo: PageInfo;
};

export type User = {
  __typename?: 'User';
  accountYears: Array<Scalars['Int']['output']>;
  airtableId?: Maybe<Scalars['String']['output']>;
  blocked: Scalars['Boolean']['output'];
  businessUser?: Maybe<Scalars['Boolean']['output']>;
  clonedUser?: Maybe<User>;
  clones?: Maybe<Array<User>>;
  createdAt: Scalars['DateTime']['output'];
  customerId?: Maybe<Scalars['String']['output']>;
  dataModelV2UpgradeState?: Maybe<EnumDataModelV2UpgradeState>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  emailVerified: Scalars['Boolean']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  hideSpam: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  includeFees?: Maybe<Scalars['Boolean']['output']>;
  isTest?: Maybe<Scalars['Boolean']['output']>;
  lastMadeEditsAt?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastSuccessfulCharge?: Maybe<Scalars['DateTime']['output']>;
  lockedThroughYear?: Maybe<Scalars['Int']['output']>;
  lockedTilDate?: Maybe<Scalars['DateTime']['output']>;
  loginCount?: Maybe<Scalars['Int']['output']>;
  marginTradeAccount?: Maybe<Scalars['Boolean']['output']>;
  minimizationForAllYears?: Maybe<Scalars['Boolean']['output']>;
  orgDemoUser?: Maybe<Scalars['Boolean']['output']>;
  orgRoles: Array<UserOrgRole>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<Scalars['String']['output']>;
  recalcByAccount?: Maybe<Scalars['Boolean']['output']>;
  recalcByAccountStartYear?: Maybe<Scalars['Int']['output']>;
  reconMode?: Maybe<Scalars['Boolean']['output']>;
  referredBy?: Maybe<Scalars['Int']['output']>;
  resetPasswordExpires?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Always null. The token is only ever sent by email. */
  resetPasswordToken?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  secretMode?: Maybe<Scalars['Boolean']['output']>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  taxDetails: Array<UserTaxDetail>;
  twoFactorEnabled: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  useHoursMinsComparison?: Maybe<Scalars['Boolean']['output']>;
  usesGroupsSince?: Maybe<Scalars['DateTime']['output']>;
  v2TransitionProgress?: Maybe<EnumGenericJobStatus>;
};

export type UserOrgRole = {
  __typename?: 'UserOrgRole';
  createdAt: Scalars['DateTime']['output'];
  organization: Organization;
  organizationId: Scalars['Int']['output'];
  role: Role;
  roleId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['Int']['output'];
};

export type UserProfileData = {
  __typename?: 'UserProfileData';
  data: Scalars['Json']['output'];
  touchedSections: Array<Scalars['String']['output']>;
};

export type UserProfileInputData = {
  data: Scalars['Json']['input'];
  touchedSections: Array<Scalars['String']['input']>;
};

export type UserTaxDetail = {
  __typename?: 'UserTaxDetail';
  addons: Array<UserTaxDetailAddon>;
  baseCurrency?: Maybe<Scalars['String']['output']>;
  calculateAsMargin?: Maybe<Scalars['Boolean']['output']>;
  country: Country;
  countryId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  dateRange?: Maybe<DateRange>;
  filingStatus?: Maybe<Scalars['String']['output']>;
  fullFilingPlan?: Maybe<Scalars['String']['output']>;
  grossIncome?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  isEngaged: Scalars['Boolean']['output'];
  likeKind?: Maybe<Scalars['Boolean']['output']>;
  longTermCapitalGainsRate?: Maybe<Scalars['Float']['output']>;
  marginalTaxRate?: Maybe<Scalars['Float']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  needsFbar?: Maybe<Scalars['Boolean']['output']>;
  plan?: Maybe<Scalars['String']['output']>;
  setFilingMethodSkipped?: Maybe<Scalars['Boolean']['output']>;
  skipped?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  taxMethod?: Maybe<TaxMethod>;
  taxYear: Scalars['Int']['output'];
  ukBnbRule?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  useHoursMinsComparison?: Maybe<Scalars['Boolean']['output']>;
  userId: Scalars['Int']['output'];
};

export type UserTaxDetailAddon = {
  __typename?: 'UserTaxDetailAddon';
  addon: Addon;
  addonId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userTaxDetail: UserTaxDetail;
  userTaxDetailId: Scalars['Int']['output'];
};

export type UserTaxMethods = {
  __typename?: 'UserTaxMethods';
  methods: Array<TaxMethod>;
};

export type ValidatedMissingWallets = {
  __typename?: 'ValidatedMissingWallets';
  edges: Array<MissingWalletWithTxnValidation>;
};

export type Version = {
  __typename?: 'Version';
  adminNotes?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isComplete: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  txnReportDataAverageCost?: Maybe<Scalars['Json']['output']>;
  txnReportDataFifo?: Maybe<Scalars['Json']['output']>;
  txnReportDataLifo?: Maybe<Scalars['Json']['output']>;
  txnReportDataMinimization?: Maybe<Scalars['Json']['output']>;
  txnReportDataMinimizationV2?: Maybe<Scalars['Json']['output']>;
  txnReportJobId?: Maybe<Scalars['Int']['output']>;
};

export enum VersionJobType {
  restore = 'restore',
  save = 'save',
}

export type VersionsResponse = {
  __typename?: 'VersionsResponse';
  items: Array<Version>;
  status: VersionsStatus;
};

export type VersionsStatus = {
  __typename?: 'VersionsStatus';
  isRestoringVersion: Scalars['Boolean']['output'];
  isSavingCurrentVersion: Scalars['Boolean']['output'];
  lastRestoredAt?: Maybe<Scalars['DateTime']['output']>;
  latestStatus?: Maybe<EnumGenericJobStatus>;
  latestType?: Maybe<VersionJobType>;
  restoredVersionNumber?: Maybe<Scalars['Int']['output']>;
};

export type WalletLookupCredential = {
  __typename?: 'WalletLookupCredential';
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  integrationId?: Maybe<Scalars['String']['output']>;
};

export type WalletLookupUser = {
  __typename?: 'WalletLookupUser';
  credentials: Array<WalletLookupCredential>;
  email: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type WalletTxnCount = {
  __typename?: 'WalletTxnCount';
  address: Scalars['String']['output'];
  chain: Scalars['String']['output'];
  count?: Maybe<Scalars['Int']['output']>;
  earliestTxnDate?: Maybe<Scalars['String']['output']>;
  latestTxnDate?: Maybe<Scalars['String']['output']>;
};

export type WalletTxnCountInput = {
  address: Scalars['String']['input'];
  chain: Scalars['String']['input'];
};

export type Workpaper = {
  __typename?: 'Workpaper';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['Int']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  includeReviewed: Scalars['Boolean']['output'];
  includeSpam: Scalars['Boolean']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: EnumGenericJobStatus;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['Int']['output'];
};

export type WorkpaperEcosystemCount = {
  __typename?: 'WorkpaperEcosystemCount';
  count: Scalars['Int']['output'];
  ecosystem?: Maybe<Scalars['String']['output']>;
};

export type WorkpaperFilterQuery = {
  contract?: InputMaybe<Array<WorkpaperSearchFilter>>;
  ecosystem?: InputMaybe<WorkpaperMultiSelectFilter>;
  hideCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Array<WorkpaperSearchFilter>>;
  location?: InputMaybe<Array<WorkpaperSearchFilter>>;
  methodId?: InputMaybe<Array<WorkpaperSearchFilter>>;
  notes?: InputMaybe<Array<WorkpaperSearchFilter>>;
  treatmentName?: InputMaybe<WorkpaperMultiSelectFilter>;
};

export type WorkpaperMultiSelectFilter = {
  operator: FilterOperatorTypes;
  values: Array<Scalars['String']['input']>;
};

export type WorkpaperRow = {
  __typename?: 'WorkpaperRow';
  completed: Scalars['Boolean']['output'];
  contract?: Maybe<Scalars['String']['output']>;
  count: Scalars['Int']['output'];
  credentialIds: Array<Scalars['Int']['output']>;
  earliestTxnTimestamp: Scalars['DateTime']['output'];
  ecosystem?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  integrationId?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  latestTxnTimestamp: Scalars['DateTime']['output'];
  location: Scalars['String']['output'];
  methodId?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  reconIdentifier?: Maybe<Scalars['String']['output']>;
  treatmentName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: Scalars['Int']['output'];
  workpaperId: Scalars['String']['output'];
};

export type WorkpaperRowTableInput = {
  filterQuery?: InputMaybe<WorkpaperFilterQuery>;
  pagination?: InputMaybe<PaginationOptions>;
  sortBy: WorkpaperSortOptions;
  sortDirection: SortDirectionOptions;
};

export type WorkpaperRows = {
  __typename?: 'WorkpaperRows';
  ecosystemCounts: Array<WorkpaperEcosystemCount>;
  edges: Array<WorkpaperRow>;
  pageInfo: PageInfo;
  treatmentCounts: Array<WorkpaperTreatmentCount>;
};

export type WorkpaperSearchFilter = {
  operator: FilterOperatorTypes;
  value: Scalars['String']['input'];
};

export enum WorkpaperSearchFilterKeys {
  contract = 'contract',
  key = 'key',
  location = 'location',
  methodId = 'methodId',
  notes = 'notes',
}

export enum WorkpaperSortOptions {
  count = 'count',
  earliestTxnTimestamp = 'earliestTxnTimestamp',
  ecosystem = 'ecosystem',
  key = 'key',
  latestTxnTimestamp = 'latestTxnTimestamp',
  location = 'location',
  treatmentName = 'treatmentName',
}

export type WorkpaperTreatmentCount = {
  __typename?: 'WorkpaperTreatmentCount';
  count: Scalars['Int']['output'];
  treatmentName?: Maybe<Scalars['String']['output']>;
};

export type YearCount = {
  __typename?: 'YearCount';
  count: Scalars['Int']['output'];
  taxYear: Scalars['String']['output'];
};

export type CloneUserJob = {
  __typename?: 'cloneUserJob';
  cloneId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  sourceId: Scalars['Int']['output'];
  status: EnumGenericJobStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IsPasswordResetTokenValidQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;

export type IsPasswordResetTokenValidQuery = { __typename?: 'Query'; isPasswordResetTokenValid: boolean };

export type ActivateAccountMutationVariables = Exact<{
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;

export type ActivateAccountMutation = {
  __typename?: 'Mutation';
  activateAccount: {
    __typename?: 'LoginOrSignupResponse';
    userHash: string;
    user: { __typename?: 'User'; id: number };
  };
};

export type ActivatePlanFromCheckoutMutationVariables = Exact<{
  checkoutSessionId: Scalars['String']['input'];
  attributionSource?: InputMaybe<Scalars['String']['input']>;
  attributionMedium?: InputMaybe<Scalars['String']['input']>;
  attributionCampaign?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  gbraid?: InputMaybe<Scalars['String']['input']>;
  wbraid?: InputMaybe<Scalars['String']['input']>;
  fbclid?: InputMaybe<Scalars['String']['input']>;
  marketingAnonymousId?: InputMaybe<Scalars['String']['input']>;
}>;

export type ActivatePlanFromCheckoutMutation = {
  __typename?: 'Mutation';
  activatePlanFromCheckout: { __typename?: 'PlanActivationData'; plan: string; year: number; price: number };
};

export type RetrieveCheckoutQueryVariables = Exact<{
  checkoutSessionId: Scalars['String']['input'];
}>;

export type RetrieveCheckoutQuery = {
  __typename?: 'Query';
  retrieveCheckout?: {
    __typename?: 'CheckoutSession';
    email: string;
    activated: boolean;
    plan: string;
    emailHasMatchingAccount: boolean;
    amountTotal: number;
    userId?: number | null;
    paymentIntentId?: string | null;
    invoiceId?: string | null;
    paymentCompleted: boolean;
  } | null;
};

export type LockUserMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
  lockedThroughYear?: InputMaybe<Scalars['Int']['input']>;
}>;

export type LockUserMutation = {
  __typename?: 'Mutation';
  lockUser: { __typename?: 'User'; id: number; lockedThroughYear?: number | null };
};

export type GetUserInfoQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;

export type GetUserInfoQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'User';
    id: number;
    accountYears: Array<number>;
    airtableId?: string | null;
    blocked: boolean;
    createdAt: any;
    customerId?: string | null;
    deletedAt?: any | null;
    email: string;
    emailVerified: boolean;
    firstName?: string | null;
    includeFees?: boolean | null;
    secretMode?: boolean | null;
    isTest?: boolean | null;
    businessUser?: boolean | null;
    lastName?: string | null;
    lastSuccessfulCharge?: any | null;
    lockedTilDate?: any | null;
    lockedThroughYear?: number | null;
    loginCount?: number | null;
    marginTradeAccount?: boolean | null;
    minimizationForAllYears?: boolean | null;
    orgDemoUser?: boolean | null;
    organizationId?: number | null;
    phone?: string | null;
    plan?: string | null;
    recalcByAccount?: boolean | null;
    recalcByAccountStartYear?: number | null;
    reconMode?: boolean | null;
    hideSpam: boolean;
    resetPasswordExpires?: any | null;
    role?: string | null;
    subscriptionId?: string | null;
    twoFactorEnabled: boolean;
    updatedAt: any;
    useHoursMinsComparison?: boolean | null;
    lastMadeEditsAt?: any | null;
    usesGroupsSince?: any | null;
    dataModelV2UpgradeState?: EnumDataModelV2UpgradeState | null;
    v2TransitionProgress?: EnumGenericJobStatus | null;
    clonedUser?: { __typename?: 'User'; id: number; email: string } | null;
    clones?: Array<{ __typename?: 'User'; id: number; email: string; createdAt: any }> | null;
    orgRoles: Array<{
      __typename?: 'UserOrgRole';
      userId: number;
      roleId: number;
      organizationId: number;
      createdAt: any;
      updatedAt: any;
      organization: {
        __typename?: 'Organization';
        id: number;
        name?: string | null;
        slug?: string | null;
        status?: EnumOrganizationStatus | null;
        includeDemoUser?: boolean | null;
        discount?: number | null;
        logo?: string | null;
        colorPrimary?: string | null;
        colorSecondary?: string | null;
        colorLink?: string | null;
        createdAt: any;
        updatedAt: any;
        deletedAt?: any | null;
      };
      role: { __typename?: 'Role'; name: string };
    }>;
    taxDetails: Array<{
      __typename?: 'UserTaxDetail';
      id: number;
      baseCurrency?: string | null;
      calculateAsMargin?: boolean | null;
      createdAt: any;
      filingStatus?: string | null;
      fullFilingPlan?: string | null;
      grossIncome?: number | null;
      likeKind?: boolean | null;
      longTermCapitalGainsRate?: number | null;
      marginalTaxRate?: number | null;
      method?: string | null;
      needsFbar?: boolean | null;
      plan?: string | null;
      setFilingMethodSkipped?: boolean | null;
      skipped?: boolean | null;
      state?: string | null;
      taxYear: number;
      ukBnbRule?: boolean | null;
      updatedAt: any;
      useHoursMinsComparison?: boolean | null;
      userId: number;
      isEngaged: boolean;
      addons: Array<{
        __typename?: 'UserTaxDetailAddon';
        id: number;
        addon: {
          __typename?: 'Addon';
          createdAt: any;
          displayName: string;
          price?: number | null;
          product: string;
          sku: string;
          updatedAt: any;
        };
      }>;
      country: {
        __typename?: 'Country';
        id: number;
        endDateDay: number;
        endDateMonth: number;
        name: string;
        shorthand: string;
        methods: Array<string>;
        startDateDay: number;
        startDateMonth: number;
        taxMethods: Array<{ __typename?: 'TaxMethod'; id: EnumTaxMethod; label: string }>;
      };
      dateRange?: { __typename?: 'DateRange'; startDate: string; endDate: string } | null;
      taxMethod?: { __typename?: 'TaxMethod'; id: EnumTaxMethod; label: string } | null;
    }>;
  } | null;
};

export type ExchangeServiceApiErrorsQueryVariables = Exact<{
  exchangeServiceApiErrorsTableInput: ExchangeServiceApiErrorsTableInput;
}>;

export type ExchangeServiceApiErrorsQuery = {
  __typename?: 'Query';
  exchangeServiceApiErrors: {
    __typename?: 'ExchangeServiceApiErrors';
    credentialIds: Array<number>;
    edges: Array<{
      __typename?: 'ExchangeServiceApiError';
      exchangeServiceRequestId: number;
      email: string;
      userId: number;
      address?: string | null;
      createdAt: any;
      errorMessage?: string | null;
      importName?: string | null;
      integration?: string | null;
      credentialId: number;
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNext?: boolean | null;
      filteredCount?: number | null;
      totalCount?: number | null;
      totalPages?: number | null;
    };
  };
};

export type BlockUserMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
  block: Scalars['Boolean']['input'];
}>;

export type BlockUserMutation = {
  __typename?: 'Mutation';
  blockUser: { __typename?: 'User'; id: number; blocked: boolean };
};

export type CountriesQueryVariables = Exact<{ [key: string]: never }>;

export type CountriesQuery = {
  __typename?: 'Query';
  countries: Array<{ __typename?: 'Country'; id: number; name: string; shorthand: string }>;
};

export type BulkCreateUsersMutationVariables = Exact<{
  usernames: Array<Scalars['String']['input']> | Scalars['String']['input'];
  password: Scalars['String']['input'];
  cryptoOnlyPlan?: InputMaybe<Scalars['String']['input']>;
  fullFilingPlan?: InputMaybe<Scalars['String']['input']>;
  countryId: Scalars['Int']['input'];
  useDataModelV1?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type BulkCreateUsersMutation = { __typename?: 'Mutation'; bulkCreateUsers: boolean };

export type OpenAiResponseQueryVariables = Exact<{
  responseId: Scalars['String']['input'];
}>;

export type OpenAiResponseQuery = {
  __typename?: 'Query';
  openAIResponse: {
    __typename?: 'OpenAIResponse';
    userId: number;
    email: string;
    featureType: FeatureType;
    response: {
      __typename?: 'ResponseDetails';
      id: string;
      created_at: any;
      instructions?: any | null;
      previous_response_id?: string | null;
      output: Array<{
        __typename?: 'OpenAIResponseOutput';
        type: string;
        id: string;
        status: string;
        content?: {
          __typename?: 'OpenAIResponseOutputContent';
          type: string;
          text?: string | null;
          annotations?: any | null;
        } | null;
      }>;
    };
  };
};

export type CsvsInReviewQueryVariables = Exact<{
  csvTableInput: CsvsInReviewTableInput;
}>;

export type CsvsInReviewQuery = {
  __typename?: 'Query';
  csvsInReview: {
    __typename?: 'CsvsInReview';
    edges: Array<{
      __typename?: 'CsvInReview';
      exchangeServiceRequestId: number;
      email: string;
      userId: number;
      uploadUrl?: string | null;
      uploadName: string;
      uploadedAt: any;
      slackUrl?: string | null;
      linearIssueUrl?: string | null;
      isMargin: boolean;
      isUrgent: boolean;
      errorMessage?: string | null;
      parser?: string | null;
      importName?: string | null;
      integration?: string | null;
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNext?: boolean | null;
      filteredCount?: number | null;
      totalCount?: number | null;
      totalPages?: number | null;
    };
  };
};

export type UpdateCsvLabelsMutationVariables = Exact<{
  exchangeServiceRequestId: Scalars['Int']['input'];
  isMargin: Scalars['Boolean']['input'];
  isUrgent: Scalars['Boolean']['input'];
}>;

export type UpdateCsvLabelsMutation = { __typename?: 'Mutation'; updateCsvLabels: boolean };

export type RetryCsvImportMutationVariables = Exact<{
  exchangeServiceRequestId: Scalars['Int']['input'];
}>;

export type RetryCsvImportMutation = { __typename?: 'Mutation'; retryCsvImport: boolean };

export type CommentsQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;

export type CommentsQuery = {
  __typename?: 'Query';
  comments: Array<{
    __typename?: 'Comment';
    id: number;
    userId: number;
    userIdTopic: number;
    content: string;
    createdAt: any;
    updatedAt: any;
    isPrivate: boolean;
    author: { __typename?: 'User'; id: number; email: string };
  }>;
};

export type AddCommentMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
  content: Scalars['String']['input'];
  isPrivate: Scalars['Boolean']['input'];
}>;

export type AddCommentMutation = { __typename?: 'Mutation'; addComment: boolean };

export type UpdateCommentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  content: Scalars['String']['input'];
  isPrivate: Scalars['Boolean']['input'];
}>;

export type UpdateCommentMutation = { __typename?: 'Mutation'; updateComment: boolean };

export type DeleteCommentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type DeleteCommentMutation = { __typename?: 'Mutation'; deleteComment: boolean };

export type StripeDisputeFieldsFragment = {
  __typename?: 'StripeDispute';
  id: number;
  disputeId: string;
  chargeId?: string | null;
  paymentIntentId?: string | null;
  invoiceId?: string | null;
  stripeCustomerId?: string | null;
  userId?: number | null;
  email?: string | null;
  amount: number;
  currency: string;
  reason?: string | null;
  status: string;
  evidenceState: string;
  evidenceSubmittedAt?: any | null;
  evidenceRegeneratedAt?: any | null;
  evidenceDueBy?: any | null;
  evidenceJson?: any | null;
  evidenceError?: string | null;
  receiptUrl?: string | null;
  receiptDownloadUrl?: string | null;
  serviceDocumentationUrl?: string | null;
  serviceDocumentationDownloadUrl?: string | null;
  outcome?: string | null;
  outcomeReason?: string | null;
  resolvedAt?: any | null;
  stripeCreatedAt?: any | null;
  lastSyncedAt?: any | null;
  stripeDashboardUrl: string;
};

export type StripeDisputesDashboardQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;

export type StripeDisputesDashboardQuery = {
  __typename?: 'Query';
  stripeDisputeStats: {
    __typename?: 'StripeDisputeStats';
    totalCount: number;
    pendingCount: number;
    wonCount: number;
    lostCount: number;
    last30DaysCount: number;
    last30DaysAmount: number;
    last12MonthsCount: number;
    last12MonthsAmount: number;
    totalDisputedAmount: number;
  };
  stripeDisputeSyncCache?: {
    __typename?: 'StripeDisputeSyncCache';
    syncedAt: string;
    totalDisputes: number;
    submittedCount: number;
    failedCount: number;
    errors: any;
  } | null;
  stripeDisputes: {
    __typename?: 'StripeDisputeList';
    totalCount: number;
    edges: Array<{
      __typename?: 'StripeDispute';
      id: number;
      disputeId: string;
      chargeId?: string | null;
      paymentIntentId?: string | null;
      invoiceId?: string | null;
      stripeCustomerId?: string | null;
      userId?: number | null;
      email?: string | null;
      amount: number;
      currency: string;
      reason?: string | null;
      status: string;
      evidenceState: string;
      evidenceSubmittedAt?: any | null;
      evidenceRegeneratedAt?: any | null;
      evidenceDueBy?: any | null;
      evidenceJson?: any | null;
      evidenceError?: string | null;
      receiptUrl?: string | null;
      receiptDownloadUrl?: string | null;
      serviceDocumentationUrl?: string | null;
      serviceDocumentationDownloadUrl?: string | null;
      outcome?: string | null;
      outcomeReason?: string | null;
      resolvedAt?: any | null;
      stripeCreatedAt?: any | null;
      lastSyncedAt?: any | null;
      stripeDashboardUrl: string;
    }>;
  };
};

export type StripeDisputeDetailQueryVariables = Exact<{
  disputeId: Scalars['String']['input'];
}>;

export type StripeDisputeDetailQuery = {
  __typename?: 'Query';
  stripeDispute?: {
    __typename?: 'StripeDispute';
    id: number;
    disputeId: string;
    chargeId?: string | null;
    paymentIntentId?: string | null;
    invoiceId?: string | null;
    stripeCustomerId?: string | null;
    userId?: number | null;
    email?: string | null;
    amount: number;
    currency: string;
    reason?: string | null;
    status: string;
    evidenceState: string;
    evidenceSubmittedAt?: any | null;
    evidenceRegeneratedAt?: any | null;
    evidenceDueBy?: any | null;
    evidenceJson?: any | null;
    evidenceError?: string | null;
    receiptUrl?: string | null;
    receiptDownloadUrl?: string | null;
    serviceDocumentationUrl?: string | null;
    serviceDocumentationDownloadUrl?: string | null;
    outcome?: string | null;
    outcomeReason?: string | null;
    resolvedAt?: any | null;
    stripeCreatedAt?: any | null;
    lastSyncedAt?: any | null;
    stripeDashboardUrl: string;
  } | null;
};

export type UserStripeDisputesQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type UserStripeDisputesQuery = {
  __typename?: 'Query';
  userStripeDisputes: {
    __typename?: 'StripeDisputeList';
    totalCount: number;
    edges: Array<{
      __typename?: 'StripeDispute';
      id: number;
      disputeId: string;
      chargeId?: string | null;
      paymentIntentId?: string | null;
      invoiceId?: string | null;
      stripeCustomerId?: string | null;
      userId?: number | null;
      email?: string | null;
      amount: number;
      currency: string;
      reason?: string | null;
      status: string;
      evidenceState: string;
      evidenceSubmittedAt?: any | null;
      evidenceRegeneratedAt?: any | null;
      evidenceDueBy?: any | null;
      evidenceJson?: any | null;
      evidenceError?: string | null;
      receiptUrl?: string | null;
      receiptDownloadUrl?: string | null;
      serviceDocumentationUrl?: string | null;
      serviceDocumentationDownloadUrl?: string | null;
      outcome?: string | null;
      outcomeReason?: string | null;
      resolvedAt?: any | null;
      stripeCreatedAt?: any | null;
      lastSyncedAt?: any | null;
      stripeDashboardUrl: string;
    }>;
  };
};

export type SubmitStripeDisputeEvidenceMutationVariables = Exact<{
  disputeId: Scalars['String']['input'];
}>;

export type SubmitStripeDisputeEvidenceMutation = {
  __typename?: 'Mutation';
  submitStripeDisputeEvidence: {
    __typename?: 'StripeDispute';
    id: number;
    disputeId: string;
    chargeId?: string | null;
    paymentIntentId?: string | null;
    invoiceId?: string | null;
    stripeCustomerId?: string | null;
    userId?: number | null;
    email?: string | null;
    amount: number;
    currency: string;
    reason?: string | null;
    status: string;
    evidenceState: string;
    evidenceSubmittedAt?: any | null;
    evidenceRegeneratedAt?: any | null;
    evidenceDueBy?: any | null;
    evidenceJson?: any | null;
    evidenceError?: string | null;
    receiptUrl?: string | null;
    receiptDownloadUrl?: string | null;
    serviceDocumentationUrl?: string | null;
    serviceDocumentationDownloadUrl?: string | null;
    outcome?: string | null;
    outcomeReason?: string | null;
    resolvedAt?: any | null;
    stripeCreatedAt?: any | null;
    lastSyncedAt?: any | null;
    stripeDashboardUrl: string;
  };
};

export type RegenerateStripeDisputeEvidenceMutationVariables = Exact<{
  disputeId: Scalars['String']['input'];
}>;

export type RegenerateStripeDisputeEvidenceMutation = {
  __typename?: 'Mutation';
  regenerateStripeDisputeEvidence: {
    __typename?: 'StripeDispute';
    id: number;
    disputeId: string;
    chargeId?: string | null;
    paymentIntentId?: string | null;
    invoiceId?: string | null;
    stripeCustomerId?: string | null;
    userId?: number | null;
    email?: string | null;
    amount: number;
    currency: string;
    reason?: string | null;
    status: string;
    evidenceState: string;
    evidenceSubmittedAt?: any | null;
    evidenceRegeneratedAt?: any | null;
    evidenceDueBy?: any | null;
    evidenceJson?: any | null;
    evidenceError?: string | null;
    receiptUrl?: string | null;
    receiptDownloadUrl?: string | null;
    serviceDocumentationUrl?: string | null;
    serviceDocumentationDownloadUrl?: string | null;
    outcome?: string | null;
    outcomeReason?: string | null;
    resolvedAt?: any | null;
    stripeCreatedAt?: any | null;
    lastSyncedAt?: any | null;
    stripeDashboardUrl: string;
  };
};

export type RefreshStripeDisputeMutationVariables = Exact<{
  disputeId: Scalars['String']['input'];
}>;

export type RefreshStripeDisputeMutation = {
  __typename?: 'Mutation';
  refreshStripeDispute: {
    __typename?: 'StripeDispute';
    id: number;
    disputeId: string;
    chargeId?: string | null;
    paymentIntentId?: string | null;
    invoiceId?: string | null;
    stripeCustomerId?: string | null;
    userId?: number | null;
    email?: string | null;
    amount: number;
    currency: string;
    reason?: string | null;
    status: string;
    evidenceState: string;
    evidenceSubmittedAt?: any | null;
    evidenceRegeneratedAt?: any | null;
    evidenceDueBy?: any | null;
    evidenceJson?: any | null;
    evidenceError?: string | null;
    receiptUrl?: string | null;
    receiptDownloadUrl?: string | null;
    serviceDocumentationUrl?: string | null;
    serviceDocumentationDownloadUrl?: string | null;
    outcome?: string | null;
    outcomeReason?: string | null;
    resolvedAt?: any | null;
    stripeCreatedAt?: any | null;
    lastSyncedAt?: any | null;
    stripeDashboardUrl: string;
  };
};

export type EvmGuideInstructionDetailQueryVariables = Exact<{
  methodId: Scalars['String']['input'];
  chain: Scalars['String']['input'];
  contractAddress: Scalars['String']['input'];
}>;

export type EvmGuideInstructionDetailQuery = {
  __typename?: 'Query';
  evmGuideInstruction?: {
    __typename?: 'EvmInstruction';
    chainId?: number | null;
    pred1?: number | null;
    pred2?: number | null;
    proba1?: number | null;
    proba2?: number | null;
    publicNotes?: string | null;
    tokenParam1?: Array<string> | null;
    tokenParam2?: Array<string> | null;
    id: number;
    contractId: number;
    treatmentId: number;
    blockSvcMethodId: number;
    notes?: string | null;
    updatedAt?: any | null;
    evmContract?: {
      __typename?: 'EvmContract';
      id: number;
      name: string;
      publicName?: string | null;
      undecodedCodeLength?: number | null;
      userCount?: number | null;
      transactionCount?: number | null;
      address: string;
    } | null;
    evmMethod?: { __typename?: 'EvmMethod'; id: number; name: string; hash: string } | null;
    chain?: {
      __typename?: 'Chain';
      id: number;
      shortName: string;
      description?: string | null;
      ecosystemId: number;
      credentialType: Array<string>;
      ecosystem: { __typename?: 'Ecosystem'; id: number; name: string; description?: string | null };
    } | null;
    reviews?: Array<{
      __typename?: 'EvmReview';
      id: number;
      createdAt: any;
      reconRepId: number;
      instructionId: number;
      beforeTreatmentId?: number | null;
      afterTreatmentId?: number | null;
      beforeTokenParam1?: Array<string> | null;
      beforeTokenParam2?: Array<string> | null;
      afterTokenParam1?: Array<string> | null;
      afterTokenParam2?: Array<string> | null;
      beforeNotes?: string | null;
      afterNotes?: string | null;
      beforePublicNotes?: string | null;
      afterPublicNotes?: string | null;
      reconRep: { __typename?: 'ReconRep'; id: number; userId?: number | null; email: string };
      beforeTreatment?: {
        __typename?: 'Treatment';
        id: number;
        name: string;
        description?: string | null;
        reconOrder?: number | null;
      } | null;
      afterTreatment?: {
        __typename?: 'Treatment';
        id: number;
        name: string;
        description?: string | null;
        reconOrder?: number | null;
      } | null;
    }> | null;
    topicInstructions?: Array<{
      __typename?: 'EvmTopicInstruction';
      id: number;
      instructionId: number;
      txnTopicFingerprint?: string | null;
      topicInstruction?: any | null;
    }> | null;
    treatment?: {
      __typename?: 'Treatment';
      id: number;
      name: string;
      description?: string | null;
      reconOrder?: number | null;
    } | null;
  } | null;
};

export type OverlappingContractsQueryVariables = Exact<{
  methodId: Scalars['String']['input'];
  chain: Scalars['String']['input'];
  contractAddress: Scalars['String']['input'];
  overlappingContractsTableInput: OverlappingContractsTableInput;
}>;

export type OverlappingContractsQuery = {
  __typename?: 'Query';
  overlappingContracts: {
    __typename?: 'OverlappingContracts';
    edges: Array<{
      __typename?: 'OverlappingContract';
      id: number;
      contractId: number;
      blockSvcMethodId: number;
      treatmentId: number;
      notes?: string | null;
      updatedAt?: any | null;
      distance?: number | null;
      contractAddress: string;
      chainName: string;
      chainCredentialType: Array<string>;
      methodHash?: string | null;
      treatment?: {
        __typename?: 'Treatment';
        id: number;
        name: string;
        description?: string | null;
        reconOrder?: number | null;
      } | null;
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      filteredCount?: number | null;
      hasNext?: boolean | null;
      totalCount?: number | null;
      totalPages?: number | null;
    };
    chainCounts: Array<{
      __typename?: 'OverlappingContractsChainCount';
      chainName: string;
      chainDescription?: string | null;
      count: number;
    }>;
    treatmentCounts: Array<{
      __typename?: 'OverlappingContractsTreatmentCount';
      treatmentId: number;
      treatmentName: string;
      count: number;
    }>;
  };
};

export type EditTopicInstructionMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  topicInstruction: Scalars['String']['input'];
}>;

export type EditTopicInstructionMutation = { __typename?: 'Mutation'; editTopicInstruction: boolean };

export type IbcGuideInstructionDetailQueryVariables = Exact<{
  identifier: Scalars['String']['input'];
}>;

export type IbcGuideInstructionDetailQuery = {
  __typename?: 'Query';
  ibcGuideInstruction?: {
    __typename?: 'IdentifierBasedInstruction';
    id: number;
    identifier: string;
    treatmentId: number;
    notes?: string | null;
    publicName?: string | null;
    publicNotes?: string | null;
    updatedAt?: any | null;
    tokenParam1?: Array<string> | null;
    tokenParam2?: Array<string> | null;
    reviews?: Array<
      | {
          __typename?: 'IbcReview';
          id: number;
          createdAt: any;
          reconRepId: number;
          instructionId: number;
          beforeTreatmentId?: number | null;
          afterTreatmentId?: number | null;
          beforeTokenParam1?: Array<string> | null;
          beforeTokenParam2?: Array<string> | null;
          afterTokenParam1?: Array<string> | null;
          afterTokenParam2?: Array<string> | null;
          beforeNotes?: string | null;
          afterNotes?: string | null;
          beforePublicNotes?: string | null;
          afterPublicNotes?: string | null;
          transactionHash?: string | null;
          reconRep: { __typename?: 'ReconRep'; id: number; userId?: number | null; email: string };
          beforeTreatment?: {
            __typename?: 'Treatment';
            id: number;
            name: string;
            description?: string | null;
            reconOrder?: number | null;
          } | null;
          afterTreatment?: {
            __typename?: 'Treatment';
            id: number;
            name: string;
            description?: string | null;
            reconOrder?: number | null;
          } | null;
        }
      | { __typename?: 'SolanaReview' }
    > | null;
    treatment?: {
      __typename?: 'Treatment';
      id: number;
      name: string;
      description?: string | null;
      reconOrder?: number | null;
    } | null;
  } | null;
};

export type SolanaGuideInstructionDetailQueryVariables = Exact<{
  identifier: Scalars['String']['input'];
}>;

export type SolanaGuideInstructionDetailQuery = {
  __typename?: 'Query';
  solanaGuideInstruction?: {
    __typename?: 'IdentifierBasedInstruction';
    id: number;
    identifier: string;
    treatmentId: number;
    notes?: string | null;
    publicName?: string | null;
    publicNotes?: string | null;
    updatedAt?: any | null;
    tokenParam1?: Array<string> | null;
    tokenParam2?: Array<string> | null;
    reviews?: Array<
      | { __typename?: 'IbcReview' }
      | {
          __typename?: 'SolanaReview';
          id: number;
          createdAt: any;
          reconRepId?: number | null;
          instructionId: number;
          beforeTreatmentId?: number | null;
          afterTreatmentId?: number | null;
          beforeTokenParam1?: Array<string> | null;
          beforeTokenParam2?: Array<string> | null;
          afterTokenParam1?: Array<string> | null;
          afterTokenParam2?: Array<string> | null;
          beforeNotes?: string | null;
          afterNotes?: string | null;
          beforePublicNotes?: string | null;
          afterPublicNotes?: string | null;
          signature?: string | null;
          reconRep?: { __typename?: 'ReconRep'; id: number; userId?: number | null; email: string } | null;
          beforeTreatment?: {
            __typename?: 'Treatment';
            id: number;
            name: string;
            description?: string | null;
            reconOrder?: number | null;
          } | null;
          afterTreatment?: {
            __typename?: 'Treatment';
            id: number;
            name: string;
            description?: string | null;
            reconOrder?: number | null;
          } | null;
        }
    > | null;
    treatment?: {
      __typename?: 'Treatment';
      id: number;
      name: string;
      description?: string | null;
      reconOrder?: number | null;
    } | null;
  } | null;
};

export type BulkResyncCredentialsMutationVariables = Exact<{
  credentialIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  hardResync?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type BulkResyncCredentialsMutation = { __typename?: 'Mutation'; bulkResyncCredentials: boolean };

export type BulkEnableRecalcByAccountMutationVariables = Exact<{
  userIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  generateAccounts: Scalars['Boolean']['input'];
  generateMovements: Scalars['Boolean']['input'];
}>;

export type BulkEnableRecalcByAccountMutation = {
  __typename?: 'Mutation';
  bulkEnableRecalcByAccount: boolean;
};

export type BatchSaveVersionForUsersMutationVariables = Exact<{
  userIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;

export type BatchSaveVersionForUsersMutation = {
  __typename?: 'Mutation';
  batchSaveVersionForUsers?: boolean | null;
};

export type RepairGroupTxnRefsMutationVariables = Exact<{
  userIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type RepairGroupTxnRefsMutation = { __typename?: 'Mutation'; repairGroupTxnRefs: boolean };

export type ReprocessAllForm1099DAsMutationVariables = Exact<{
  integrationId?: InputMaybe<Scalars['String']['input']>;
  taxYear?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  documentIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;

export type ReprocessAllForm1099DAsMutation = {
  __typename?: 'Mutation';
  reprocessAllForm1099DAs: {
    __typename?: 'ReprocessAllForm1099DAsResponse';
    totalFound: number;
    processed: number;
    succeeded: number;
    failed: number;
    results: Array<{
      __typename?: 'ReprocessForm1099DAResultItem';
      id: number;
      userId: number;
      originalFilename: string;
      previousIntegrationId?: string | null;
      newIntegrationId?: string | null;
      previousTransactionCount: number;
      newTransactionCount: number;
      success: boolean;
      error?: string | null;
    }>;
  };
};

export type SendSupportEmailMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
  exchanges: Array<Scalars['String']['input']> | Scalars['String']['input'];
  fileName?: InputMaybe<Scalars['String']['input']>;
  hasWallet?: InputMaybe<Scalars['Boolean']['input']>;
  hasStaking?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type SendSupportEmailMutation = { __typename?: 'Mutation'; sendSupportEmail: boolean };

export type TrelloJobFieldsFragment = {
  __typename?: 'TrelloJob';
  id: string;
  jobType: EnumTrelloJobType;
  status: string;
  createdAt: any;
  updatedAt: any;
  createdBy: number;
  userId?: number | null;
  url?: string | null;
};

export type TrelloJobsQueryVariables = Exact<{
  trelloJobsTableInput: TrelloJobsTableInput;
}>;

export type TrelloJobsQuery = {
  __typename?: 'Query';
  trelloJobs: {
    __typename?: 'TrelloJobs';
    edges: Array<{
      __typename?: 'TrelloJob';
      id: string;
      jobType: EnumTrelloJobType;
      status: string;
      createdAt: any;
      updatedAt: any;
      createdBy: number;
      userId?: number | null;
      url?: string | null;
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      filteredCount?: number | null;
      hasNext?: boolean | null;
      totalCount?: number | null;
      totalPages?: number | null;
    };
  };
};

export type CreateTrelloJobMutationVariables = Exact<{
  input: CreateTrelloJobInput;
}>;

export type CreateTrelloJobMutation = {
  __typename?: 'Mutation';
  createTrelloJob: {
    __typename?: 'TrelloJob';
    id: string;
    jobType: EnumTrelloJobType;
    status: string;
    createdAt: any;
    updatedAt: any;
    createdBy: number;
    userId?: number | null;
    url?: string | null;
  };
};

export type TrelloCardSearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
  includeArchivedLists: Scalars['Boolean']['input'];
  reconBoard: Scalars['Boolean']['input'];
  taxBoard: Scalars['Boolean']['input'];
  enterpriseBoard: Scalars['Boolean']['input'];
}>;

export type TrelloCardSearchQuery = {
  __typename?: 'Query';
  trelloCardSearch: {
    __typename?: 'TrelloCards';
    edges: Array<{
      __typename?: 'TrelloCard';
      id: string;
      name: string;
      url?: string | null;
      closed: boolean;
      idBoard: string;
      idList: string;
      boardName: string;
      listName: string;
    }>;
  };
};

export type CloneUserMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;

export type CloneUserMutation = {
  __typename?: 'Mutation';
  cloneUser: { __typename?: 'ClonedAccountResponse'; cloneUserJobId: number };
};

export type SetBusinessUserMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
  businessUser: Scalars['Boolean']['input'];
}>;

export type SetBusinessUserMutation = { __typename?: 'Mutation'; setBusinessUser: boolean };

export type DeleteUserMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;

export type DeleteUserMutation = { __typename?: 'Mutation'; deleteUser: boolean };

export type PortToTransfersMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;

export type PortToTransfersMutation = { __typename?: 'Mutation'; portToTransfers: boolean };

export type UndoPortToTransfersMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;

export type UndoPortToTransfersMutation = { __typename?: 'Mutation'; undoPortToTransfers: boolean };

export type LatestCloneUserJobQueryVariables = Exact<{ [key: string]: never }>;

export type LatestCloneUserJobQuery = {
  __typename?: 'Query';
  latestCloneUserJob?: {
    __typename?: 'cloneUserJob';
    id: number;
    sourceId: number;
    cloneId?: number | null;
    status: EnumGenericJobStatus;
    createdAt: any;
    updatedAt?: any | null;
  } | null;
};

export type AdminLatestDataModelV2UpgradeJobQueryVariables = Exact<{ [key: string]: never }>;

export type AdminLatestDataModelV2UpgradeJobQuery = {
  __typename?: 'Query';
  latestDataModelV2UpgradeJob?: {
    __typename?: 'DataModelV2UpgradeJob';
    id: string;
    status: EnumGenericJobStatus;
    stage?: EnumDataModelV2UpgradeStage | null;
    errorMessage?: string | null;
  } | null;
};

export type InvoicesQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;

export type InvoicesQuery = {
  __typename?: 'Query';
  invoices: {
    __typename?: 'Invoices';
    edges: Array<{
      __typename?: 'Invoice';
      id: string;
      userId: number;
      number?: string | null;
      created: number;
      dueDate?: number | null;
      currency: string;
      paid: boolean;
      voided: boolean;
      amountRemaining: number;
      description?: string | null;
      createdBy?: string | null;
    }>;
  };
};

export type JobFieldsFragment = {
  __typename?: 'LatestJob';
  id: string;
  updatedAt: any;
  status: EnumGenericJobStatus;
  logUrl: string;
};

export type ExchangeServiceRequestJobFieldsFragment = {
  __typename?: 'LatestExchangeServiceRequestJob';
  id: string;
  updatedAt: any;
  status: EnumExchangeServiceRequestStatus;
  logUrl: string;
};

export type LatestJobsQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;

export type LatestJobsQuery = {
  __typename?: 'Query';
  latestJobs?: {
    __typename?: 'LatestJobs';
    changeCredentialAccountJob?: {
      __typename?: 'LatestJob';
      id: string;
      updatedAt: any;
      status: EnumGenericJobStatus;
      logUrl: string;
    } | null;
    cloneUserJob?: {
      __typename?: 'LatestJob';
      id: string;
      updatedAt: any;
      status: EnumGenericJobStatus;
      logUrl: string;
    } | null;
    createMovementsJob?: {
      __typename?: 'LatestJob';
      id: string;
      updatedAt: any;
      status: EnumGenericJobStatus;
      logUrl: string;
    } | null;
    reconGuideTreatmentsJob?: {
      __typename?: 'LatestJob';
      id: string;
      updatedAt: any;
      status: EnumGenericJobStatus;
      logUrl: string;
    } | null;
    generateAccountsJob?: {
      __typename?: 'LatestJob';
      id: string;
      updatedAt: any;
      status: EnumGenericJobStatus;
      logUrl: string;
    } | null;
    missingPricesJob?: {
      __typename?: 'LatestJob';
      id: string;
      updatedAt: any;
      status: EnumGenericJobStatus;
      logUrl: string;
    } | null;
    pricingAnomalyJob?: {
      __typename?: 'LatestJob';
      id: string;
      updatedAt: any;
      status: EnumGenericJobStatus;
      logUrl: string;
    } | null;
    versionJob?: {
      __typename?: 'LatestJob';
      id: string;
      updatedAt: any;
      status: EnumGenericJobStatus;
      logUrl: string;
    } | null;
    snapshotJob?: {
      __typename?: 'LatestJob';
      id: string;
      updatedAt: any;
      status: EnumGenericJobStatus;
      logUrl: string;
    } | null;
    txnBatchDeleteJob?: {
      __typename?: 'LatestJob';
      id: string;
      updatedAt: any;
      status: EnumGenericJobStatus;
      logUrl: string;
    } | null;
    exchangeServiceRequestJob?: {
      __typename?: 'LatestExchangeServiceRequestJob';
      id: string;
      updatedAt: any;
      status: EnumExchangeServiceRequestStatus;
      logUrl: string;
    } | null;
  } | null;
};

export type PaymentsQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;

export type PaymentsQuery = {
  __typename?: 'Query';
  payments: {
    __typename?: 'Payments';
    edges: Array<{
      __typename?: 'Payment';
      id: string;
      timestamp: any;
      amount: number;
      products: {
        __typename?: 'Products';
        cryptoOnlyPlans?: Array<{ __typename?: 'Plan'; planId: string; year: number }> | null;
        fullFilingPlans?: Array<{ __typename?: 'Plan'; planId: string; year: number }> | null;
        addons?: Array<{ __typename?: 'Plan'; planId: string; year: number }> | null;
      };
    }>;
  };
};

export type FindUsersQueryVariables = Exact<{
  input: Scalars['String']['input'];
}>;

export type FindUsersQuery = {
  __typename?: 'Query';
  findUsers: Array<{
    __typename?: 'User';
    id: number;
    accountYears: Array<number>;
    airtableId?: string | null;
    blocked: boolean;
    createdAt: any;
    customerId?: string | null;
    deletedAt?: any | null;
    email: string;
    emailVerified: boolean;
    firstName?: string | null;
    includeFees?: boolean | null;
    secretMode?: boolean | null;
    isTest?: boolean | null;
    businessUser?: boolean | null;
    lastName?: string | null;
    lastSuccessfulCharge?: any | null;
    lockedTilDate?: any | null;
    lockedThroughYear?: number | null;
    loginCount?: number | null;
    marginTradeAccount?: boolean | null;
    minimizationForAllYears?: boolean | null;
    orgDemoUser?: boolean | null;
    organizationId?: number | null;
    phone?: string | null;
    plan?: string | null;
    recalcByAccount?: boolean | null;
    recalcByAccountStartYear?: number | null;
    reconMode?: boolean | null;
    hideSpam: boolean;
    resetPasswordExpires?: any | null;
    role?: string | null;
    subscriptionId?: string | null;
    twoFactorEnabled: boolean;
    updatedAt: any;
    useHoursMinsComparison?: boolean | null;
    lastMadeEditsAt?: any | null;
    usesGroupsSince?: any | null;
    dataModelV2UpgradeState?: EnumDataModelV2UpgradeState | null;
    v2TransitionProgress?: EnumGenericJobStatus | null;
    clonedUser?: { __typename?: 'User'; id: number; email: string } | null;
    clones?: Array<{ __typename?: 'User'; id: number; email: string; createdAt: any }> | null;
    orgRoles: Array<{
      __typename?: 'UserOrgRole';
      userId: number;
      roleId: number;
      organizationId: number;
      createdAt: any;
      updatedAt: any;
      organization: {
        __typename?: 'Organization';
        id: number;
        name?: string | null;
        slug?: string | null;
        status?: EnumOrganizationStatus | null;
        includeDemoUser?: boolean | null;
        discount?: number | null;
        logo?: string | null;
        colorPrimary?: string | null;
        colorSecondary?: string | null;
        colorLink?: string | null;
        createdAt: any;
        updatedAt: any;
        deletedAt?: any | null;
      };
      role: { __typename?: 'Role'; name: string };
    }>;
    taxDetails: Array<{
      __typename?: 'UserTaxDetail';
      id: number;
      baseCurrency?: string | null;
      calculateAsMargin?: boolean | null;
      createdAt: any;
      filingStatus?: string | null;
      fullFilingPlan?: string | null;
      grossIncome?: number | null;
      likeKind?: boolean | null;
      longTermCapitalGainsRate?: number | null;
      marginalTaxRate?: number | null;
      method?: string | null;
      needsFbar?: boolean | null;
      plan?: string | null;
      setFilingMethodSkipped?: boolean | null;
      skipped?: boolean | null;
      state?: string | null;
      taxYear: number;
      ukBnbRule?: boolean | null;
      updatedAt: any;
      useHoursMinsComparison?: boolean | null;
      userId: number;
      isEngaged: boolean;
      addons: Array<{
        __typename?: 'UserTaxDetailAddon';
        id: number;
        addon: {
          __typename?: 'Addon';
          createdAt: any;
          displayName: string;
          price?: number | null;
          product: string;
          sku: string;
          updatedAt: any;
        };
      }>;
      country: {
        __typename?: 'Country';
        id: number;
        endDateDay: number;
        endDateMonth: number;
        name: string;
        shorthand: string;
        methods: Array<string>;
        startDateDay: number;
        startDateMonth: number;
        taxMethods: Array<{ __typename?: 'TaxMethod'; id: EnumTaxMethod; label: string }>;
      };
      dateRange?: { __typename?: 'DateRange'; startDate: string; endDate: string } | null;
      taxMethod?: { __typename?: 'TaxMethod'; id: EnumTaxMethod; label: string } | null;
    }>;
  }>;
};

export type WalletLookupQueryVariables = Exact<{
  address: Scalars['String']['input'];
}>;

export type WalletLookupQuery = {
  __typename?: 'Query';
  walletLookup: Array<{
    __typename?: 'WalletLookupUser';
    userId: number;
    email: string;
    credentials: Array<{
      __typename?: 'WalletLookupCredential';
      id: number;
      integrationId?: string | null;
      deletedAt?: any | null;
    }>;
  }>;
};

export type EvmGuideClientSummaryQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
  evmGuideClientSummaryTableInput: EvmGuideClientSummaryTableInput;
}>;

export type EvmGuideClientSummaryQuery = {
  __typename?: 'Query';
  evmGuideClientSummary: {
    __typename?: 'EvmGuideClientSummary';
    edges: Array<{
      __typename?: 'EvmGuideClientSummaryEdge';
      credentialType: string;
      contractAddress: string;
      methodId: string;
      methodName?: string | null;
      txnCount: number;
      firstTxnDate: any;
      lastTxnDate: any;
      treatmentId?: number | null;
      notes?: string | null;
      publicNotes?: string | null;
      treatment?: {
        __typename?: 'Treatment';
        id: number;
        name: string;
        description?: string | null;
        reconOrder?: number | null;
      } | null;
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      filteredCount?: number | null;
      hasNext?: boolean | null;
      totalCount?: number | null;
      totalPages?: number | null;
    };
    chainCounts: Array<{
      __typename?: 'EvmGuideClientSummaryChainCount';
      chainName: string;
      chainDescription?: string | null;
      count: number;
    }>;
    treatmentCounts: Array<{
      __typename?: 'EvmGuideClientSummaryTreatmentCount';
      treatmentId: number;
      treatmentName: string;
      count: number;
    }>;
  };
};

export type SolanaGuideClientSummaryQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
  solanaGuideClientSummaryTableInput: SolanaGuideClientSummaryTableInput;
}>;

export type SolanaGuideClientSummaryQuery = {
  __typename?: 'Query';
  solanaGuideClientSummary: {
    __typename?: 'SolanaGuideClientSummary';
    edges: Array<{
      __typename?: 'SolanaGuideClientSummaryEdge';
      identifier: string;
      txnCount: number;
      firstTxnDate: any;
      lastTxnDate: any;
      treatmentId?: number | null;
      notes?: string | null;
      publicNotes?: string | null;
      treatment?: {
        __typename?: 'Treatment';
        id: number;
        name: string;
        description?: string | null;
        reconOrder?: number | null;
      } | null;
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      filteredCount?: number | null;
      hasNext?: boolean | null;
      totalCount?: number | null;
      totalPages?: number | null;
    };
    treatmentCounts: Array<{
      __typename?: 'SolanaGuideClientSummaryTreatmentCount';
      treatmentId: number;
      treatmentName: string;
      count: number;
    }>;
  };
};

export type IbcGuideClientSummaryQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
  ibcGuideClientSummaryTableInput: IbcGuideClientSummaryTableInput;
}>;

export type IbcGuideClientSummaryQuery = {
  __typename?: 'Query';
  ibcGuideClientSummary: {
    __typename?: 'IbcGuideClientSummary';
    edges: Array<{
      __typename?: 'IbcGuideClientSummaryEdge';
      identifier: string;
      txnCount: number;
      firstTxnDate: any;
      lastTxnDate: any;
      treatmentId?: number | null;
      notes?: string | null;
      publicNotes?: string | null;
      treatment?: {
        __typename?: 'Treatment';
        id: number;
        name: string;
        description?: string | null;
        reconOrder?: number | null;
      } | null;
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      filteredCount?: number | null;
      hasNext?: boolean | null;
      totalCount?: number | null;
      totalPages?: number | null;
    };
    treatmentCounts: Array<{
      __typename?: 'IbcGuideClientSummaryTreatmentCount';
      treatmentId: number;
      treatmentName: string;
      count: number;
    }>;
  };
};

export type WorkpapersQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;

export type WorkpapersQuery = {
  __typename?: 'Query';
  workpapers: Array<{
    __typename?: 'Workpaper';
    id: string;
    userId: number;
    title: string;
    status: EnumGenericJobStatus;
    createdBy: number;
    createdAt: any;
    updatedAt: any;
    includeReviewed: boolean;
    includeSpam: boolean;
  }>;
};

export type WorkpaperQueryVariables = Exact<{
  workpaperId: Scalars['String']['input'];
  workpaperRowTableInput: WorkpaperRowTableInput;
}>;

export type WorkpaperQuery = {
  __typename?: 'Query';
  workpaper: {
    __typename?: 'WorkpaperRows';
    edges: Array<{
      __typename?: 'WorkpaperRow';
      id: number;
      workpaperId: string;
      key: string;
      ecosystem?: string | null;
      count: number;
      earliestTxnTimestamp: any;
      latestTxnTimestamp: any;
      location: string;
      integrationId?: string | null;
      contract?: string | null;
      methodId?: string | null;
      credentialIds: Array<number>;
      reconIdentifier?: string | null;
      treatmentName?: string | null;
      notes?: string | null;
      completed: boolean;
      updatedAt: any;
      updatedBy: number;
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      totalCount?: number | null;
      filteredCount?: number | null;
      hasNext?: boolean | null;
      totalPages?: number | null;
    };
    ecosystemCounts: Array<{
      __typename?: 'WorkpaperEcosystemCount';
      ecosystem?: string | null;
      count: number;
    }>;
    treatmentCounts: Array<{
      __typename?: 'WorkpaperTreatmentCount';
      treatmentName?: string | null;
      count: number;
    }>;
  };
};

export type CreateWorkpaperMutationVariables = Exact<{
  input: CreateWorkpaperInput;
}>;

export type CreateWorkpaperMutation = {
  __typename?: 'Mutation';
  createWorkpaper: {
    __typename?: 'Workpaper';
    id: string;
    userId: number;
    title: string;
    status: EnumGenericJobStatus;
    createdBy: number;
    createdAt: any;
    updatedAt: any;
  };
};

export type EditWorkpaperRowMutationVariables = Exact<{
  rowId: Scalars['Int']['input'];
  input: EditWorkpaperRowInput;
}>;

export type EditWorkpaperRowMutation = {
  __typename?: 'Mutation';
  editWorkpaperRow: { __typename?: 'WorkpaperRow'; id: number };
};

export type DownloadWorkpaperCsvMutationVariables = Exact<{
  workpaperId: Scalars['String']['input'];
}>;

export type DownloadWorkpaperCsvMutation = { __typename?: 'Mutation'; downloadWorkpaperCsv?: string | null };

export type DuplicateTxnsMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  count: Scalars['Int']['input'];
}>;

export type DuplicateTxnsMutation = { __typename?: 'Mutation'; duplicateTxns: boolean };

export type SpecIdTxnQueryVariables = Exact<{
  sellId: Scalars['String']['input'];
}>;

export type SpecIdTxnQuery = {
  __typename?: 'Query';
  txn?: {
    __typename?: 'Txn';
    id: string;
    sellQuantity: string;
    sellCurrency: string;
    sellPrice: string;
    feeQuantity?: number | null;
    feeCurrency?: string | null;
    feePrice: string;
    txnTimestamp: any;
    blocksvcHash?: string | null;
    specIdMatchesAsSell: Array<{
      __typename?: 'SpecIdMatch';
      componentId: string;
      sellId: string;
      componentQuantity: number;
      componentOrder: number;
      component: {
        __typename?: 'Txn';
        buyCurrency: string;
        buyQuantity: string;
        buyPrice: string;
        txnTimestamp: any;
        feeCurrency?: string | null;
        feeQuantity?: number | null;
        feePrice: string;
        specIdMatchesAsComponent: Array<{
          __typename?: 'SpecIdMatch';
          componentId: string;
          sellId: string;
          componentQuantity: number;
          componentOrder: number;
        }>;
      };
    }>;
  } | null;
};

export type CredentialsBeingReconciledQueryVariables = Exact<{ [key: string]: never }>;

export type CredentialsBeingReconciledQuery = {
  __typename?: 'Query';
  credentialsBeingReconciled: Array<{ __typename?: 'Credential'; id: number }>;
};

export type SaveSpecIdMutationVariables = Exact<{
  sellId: Scalars['String']['input'];
  componentIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type SaveSpecIdMutation = { __typename?: 'Mutation'; saveSpecId: boolean };

export type CountsQueryVariables = Exact<{
  filterQuery: TxnFilterQuery;
}>;

export type CountsQuery = {
  __typename?: 'Query';
  txnExchangeNameCount: Array<{
    __typename?: 'TxnExchangeNameCount';
    year: string;
    total: number;
    counts: Array<{ __typename?: 'ExchangeNameCount'; count: number; exchangeName: string }>;
  }>;
};

export type DeleteTxnsMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type DeleteTxnsMutation = { __typename?: 'Mutation'; deleteTxns: number };

export type BatchDeleteTxnsMutationVariables = Exact<{
  filterQuery: TxnFilterQuery;
}>;

export type BatchDeleteTxnsMutation = { __typename?: 'Mutation'; batchDeleteTxns: boolean };

export type UndoMovementsMutationVariables = Exact<{
  txnGroupIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type UndoMovementsMutation = { __typename?: 'Mutation'; undoMovements: boolean };

export type TxnsQueryVariables = Exact<{
  pagination: PaginationOptions;
  sortBy: TxnSortOptions;
  sortDirection: SortDirectionOptions;
  filterQuery: TxnFilterQuery;
  isAdmin: Scalars['Boolean']['input'];
}>;

export type TxnsQuery = {
  __typename?: 'Query';
  txns: {
    __typename?: 'Txns';
    pageInfo: { __typename?: 'PageInfo'; filteredCount?: number | null };
    edges: Array<{
      __typename?: 'Txn';
      id: string;
      associatedExchangeAddress?: string | null;
      blocksvcHash?: string | null;
      credentialId?: number | null;
      buyCurrency: string;
      buyTokenId?: string | null;
      buyAddress?: string | null;
      buyNftId?: string | null;
      description?: string | null;
      exchangeId?: string | null;
      exchangeName?: string | null;
      feeCurrency?: string | null;
      feeTokenId?: string | null;
      feeQuantity?: number | null;
      feePrice: string;
      feeAddress?: string | null;
      buyPrice: string;
      sellPrice: string;
      buyQuantity: string;
      sellCurrency: string;
      sellTokenId?: string | null;
      sellAddress?: string | null;
      sellNftId?: string | null;
      sellQuantity: string;
      txnTimestamp: any;
      txnType: TxnType;
      unitPrice?: number | null;
      priceFetchingSide?: PriceFetchingSide | null;
      usdSpotPrice?: number | null;
      blocksvcMethodId?: string | null;
      blocksvcToAddress?: string | null;
      blocksvcFromAddress?: string | null;
      createdAt: any;
      updatedAt: any;
      isEdited?: boolean | null;
      isSpam: boolean;
      reviewed?: boolean | null;
      editedByReconGuideJob: boolean;
      reconIdentifier?: string | null;
      txnTopicFingerprint?: string | null;
      transferTopicFingerprint?: string | null;
      bkpVendorId?: number | null;
      bkpAccountDebitId?: number | null;
      bkpAccountCreditId?: number | null;
      accountId?: number | null;
      toAccountId?: number | null;
      hasMovement?: boolean | null;
      isPricingAnomaly: boolean;
      groupId?: number | null;
      groupComponentType?: TxnGroupComponentType | null;
      bkpVendor?: {
        __typename?: 'BkpVendor';
        id: number;
        bkpIntegrationId?: string | null;
        bkpIntegrationDisplayName?: string | null;
      } | null;
      bkpAccountDebit?: {
        __typename?: 'BkpAccount';
        id: number;
        bkpIntegrationId?: string | null;
        name?: string | null;
      } | null;
      bkpAccountCredit?: {
        __typename?: 'BkpAccount';
        id: number;
        bkpIntegrationId?: string | null;
        name?: string | null;
      } | null;
      credential: {
        __typename?: 'Credential';
        accountId?: number | null;
        credentialType: string;
        source: CredentialSource;
        name?: string | null;
        address?: string | null;
        integrationId?: string | null;
      };
      specIdMatchesAsComponent: Array<{
        __typename?: 'SpecIdMatch';
        componentId: string;
        sellId: string;
        componentQuantity: number;
        componentOrder: number;
      }>;
      specIdMatchesAsSell: Array<{
        __typename?: 'SpecIdMatch';
        componentId: string;
        sellId: string;
        componentQuantity: number;
        componentOrder: number;
      }>;
    }>;
  };
};

export type TxnCountQueryVariables = Exact<{ [key: string]: never }>;

export type TxnCountQuery = {
  __typename?: 'Query';
  userTxnCount: {
    __typename?: 'TxnCount';
    totalCount: number;
    reviewedCount: number;
    txnTypeCounts: Array<{ __typename?: 'TxnTypeCount'; count: number; type: TxnType }>;
    txnOtherFiltersCounts: Array<{ __typename?: 'TxnOtherFiltersCount'; count: number; type: OtherFilters }>;
    txnImportTypeCounts: Array<{ __typename?: 'TxnImportTypeCount'; count: number; importType: string }>;
  };
};

export type MergeTxnsMutationVariables = Exact<{
  txnIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type MergeTxnsMutation = { __typename?: 'Mutation'; mergeTxns: boolean };

export type MergeToMovementAndTradeMutationVariables = Exact<{
  txnIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  priceFetchingSide?: InputMaybe<PriceFetchingSide>;
}>;

export type MergeToMovementAndTradeMutation = { __typename?: 'Mutation'; mergeToMovementAndTrade: boolean };

export type TransferExchangeNameCountQueryVariables = Exact<{
  filterQuery: TransferGroupFilterQuery;
}>;

export type TransferExchangeNameCountQuery = {
  __typename?: 'Query';
  transferExchangeNameCount: Array<{
    __typename?: 'TxnExchangeNameCount';
    year: string;
    total: number;
    counts: Array<{ __typename?: 'ExchangeNameCount'; exchangeName: string; count: number }>;
  }>;
};

export type MarkTransferGroupsSpamMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  filterQuery?: InputMaybe<TransferGroupFilterQuery>;
  spam: Scalars['Boolean']['input'];
}>;

export type MarkTransferGroupsSpamMutation = {
  __typename?: 'Mutation';
  markTransferGroupsSpam: {
    __typename?: 'UpdatedTransferGroupsResponse';
    count: number;
    transferGroups: Array<{ __typename?: 'TransferGroup'; id: string; type: EnumTransferGroupType }>;
  };
};

export type ReviewTransferGroupsMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  filterQuery?: InputMaybe<TransferGroupFilterQuery>;
  reviewed: Scalars['Boolean']['input'];
}>;

export type ReviewTransferGroupsMutation = {
  __typename?: 'Mutation';
  reviewTransferGroups: {
    __typename?: 'UpdatedTransferGroupsResponse';
    count: number;
    transferGroups: Array<{ __typename?: 'TransferGroup'; id: string; reviewed: boolean }>;
  };
};

export type MergeTransferGroupsIntoMovementMutationVariables = Exact<{
  transferGroupIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type MergeTransferGroupsIntoMovementMutation = {
  __typename?: 'Mutation';
  mergeTransferGroupsIntoMovement: {
    __typename?: 'TransferGroup';
    id: string;
    userId: number;
    type: EnumTransferGroupType;
    description?: string | null;
    location?: string | null;
    reviewed: boolean;
    bkpVendorId?: number | null;
    bkpAccountDebitId?: number | null;
    bkpAccountCreditId?: number | null;
    hashes: Array<string>;
    currenciesIn: Array<string>;
    currenciesOut: Array<string>;
    currenciesFee: Array<string>;
    valueIn?: string | null;
    valueOut?: string | null;
    valueFee?: string | null;
    value?: string | null;
    timestampMin: any;
    timestampMax: any;
    createdAt: any;
    updatedAt: any;
    deletedAt?: any | null;
    suggestedInstruction?:
      | {
          __typename?: 'EvmInstruction';
          id: number;
          contractId: number;
          notes?: string | null;
          proba1?: number | null;
          pred1?: number | null;
          publicNotes?: string | null;
          tokenParam1?: Array<string> | null;
          tokenParam2?: Array<string> | null;
          treatment?: { __typename?: 'Treatment'; id: number; description?: string | null } | null;
        }
      | {
          __typename?: 'IdentifierBasedInstruction';
          id: number;
          notes?: string | null;
          publicNotes?: string | null;
          tokenParam1?: Array<string> | null;
          tokenParam2?: Array<string> | null;
          treatment?: { __typename?: 'Treatment'; id: number; description?: string | null } | null;
        }
      | null;
    transfers: Array<{
      __typename?: 'Transfer';
      id: string;
      userId: number;
      groupId: string;
      direction: EnumTransferDirection;
      type?: EnumTransferType | null;
      taxTreatment?: EnumTaxTreatment | null;
      credentialId: number;
      accountId?: number | null;
      exchangeId?: string | null;
      timestamp: any;
      hash?: string | null;
      inDateRange: boolean;
      currency: string;
      quantity: string;
      tokenAddress?: string | null;
      tokenId?: string | null;
      transactionId?: string | null;
      price?: string | null;
      valueUsd?: string | null;
      createdAt: any;
      updatedAt: any;
      deletedAt?: any | null;
      credential: {
        __typename?: 'Credential';
        credentialType: string;
        source: CredentialSource;
        address?: string | null;
        name?: string | null;
        ensAlias?: string | null;
        integrationName?: string | null;
      };
    }>;
    user: { __typename?: 'User'; id: number; email: string };
  };
};

export type SetTransferGroupsDescriptionMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  filterQuery?: InputMaybe<TransferGroupFilterQuery>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;

export type SetTransferGroupsDescriptionMutation = {
  __typename?: 'Mutation';
  setTransferGroupsDescription: {
    __typename?: 'UpdatedTransferGroupsResponse';
    count: number;
    transferGroups: Array<{ __typename?: 'TransferGroup'; id: string; description?: string | null }>;
  };
};

export type SetTransferGroupsAmountMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  filterQuery?: InputMaybe<TransferGroupFilterQuery>;
  direction: EnumTransferDirection;
  currency: Scalars['String']['input'];
  quantity: Scalars['String']['input'];
}>;

export type SetTransferGroupsAmountMutation = {
  __typename?: 'Mutation';
  setTransferGroupsAmount: {
    __typename?: 'UpdatedTransferGroupsResponse';
    count: number;
    transferGroups: Array<{ __typename?: 'TransferGroup'; id: string }>;
  };
};

export type SetTransferGroupsPriceMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  filterQuery?: InputMaybe<TransferGroupFilterQuery>;
  direction: EnumTransferDirection;
  currency: Scalars['String']['input'];
  price: Scalars['String']['input'];
}>;

export type SetTransferGroupsPriceMutation = {
  __typename?: 'Mutation';
  setTransferGroupsPrice: {
    __typename?: 'UpdatedTransferGroupsResponse';
    count: number;
    transferGroups: Array<{ __typename?: 'TransferGroup'; id: string }>;
  };
};

export type ShiftTransferGroupsTimezoneMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  filterQuery?: InputMaybe<TransferGroupFilterQuery>;
  hours: Scalars['Int']['input'];
}>;

export type ShiftTransferGroupsTimezoneMutation = {
  __typename?: 'Mutation';
  shiftTransferGroupsTimezone: {
    __typename?: 'UpdatedTransferGroupsResponse';
    count: number;
    groupIds?: Array<string> | null;
    transferGroups: Array<{
      __typename?: 'TransferGroup';
      id: string;
      timestampMin: any;
      timestampMax: any;
      transfers: Array<{ __typename?: 'Transfer'; id: string; timestamp: any }>;
    }>;
  };
};

export type SetTransferGroupsCurrencyMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  filterQuery?: InputMaybe<TransferGroupFilterQuery>;
  direction: EnumTransferDirection;
  fromCurrency: Scalars['String']['input'];
  toCurrency: Scalars['String']['input'];
  tokenId?: InputMaybe<Scalars['String']['input']>;
}>;

export type SetTransferGroupsCurrencyMutation = {
  __typename?: 'Mutation';
  setTransferGroupsCurrency: {
    __typename?: 'UpdatedTransferGroupsResponse';
    count: number;
    groupIds?: Array<string> | null;
    transferGroups: Array<{
      __typename?: 'TransferGroup';
      id: string;
      currenciesIn: Array<string>;
      currenciesOut: Array<string>;
      currenciesFee: Array<string>;
      transfers: Array<{
        __typename?: 'Transfer';
        id: string;
        currency: string;
        tokenId?: string | null;
        price?: string | null;
        tokenAddress?: string | null;
      }>;
    }>;
  };
};

export type DeleteTransferGroupsMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  filterQuery?: InputMaybe<TransferGroupFilterQuery>;
}>;

export type DeleteTransferGroupsMutation = { __typename?: 'Mutation'; deleteTransferGroups: number };

export type RefetchTransferGroupPricesMutationVariables = Exact<{
  groupIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  filterQuery?: InputMaybe<TransferGroupFilterQuery>;
  currency: Scalars['String']['input'];
}>;

export type RefetchTransferGroupPricesMutation = {
  __typename?: 'Mutation';
  refetchTransferGroupPrices: string;
};

export type CancelRefetchTransferGroupPricesJobMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;

export type CancelRefetchTransferGroupPricesJobMutation = {
  __typename?: 'Mutation';
  cancelRefetchTransferGroupPricesJob: boolean;
};

export type ExportTransferGroupsMutationVariables = Exact<{
  sortBy: TransferGroupSortOptions;
  sortDirection: SortDirectionOptions;
  filterQuery: TransferGroupFilterQuery;
  transferGroupIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type ExportTransferGroupsMutation = { __typename?: 'Mutation'; exportTransferGroups?: string | null };

export type TransferGroupsQueryVariables = Exact<{
  pagination: PaginationOptions;
  sortBy: TransferGroupSortOptions;
  sortDirection: SortDirectionOptions;
  filterQuery?: InputMaybe<TransferGroupFilterQuery>;
}>;

export type TransferGroupsQuery = {
  __typename?: 'Query';
  transferGroups: {
    __typename?: 'TransferGroups';
    pageInfo: { __typename?: 'PageInfo'; filteredCount?: number | null };
    edges: Array<{
      __typename?: 'TransferGroup';
      id: string;
      userId: number;
      type: EnumTransferGroupType;
      hashes: Array<string>;
      currenciesIn: Array<string>;
      currenciesOut: Array<string>;
      currenciesFee: Array<string>;
      valueIn?: string | null;
      valueOut?: string | null;
      valueFee?: string | null;
      value?: string | null;
      timestampMin: any;
      timestampMax: any;
      createdAt: any;
      updatedAt: any;
      deletedAt?: any | null;
      reviewed: boolean;
      description?: string | null;
      location?: string | null;
      bkpVendorId?: number | null;
      bkpAccountDebitId?: number | null;
      bkpAccountCreditId?: number | null;
      suggestedInstruction?:
        | {
            __typename?: 'EvmInstruction';
            id: number;
            contractId: number;
            notes?: string | null;
            proba1?: number | null;
            pred1?: number | null;
            publicNotes?: string | null;
            tokenParam1?: Array<string> | null;
            tokenParam2?: Array<string> | null;
            treatment?: { __typename?: 'Treatment'; id: number; description?: string | null } | null;
          }
        | {
            __typename?: 'IdentifierBasedInstruction';
            id: number;
            notes?: string | null;
            publicNotes?: string | null;
            tokenParam1?: Array<string> | null;
            tokenParam2?: Array<string> | null;
            treatment?: { __typename?: 'Treatment'; id: number; description?: string | null } | null;
          }
        | null;
      locations: Array<{
        __typename?: 'Location';
        integrationId: string;
        name?: string | null;
        contractAddress?: string | null;
      }>;
      transfers: Array<{
        __typename?: 'Transfer';
        id: string;
        userId: number;
        groupId: string;
        type?: EnumTransferType | null;
        direction: EnumTransferDirection;
        fromAddress?: string | null;
        toAddress?: string | null;
        contractAddress?: string | null;
        methodId?: string | null;
        methodName?: string | null;
        taxTreatment?: EnumTaxTreatment | null;
        credentialId: number;
        integrationId?: string | null;
        exchangeId?: string | null;
        accountId?: number | null;
        timestamp: any;
        hash?: string | null;
        inDateRange: boolean;
        currency: string;
        quantity: string;
        tokenAddress?: string | null;
        tokenId?: string | null;
        transactionId?: string | null;
        price?: string | null;
        valueUsd?: string | null;
        specIdTotalQuantity?: string | null;
        specIdAvailableQuantity?: string | null;
        specIdViable?: boolean | null;
        synthetic: boolean;
        createdAt: any;
        updatedAt: any;
        deletedAt?: any | null;
        credential: {
          __typename?: 'Credential';
          credentialType: string;
          source: CredentialSource;
          integrationId?: string | null;
          address?: string | null;
          name?: string | null;
          ensAlias?: string | null;
          integrationName?: string | null;
        };
      }>;
      user: { __typename?: 'User'; id: number; email: string };
    }>;
  };
};

export type TransferGroupCountsQueryVariables = Exact<{ [key: string]: never }>;

export type TransferGroupCountsQuery = {
  __typename?: 'Query';
  transferGroupCounts: {
    __typename?: 'TransferCount';
    totalCount: number;
    typeCounts: Array<{ __typename?: 'TransferGroupTypeCount'; count: number; type: EnumTransferGroupType }>;
  };
};

export type LatestRefetchTransferGroupPricesJobQueryVariables = Exact<{ [key: string]: never }>;

export type LatestRefetchTransferGroupPricesJobQuery = {
  __typename?: 'Query';
  latestRefetchTransferGroupPricesJob?: {
    __typename?: 'LatestRefetchTransferGroupPricesJob';
    id: string;
    status: EnumCancellableJobStatus;
    currency: string;
    modifiedCount: number;
    createdAt: any;
  } | null;
};

export type TransferGroupPageQueryVariables = Exact<{
  transferGroupId: Scalars['String']['input'];
  transferGroupTableInput: TransferGroupTableInput;
}>;

export type TransferGroupPageQuery = { __typename?: 'Query'; transferGroupPage?: number | null };

export type GetCsvUploadsQueryVariables = Exact<{ [key: string]: never }>;

export type GetCsvUploadsQuery = {
  __typename?: 'Query';
  uploads: {
    __typename?: 'Uploads';
    edges: Array<{
      __typename?: 'Upload';
      id: number;
      userId?: number | null;
      name: string;
      url?: string | null;
      createdAt: any;
      updatedAt: any;
      isHidden: boolean;
      uploadType?: string | null;
      credentialId?: number | null;
      credential?: {
        __typename?: 'Credential';
        id: number;
        name?: string | null;
        deletedAt?: any | null;
      } | null;
    }>;
  };
};

export type GetCsvUploadStatusQueryVariables = Exact<{
  requestId: Scalars['String']['input'];
}>;

export type GetCsvUploadStatusQuery = {
  __typename?: 'Query';
  csvUploadStatus: {
    __typename?: 'CsvUploadStatus';
    credentialId?: number | null;
    status: EnumExchangeServiceRequestStatus;
    unsupportedKnownCsv?: {
      __typename?: 'UnsupportedKnownCsv';
      expectedFile: string;
      message: string;
      exchange: string;
      link?: { __typename?: 'Link'; path: string; text: string } | null;
    } | null;
  };
};

export type RecordCheckoutConversionMutationVariables = Exact<{
  checkoutSessionId: Scalars['String']['input'];
  gclid?: InputMaybe<Scalars['String']['input']>;
  gbraid?: InputMaybe<Scalars['String']['input']>;
  wbraid?: InputMaybe<Scalars['String']['input']>;
  fbclid?: InputMaybe<Scalars['String']['input']>;
  marketingAnonymousId?: InputMaybe<Scalars['String']['input']>;
}>;

export type RecordCheckoutConversionMutation = { __typename?: 'Mutation'; recordCheckoutConversion: boolean };

export type UserQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;

export type UserQuery = {
  __typename?: 'Query';
  user?: { __typename?: 'User'; firstName?: string | null; lastName?: string | null; email: string } | null;
};

export type CreateInvoiceMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['Int']['input']>;
  newUserEmail?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate: Scalars['Int']['input'];
  lines: Array<InvoiceLine> | InvoiceLine;
  products: InvoiceProductsInput;
  hideDefaultCrypto?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type CreateInvoiceMutation = { __typename?: 'Mutation'; createInvoice: string };

export type DataModelV2UpgradeJobFieldsFragment = {
  __typename?: 'DataModelV2UpgradeJob';
  id: string;
  createdAt: any;
  updatedAt: any;
  status: EnumGenericJobStatus;
  stage?: EnumDataModelV2UpgradeStage | null;
  jobData?: any | null;
  errorMessage?: string | null;
};

export type LatestDataModelV2UpgradeJobQueryVariables = Exact<{ [key: string]: never }>;

export type LatestDataModelV2UpgradeJobQuery = {
  __typename?: 'Query';
  latestDataModelV2UpgradeJob?: {
    __typename?: 'DataModelV2UpgradeJob';
    id: string;
    createdAt: any;
    updatedAt: any;
    status: EnumGenericJobStatus;
    stage?: EnumDataModelV2UpgradeStage | null;
    jobData?: any | null;
    errorMessage?: string | null;
  } | null;
};

export type RunDataModelV2UpgradeJobMutationVariables = Exact<{ [key: string]: never }>;

export type RunDataModelV2UpgradeJobMutation = {
  __typename?: 'Mutation';
  runDataModelV2UpgradeJob: {
    __typename?: 'DataModelV2UpgradeJob';
    id: string;
    createdAt: any;
    updatedAt: any;
    status: EnumGenericJobStatus;
    stage?: EnumDataModelV2UpgradeStage | null;
    jobData?: any | null;
    errorMessage?: string | null;
  };
};

export type HasUnlockedSpecIdV1DataQueryVariables = Exact<{ [key: string]: never }>;

export type HasUnlockedSpecIdV1DataQuery = { __typename?: 'Query'; hasUnlockedSpecIdV1Data: boolean };

export type AcknowledgeV2UpgradeMutationVariables = Exact<{ [key: string]: never }>;

export type AcknowledgeV2UpgradeMutation = { __typename?: 'Mutation'; acknowledgeV2Upgrade: boolean };

export type CsvUploadHistoryQueryVariables = Exact<{
  uploadTableInput: UploadTableInput;
  includeUploader: Scalars['Boolean']['input'];
}>;

export type CsvUploadHistoryQuery = {
  __typename?: 'Query';
  uploads: {
    __typename?: 'Uploads';
    edges: Array<{
      __typename?: 'Upload';
      id: number;
      name: string;
      url?: string | null;
      createdAt: any;
      deletedAt?: any | null;
      uploadedByEmail?: string | null;
      credential?: {
        __typename?: 'Credential';
        id: number;
        name?: string | null;
        deletedAt?: any | null;
      } | null;
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      totalCount?: number | null;
      filteredCount?: number | null;
      hasNext?: boolean | null;
    };
  };
};

export type ToggleDocumentVisibilityMutationVariables = Exact<{
  documentIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  hidden: Scalars['Boolean']['input'];
}>;

export type ToggleDocumentVisibilityMutation = {
  __typename?: 'Mutation';
  toggleDocumentVisibility?: {
    __typename?: 'DocumentToggleVisibility';
    edges: Array<{
      __typename?: 'Report';
      id: number;
      reportType: string;
      createdAt: any;
      createdById?: number | null;
      createdByAdmin?: boolean | null;
      status: string;
      taxYear?: string | null;
      method?: string | null;
      url?: string | null;
      hidden?: boolean | null;
      margin?: boolean | null;
      extraCols?: boolean | null;
      errorDetails?: {
        __typename?: 'ReportErrorDetails';
        code: string;
        message: string;
        severity: string;
      } | null;
    }>;
  } | null;
};

export type DeleteDocumentsMutationVariables = Exact<{
  documentIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type DeleteDocumentsMutation = { __typename?: 'Mutation'; deleteDocuments: boolean };

export type TxnAllowanceForYearQueryVariables = Exact<{
  year: Scalars['Int']['input'];
}>;

export type TxnAllowanceForYearQuery = {
  __typename?: 'Query';
  txnAllowanceForYear: { __typename?: 'TxnAllowanceForYear'; allowed: number; count: number };
};

export type DocumentsQueryVariables = Exact<{
  pagination: PaginationOptions;
  sortBy: DocSortOptions;
  sortDirection: SortDirectionOptions;
  filterQuery: DocFilterQuery;
}>;

export type DocumentsQuery = {
  __typename?: 'Query';
  documents: {
    __typename?: 'Documents';
    pageInfo: { __typename?: 'PageInfo'; filteredCount?: number | null };
    edges: Array<{
      __typename?: 'Report';
      id: number;
      reportType: string;
      createdAt: any;
      createdById?: number | null;
      createdByAdmin?: boolean | null;
      status: string;
      taxYear?: string | null;
      method?: string | null;
      url?: string | null;
      hidden?: boolean | null;
      margin?: boolean | null;
      extraCols?: boolean | null;
      errorDetails?: {
        __typename?: 'ReportErrorDetails';
        code: string;
        message: string;
        severity: string;
      } | null;
    }>;
  };
};

export type DocumentsCountQueryVariables = Exact<{ [key: string]: never }>;

export type DocumentsCountQuery = {
  __typename?: 'Query';
  documentsCount: {
    __typename?: 'DocumentsCount';
    totalCount: number;
    yearCounts: Array<{ __typename?: 'YearCount'; taxYear: string; count: number }>;
    recommendedDocumentCounts: Array<{ __typename?: 'YearCount'; taxYear: string; count: number }>;
  };
};

export type DocumentDownloadUrlsQueryVariables = Exact<{
  documentIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type DocumentDownloadUrlsQuery = {
  __typename?: 'Query';
  documentDownloadUrls: {
    __typename?: 'DocumentUrls';
    edges: Array<{ __typename?: 'DocumentUrl'; id: number; url: string }>;
  };
};

export type Available8949PdfYearsQueryVariables = Exact<{ [key: string]: never }>;

export type Available8949PdfYearsQuery = { __typename?: 'Query'; available8949PdfYears: Array<number> };

export type EditTransferGroupResultFragment = {
  __typename?: 'TransferGroup';
  id: string;
  userId: number;
  type: EnumTransferGroupType;
  description?: string | null;
  location?: string | null;
  reviewed: boolean;
  bkpVendorId?: number | null;
  bkpAccountDebitId?: number | null;
  bkpAccountCreditId?: number | null;
  hashes: Array<string>;
  currenciesIn: Array<string>;
  currenciesOut: Array<string>;
  currenciesFee: Array<string>;
  valueIn?: string | null;
  valueOut?: string | null;
  valueFee?: string | null;
  value?: string | null;
  timestampMin: any;
  timestampMax: any;
  createdAt: any;
  updatedAt: any;
  deletedAt?: any | null;
  suggestedInstruction?:
    | {
        __typename?: 'EvmInstruction';
        id: number;
        contractId: number;
        notes?: string | null;
        proba1?: number | null;
        pred1?: number | null;
        publicNotes?: string | null;
        tokenParam1?: Array<string> | null;
        tokenParam2?: Array<string> | null;
        treatment?: { __typename?: 'Treatment'; id: number; description?: string | null } | null;
      }
    | {
        __typename?: 'IdentifierBasedInstruction';
        id: number;
        notes?: string | null;
        publicNotes?: string | null;
        tokenParam1?: Array<string> | null;
        tokenParam2?: Array<string> | null;
        treatment?: { __typename?: 'Treatment'; id: number; description?: string | null } | null;
      }
    | null;
  transfers: Array<{
    __typename?: 'Transfer';
    id: string;
    userId: number;
    groupId: string;
    direction: EnumTransferDirection;
    type?: EnumTransferType | null;
    taxTreatment?: EnumTaxTreatment | null;
    credentialId: number;
    accountId?: number | null;
    exchangeId?: string | null;
    timestamp: any;
    hash?: string | null;
    inDateRange: boolean;
    currency: string;
    quantity: string;
    tokenAddress?: string | null;
    tokenId?: string | null;
    transactionId?: string | null;
    price?: string | null;
    valueUsd?: string | null;
    createdAt: any;
    updatedAt: any;
    deletedAt?: any | null;
    credential: {
      __typename?: 'Credential';
      credentialType: string;
      source: CredentialSource;
      address?: string | null;
      name?: string | null;
      ensAlias?: string | null;
      integrationName?: string | null;
    };
  }>;
  user: { __typename?: 'User'; id: number; email: string };
};

export type UpdateTransferGroupMutationVariables = Exact<{
  input: UpdateTransferGroupInput;
}>;

export type UpdateTransferGroupMutation = {
  __typename?: 'Mutation';
  updateTransferGroup: {
    __typename?: 'TransferGroup';
    id: string;
    userId: number;
    type: EnumTransferGroupType;
    description?: string | null;
    location?: string | null;
    reviewed: boolean;
    bkpVendorId?: number | null;
    bkpAccountDebitId?: number | null;
    bkpAccountCreditId?: number | null;
    hashes: Array<string>;
    currenciesIn: Array<string>;
    currenciesOut: Array<string>;
    currenciesFee: Array<string>;
    valueIn?: string | null;
    valueOut?: string | null;
    valueFee?: string | null;
    value?: string | null;
    timestampMin: any;
    timestampMax: any;
    createdAt: any;
    updatedAt: any;
    deletedAt?: any | null;
    transfers: Array<{
      __typename?: 'Transfer';
      contractAddress?: string | null;
      methodId?: string | null;
      integrationId?: string | null;
      synthetic: boolean;
      id: string;
      userId: number;
      groupId: string;
      direction: EnumTransferDirection;
      type?: EnumTransferType | null;
      taxTreatment?: EnumTaxTreatment | null;
      credentialId: number;
      accountId?: number | null;
      exchangeId?: string | null;
      timestamp: any;
      hash?: string | null;
      inDateRange: boolean;
      currency: string;
      quantity: string;
      tokenAddress?: string | null;
      tokenId?: string | null;
      transactionId?: string | null;
      price?: string | null;
      valueUsd?: string | null;
      createdAt: any;
      updatedAt: any;
      deletedAt?: any | null;
      credential: {
        __typename?: 'Credential';
        integrationId?: string | null;
        credentialType: string;
        source: CredentialSource;
        address?: string | null;
        name?: string | null;
        ensAlias?: string | null;
        integrationName?: string | null;
      };
    }>;
    suggestedInstruction?:
      | {
          __typename?: 'EvmInstruction';
          id: number;
          contractId: number;
          notes?: string | null;
          proba1?: number | null;
          pred1?: number | null;
          publicNotes?: string | null;
          tokenParam1?: Array<string> | null;
          tokenParam2?: Array<string> | null;
          treatment?: { __typename?: 'Treatment'; id: number; description?: string | null } | null;
        }
      | {
          __typename?: 'IdentifierBasedInstruction';
          id: number;
          notes?: string | null;
          publicNotes?: string | null;
          tokenParam1?: Array<string> | null;
          tokenParam2?: Array<string> | null;
          treatment?: { __typename?: 'Treatment'; id: number; description?: string | null } | null;
        }
      | null;
    user: { __typename?: 'User'; id: number; email: string };
  };
};

export type CreateTransferGroupMutationVariables = Exact<{
  input: CreateTransferGroupInput;
}>;

export type CreateTransferGroupMutation = {
  __typename?: 'Mutation';
  createTransferGroup: {
    __typename?: 'TransferGroup';
    id: string;
    userId: number;
    type: EnumTransferGroupType;
    description?: string | null;
    location?: string | null;
    reviewed: boolean;
    bkpVendorId?: number | null;
    bkpAccountDebitId?: number | null;
    bkpAccountCreditId?: number | null;
    hashes: Array<string>;
    currenciesIn: Array<string>;
    currenciesOut: Array<string>;
    currenciesFee: Array<string>;
    valueIn?: string | null;
    valueOut?: string | null;
    valueFee?: string | null;
    value?: string | null;
    timestampMin: any;
    timestampMax: any;
    createdAt: any;
    updatedAt: any;
    deletedAt?: any | null;
    suggestedInstruction?:
      | {
          __typename?: 'EvmInstruction';
          id: number;
          contractId: number;
          notes?: string | null;
          proba1?: number | null;
          pred1?: number | null;
          publicNotes?: string | null;
          tokenParam1?: Array<string> | null;
          tokenParam2?: Array<string> | null;
          treatment?: { __typename?: 'Treatment'; id: number; description?: string | null } | null;
        }
      | {
          __typename?: 'IdentifierBasedInstruction';
          id: number;
          notes?: string | null;
          publicNotes?: string | null;
          tokenParam1?: Array<string> | null;
          tokenParam2?: Array<string> | null;
          treatment?: { __typename?: 'Treatment'; id: number; description?: string | null } | null;
        }
      | null;
    transfers: Array<{
      __typename?: 'Transfer';
      id: string;
      userId: number;
      groupId: string;
      direction: EnumTransferDirection;
      type?: EnumTransferType | null;
      taxTreatment?: EnumTaxTreatment | null;
      credentialId: number;
      accountId?: number | null;
      exchangeId?: string | null;
      timestamp: any;
      hash?: string | null;
      inDateRange: boolean;
      currency: string;
      quantity: string;
      tokenAddress?: string | null;
      tokenId?: string | null;
      transactionId?: string | null;
      price?: string | null;
      valueUsd?: string | null;
      createdAt: any;
      updatedAt: any;
      deletedAt?: any | null;
      credential: {
        __typename?: 'Credential';
        credentialType: string;
        source: CredentialSource;
        address?: string | null;
        name?: string | null;
        ensAlias?: string | null;
        integrationName?: string | null;
      };
    }>;
    user: { __typename?: 'User'; id: number; email: string };
  };
};

export type BulkUpdateTransferGroupsMutationVariables = Exact<{
  inputs: Array<UpdateTransferGroupInput> | UpdateTransferGroupInput;
}>;

export type BulkUpdateTransferGroupsMutation = {
  __typename?: 'Mutation';
  bulkUpdateTransferGroups: {
    __typename?: 'UpdatedTransferGroupsResponse';
    count: number;
    transferGroups: Array<{
      __typename?: 'TransferGroup';
      id: string;
      userId: number;
      type: EnumTransferGroupType;
      description?: string | null;
      location?: string | null;
      reviewed: boolean;
      bkpVendorId?: number | null;
      bkpAccountDebitId?: number | null;
      bkpAccountCreditId?: number | null;
      hashes: Array<string>;
      currenciesIn: Array<string>;
      currenciesOut: Array<string>;
      currenciesFee: Array<string>;
      valueIn?: string | null;
      valueOut?: string | null;
      valueFee?: string | null;
      value?: string | null;
      timestampMin: any;
      timestampMax: any;
      createdAt: any;
      updatedAt: any;
      deletedAt?: any | null;
      suggestedInstruction?:
        | {
            __typename?: 'EvmInstruction';
            id: number;
            contractId: number;
            notes?: string | null;
            proba1?: number | null;
            pred1?: number | null;
            publicNotes?: string | null;
            tokenParam1?: Array<string> | null;
            tokenParam2?: Array<string> | null;
            treatment?: { __typename?: 'Treatment'; id: number; description?: string | null } | null;
          }
        | {
            __typename?: 'IdentifierBasedInstruction';
            id: number;
            notes?: string | null;
            publicNotes?: string | null;
            tokenParam1?: Array<string> | null;
            tokenParam2?: Array<string> | null;
            treatment?: { __typename?: 'Treatment'; id: number; description?: string | null } | null;
          }
        | null;
      transfers: Array<{
        __typename?: 'Transfer';
        id: string;
        userId: number;
        groupId: string;
        direction: EnumTransferDirection;
        type?: EnumTransferType | null;
        taxTreatment?: EnumTaxTreatment | null;
        credentialId: number;
        accountId?: number | null;
        exchangeId?: string | null;
        timestamp: any;
        hash?: string | null;
        inDateRange: boolean;
        currency: string;
        quantity: string;
        tokenAddress?: string | null;
        tokenId?: string | null;
        transactionId?: string | null;
        price?: string | null;
        valueUsd?: string | null;
        createdAt: any;
        updatedAt: any;
        deletedAt?: any | null;
        credential: {
          __typename?: 'Credential';
          credentialType: string;
          source: CredentialSource;
          address?: string | null;
          name?: string | null;
          ensAlias?: string | null;
          integrationName?: string | null;
        };
      }>;
      user: { __typename?: 'User'; id: number; email: string };
    }>;
  };
};

export type UnmergeMovementMutationVariables = Exact<{
  transferGroupId: Scalars['String']['input'];
  accountId: Scalars['Int']['input'];
}>;

export type UnmergeMovementMutation = {
  __typename?: 'Mutation';
  unmergeMovement: {
    __typename?: 'TransferGroup';
    id: string;
    userId: number;
    type: EnumTransferGroupType;
    description?: string | null;
    location?: string | null;
    reviewed: boolean;
    bkpVendorId?: number | null;
    bkpAccountDebitId?: number | null;
    bkpAccountCreditId?: number | null;
    hashes: Array<string>;
    currenciesIn: Array<string>;
    currenciesOut: Array<string>;
    currenciesFee: Array<string>;
    valueIn?: string | null;
    valueOut?: string | null;
    valueFee?: string | null;
    value?: string | null;
    timestampMin: any;
    timestampMax: any;
    createdAt: any;
    updatedAt: any;
    deletedAt?: any | null;
    suggestedInstruction?:
      | {
          __typename?: 'EvmInstruction';
          id: number;
          contractId: number;
          notes?: string | null;
          proba1?: number | null;
          pred1?: number | null;
          publicNotes?: string | null;
          tokenParam1?: Array<string> | null;
          tokenParam2?: Array<string> | null;
          treatment?: { __typename?: 'Treatment'; id: number; description?: string | null } | null;
        }
      | {
          __typename?: 'IdentifierBasedInstruction';
          id: number;
          notes?: string | null;
          publicNotes?: string | null;
          tokenParam1?: Array<string> | null;
          tokenParam2?: Array<string> | null;
          treatment?: { __typename?: 'Treatment'; id: number; description?: string | null } | null;
        }
      | null;
    transfers: Array<{
      __typename?: 'Transfer';
      id: string;
      userId: number;
      groupId: string;
      direction: EnumTransferDirection;
      type?: EnumTransferType | null;
      taxTreatment?: EnumTaxTreatment | null;
      credentialId: number;
      accountId?: number | null;
      exchangeId?: string | null;
      timestamp: any;
      hash?: string | null;
      inDateRange: boolean;
      currency: string;
      quantity: string;
      tokenAddress?: string | null;
      tokenId?: string | null;
      transactionId?: string | null;
      price?: string | null;
      valueUsd?: string | null;
      createdAt: any;
      updatedAt: any;
      deletedAt?: any | null;
      credential: {
        __typename?: 'Credential';
        credentialType: string;
        source: CredentialSource;
        address?: string | null;
        name?: string | null;
        ensAlias?: string | null;
        integrationName?: string | null;
      };
    }>;
    user: { __typename?: 'User'; id: number; email: string };
  };
};

export type BatchUpdateTxnsMutationVariables = Exact<{
  txnInput: PartialTxnInput;
  filterQuery?: InputMaybe<TxnFilterQuery>;
}>;

export type BatchUpdateTxnsMutation = { __typename?: 'Mutation'; batchUpdateTxns: boolean };

export type BkpAccountsVendorsQueryVariables = Exact<{ [key: string]: never }>;

export type BkpAccountsVendorsQuery = {
  __typename?: 'Query';
  bkpVendors: Array<{
    __typename?: 'BkpVendor';
    id: number;
    name?: string | null;
    active?: boolean | null;
    bkpIntegrationId?: string | null;
    bkpIntegrationDisplayName?: string | null;
    bkpIntegrationSyncToken?: string | null;
    createdAt: any;
    updatedAt: any;
  }>;
  bkpAccounts: Array<{
    __typename?: 'BkpAccount';
    id: number;
    name?: string | null;
    active?: boolean | null;
    bkpIntegrationId?: string | null;
    bkpIntegrationClassification?: string | null;
    bkpIntegrationAccountType?: string | null;
    bkpIntegrationSyncToken?: string | null;
    bkpIntegrationAcctNum?: string | null;
    bkpIntegrationParentRefId?: string | null;
    createdAt: any;
    updatedAt: any;
  }>;
};

export type PriceQueryVariables = Exact<{
  symbol: Scalars['String']['input'];
  tokenId?: InputMaybe<Scalars['String']['input']>;
  date: DateObject;
  address?: InputMaybe<Scalars['String']['input']>;
  credentialType?: InputMaybe<Scalars['String']['input']>;
}>;

export type PriceQuery = { __typename?: 'Query'; price?: number | null };

export type PriceForTxnQueryVariables = Exact<{
  currency: Scalars['String']['input'];
  soldCurrency: Scalars['String']['input'];
  buyTokenId?: InputMaybe<Scalars['String']['input']>;
  sellTokenId?: InputMaybe<Scalars['String']['input']>;
  buyAddress?: InputMaybe<Scalars['String']['input']>;
  sellAddress?: InputMaybe<Scalars['String']['input']>;
  credentialType: Scalars['String']['input'];
  priceFetchingSide?: InputMaybe<PriceFetchingSide>;
  date: DateObject;
}>;

export type PriceForTxnQuery = {
  __typename?: 'Query';
  priceForTxn?: { __typename?: 'BuyOrSellPrice'; buyPrice?: number | null; sellPrice?: number | null } | null;
};

export type PasswordForgotMutationVariables = Exact<{
  email: Scalars['String']['input'];
  captchaResponse: Scalars['String']['input'];
}>;

export type PasswordForgotMutation = { __typename?: 'Mutation'; passwordForgot: boolean };

export type GetForm1099DaManualEntryQueryVariables = Exact<{
  integrationId: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
}>;

export type GetForm1099DaManualEntryQuery = {
  __typename?: 'Query';
  form1099daManualEntry?: {
    __typename?: 'Form1099DAManualEntry';
    id: number;
    integrationId: string;
    taxYear: number;
    createdAt: string;
    updatedAt: string;
    rows: Array<{ __typename?: 'Form1099DAManualEntryRow'; id: number; assetName: string; proceeds: number }>;
  } | null;
};

export type UpsertForm1099DaManualEntryMutationVariables = Exact<{
  integrationId: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
  rows: Array<Form1099DaManualEntryRowInput> | Form1099DaManualEntryRowInput;
}>;

export type UpsertForm1099DaManualEntryMutation = {
  __typename?: 'Mutation';
  upsertForm1099DAManualEntry: {
    __typename?: 'Form1099DAManualEntry';
    id: number;
    integrationId: string;
    taxYear: number;
    createdAt: string;
    updatedAt: string;
    rows: Array<{ __typename?: 'Form1099DAManualEntryRow'; id: number; assetName: string; proceeds: number }>;
  };
};

export type DeleteForm1099DaManualEntryMutationVariables = Exact<{
  integrationId: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
}>;

export type DeleteForm1099DaManualEntryMutation = {
  __typename?: 'Mutation';
  deleteForm1099DAManualEntry: boolean;
};

export type GetForm1099DaUploadUrlMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
}>;

export type GetForm1099DaUploadUrlMutation = {
  __typename?: 'Mutation';
  getForm1099DAUploadURL: { __typename?: 'Form1099DAUploadUrlData'; Key: string; url: string };
};

export type ProcessForm1099DaMutationVariables = Exact<{
  Key: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  taxYear?: InputMaybe<Scalars['Int']['input']>;
}>;

export type ProcessForm1099DaMutation = {
  __typename?: 'Mutation';
  processForm1099DA: {
    __typename?: 'ProcessForm1099DAResponse';
    id: number;
    originalFilename: string;
    taxYear?: number | null;
    transactionCount: number;
    integrationId?: string | null;
    extractionWarnings: Array<string>;
    createdAt: string;
  };
};

export type GetForm1099DAsQueryVariables = Exact<{ [key: string]: never }>;

export type GetForm1099DAsQuery = {
  __typename?: 'Query';
  form1099DAs: {
    __typename?: 'Form1099DAListResponse';
    totalCount: number;
    documents: Array<{
      __typename?: 'Form1099DA';
      id: number;
      originalFilename: string;
      taxYear?: number | null;
      fileSizeBytes: number;
      transactionCount: number;
      integrationId?: string | null;
      extractionWarnings: Array<string>;
      createdAt: string;
    }>;
  };
};

export type DeleteForm1099DaMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type DeleteForm1099DaMutation = { __typename?: 'Mutation'; deleteForm1099DA: boolean };

export type DeleteAllForm1099DAsMutationVariables = Exact<{ [key: string]: never }>;

export type DeleteAllForm1099DAsMutation = { __typename?: 'Mutation'; deleteAllForm1099DAs: boolean };

export type DownloadForm1099DaQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type DownloadForm1099DaQuery = { __typename?: 'Query'; downloadForm1099DA: string };

export type LoginOrSignupWithGoogleMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;

export type LoginOrSignupWithGoogleMutation = {
  __typename?: 'Mutation';
  loginOrSignupWithGoogle: {
    __typename?: 'GoogleLoginOrSignupResponse';
    userHash: string;
    isSignup: boolean;
    user: {
      __typename?: 'User';
      email: string;
      firstName?: string | null;
      lastName?: string | null;
      id: number;
    };
  };
};

export type GetTaxLossHarvestingAssetsCsvQueryVariables = Exact<{
  taxLossHarvestingAssetsInput: TaxLossHarvestingAssetsInput;
}>;

export type GetTaxLossHarvestingAssetsCsvQuery = {
  __typename?: 'Query';
  taxLossHarvestingAssets: { __typename?: 'TaxLossHarvestingAssets'; csv?: string | null };
};

export type TaxLossHarvestingAssetsQueryVariables = Exact<{
  taxLossHarvestingAssetsInput: TaxLossHarvestingAssetsInput;
}>;

export type TaxLossHarvestingAssetsQuery = {
  __typename?: 'Query';
  taxLossHarvestingAssets: {
    __typename?: 'TaxLossHarvestingAssets';
    report: { __typename?: 'HoldingsReportMetadata'; taxYear: number; calculatedAt: any; method: string };
    edges: Array<{
      __typename?: 'TaxLossHarvestingAsset';
      amount: number;
      currentUnitPrice?: number | null;
      id: any;
      taxLots: number;
      token: string;
      costBasis: number;
      totalMarketValue?: number | null;
      unrealizedGainLoss?: number | null;
      pricePaidPerUnit: number;
      lossesAmount?: number | null;
      isNft: boolean;
      address?: string | null;
      balanceAtDate?: number | null;
      priceAtDate?: number | null;
      marketValueAtDate?: number | null;
    }>;
    pageInfo: { __typename?: 'PageInfo'; filteredCount?: number | null; totalCount?: number | null };
  };
};

export type GetTaxLossHarvestingTaxLotsCsvQueryVariables = Exact<{
  taxLossHarvestingTaxLotsInput: TaxLossHarvestingTaxLotsInput;
}>;

export type GetTaxLossHarvestingTaxLotsCsvQuery = {
  __typename?: 'Query';
  taxLossHarvestingTaxLots: { __typename?: 'TaxLossHarvestingTaxLots'; csv?: string | null };
};

export type TaxLossHarvestingTaxLotsQueryVariables = Exact<{
  taxLossHarvestingTaxLotsInput: TaxLossHarvestingTaxLotsInput;
}>;

export type TaxLossHarvestingTaxLotsQuery = {
  __typename?: 'Query';
  taxLossHarvestingTaxLots: {
    __typename?: 'TaxLossHarvestingTaxLots';
    report: { __typename?: 'HoldingsReportMetadata'; taxYear: number; calculatedAt: any; method: string };
    edges: Array<{
      __typename?: 'TaxLossHarvestingTaxLot';
      amount: number;
      costBasis: number;
      currentUnitPrice?: number | null;
      dateAcquired: any;
      id: any;
      potentialSavings?: number | null;
      timeToLongTerm?: number | null;
      token: string;
      unrealizedGainLoss?: number | null;
      account?: { __typename?: 'Account'; name: string } | null;
    }>;
    pageInfo: { __typename?: 'PageInfo'; filteredCount?: number | null; totalCount?: number | null };
    totals: {
      __typename?: 'TaxLossHarvestingTaxLotsTotals';
      currentUnitPrice?: number | null;
      totalMarketValue?: number | null;
      totalCostBasis?: number | null;
      totalUnrealizedGainLoss?: number | null;
    };
    filteredTotals: {
      __typename?: 'TaxLossHarvestingTaxLotsFilteredTotals';
      costBasis?: number | null;
      unrealizedGainLoss?: number | null;
      potentialSavings?: number | null;
    };
  };
};

export type MarkAssetLostMutationVariables = Exact<{
  unsoldBuyReportId?: InputMaybe<Scalars['BigInt']['input']>;
  nftAddress?: InputMaybe<Scalars['String']['input']>;
}>;

export type MarkAssetLostMutation = {
  __typename?: 'Mutation';
  markAssetLost: { __typename?: 'CreatedCredential'; credential: { __typename?: 'Credential'; id: number } };
};

export type UpdateCredentialSecretsMutationVariables = Exact<{
  credentialId: Scalars['Int']['input'];
  credentials: Scalars['String']['input'];
  skipResync?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type UpdateCredentialSecretsMutation = {
  __typename?: 'Mutation';
  updateCredentialSecrets: {
    __typename?: 'UpdatedCredential';
    exchangeServiceRequest?: {
      __typename?: 'ExchangeServiceRequest';
      status?: EnumExchangeServiceRequestStatus | null;
      credentialId: number;
    } | null;
    credential: {
      __typename?: 'Credential';
      id: number;
      status?: EnumExchangeServiceRequestStatus | null;
      lastRefreshError?: string | null;
      errorType?: string | null;
      requiresCredentialUpdate?: boolean | null;
      errorRemediation?: string | null;
    };
  };
};

export type ResyncCredentialsMutationVariables = Exact<{
  credentialIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  hardResync?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ResyncCredentialsMutation = { __typename?: 'Mutation'; resyncCredentials: boolean };

export type CancelCredentialSyncMutationVariables = Exact<{
  credentialIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type CancelCredentialSyncMutation = { __typename?: 'Mutation'; cancelCredentialSync: boolean };

export type ShiftCsvTimezoneMutationVariables = Exact<{
  credentialId: Scalars['Int']['input'];
  timezone: Scalars['String']['input'];
}>;

export type ShiftCsvTimezoneMutation = { __typename?: 'Mutation'; shiftCsvTimezone: number };

export type AddOauthIntegrationMutationVariables = Exact<{
  api: Scalars['String']['input'];
  code: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
}>;

export type AddOauthIntegrationMutation = {
  __typename?: 'Mutation';
  addOauthIntegration: {
    __typename?: 'CreatedCredential';
    exchangeServiceRequest: {
      __typename?: 'ExchangeServiceRequest';
      status?: EnumExchangeServiceRequestStatus | null;
      credentialId: number;
    };
    credential: { __typename?: 'Credential'; id: number; status?: EnumExchangeServiceRequestStatus | null };
  };
};

export type UpdateOauthIntegrationMutationVariables = Exact<{
  credentialId: Scalars['Int']['input'];
  code: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
}>;

export type UpdateOauthIntegrationMutation = {
  __typename?: 'Mutation';
  updateOauthIntegration: {
    __typename?: 'Credential';
    id: number;
    status?: EnumExchangeServiceRequestStatus | null;
  };
};

export type RegenCoinbaseCredentialsMutationVariables = Exact<{
  credentialId: Scalars['Int']['input'];
}>;

export type RegenCoinbaseCredentialsMutation = { __typename?: 'Mutation'; regenCoinbaseCredentials: boolean };

export type AddApiIntegrationMutationVariables = Exact<{
  api: Scalars['String']['input'];
  credentials: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}>;

export type AddApiIntegrationMutation = {
  __typename?: 'Mutation';
  addApiIntegration: {
    __typename?: 'CreatedCredential';
    exchangeServiceRequest: {
      __typename?: 'ExchangeServiceRequest';
      status?: EnumExchangeServiceRequestStatus | null;
      credentialId: number;
    };
    credential: { __typename?: 'Credential'; id: number; status?: EnumExchangeServiceRequestStatus | null };
  };
};

export type EditCredentialMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  accountId?: InputMaybe<Scalars['Int']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  credentials?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Int']['input']>;
  filterSpam?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reconcileOnSync?: InputMaybe<Scalars['Boolean']['input']>;
  skipResync?: InputMaybe<Scalars['Boolean']['input']>;
  skipUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Int']['input']>;
}>;

export type EditCredentialMutation = {
  __typename?: 'Mutation';
  editCredential: {
    __typename?: 'UpdatedCredential';
    credential: {
      __typename?: 'Credential';
      id: number;
      source: CredentialSource;
      name?: string | null;
      address?: string | null;
      startDate?: any | null;
      endDate?: any | null;
      filterSpam?: boolean | null;
      txnCount: number;
      credentialType: string;
      integrationName?: string | null;
      latestTransaction?: any | null;
      earliestTransaction?: any | null;
      createdAt: any;
      updatedAt: any;
      status?: EnumExchangeServiceRequestStatus | null;
      lastRefreshError?: string | null;
      errorRemediation?: string | null;
      errorType?: string | null;
      requiresCredentialUpdate?: boolean | null;
      integrationId?: string | null;
      isOauth: boolean;
      reconcileOnSync?: boolean | null;
      accountId?: number | null;
      ensAlias?: string | null;
      otherIntegration?: boolean | null;
      variousIntegrations?: boolean | null;
      account?: { __typename?: 'Account'; id: number; name: string } | null;
    };
  };
};

export type AddWalletsIntegrationMutationVariables = Exact<{
  addresses: Array<AddressWithCurrencyInput> | AddressWithCurrencyInput;
  incomingType?: InputMaybe<TxnType>;
  outgoingType?: InputMaybe<TxnType>;
  name?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['Int']['input']>;
  filterSpam?: InputMaybe<Scalars['Boolean']['input']>;
  reconcileOnSync?: InputMaybe<Scalars['Boolean']['input']>;
  checkMissingWallets?: InputMaybe<Scalars['Boolean']['input']>;
  btcFundingWallet?: InputMaybe<Scalars['String']['input']>;
}>;

export type AddWalletsIntegrationMutation = {
  __typename?: 'Mutation';
  addWallets: {
    __typename?: 'CreatedCredentials';
    credentials: number;
    exchangeServiceRequests: number;
    duplicates: number;
    missingWallets: Array<{
      __typename?: 'MissingWalletWithTxnValidation';
      id: string;
      chain: string;
      address: string;
      hasTransactions: boolean;
    }>;
  };
};

export type HasMovementTxnsQueryVariables = Exact<{
  credentialIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type HasMovementTxnsQuery = { __typename?: 'Query'; hasMovementTxns: boolean };

export type CredentialHistoryQueryVariables = Exact<{
  credentialId: Scalars['Int']['input'];
  count?: InputMaybe<Scalars['Int']['input']>;
  includePerformedBy: Scalars['Boolean']['input'];
}>;

export type CredentialHistoryQuery = {
  __typename?: 'Query';
  credentialHistory: Array<{
    __typename?: 'CredentialHistoryItem';
    date: any;
    hardResync: boolean;
    performedBy?: string | null;
  }>;
};

export type IncomeDashboardQueryVariables = Exact<{ [key: string]: never }>;

export type IncomeDashboardQuery = {
  __typename?: 'Query';
  incomeDashboard?: {
    __typename?: 'Txns';
    edges: Array<{
      __typename?: 'Txn';
      quantity?: number | null;
      currency?: string | null;
      usdSpotPrice?: number | null;
      unitPrice?: number | null;
      sellQuantity: string;
      sellCurrency: string;
      txnTimestamp: any;
    }>;
  } | null;
};

export type PayInvoiceMutationVariables = Exact<{
  invoiceId: Scalars['String']['input'];
  stripeToken: Scalars['String']['input'];
  method: InvoicePaymentMethod;
}>;

export type PayInvoiceMutation = { __typename?: 'Mutation'; payInvoice: boolean };

export type MarkInvoiceAsPaidMutationVariables = Exact<{
  invoiceId: Scalars['String']['input'];
  method: InvoicePaymentMethod;
  cryptocurrency?: InputMaybe<Scalars['String']['input']>;
  txnHash?: InputMaybe<Scalars['String']['input']>;
}>;

export type MarkInvoiceAsPaidMutation = { __typename?: 'Mutation'; markInvoiceAsPaid: boolean };

export type MarkInvoiceAsVoidMutationVariables = Exact<{
  invoiceId: Scalars['String']['input'];
}>;

export type MarkInvoiceAsVoidMutation = { __typename?: 'Mutation'; markInvoiceAsVoid: boolean };

export type InvoiceEventsQueryVariables = Exact<{
  invoiceId: Scalars['String']['input'];
}>;

export type InvoiceEventsQuery = {
  __typename?: 'Query';
  invoiceEvents: {
    __typename?: 'InvoiceEvents';
    invoiceEvents: Array<{ __typename?: 'InvoiceEvent'; timestamp: number; type: string }>;
  };
};

export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  captchaResponse: Scalars['String']['input'];
}>;

export type LoginMutation = {
  __typename?: 'Mutation';
  login: {
    __typename?: 'LoginOrSignupResponse';
    userHash: string;
    user: { __typename?: 'User'; id: number };
  };
};

export type VerifyTwoFactorLoginMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;

export type VerifyTwoFactorLoginMutation = {
  __typename?: 'Mutation';
  verifyTwoFactorLogin: {
    __typename?: 'LoginOrSignupResponse';
    userHash: string;
    user: { __typename?: 'User'; id: number; email: string };
  };
};

export type SyncCovalentWalletsMutationVariables = Exact<{
  addresses: Array<Scalars['String']['input']> | Scalars['String']['input'];
  chainIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type SyncCovalentWalletsMutation = {
  __typename?: 'Mutation';
  syncCovalentWallets: {
    __typename?: 'CreatedCredentials';
    credentials: number;
    exchangeServiceRequests: number;
    duplicates: number;
  };
};

export type BuyProductsMutationVariables = Exact<{
  existingSourceId?: InputMaybe<Scalars['String']['input']>;
  newSourceTokenId?: InputMaybe<Scalars['String']['input']>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  cryptoOnlyPlans: Array<ProductInput> | ProductInput;
  fullFilingPlans: Array<ProductInput> | ProductInput;
  addons: Array<ProductInput> | ProductInput;
  subTotal: Scalars['Int']['input'];
  cardHolderName: Scalars['String']['input'];
  attributionSource?: InputMaybe<Scalars['String']['input']>;
  attributionMedium?: InputMaybe<Scalars['String']['input']>;
  attributionCampaign?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  gbraid?: InputMaybe<Scalars['String']['input']>;
  wbraid?: InputMaybe<Scalars['String']['input']>;
  fbclid?: InputMaybe<Scalars['String']['input']>;
  marketingAnonymousId?: InputMaybe<Scalars['String']['input']>;
}>;

export type BuyProductsMutation = {
  __typename?: 'Mutation';
  buyProducts: {
    __typename?: 'BuyProductsResponse';
    invoiceId: string;
    total: number;
    couponCode?: string | null;
    couponPercentOff?: number | null;
    customerId?: string | null;
    analyticsProducts: Array<{
      __typename?: 'AnalyticsProductData';
      name: string;
      price: number;
      product_id: string;
      quantity: number;
      is_upgrade?: boolean | null;
    }>;
  };
};

export type ValidateCouponMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;

export type ValidateCouponMutation = {
  __typename?: 'Mutation';
  validateCoupon: { __typename?: 'CouponValidationResponse'; valid: boolean; percentOff?: number | null };
};

export type EvmGuideSubmitNewInstructionMutationVariables = Exact<{
  methodId: Scalars['String']['input'];
  chain: Scalars['String']['input'];
  contractAddress: Scalars['String']['input'];
  treatmentId: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
}>;

export type EvmGuideSubmitNewInstructionMutation = {
  __typename?: 'Mutation';
  evmGuideNewInstruction: boolean;
};

export type SolanaGuideSubmitNewInstructionMutationVariables = Exact<{
  identifier: Scalars['String']['input'];
  treatmentId: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  transactionHash: Scalars['String']['input'];
}>;

export type SolanaGuideSubmitNewInstructionMutation = {
  __typename?: 'Mutation';
  solanaGuideNewInstruction: boolean;
};

export type IbcGuideSubmitNewInstructionMutationVariables = Exact<{
  identifier: Scalars['String']['input'];
  treatmentId: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  credentialType: Scalars['String']['input'];
  transactionHash: Scalars['String']['input'];
}>;

export type IbcGuideSubmitNewInstructionMutation = {
  __typename?: 'Mutation';
  ibcGuideNewInstruction: boolean;
};

export type AddUserProfileMutationVariables = Exact<{
  userProfileInputData: UserProfileInputData;
}>;

export type AddUserProfileMutation = { __typename?: 'Mutation'; addUserProfile: boolean };

export type GetLatestUserProfileQueryVariables = Exact<{ [key: string]: never }>;

export type GetLatestUserProfileQuery = {
  __typename?: 'Query';
  getLatestUserProfile?: { __typename?: 'UserProfileData'; data: any; touchedSections: Array<string> } | null;
};

export type GetCountriesQueryVariables = Exact<{ [key: string]: never }>;

export type GetCountriesQuery = {
  __typename?: 'Query';
  countries: Array<{
    __typename?: 'Country';
    id: number;
    name: string;
    shorthand: string;
    methods: Array<string>;
  }>;
};

export type GetAccountYearsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAccountYearsQuery = {
  __typename?: 'Query';
  user?: { __typename?: 'User'; taxDetails: Array<{ __typename?: 'UserTaxDetail'; taxYear: number }> } | null;
};

export type GetUserQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserQuery = {
  __typename?: 'Query';
  user?: { __typename?: 'User'; id: number; email: string } | null;
};

export type PasswordResetMutationVariables = Exact<{
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
  captchaResponse: Scalars['String']['input'];
}>;

export type PasswordResetMutation = { __typename?: 'Mutation'; passwordReset: boolean };

export type DailyBalanceFiltersQueryVariables = Exact<{ [key: string]: never }>;

export type DailyBalanceFiltersQuery = {
  __typename?: 'Query';
  dailyBalanceFilters: { __typename?: 'DailyBalanceFilters'; currencies: Array<string> };
};

export type DailyBalancesQueryVariables = Exact<{
  currency: Scalars['String']['input'];
}>;

export type DailyBalancesQuery = {
  __typename?: 'Query';
  dailyBalances: Array<{
    __typename?: 'AccountBalanceMap';
    accountId: number;
    entries: Array<{
      __typename?: 'BalanceEntry';
      date: string;
      currency: string;
      balance: number;
      missingCostBasis: boolean;
      usedUnassignedBalance?: boolean | null;
    }>;
  }>;
};

export type SupportedIntegrationIdsQueryVariables = Exact<{ [key: string]: never }>;

export type SupportedIntegrationIdsQuery = {
  __typename?: 'Query';
  supportedIntegrationIds: { __typename?: 'SupportedIntegrationIds'; integrationIds: Array<string> };
};

export type ExternalBalanceQueryVariables = Exact<{
  input: ExternalBalanceInput;
}>;

export type ExternalBalanceQuery = {
  __typename?: 'Query';
  externalBalance: {
    __typename?: 'ExternalBalance';
    date: any;
    integrationId: string;
    tokenSymbol: string;
    tokenAddress?: string | null;
    balance?: number | null;
    address: string;
  };
};

export type EditAccountMutationVariables = Exact<{
  accountId: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  integrationId?: InputMaybe<Scalars['String']['input']>;
}>;

export type EditAccountMutation = {
  __typename?: 'Mutation';
  editAccount: {
    __typename?: 'Account';
    id: number;
    address?: string | null;
    name: string;
    integrationId?: string | null;
  };
};

export type DeleteAccountMutationVariables = Exact<{
  accountId: Scalars['Int']['input'];
}>;

export type DeleteAccountMutation = { __typename?: 'Mutation'; deleteAccount: boolean };

export type RunCreateAccountsJobMutationVariables = Exact<{ [key: string]: never }>;

export type RunCreateAccountsJobMutation = {
  __typename?: 'Mutation';
  runCreateAccountsJob: { __typename?: 'GenerateAccountsJob'; id: string };
};

export type LatestGenerateAccountsJobQueryVariables = Exact<{ [key: string]: never }>;

export type LatestGenerateAccountsJobQuery = {
  __typename?: 'Query';
  latestGenerateAccountsJob?: {
    __typename?: 'GenerateAccountsJob';
    id: string;
    status?: EnumGenericJobStatus | null;
    createdAt?: any | null;
  } | null;
};

export type MovementsQueryVariables = Exact<{
  movementTableInput: MovementTableInput;
}>;

export type MovementsQuery = {
  __typename?: 'Query';
  movements: {
    __typename?: 'Movements';
    edges: Array<{
      __typename?: 'Movement';
      id: number;
      movements: Array<{
        __typename?: 'MovementComponent';
        id: string;
        component: EnumTxnGroupComponent;
        txnId: string;
        txnTimestamp: any;
        txnHash?: string | null;
        currency?: string | null;
        soldCurrency?: string | null;
        quantity?: number | null;
        soldQuantity?: number | null;
        credential: { __typename?: 'Credential'; id: number; name?: string | null; address?: string | null };
        fromAccount?: {
          __typename?: 'Account';
          id: number;
          name: string;
          address?: string | null;
          integrationId?: string | null;
        } | null;
        toAccount?: {
          __typename?: 'Account';
          id: number;
          name: string;
          address?: string | null;
          integrationId?: string | null;
        } | null;
      }>;
      deposits: Array<{
        __typename?: 'MovementComponent';
        id: string;
        component: EnumTxnGroupComponent;
        txnId: string;
        txnTimestamp: any;
        txnHash?: string | null;
        currency?: string | null;
        quantity?: number | null;
        credential: {
          __typename?: 'Credential';
          id: number;
          name?: string | null;
          address?: string | null;
          credentialType: string;
        };
      }>;
      withdrawals: Array<{
        __typename?: 'MovementComponent';
        id: string;
        component: EnumTxnGroupComponent;
        txnId: string;
        txnTimestamp: any;
        txnHash?: string | null;
        soldCurrency?: string | null;
        soldQuantity?: number | null;
        credential: {
          __typename?: 'Credential';
          id: number;
          name?: string | null;
          address?: string | null;
          credentialType: string;
        };
      }>;
      spend: Array<{
        __typename?: 'MovementComponent';
        id: string;
        component: EnumTxnGroupComponent;
        txnId: string;
        txnTimestamp: any;
        txnHash?: string | null;
        soldCurrency?: string | null;
        soldQuantity?: number | null;
      }>;
      income: Array<{
        __typename?: 'MovementComponent';
        id: string;
        component: EnumTxnGroupComponent;
        txnId: string;
        txnTimestamp: any;
        txnHash?: string | null;
        currency?: string | null;
        quantity?: number | null;
      }>;
    }>;
    pageInfo: { __typename?: 'PageInfo'; filteredCount?: number | null };
  };
};

export type LatestCreateMovementsJobQueryVariables = Exact<{ [key: string]: never }>;

export type LatestCreateMovementsJobQuery = {
  __typename?: 'Query';
  latestCreateMovementsJob?: {
    __typename?: 'LatestCreateMovementsJob';
    id: string;
    status: EnumGenericJobStatus;
    createdAt: any;
    modifiedTxnsLength?: number | null;
  } | null;
};

export type RunCreateMovementsJobMutationVariables = Exact<{ [key: string]: never }>;

export type RunCreateMovementsJobMutation = {
  __typename?: 'Mutation';
  runCreateMovementsJob: { __typename?: 'CreateMovementsJob'; id: string };
};

export type MovementMergeCandidatesQueryVariables = Exact<{
  movementTableInput: MovementTableInput;
}>;

export type MovementMergeCandidatesQuery = {
  __typename?: 'Query';
  movementMergeCandidates: {
    __typename?: 'MovementMergeCandidates';
    edges: Array<{
      __typename?: 'MovementMergeCandidate';
      id: string;
      txnType: string;
      txnTimestamp: any;
      txnHash?: string | null;
      blocksvcToAddress?: string | null;
      currency?: string | null;
      soldCurrency?: string | null;
      quantity?: number | null;
      soldQuantity?: number | null;
      account?: { __typename?: 'Account'; id: number; name: string } | null;
      credential: {
        __typename?: 'Credential';
        id: number;
        name?: string | null;
        address?: string | null;
        credentialType: string;
        integrationId?: string | null;
      };
    }>;
    pageInfo: { __typename?: 'PageInfo'; filteredCount?: number | null };
  };
};

export type MarkMergeCandidatesAsReviewedMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  reviewed: Scalars['Boolean']['input'];
}>;

export type MarkMergeCandidatesAsReviewedMutation = {
  __typename?: 'Mutation';
  reviewTxns: {
    __typename?: 'UpdatedTxnResponse';
    count: number;
    errors: Array<{ __typename?: 'FailedTransactionUpdate'; transactionId: string; error: string }>;
    updatedTxns: Array<{ __typename?: 'Txn'; id: string; reviewed?: boolean | null }>;
  };
};

export type MissingExchangesQueryVariables = Exact<{ [key: string]: never }>;

export type MissingExchangesQuery = {
  __typename?: 'Query';
  missingExchanges: {
    __typename?: 'MissingExchanges';
    edges: Array<{
      __typename?: 'MissingExchange';
      name: string;
      transactions: Array<{
        __typename?: 'MissingExchangeTransaction';
        id: string;
        userId: number;
        credentialType: string;
        timestamp: any;
        hash?: string | null;
        toAddress?: string | null;
        fromAddress?: string | null;
      }>;
    }>;
  };
};

export type MissingWalletsQueryVariables = Exact<{ [key: string]: never }>;

export type MissingWalletsQuery = {
  __typename?: 'Query';
  missingWallets: {
    __typename?: 'MissingWallets';
    edges: Array<{ __typename?: 'MissingWallet'; id: string; chain: string; address: string }>;
  };
};

export type MissingWalletTxnCountQueryVariables = Exact<{
  wallets: Array<WalletTxnCountInput> | WalletTxnCountInput;
}>;

export type MissingWalletTxnCountQuery = {
  __typename?: 'Query';
  missingWalletTxnCount?: Array<{
    __typename?: 'WalletTxnCount';
    chain: string;
    address: string;
    count?: number | null;
    earliestTxnDate?: string | null;
    latestTxnDate?: string | null;
  }> | null;
};

export type ValidateMissingWalletsQueryVariables = Exact<{
  missingWallets: Array<MissingWalletValidationInput> | MissingWalletValidationInput;
}>;

export type ValidateMissingWalletsQuery = {
  __typename?: 'Query';
  validateMissingWallets: {
    __typename?: 'ValidatedMissingWallets';
    edges: Array<{ __typename?: 'MissingWalletWithTxnValidation'; id: string; hasTransactions: boolean }>;
  };
};

export type AddMissingPricesMutationVariables = Exact<{
  credentialIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  plusOrMinusDays?: InputMaybe<Scalars['Int']['input']>;
}>;

export type AddMissingPricesMutation = { __typename?: 'Mutation'; addMissingPrices: string };

export type DetectPricingAnomaliesMutationVariables = Exact<{
  credentialIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  windowSizeMonths?: InputMaybe<Scalars['Int']['input']>;
  zScoreThreshold?: InputMaybe<Scalars['Float']['input']>;
  minUsdThreshold?: InputMaybe<Scalars['Float']['input']>;
}>;

export type DetectPricingAnomaliesMutation = { __typename?: 'Mutation'; detectPricingAnomalies: string };

export type MissingPricesDataQueryVariables = Exact<{ [key: string]: never }>;

export type MissingPricesDataQuery = {
  __typename?: 'Query';
  missingPricesData: Array<{ __typename?: 'MissingPricesDetail'; type: TxnType; count: number }>;
};

export type LatestMissingPricesJobQueryVariables = Exact<{ [key: string]: never }>;

export type LatestMissingPricesJobQuery = {
  __typename?: 'Query';
  latestMissingPricesJob?: {
    __typename?: 'LatestMissingPricesJob';
    id: string;
    status: EnumGenericJobStatus;
    createdAt: any;
    modifiedTxnsLength?: number | null;
    modifiedTxnDetails?: Array<{ __typename?: 'ModifiedTxnDetail'; token: string; count: number }> | null;
  } | null;
};

export type UnbusyCredentialsQueryVariables = Exact<{ [key: string]: never }>;

export type UnbusyCredentialsQuery = {
  __typename?: 'Query';
  unbusyCredentials: Array<{ __typename?: 'Credential'; id: number }>;
};

export type LatestPricingAnomalyJobQueryVariables = Exact<{ [key: string]: never }>;

export type LatestPricingAnomalyJobQuery = {
  __typename?: 'Query';
  latestPricingAnomalyJob?: {
    __typename?: 'LatestPricingAnomalyJob';
    id: string;
    status: EnumGenericJobStatus;
    createdAt: any;
    modifiedTxnsLength?: number | null;
    totalUsdImpact?: number | null;
    highestUsdDiscrepancy?: number | null;
    anomaliesAboveThreshold?: number | null;
    anomalyMetadata?: Array<{
      __typename?: 'AnomalyMetadata';
      transactionId: string;
      usdValueOfDiscrepancy: number;
      anomalyType: string;
      flaggedField: string;
      confidence: number;
      currency: string;
      comparisonWindow: {
        __typename?: 'AnomalyComparisonWindow';
        startDate: string;
        endDate: string;
        referenceValue: number;
        windowSizeMonths: number;
      };
    }> | null;
  } | null;
};

export type Form1099DaComparisonQueryVariables = Exact<{
  taxYear: Scalars['Int']['input'];
}>;

export type Form1099DaComparisonQuery = {
  __typename?: 'Query';
  form1099daComparison: {
    __typename?: 'Form1099DAComparisonResult';
    edges: Array<{
      __typename?: 'Form1099DAComparisonEdge';
      isManualEntry: boolean;
      form1099daProceeds?: number | null;
      form1099daTransactionCount?: number | null;
      form8949Proceeds?: number | null;
      form8949TransactionCount?: number | null;
      unadjustedForm1099daProceeds?: number | null;
      unadjustedForm1099daTransactionCount?: number | null;
      unadjustedForm8949Proceeds?: number | null;
      unadjustedForm8949TransactionCount?: number | null;
      integration?: { __typename?: 'Form1099DaIntegration'; id: string; name: string } | null;
      exclusionRules: Array<{
        __typename?: 'Form1099DaComparisonExclusionRule';
        integrationId: string;
        currency: string;
        message: string;
        url: string;
      }>;
      proceedsByAsset: Array<{
        __typename?: 'ProceedsComparisonByAsset';
        assetName: string;
        form1099daProceeds?: number | null;
        form1099daTransactionCount?: number | null;
        form8949Proceeds?: number | null;
        form8949TransactionCount?: number | null;
        excluded: boolean;
      }>;
      trueUpItems: Array<{
        __typename?: 'Form1099DaTrueUpItem';
        id: string;
        amount: number;
        createdAt: string;
      }>;
    }>;
  };
};

export type CreateForm1099DaTrueUpTxnMutationVariables = Exact<{
  amount: Scalars['Float']['input'];
  integrationId: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
}>;

export type CreateForm1099DaTrueUpTxnMutation = {
  __typename?: 'Mutation';
  createForm1099DaTrueUpTxn: boolean;
};

export type DeleteForm1099DaTrueUpTxnMutationVariables = Exact<{
  integrationId: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
}>;

export type DeleteForm1099DaTrueUpTxnMutation = {
  __typename?: 'Mutation';
  deleteForm1099DaTrueUpTxn: boolean;
};

export type ResolveUnreconciledTransactionsMutationVariables = Exact<{
  unreconciledTransactionInputs: Array<UnreconciledTransactionInput> | UnreconciledTransactionInput;
}>;

export type ResolveUnreconciledTransactionsMutation = {
  __typename?: 'Mutation';
  resolveUnreconciledTransactions: {
    __typename?: 'ResolveUnreconciledTransactionResponse';
    errors: Array<{ __typename?: 'ResolutionError'; unreconciledTransactionId: string; message: string }>;
    resolutions: Array<{
      __typename?: 'UnreconciledTransactionResolution';
      id: number;
      unreconciledTransactionId: string;
      userId: number;
      credentialType: string;
      blocksvcHash: string;
      category: string;
      edited: boolean;
      appliedAt: any;
      invalidatedAt?: any | null;
      revertedAt?: any | null;
      drafts: Array<{
        __typename?: 'Draft';
        sent?: {
          __typename?: 'TransfersGroup';
          txns: Array<{
            __typename?: 'SelfReconTransfer';
            id?: string | null;
            currency: string;
            tokenId?: string | null;
            quantity: string;
            type: TransferType;
          } | null>;
        } | null;
        received?: {
          __typename?: 'TransfersGroup';
          txns: Array<{
            __typename?: 'SelfReconTransfer';
            id?: string | null;
            currency: string;
            tokenId?: string | null;
            quantity: string;
            type: TransferType;
          } | null>;
        } | null;
      }>;
    }>;
  };
};

export type UnreconciledTransactionsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationOptions>;
  sortBy: UnreconciledTransactionsSortOptions;
  sortDirection: SortDirectionOptions;
  filterQuery?: InputMaybe<UnreconciledTxnsFiltersQuery>;
  hashes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type UnreconciledTransactionsQuery = {
  __typename?: 'Query';
  unreconciledTransactions: {
    __typename?: 'UnreconciledTransactions';
    edges: Array<{
      __typename?: 'UnreconciledTransaction';
      id: string;
      hash: string;
      sentTxnsCount: number;
      receivedTxnsCount: number;
      timestamp: any;
      editedAt?: any | null;
      from?: string | null;
      to?: string | null;
      contractPublicName?: string | null;
      resolved: boolean;
      invalidated: boolean;
      resolutionCategory?: string | null;
      resolutionId?: number | null;
      ecosystem: SupportedEcosystem;
      reconIdentifier?: string | null;
      credentials: Array<{
        __typename?: 'UnreconciledTxnCredential';
        id: number;
        source: CredentialSource;
        type: string;
        name?: string | null;
        address?: string | null;
      }>;
      method: {
        __typename?: 'UnreconciledTransactionMethod';
        id?: number | null;
        hash: string;
        name?: string | null;
      };
      instruction?:
        | {
            __typename?: 'EvmInstruction';
            id: number;
            contractId: number;
            notes?: string | null;
            proba1?: number | null;
            pred1?: number | null;
            publicNotes?: string | null;
            tokenParam1?: Array<string> | null;
            tokenParam2?: Array<string> | null;
            treatment?: { __typename?: 'Treatment'; id: number; description?: string | null } | null;
          }
        | {
            __typename?: 'IdentifierBasedInstruction';
            id: number;
            notes?: string | null;
            publicNotes?: string | null;
            tokenParam1?: Array<string> | null;
            tokenParam2?: Array<string> | null;
            treatment?: { __typename?: 'Treatment'; id: number; description?: string | null } | null;
          }
        | null;
    }>;
    pageInfo: { __typename?: 'PageInfo'; filteredCount?: number | null };
  };
};

export type GetLpTokensQueryVariables = Exact<{ [key: string]: never }>;

export type GetLpTokensQuery = {
  __typename?: 'Query';
  getLpTokens: Array<{ __typename?: 'LpToken'; address: string; ticker: string }>;
};

export type UnreconciledTransactionDataFragmentFragment = {
  __typename?: 'Txn';
  id: string;
  txnType: TxnType;
  buyAddress?: string | null;
  buyCurrency: string;
  buyPrice: string;
  buyQuantity: string;
  buyTokenId?: string | null;
  sellAddress?: string | null;
  sellCurrency: string;
  sellPrice: string;
  sellQuantity: string;
  sellTokenId?: string | null;
  feeCurrency?: string | null;
  feeTokenId?: string | null;
  feeQuantity?: number | null;
  feePrice: string;
  blocksvcToAddress?: string | null;
  blocksvcFromAddress?: string | null;
};

export type UnreconciledTxnsDataQueryVariables = Exact<{
  txnHashes: Array<Scalars['String']['input']> | Scalars['String']['input'];
  credentialType: Scalars['String']['input'];
}>;

export type UnreconciledTxnsDataQuery = {
  __typename?: 'Query';
  unreconciledTxnsData: Array<{
    __typename?: 'UnreconciledTxnsData';
    txnHash: string;
    ecosystem: SupportedEcosystem;
    txns: Array<{
      __typename?: 'Txn';
      id: string;
      txnType: TxnType;
      buyAddress?: string | null;
      buyCurrency: string;
      buyPrice: string;
      buyQuantity: string;
      buyTokenId?: string | null;
      sellAddress?: string | null;
      sellCurrency: string;
      sellPrice: string;
      sellQuantity: string;
      sellTokenId?: string | null;
      feeCurrency?: string | null;
      feeTokenId?: string | null;
      feeQuantity?: number | null;
      feePrice: string;
      blocksvcToAddress?: string | null;
      blocksvcFromAddress?: string | null;
    }>;
  }>;
};

export type SupportedSelfReconCredentialsCountQueryVariables = Exact<{ [key: string]: never }>;

export type SupportedSelfReconCredentialsCountQuery = {
  __typename?: 'Query';
  supportedSelfReconCredentialsCount: { __typename?: 'SupportedSelfReconCredentialCount'; count: number };
};

export type TransferGroupEditHistoryQueryVariables = Exact<{
  transferGroupEditTableInput: TransferGroupEditTableInput;
}>;

export type TransferGroupEditHistoryQuery = {
  __typename?: 'Query';
  transferGroupEdits: {
    __typename?: 'TransferGroupEdits';
    edges: Array<{
      __typename?: 'TransferGroupEdit';
      id: string;
      userId: number;
      transferGroupId: string;
      status: EnumTransferGroupEditStatus;
      description?: string | null;
      createdByEmail?: string | null;
      createdAt: any;
      appliedAt?: any | null;
    }>;
    statusCounts: Array<{
      __typename?: 'TransferGroupEditStatusCount';
      status: EnumTransferGroupEditStatus;
      count: number;
    }>;
    pageInfo: { __typename?: 'PageInfo'; filteredCount?: number | null; hasNext?: boolean | null };
  };
};

export type InviteUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;

export type InviteUserMutation = { __typename?: 'Mutation'; inviteUser: boolean };

export type SendEmailVerificationMutationVariables = Exact<{ [key: string]: never }>;

export type SendEmailVerificationMutation = { __typename?: 'Mutation'; sendEmailVerification: boolean };

export type BeginTwoFactorSetupMutationVariables = Exact<{ [key: string]: never }>;

export type BeginTwoFactorSetupMutation = {
  __typename?: 'Mutation';
  beginTwoFactorSetup: { __typename?: 'TwoFactorSetup'; qrCodeDataUrl: string; manualEntryKey: string };
};

export type ConfirmTwoFactorSetupMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;

export type ConfirmTwoFactorSetupMutation = { __typename?: 'Mutation'; confirmTwoFactorSetup: Array<string> };

export type DisableTwoFactorMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;

export type DisableTwoFactorMutation = { __typename?: 'Mutation'; disableTwoFactor: boolean };

export type RegenerateTwoFactorRecoveryCodesMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;

export type RegenerateTwoFactorRecoveryCodesMutation = {
  __typename?: 'Mutation';
  regenerateTwoFactorRecoveryCodes: Array<string>;
};

export type ChangePasswordMutationVariables = Exact<{
  oldPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;

export type ChangePasswordMutation = { __typename?: 'Mutation'; changePassword: boolean };

export type QuickbooksAuthUrlQueryVariables = Exact<{ [key: string]: never }>;

export type QuickbooksAuthUrlQuery = { __typename?: 'Query'; quickbooksAuthUrl: string };

export type QuickbooksConnectedQueryVariables = Exact<{ [key: string]: never }>;

export type QuickbooksConnectedQuery = { __typename?: 'Query'; quickbooksConnected: boolean };

export type QuickbooksOauthMutationVariables = Exact<{
  code: Scalars['String']['input'];
  state: Scalars['String']['input'];
  realmId: Scalars['String']['input'];
}>;

export type QuickbooksOauthMutation = { __typename?: 'Mutation'; quickbooksOauth: boolean };

export type QuickbooksSyncMutationVariables = Exact<{ [key: string]: never }>;

export type QuickbooksSyncMutation = { __typename?: 'Mutation'; quickbooksSyncData: boolean };

export type QuickbooksDisconnectMutationVariables = Exact<{ [key: string]: never }>;

export type QuickbooksDisconnectMutation = { __typename?: 'Mutation'; quickbooksDisconnect: boolean };

export type McpIntegrationsQueryVariables = Exact<{ [key: string]: never }>;

export type McpIntegrationsQuery = {
  __typename?: 'Query';
  mcpIntegrations: Array<{
    __typename?: 'McpIntegration';
    clientId: string;
    clientName?: string | null;
    authorizedAt: number;
    lastRefreshedAt: number;
  }>;
};

export type RevokeMcpIntegrationMutationVariables = Exact<{
  clientId: Scalars['String']['input'];
}>;

export type RevokeMcpIntegrationMutation = { __typename?: 'Mutation'; revokeMcpIntegration: boolean };

export type UpdateUserTaxDetailMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  countryId: Scalars['Int']['input'];
  longTermCapitalGainsRate: Scalars['Float']['input'];
  marginalTaxRate: Scalars['Float']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateUserTaxDetailMutation = {
  __typename?: 'Mutation';
  updateUserTaxDetail: {
    __typename?: 'UserTaxDetail';
    id: number;
    state?: string | null;
    marginalTaxRate?: number | null;
    longTermCapitalGainsRate?: number | null;
    taxYear: number;
    taxMethod?: { __typename?: 'TaxMethod'; id: EnumTaxMethod; label: string } | null;
    country: { __typename?: 'Country'; name: string; shorthand: string; id: number };
  };
};

export type SetUserLockedThroughYearMutationVariables = Exact<{
  lockedThroughYear?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SetUserLockedThroughYearMutation = {
  __typename?: 'Mutation';
  setUserLockedThroughYear: { __typename?: 'User'; id: number };
};

export type SignupMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  captchaResponse: Scalars['String']['input'];
}>;

export type SignupMutation = {
  __typename?: 'Mutation';
  signup: {
    __typename?: 'LoginOrSignupResponse';
    userHash: string;
    user: { __typename?: 'User'; id: number };
  };
};

export type AuditDetailFragment = {
  __typename?: 'LineItemAuditDetail';
  date?: any | null;
  txnType: TxnType;
  location: string;
  soldCurrency: string;
  boughtCurrency: string;
  feeCurrency: string;
  soldAmount: number;
  boughtAmount: number;
  feeAmount: number;
  price: number;
  isMovementFromUnassigned: boolean;
  txn?: {
    __typename?: 'Txn';
    id: string;
    associatedExchangeAddress?: string | null;
    blocksvcHash?: string | null;
    credentialId?: number | null;
    buyCurrency: string;
    buyTokenId?: string | null;
    buyAddress?: string | null;
    buyNftId?: string | null;
    description?: string | null;
    exchangeId?: string | null;
    exchangeName?: string | null;
    feeCurrency?: string | null;
    feeTokenId?: string | null;
    feeQuantity?: number | null;
    feePrice: string;
    feeAddress?: string | null;
    buyPrice: string;
    sellPrice: string;
    buyQuantity: string;
    sellCurrency: string;
    sellTokenId?: string | null;
    sellAddress?: string | null;
    sellNftId?: string | null;
    sellQuantity: string;
    txnTimestamp: any;
    txnType: TxnType;
    unitPrice?: number | null;
    priceFetchingSide?: PriceFetchingSide | null;
    usdSpotPrice?: number | null;
    blocksvcMethodId?: string | null;
    blocksvcToAddress?: string | null;
    blocksvcFromAddress?: string | null;
    createdAt: any;
    updatedAt: any;
    isEdited?: boolean | null;
    isSpam: boolean;
    reviewed?: boolean | null;
    editedByReconGuideJob: boolean;
    reconIdentifier?: string | null;
    txnTopicFingerprint?: string | null;
    transferTopicFingerprint?: string | null;
    bkpVendorId?: number | null;
    bkpAccountDebitId?: number | null;
    bkpAccountCreditId?: number | null;
    accountId?: number | null;
    toAccountId?: number | null;
    hasMovement?: boolean | null;
    isPricingAnomaly: boolean;
    groupId?: number | null;
    groupComponentType?: TxnGroupComponentType | null;
    bkpVendor?: {
      __typename?: 'BkpVendor';
      id: number;
      bkpIntegrationId?: string | null;
      bkpIntegrationDisplayName?: string | null;
    } | null;
    bkpAccountDebit?: {
      __typename?: 'BkpAccount';
      id: number;
      bkpIntegrationId?: string | null;
      name?: string | null;
    } | null;
    bkpAccountCredit?: {
      __typename?: 'BkpAccount';
      id: number;
      bkpIntegrationId?: string | null;
      name?: string | null;
    } | null;
    credential: {
      __typename?: 'Credential';
      accountId?: number | null;
      credentialType: string;
      source: CredentialSource;
      name?: string | null;
      address?: string | null;
      integrationId?: string | null;
    };
    specIdMatchesAsComponent: Array<{
      __typename?: 'SpecIdMatch';
      componentId: string;
      sellId: string;
      componentQuantity: number;
      componentOrder: number;
    }>;
    specIdMatchesAsSell: Array<{
      __typename?: 'SpecIdMatch';
      componentId: string;
      sellId: string;
      componentQuantity: number;
      componentOrder: number;
    }>;
  } | null;
  fromAccount?: { __typename?: 'Account'; name: string; integrationId?: string | null } | null;
  toAccount?: { __typename?: 'Account'; name: string; integrationId?: string | null } | null;
};

export type ExpandedRowQueryVariables = Exact<{
  lineItemId: Scalars['BigInt']['input'];
  isAdmin: Scalars['Boolean']['input'];
}>;

export type ExpandedRowQuery = {
  __typename?: 'Query';
  lineItemDetails: {
    __typename?: 'LineItemDetail';
    missingCostBasis: boolean;
    term?: string | null;
    averageCost?: number | null;
    soldAmountFlat: number;
    costBasis: number;
    costBasisFlat: number;
    costBasisFromSellFee: number;
    costBasisFeeAddition: number;
    costBasisFeeAdditionUnits: number;
    costBasisFeeAdditionCurrency: string;
    proceeds: number;
    proceedsFlat: number;
    proceedsFromSellFee: number;
    proceedsFeeDeduction: number;
    proceedsFeeDeductionUnits: number;
    proceedsFeeDeductionCurrency: string;
    gainLoss: number;
    bnbMatchType?: string | null;
    specIdMatch?: boolean | null;
    originDetail?: {
      __typename?: 'LineItemAuditDetail';
      date?: any | null;
      txnType: TxnType;
      location: string;
      soldCurrency: string;
      boughtCurrency: string;
      feeCurrency: string;
      soldAmount: number;
      boughtAmount: number;
      feeAmount: number;
      price: number;
      isMovementFromUnassigned: boolean;
      txn?: {
        __typename?: 'Txn';
        id: string;
        associatedExchangeAddress?: string | null;
        blocksvcHash?: string | null;
        credentialId?: number | null;
        buyCurrency: string;
        buyTokenId?: string | null;
        buyAddress?: string | null;
        buyNftId?: string | null;
        description?: string | null;
        exchangeId?: string | null;
        exchangeName?: string | null;
        feeCurrency?: string | null;
        feeTokenId?: string | null;
        feeQuantity?: number | null;
        feePrice: string;
        feeAddress?: string | null;
        buyPrice: string;
        sellPrice: string;
        buyQuantity: string;
        sellCurrency: string;
        sellTokenId?: string | null;
        sellAddress?: string | null;
        sellNftId?: string | null;
        sellQuantity: string;
        txnTimestamp: any;
        txnType: TxnType;
        unitPrice?: number | null;
        priceFetchingSide?: PriceFetchingSide | null;
        usdSpotPrice?: number | null;
        blocksvcMethodId?: string | null;
        blocksvcToAddress?: string | null;
        blocksvcFromAddress?: string | null;
        createdAt: any;
        updatedAt: any;
        isEdited?: boolean | null;
        isSpam: boolean;
        reviewed?: boolean | null;
        editedByReconGuideJob: boolean;
        reconIdentifier?: string | null;
        txnTopicFingerprint?: string | null;
        transferTopicFingerprint?: string | null;
        bkpVendorId?: number | null;
        bkpAccountDebitId?: number | null;
        bkpAccountCreditId?: number | null;
        accountId?: number | null;
        toAccountId?: number | null;
        hasMovement?: boolean | null;
        isPricingAnomaly: boolean;
        groupId?: number | null;
        groupComponentType?: TxnGroupComponentType | null;
        bkpVendor?: {
          __typename?: 'BkpVendor';
          id: number;
          bkpIntegrationId?: string | null;
          bkpIntegrationDisplayName?: string | null;
        } | null;
        bkpAccountDebit?: {
          __typename?: 'BkpAccount';
          id: number;
          bkpIntegrationId?: string | null;
          name?: string | null;
        } | null;
        bkpAccountCredit?: {
          __typename?: 'BkpAccount';
          id: number;
          bkpIntegrationId?: string | null;
          name?: string | null;
        } | null;
        credential: {
          __typename?: 'Credential';
          accountId?: number | null;
          credentialType: string;
          source: CredentialSource;
          name?: string | null;
          address?: string | null;
          integrationId?: string | null;
        };
        specIdMatchesAsComponent: Array<{
          __typename?: 'SpecIdMatch';
          componentId: string;
          sellId: string;
          componentQuantity: number;
          componentOrder: number;
        }>;
        specIdMatchesAsSell: Array<{
          __typename?: 'SpecIdMatch';
          componentId: string;
          sellId: string;
          componentQuantity: number;
          componentOrder: number;
        }>;
      } | null;
      fromAccount?: { __typename?: 'Account'; name: string; integrationId?: string | null } | null;
      toAccount?: { __typename?: 'Account'; name: string; integrationId?: string | null } | null;
    } | null;
    migrationDetail?: {
      __typename?: 'LineItemAuditDetail';
      date?: any | null;
      txnType: TxnType;
      location: string;
      soldCurrency: string;
      boughtCurrency: string;
      feeCurrency: string;
      soldAmount: number;
      boughtAmount: number;
      feeAmount: number;
      price: number;
      isMovementFromUnassigned: boolean;
      txn?: {
        __typename?: 'Txn';
        id: string;
        associatedExchangeAddress?: string | null;
        blocksvcHash?: string | null;
        credentialId?: number | null;
        buyCurrency: string;
        buyTokenId?: string | null;
        buyAddress?: string | null;
        buyNftId?: string | null;
        description?: string | null;
        exchangeId?: string | null;
        exchangeName?: string | null;
        feeCurrency?: string | null;
        feeTokenId?: string | null;
        feeQuantity?: number | null;
        feePrice: string;
        feeAddress?: string | null;
        buyPrice: string;
        sellPrice: string;
        buyQuantity: string;
        sellCurrency: string;
        sellTokenId?: string | null;
        sellAddress?: string | null;
        sellNftId?: string | null;
        sellQuantity: string;
        txnTimestamp: any;
        txnType: TxnType;
        unitPrice?: number | null;
        priceFetchingSide?: PriceFetchingSide | null;
        usdSpotPrice?: number | null;
        blocksvcMethodId?: string | null;
        blocksvcToAddress?: string | null;
        blocksvcFromAddress?: string | null;
        createdAt: any;
        updatedAt: any;
        isEdited?: boolean | null;
        isSpam: boolean;
        reviewed?: boolean | null;
        editedByReconGuideJob: boolean;
        reconIdentifier?: string | null;
        txnTopicFingerprint?: string | null;
        transferTopicFingerprint?: string | null;
        bkpVendorId?: number | null;
        bkpAccountDebitId?: number | null;
        bkpAccountCreditId?: number | null;
        accountId?: number | null;
        toAccountId?: number | null;
        hasMovement?: boolean | null;
        isPricingAnomaly: boolean;
        groupId?: number | null;
        groupComponentType?: TxnGroupComponentType | null;
        bkpVendor?: {
          __typename?: 'BkpVendor';
          id: number;
          bkpIntegrationId?: string | null;
          bkpIntegrationDisplayName?: string | null;
        } | null;
        bkpAccountDebit?: {
          __typename?: 'BkpAccount';
          id: number;
          bkpIntegrationId?: string | null;
          name?: string | null;
        } | null;
        bkpAccountCredit?: {
          __typename?: 'BkpAccount';
          id: number;
          bkpIntegrationId?: string | null;
          name?: string | null;
        } | null;
        credential: {
          __typename?: 'Credential';
          accountId?: number | null;
          credentialType: string;
          source: CredentialSource;
          name?: string | null;
          address?: string | null;
          integrationId?: string | null;
        };
        specIdMatchesAsComponent: Array<{
          __typename?: 'SpecIdMatch';
          componentId: string;
          sellId: string;
          componentQuantity: number;
          componentOrder: number;
        }>;
        specIdMatchesAsSell: Array<{
          __typename?: 'SpecIdMatch';
          componentId: string;
          sellId: string;
          componentQuantity: number;
          componentOrder: number;
        }>;
      } | null;
      fromAccount?: { __typename?: 'Account'; name: string; integrationId?: string | null } | null;
      toAccount?: { __typename?: 'Account'; name: string; integrationId?: string | null } | null;
    } | null;
    exitDetail?: {
      __typename?: 'LineItemAuditDetail';
      date?: any | null;
      txnType: TxnType;
      location: string;
      soldCurrency: string;
      boughtCurrency: string;
      feeCurrency: string;
      soldAmount: number;
      boughtAmount: number;
      feeAmount: number;
      price: number;
      isMovementFromUnassigned: boolean;
      txn?: {
        __typename?: 'Txn';
        id: string;
        associatedExchangeAddress?: string | null;
        blocksvcHash?: string | null;
        credentialId?: number | null;
        buyCurrency: string;
        buyTokenId?: string | null;
        buyAddress?: string | null;
        buyNftId?: string | null;
        description?: string | null;
        exchangeId?: string | null;
        exchangeName?: string | null;
        feeCurrency?: string | null;
        feeTokenId?: string | null;
        feeQuantity?: number | null;
        feePrice: string;
        feeAddress?: string | null;
        buyPrice: string;
        sellPrice: string;
        buyQuantity: string;
        sellCurrency: string;
        sellTokenId?: string | null;
        sellAddress?: string | null;
        sellNftId?: string | null;
        sellQuantity: string;
        txnTimestamp: any;
        txnType: TxnType;
        unitPrice?: number | null;
        priceFetchingSide?: PriceFetchingSide | null;
        usdSpotPrice?: number | null;
        blocksvcMethodId?: string | null;
        blocksvcToAddress?: string | null;
        blocksvcFromAddress?: string | null;
        createdAt: any;
        updatedAt: any;
        isEdited?: boolean | null;
        isSpam: boolean;
        reviewed?: boolean | null;
        editedByReconGuideJob: boolean;
        reconIdentifier?: string | null;
        txnTopicFingerprint?: string | null;
        transferTopicFingerprint?: string | null;
        bkpVendorId?: number | null;
        bkpAccountDebitId?: number | null;
        bkpAccountCreditId?: number | null;
        accountId?: number | null;
        toAccountId?: number | null;
        hasMovement?: boolean | null;
        isPricingAnomaly: boolean;
        groupId?: number | null;
        groupComponentType?: TxnGroupComponentType | null;
        bkpVendor?: {
          __typename?: 'BkpVendor';
          id: number;
          bkpIntegrationId?: string | null;
          bkpIntegrationDisplayName?: string | null;
        } | null;
        bkpAccountDebit?: {
          __typename?: 'BkpAccount';
          id: number;
          bkpIntegrationId?: string | null;
          name?: string | null;
        } | null;
        bkpAccountCredit?: {
          __typename?: 'BkpAccount';
          id: number;
          bkpIntegrationId?: string | null;
          name?: string | null;
        } | null;
        credential: {
          __typename?: 'Credential';
          accountId?: number | null;
          credentialType: string;
          source: CredentialSource;
          name?: string | null;
          address?: string | null;
          integrationId?: string | null;
        };
        specIdMatchesAsComponent: Array<{
          __typename?: 'SpecIdMatch';
          componentId: string;
          sellId: string;
          componentQuantity: number;
          componentOrder: number;
        }>;
        specIdMatchesAsSell: Array<{
          __typename?: 'SpecIdMatch';
          componentId: string;
          sellId: string;
          componentQuantity: number;
          componentOrder: number;
        }>;
      } | null;
      fromAccount?: { __typename?: 'Account'; name: string; integrationId?: string | null } | null;
      toAccount?: { __typename?: 'Account'; name: string; integrationId?: string | null } | null;
    } | null;
    missingCostBasisDetail?: {
      __typename?: 'LineItemMissingCostBasisDetail';
      missingCurrency: string;
      missingAmount: number;
    } | null;
    lineItemTrace: Array<{
      __typename?: 'LineItem';
      id: any;
      buyId?: string | null;
      sellId?: string | null;
      sellCurrency?: string | null;
      buyCurrency?: string | null;
      unitsSold?: number | null;
      buyDate?: any | null;
      sellDate?: any | null;
      proceedsIncludingFees: number;
      costBasisIncludingFees: number;
      gainLossIncludingFees: number;
      term?: string | null;
      missingCostBasis?: boolean | null;
      splitBuyId?: string | null;
      isMovementFromUnassigned: boolean;
      lineItemType: string;
      txnLineItemSellIdTotxn?: {
        __typename?: 'Txn';
        id: string;
        associatedExchangeAddress?: string | null;
        blocksvcHash?: string | null;
        credentialId?: number | null;
        buyCurrency: string;
        buyTokenId?: string | null;
        buyAddress?: string | null;
        buyNftId?: string | null;
        description?: string | null;
        exchangeId?: string | null;
        exchangeName?: string | null;
        feeCurrency?: string | null;
        feeTokenId?: string | null;
        feeQuantity?: number | null;
        feePrice: string;
        feeAddress?: string | null;
        buyPrice: string;
        sellPrice: string;
        buyQuantity: string;
        sellCurrency: string;
        sellTokenId?: string | null;
        sellAddress?: string | null;
        sellNftId?: string | null;
        sellQuantity: string;
        txnTimestamp: any;
        txnType: TxnType;
        unitPrice?: number | null;
        priceFetchingSide?: PriceFetchingSide | null;
        usdSpotPrice?: number | null;
        blocksvcMethodId?: string | null;
        blocksvcToAddress?: string | null;
        blocksvcFromAddress?: string | null;
        createdAt: any;
        updatedAt: any;
        isEdited?: boolean | null;
        isSpam: boolean;
        reviewed?: boolean | null;
        editedByReconGuideJob: boolean;
        reconIdentifier?: string | null;
        txnTopicFingerprint?: string | null;
        transferTopicFingerprint?: string | null;
        bkpVendorId?: number | null;
        bkpAccountDebitId?: number | null;
        bkpAccountCreditId?: number | null;
        accountId?: number | null;
        toAccountId?: number | null;
        hasMovement?: boolean | null;
        isPricingAnomaly: boolean;
        groupId?: number | null;
        groupComponentType?: TxnGroupComponentType | null;
        bkpVendor?: {
          __typename?: 'BkpVendor';
          id: number;
          bkpIntegrationId?: string | null;
          bkpIntegrationDisplayName?: string | null;
        } | null;
        bkpAccountDebit?: {
          __typename?: 'BkpAccount';
          id: number;
          bkpIntegrationId?: string | null;
          name?: string | null;
        } | null;
        bkpAccountCredit?: {
          __typename?: 'BkpAccount';
          id: number;
          bkpIntegrationId?: string | null;
          name?: string | null;
        } | null;
        credential: {
          __typename?: 'Credential';
          accountId?: number | null;
          credentialType: string;
          source: CredentialSource;
          name?: string | null;
          address?: string | null;
          integrationId?: string | null;
        };
        specIdMatchesAsComponent: Array<{
          __typename?: 'SpecIdMatch';
          componentId: string;
          sellId: string;
          componentQuantity: number;
          componentOrder: number;
        }>;
        specIdMatchesAsSell: Array<{
          __typename?: 'SpecIdMatch';
          componentId: string;
          sellId: string;
          componentQuantity: number;
          componentOrder: number;
        }>;
      } | null;
      account?: { __typename?: 'Account'; id: number; name: string; integrationId?: string | null } | null;
      movementFromAccount?: {
        __typename?: 'Account';
        id: number;
        name: string;
        integrationId?: string | null;
      } | null;
    }>;
  };
};

export type LineItemsQueryVariables = Exact<{
  txnReportId: Scalars['Int']['input'];
  pagination: PaginationOptions;
  sortBy: LineItemSortOptions;
  sortDirection: SortDirectionOptions;
  filterQuery?: InputMaybe<LineItemsFilterQuery>;
  isAdmin: Scalars['Boolean']['input'];
  filterDust?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type LineItemsQuery = {
  __typename?: 'Query';
  lineItems: {
    __typename?: 'LineItems';
    pageInfo: { __typename?: 'PageInfo'; filteredCount?: number | null };
    edges: Array<{
      __typename?: 'LineItem';
      id: any;
      buyId?: string | null;
      sellId?: string | null;
      sellCurrency?: string | null;
      buyCurrency?: string | null;
      unitsSold?: number | null;
      feeUnitsSold?: number | null;
      feeCurrency?: string | null;
      buyDate?: any | null;
      sellDate?: any | null;
      proceedsIncludingFees: number;
      costBasisIncludingFees: number;
      gainLossIncludingFees: number;
      term?: string | null;
      missingCostBasis?: boolean | null;
      splitBuyId?: string | null;
      txnReportId: number;
      isFee?: boolean | null;
      accountId?: number | null;
      isMovementFromUnassigned: boolean;
      lineItemType: string;
      account?: { __typename?: 'Account'; id: number; name: string; integrationId?: string | null } | null;
      movementFromAccount?: {
        __typename?: 'Account';
        id: number;
        name: string;
        integrationId?: string | null;
      } | null;
      txnLineItemSellIdTotxn?: {
        __typename?: 'Txn';
        id: string;
        associatedExchangeAddress?: string | null;
        blocksvcHash?: string | null;
        credentialId?: number | null;
        buyCurrency: string;
        buyTokenId?: string | null;
        buyAddress?: string | null;
        buyNftId?: string | null;
        description?: string | null;
        exchangeId?: string | null;
        exchangeName?: string | null;
        feeCurrency?: string | null;
        feeTokenId?: string | null;
        feeQuantity?: number | null;
        feePrice: string;
        feeAddress?: string | null;
        buyPrice: string;
        sellPrice: string;
        buyQuantity: string;
        sellCurrency: string;
        sellTokenId?: string | null;
        sellAddress?: string | null;
        sellNftId?: string | null;
        sellQuantity: string;
        txnTimestamp: any;
        txnType: TxnType;
        unitPrice?: number | null;
        priceFetchingSide?: PriceFetchingSide | null;
        usdSpotPrice?: number | null;
        blocksvcMethodId?: string | null;
        blocksvcToAddress?: string | null;
        blocksvcFromAddress?: string | null;
        createdAt: any;
        updatedAt: any;
        isEdited?: boolean | null;
        isSpam: boolean;
        reviewed?: boolean | null;
        editedByReconGuideJob: boolean;
        reconIdentifier?: string | null;
        txnTopicFingerprint?: string | null;
        transferTopicFingerprint?: string | null;
        bkpVendorId?: number | null;
        bkpAccountDebitId?: number | null;
        bkpAccountCreditId?: number | null;
        accountId?: number | null;
        toAccountId?: number | null;
        hasMovement?: boolean | null;
        isPricingAnomaly: boolean;
        groupId?: number | null;
        groupComponentType?: TxnGroupComponentType | null;
        bkpVendor?: {
          __typename?: 'BkpVendor';
          id: number;
          bkpIntegrationId?: string | null;
          bkpIntegrationDisplayName?: string | null;
        } | null;
        bkpAccountDebit?: {
          __typename?: 'BkpAccount';
          id: number;
          bkpIntegrationId?: string | null;
          name?: string | null;
        } | null;
        bkpAccountCredit?: {
          __typename?: 'BkpAccount';
          id: number;
          bkpIntegrationId?: string | null;
          name?: string | null;
        } | null;
        credential: {
          __typename?: 'Credential';
          accountId?: number | null;
          credentialType: string;
          source: CredentialSource;
          name?: string | null;
          address?: string | null;
          integrationId?: string | null;
        };
        specIdMatchesAsComponent: Array<{
          __typename?: 'SpecIdMatch';
          componentId: string;
          sellId: string;
          componentQuantity: number;
          componentOrder: number;
        }>;
        specIdMatchesAsSell: Array<{
          __typename?: 'SpecIdMatch';
          componentId: string;
          sellId: string;
          componentQuantity: number;
          componentOrder: number;
        }>;
      } | null;
    }>;
  };
};

export type V2AuditDetailFragment = {
  __typename?: 'LineItemV2AuditDetail';
  date?: any | null;
  txnType: EnumTransferType;
  location: string;
  soldCurrency: string;
  soldAmount: number;
  price: number;
  isMovement: boolean;
  isMovementFromUnassigned: boolean;
  outgoingTransferGroupId?: string | null;
  incomingTransferGroupId?: string | null;
  fromAccount?: { __typename?: 'Account'; name: string; integrationId?: string | null } | null;
  toAccount?: { __typename?: 'Account'; name: string; integrationId?: string | null } | null;
  boughtCurrencies: Array<{ __typename?: 'LineItemV2Currency'; currency: string; amount: number }>;
  feeCurrencies: Array<{ __typename?: 'LineItemV2Currency'; currency: string; amount: number }>;
};

export type LineItemDetailsV2QueryVariables = Exact<{
  lineItemId: Scalars['BigInt']['input'];
}>;

export type LineItemDetailsV2Query = {
  __typename?: 'Query';
  lineItemDetailsV2: {
    __typename?: 'LineItemV2Detail';
    missingCostBasis: boolean;
    term?: string | null;
    averageCost?: number | null;
    soldAmountFlat: number;
    feeUnitsSold: number;
    costBasis: number;
    costBasisFlat: number;
    costBasisFromSellFee: number;
    costBasisFeeAddition: number;
    proceeds: number;
    proceedsFlat: number;
    proceedsFromSellFee: number;
    proceedsFeeDeduction: number;
    gainLoss: number;
    bnbMatchType?: string | null;
    originDetail?: {
      __typename?: 'LineItemV2AuditDetail';
      date?: any | null;
      txnType: EnumTransferType;
      location: string;
      soldCurrency: string;
      soldAmount: number;
      price: number;
      isMovement: boolean;
      isMovementFromUnassigned: boolean;
      outgoingTransferGroupId?: string | null;
      incomingTransferGroupId?: string | null;
      fromAccount?: { __typename?: 'Account'; name: string; integrationId?: string | null } | null;
      toAccount?: { __typename?: 'Account'; name: string; integrationId?: string | null } | null;
      boughtCurrencies: Array<{ __typename?: 'LineItemV2Currency'; currency: string; amount: number }>;
      feeCurrencies: Array<{ __typename?: 'LineItemV2Currency'; currency: string; amount: number }>;
    } | null;
    migrationDetail?: {
      __typename?: 'LineItemV2AuditDetail';
      date?: any | null;
      txnType: EnumTransferType;
      location: string;
      soldCurrency: string;
      soldAmount: number;
      price: number;
      isMovement: boolean;
      isMovementFromUnassigned: boolean;
      outgoingTransferGroupId?: string | null;
      incomingTransferGroupId?: string | null;
      fromAccount?: { __typename?: 'Account'; name: string; integrationId?: string | null } | null;
      toAccount?: { __typename?: 'Account'; name: string; integrationId?: string | null } | null;
      boughtCurrencies: Array<{ __typename?: 'LineItemV2Currency'; currency: string; amount: number }>;
      feeCurrencies: Array<{ __typename?: 'LineItemV2Currency'; currency: string; amount: number }>;
    } | null;
    exitDetail?: {
      __typename?: 'LineItemV2AuditDetail';
      date?: any | null;
      txnType: EnumTransferType;
      location: string;
      soldCurrency: string;
      soldAmount: number;
      price: number;
      isMovement: boolean;
      isMovementFromUnassigned: boolean;
      outgoingTransferGroupId?: string | null;
      incomingTransferGroupId?: string | null;
      fromAccount?: { __typename?: 'Account'; name: string; integrationId?: string | null } | null;
      toAccount?: { __typename?: 'Account'; name: string; integrationId?: string | null } | null;
      boughtCurrencies: Array<{ __typename?: 'LineItemV2Currency'; currency: string; amount: number }>;
      feeCurrencies: Array<{ __typename?: 'LineItemV2Currency'; currency: string; amount: number }>;
    } | null;
    missingCostBasisDetail?: {
      __typename?: 'LineItemV2MissingCostBasisDetail';
      missingCurrency: string;
      missingAmount: number;
    } | null;
    costBasisFeeAdditions: Array<{
      __typename?: 'LineItemV2Fee';
      currency: string;
      amount: number;
      value: number;
    }>;
    proceedsFeeDeductions: Array<{
      __typename?: 'LineItemV2Fee';
      currency: string;
      amount: number;
      value: number;
    }>;
    lineItemTrace: Array<{
      __typename?: 'LineItemV2';
      outgoingId?: string | null;
      sellCurrency: string;
      buyCurrencies: Array<string>;
      unitsSold: number;
      buyDate?: any | null;
      likeKindCryptoBuyDate?: any | null;
      sellDate?: any | null;
      txnHash?: string | null;
      proceeds: number;
      costBasis: number;
      gainLoss: number;
      term: string;
      missingCostBasis?: boolean | null;
      isMovementFromUnassigned: boolean;
      lineItemType: string;
      toAccount?: { __typename?: 'Account'; id: number; name: string; integrationId?: string | null } | null;
      fromAccount?: {
        __typename?: 'Account';
        id: number;
        name: string;
        integrationId?: string | null;
      } | null;
    }>;
  };
};

export type LineItemsV2QueryVariables = Exact<{
  txnReportId: Scalars['Int']['input'];
  pagination: PaginationOptions;
  sortBy: LineItemV2SortOptions;
  sortDirection: SortDirectionOptions;
  filterQuery?: InputMaybe<LineItemV2FilterQuery>;
  filterDust?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type LineItemsV2Query = {
  __typename?: 'Query';
  lineItemsV2: {
    __typename?: 'LineItemsV2';
    pageInfo: { __typename?: 'PageInfo'; filteredCount?: number | null };
    edges: Array<{
      __typename?: 'LineItemV2';
      id: any;
      outgoingId?: string | null;
      sellCurrency: string;
      buyCurrencies: Array<string>;
      unitsSold: number;
      feeUnitsSold: number;
      feeCurrencies?: Array<string> | null;
      buyDate?: any | null;
      likeKindCryptoBuyDate?: any | null;
      sellDate?: any | null;
      txnHash?: string | null;
      proceeds: number;
      costBasis: number;
      gainLoss: number;
      term: string;
      missingCostBasis?: boolean | null;
      txnReportId: number;
      isFee: boolean;
      accountId?: number | null;
      isMovementFromUnassigned: boolean;
      lineItemType: string;
      toAccount?: { __typename?: 'Account'; id: number; name: string; integrationId?: string | null } | null;
      fromAccount?: {
        __typename?: 'Account';
        id: number;
        name: string;
        integrationId?: string | null;
      } | null;
    }>;
  };
};

export type UpdateReportDetailMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  settings: Settings;
}>;

export type UpdateReportDetailMutation = {
  __typename?: 'Mutation';
  updateReportDetail: {
    __typename?: 'UserTaxDetail';
    id: number;
    baseCurrency?: string | null;
    countryId: number;
    filingStatus?: string | null;
    method?: string | null;
    state?: string | null;
    marginalTaxRate?: number | null;
    longTermCapitalGainsRate?: number | null;
    taxYear: number;
  };
};

export type ConsultationSubmitMutationVariables = Exact<{
  consultFormInput: ConsultationSubmitInput;
}>;

export type ConsultationSubmitMutation = { __typename?: 'Mutation'; consultationSubmit: boolean };

export type VerifyEmailMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;

export type VerifyEmailMutation = { __typename?: 'Mutation'; verifyEmail: boolean };

export type ClientsQueryVariables = Exact<{ [key: string]: never }>;

export type ClientsQuery = {
  __typename?: 'Query';
  clients: Array<{
    __typename?: 'User';
    id: number;
    email: string;
    organization?: { __typename?: 'Organization'; name?: string | null } | null;
  }>;
};

export type SetClientPasswordMutationVariables = Exact<{
  clientId: Scalars['Int']['input'];
  password: Scalars['String']['input'];
  organizationId: Scalars['Int']['input'];
}>;

export type SetClientPasswordMutation = { __typename?: 'Mutation'; setClientPassword: boolean };

export type GenerateTaxDetailMutationVariables = Exact<{
  grossIncome?: InputMaybe<Scalars['Int']['input']>;
  countryId: Scalars['Int']['input'];
  baseCurrency: Scalars['String']['input'];
  taxYear: Scalars['Int']['input'];
  filingStatus?: InputMaybe<FilingStatusOptions>;
  state?: InputMaybe<StateOptions>;
}>;

export type GenerateTaxDetailMutation = { __typename?: 'Mutation'; generateTaxDetail: boolean };

export type AccountFragment = {
  __typename?: 'Account';
  id: number;
  userId?: number | null;
  name: string;
  address?: string | null;
  createdAt: any;
  updatedAt: any;
  integrationId?: string | null;
  manuallyLinkedCount: number;
};

export type CredentialFragment = {
  __typename?: 'Credential';
  id: number;
  source: CredentialSource;
  name?: string | null;
  address?: string | null;
  startDate?: any | null;
  endDate?: any | null;
  filterSpam?: boolean | null;
  txnCount: number;
  credentialType: string;
  integrationName?: string | null;
  latestTransaction?: any | null;
  earliestTransaction?: any | null;
  createdAt: any;
  updatedAt: any;
  status?: EnumExchangeServiceRequestStatus | null;
  lastRefreshError?: string | null;
  errorRemediation?: string | null;
  errorType?: string | null;
  requiresCredentialUpdate?: boolean | null;
  integrationId?: string | null;
  isOauth: boolean;
  reconcileOnSync?: boolean | null;
  accountId?: number | null;
  ensAlias?: string | null;
  otherIntegration?: boolean | null;
  variousIntegrations?: boolean | null;
  account?: { __typename?: 'Account'; id: number; name: string } | null;
};

export type DocumentFragment = {
  __typename?: 'Report';
  id: number;
  reportType: string;
  createdAt: any;
  createdById?: number | null;
  createdByAdmin?: boolean | null;
  status: string;
  taxYear?: string | null;
  method?: string | null;
  url?: string | null;
  hidden?: boolean | null;
  margin?: boolean | null;
  extraCols?: boolean | null;
  errorDetails?: {
    __typename?: 'ReportErrorDetails';
    code: string;
    message: string;
    severity: string;
  } | null;
};

export type EvmInstructionFragment = {
  __typename?: 'EvmInstruction';
  id: number;
  contractId: number;
  treatmentId: number;
  blockSvcMethodId: number;
  notes?: string | null;
  updatedAt?: any | null;
  treatment?: {
    __typename?: 'Treatment';
    id: number;
    name: string;
    description?: string | null;
    reconOrder?: number | null;
  } | null;
  chain?: { __typename?: 'Chain'; credentialType: Array<string> } | null;
  evmContract?: { __typename?: 'EvmContract'; address: string } | null;
  evmMethod?: { __typename?: 'EvmMethod'; hash: string } | null;
};

export type EvmReviewFragment = {
  __typename?: 'EvmReview';
  id: number;
  createdAt: any;
  reconRepId: number;
  instructionId: number;
  beforeTreatmentId?: number | null;
  afterTreatmentId?: number | null;
  beforeTokenParam1?: Array<string> | null;
  beforeTokenParam2?: Array<string> | null;
  afterTokenParam1?: Array<string> | null;
  afterTokenParam2?: Array<string> | null;
  beforeNotes?: string | null;
  afterNotes?: string | null;
  beforePublicNotes?: string | null;
  afterPublicNotes?: string | null;
  reconRep: { __typename?: 'ReconRep'; id: number; userId?: number | null; email: string };
  beforeTreatment?: {
    __typename?: 'Treatment';
    id: number;
    name: string;
    description?: string | null;
    reconOrder?: number | null;
  } | null;
  afterTreatment?: {
    __typename?: 'Treatment';
    id: number;
    name: string;
    description?: string | null;
    reconOrder?: number | null;
  } | null;
};

export type EvmTopicInstructionFragment = {
  __typename?: 'EvmTopicInstruction';
  id: number;
  instructionId: number;
  txnTopicFingerprint?: string | null;
  topicInstruction?: any | null;
};

export type IbcInstructionFragment = {
  __typename?: 'IdentifierBasedInstruction';
  id: number;
  identifier: string;
  treatmentId: number;
  notes?: string | null;
  publicName?: string | null;
  publicNotes?: string | null;
  updatedAt?: any | null;
  tokenParam1?: Array<string> | null;
  tokenParam2?: Array<string> | null;
  treatment?: {
    __typename?: 'Treatment';
    id: number;
    name: string;
    description?: string | null;
    reconOrder?: number | null;
  } | null;
};

export type IbcReviewFragment = {
  __typename?: 'IbcReview';
  id: number;
  createdAt: any;
  reconRepId: number;
  instructionId: number;
  beforeTreatmentId?: number | null;
  afterTreatmentId?: number | null;
  beforeTokenParam1?: Array<string> | null;
  beforeTokenParam2?: Array<string> | null;
  afterTokenParam1?: Array<string> | null;
  afterTokenParam2?: Array<string> | null;
  beforeNotes?: string | null;
  afterNotes?: string | null;
  beforePublicNotes?: string | null;
  afterPublicNotes?: string | null;
  transactionHash?: string | null;
  reconRep: { __typename?: 'ReconRep'; id: number; userId?: number | null; email: string };
  beforeTreatment?: {
    __typename?: 'Treatment';
    id: number;
    name: string;
    description?: string | null;
    reconOrder?: number | null;
  } | null;
  afterTreatment?: {
    __typename?: 'Treatment';
    id: number;
    name: string;
    description?: string | null;
    reconOrder?: number | null;
  } | null;
};

type Instruction_EvmInstruction_Fragment = {
  __typename?: 'EvmInstruction';
  id: number;
  contractId: number;
  notes?: string | null;
  proba1?: number | null;
  pred1?: number | null;
  publicNotes?: string | null;
  tokenParam1?: Array<string> | null;
  tokenParam2?: Array<string> | null;
  treatment?: { __typename?: 'Treatment'; id: number; description?: string | null } | null;
};

type Instruction_IdentifierBasedInstruction_Fragment = {
  __typename?: 'IdentifierBasedInstruction';
  id: number;
  notes?: string | null;
  publicNotes?: string | null;
  tokenParam1?: Array<string> | null;
  tokenParam2?: Array<string> | null;
  treatment?: { __typename?: 'Treatment'; id: number; description?: string | null } | null;
};

export type InstructionFragment =
  | Instruction_EvmInstruction_Fragment
  | Instruction_IdentifierBasedInstruction_Fragment;

export type InvoiceFragmentFragment = {
  __typename?: 'Invoice';
  id: string;
  userId: number;
  number?: string | null;
  created: number;
  dueDate?: number | null;
  currency: string;
  paid: boolean;
  voided: boolean;
  amountRemaining: number;
  description?: string | null;
  createdBy?: string | null;
};

export type OrganizationFragment = {
  __typename?: 'Organization';
  id: number;
  name?: string | null;
  slug?: string | null;
  status?: EnumOrganizationStatus | null;
  includeDemoUser?: boolean | null;
  discount?: number | null;
  logo?: string | null;
  colorPrimary?: string | null;
  colorSecondary?: string | null;
  colorLink?: string | null;
  createdAt: any;
  updatedAt: any;
  deletedAt?: any | null;
};

export type PlanFragment = { __typename?: 'Plan'; planId: string; year: number };

export type ProductsFragment = {
  __typename?: 'Products';
  cryptoOnlyPlans?: Array<{ __typename?: 'Plan'; planId: string; year: number }> | null;
  fullFilingPlans?: Array<{ __typename?: 'Plan'; planId: string; year: number }> | null;
  addons?: Array<{ __typename?: 'Plan'; planId: string; year: number }> | null;
};

export type SolanaInstructionFragment = {
  __typename?: 'IdentifierBasedInstruction';
  id: number;
  identifier: string;
  treatmentId: number;
  notes?: string | null;
  publicName?: string | null;
  publicNotes?: string | null;
  updatedAt?: any | null;
  tokenParam1?: Array<string> | null;
  tokenParam2?: Array<string> | null;
  treatment?: {
    __typename?: 'Treatment';
    id: number;
    name: string;
    description?: string | null;
    reconOrder?: number | null;
  } | null;
};

export type SolanaReviewFragment = {
  __typename?: 'SolanaReview';
  id: number;
  createdAt: any;
  reconRepId?: number | null;
  instructionId: number;
  beforeTreatmentId?: number | null;
  afterTreatmentId?: number | null;
  beforeTokenParam1?: Array<string> | null;
  beforeTokenParam2?: Array<string> | null;
  afterTokenParam1?: Array<string> | null;
  afterTokenParam2?: Array<string> | null;
  beforeNotes?: string | null;
  afterNotes?: string | null;
  beforePublicNotes?: string | null;
  afterPublicNotes?: string | null;
  signature?: string | null;
  reconRep?: { __typename?: 'ReconRep'; id: number; userId?: number | null; email: string } | null;
  beforeTreatment?: {
    __typename?: 'Treatment';
    id: number;
    name: string;
    description?: string | null;
    reconOrder?: number | null;
  } | null;
  afterTreatment?: {
    __typename?: 'Treatment';
    id: number;
    name: string;
    description?: string | null;
    reconOrder?: number | null;
  } | null;
};

export type SpecIdMatchFragment = {
  __typename?: 'SpecIdMatch';
  componentId: string;
  sellId: string;
  componentQuantity: number;
  componentOrder: number;
};

export type SpecIdV2MatchFragment = {
  __typename?: 'SpecIdV2Match';
  id: string;
  outgoingId: string;
  incomingId: string;
  quantity: string;
};

export type SpecIdV2MemberFragment = {
  __typename?: 'SpecIdV2Member';
  id: string;
  groupId: string;
  transferId: string;
  direction: string;
  groupIndex: number;
  transfer: {
    __typename?: 'Transfer';
    id: string;
    userId: number;
    groupId: string;
    type?: EnumTransferType | null;
    direction: EnumTransferDirection;
    currency: string;
    tokenId?: string | null;
    tokenAddress?: string | null;
    quantity: string;
    specIdTotalQuantity?: string | null;
    price?: string | null;
    valueUsd?: string | null;
    timestamp: any;
    accountId?: number | null;
    groupTimestampMax: any;
    hash?: string | null;
    createdAt: any;
    credential: {
      __typename?: 'Credential';
      credentialType: string;
      address?: string | null;
      name?: string | null;
      integrationName?: string | null;
    };
  };
};

export type SpecIdV2GroupFragment = {
  __typename?: 'SpecIdV2Group';
  id: string;
  userId: number;
  createdAt: any;
  updatedAt: any;
  members: Array<{
    __typename?: 'SpecIdV2Member';
    id: string;
    groupId: string;
    transferId: string;
    direction: string;
    groupIndex: number;
    transfer: {
      __typename?: 'Transfer';
      id: string;
      userId: number;
      groupId: string;
      type?: EnumTransferType | null;
      direction: EnumTransferDirection;
      currency: string;
      tokenId?: string | null;
      tokenAddress?: string | null;
      quantity: string;
      specIdTotalQuantity?: string | null;
      price?: string | null;
      valueUsd?: string | null;
      timestamp: any;
      accountId?: number | null;
      groupTimestampMax: any;
      hash?: string | null;
      createdAt: any;
      credential: {
        __typename?: 'Credential';
        credentialType: string;
        address?: string | null;
        name?: string | null;
        integrationName?: string | null;
      };
    };
  }>;
  matches: Array<{
    __typename?: 'SpecIdV2Match';
    id: string;
    outgoingId: string;
    incomingId: string;
    quantity: string;
  }>;
  parentMatches: Array<{
    __typename?: 'SpecIdV2Match';
    id: string;
    outgoingId: string;
    incomingId: string;
    quantity: string;
  }>;
};

export type TaxDetailFragment = {
  __typename?: 'UserTaxDetail';
  id: number;
  baseCurrency?: string | null;
  calculateAsMargin?: boolean | null;
  createdAt: any;
  filingStatus?: string | null;
  fullFilingPlan?: string | null;
  grossIncome?: number | null;
  likeKind?: boolean | null;
  longTermCapitalGainsRate?: number | null;
  marginalTaxRate?: number | null;
  method?: string | null;
  needsFbar?: boolean | null;
  plan?: string | null;
  setFilingMethodSkipped?: boolean | null;
  skipped?: boolean | null;
  state?: string | null;
  taxYear: number;
  ukBnbRule?: boolean | null;
  updatedAt: any;
  useHoursMinsComparison?: boolean | null;
  userId: number;
  isEngaged: boolean;
  addons: Array<{
    __typename?: 'UserTaxDetailAddon';
    id: number;
    addon: {
      __typename?: 'Addon';
      createdAt: any;
      displayName: string;
      price?: number | null;
      product: string;
      sku: string;
      updatedAt: any;
    };
  }>;
  country: {
    __typename?: 'Country';
    id: number;
    endDateDay: number;
    endDateMonth: number;
    name: string;
    shorthand: string;
    methods: Array<string>;
    startDateDay: number;
    startDateMonth: number;
    taxMethods: Array<{ __typename?: 'TaxMethod'; id: EnumTaxMethod; label: string }>;
  };
  dateRange?: { __typename?: 'DateRange'; startDate: string; endDate: string } | null;
  taxMethod?: { __typename?: 'TaxMethod'; id: EnumTaxMethod; label: string } | null;
};

export type TransferFragment = {
  __typename?: 'Transfer';
  id: string;
  credentialId: number;
  hash?: string | null;
  timestamp: any;
  fromAddress?: string | null;
  toAddress?: string | null;
  contractAddress?: string | null;
  currency: string;
  quantity: string;
  groupId: string;
  type?: EnumTransferType | null;
  direction: EnumTransferDirection;
  transactionId?: string | null;
  accountId?: number | null;
  synthetic: boolean;
  credential: { __typename?: 'Credential'; credentialType: string; address?: string | null };
};

export type TreatmentFragment = {
  __typename?: 'Treatment';
  id: number;
  name: string;
  description?: string | null;
  reconOrder?: number | null;
};

export type TxnFragment = {
  __typename?: 'Txn';
  id: string;
  associatedExchangeAddress?: string | null;
  blocksvcHash?: string | null;
  credentialId?: number | null;
  buyCurrency: string;
  buyTokenId?: string | null;
  buyAddress?: string | null;
  buyNftId?: string | null;
  description?: string | null;
  exchangeId?: string | null;
  exchangeName?: string | null;
  feeCurrency?: string | null;
  feeTokenId?: string | null;
  feeQuantity?: number | null;
  feePrice: string;
  feeAddress?: string | null;
  buyPrice: string;
  sellPrice: string;
  buyQuantity: string;
  sellCurrency: string;
  sellTokenId?: string | null;
  sellAddress?: string | null;
  sellNftId?: string | null;
  sellQuantity: string;
  txnTimestamp: any;
  txnType: TxnType;
  unitPrice?: number | null;
  priceFetchingSide?: PriceFetchingSide | null;
  usdSpotPrice?: number | null;
  blocksvcMethodId?: string | null;
  blocksvcToAddress?: string | null;
  blocksvcFromAddress?: string | null;
  createdAt: any;
  updatedAt: any;
  isEdited?: boolean | null;
  isSpam: boolean;
  reviewed?: boolean | null;
  editedByReconGuideJob: boolean;
  reconIdentifier?: string | null;
  txnTopicFingerprint?: string | null;
  transferTopicFingerprint?: string | null;
  bkpVendorId?: number | null;
  bkpAccountDebitId?: number | null;
  bkpAccountCreditId?: number | null;
  accountId?: number | null;
  toAccountId?: number | null;
  hasMovement?: boolean | null;
  isPricingAnomaly: boolean;
  groupId?: number | null;
  groupComponentType?: TxnGroupComponentType | null;
  bkpVendor?: {
    __typename?: 'BkpVendor';
    id: number;
    bkpIntegrationId?: string | null;
    bkpIntegrationDisplayName?: string | null;
  } | null;
  bkpAccountDebit?: {
    __typename?: 'BkpAccount';
    id: number;
    bkpIntegrationId?: string | null;
    name?: string | null;
  } | null;
  bkpAccountCredit?: {
    __typename?: 'BkpAccount';
    id: number;
    bkpIntegrationId?: string | null;
    name?: string | null;
  } | null;
  credential: {
    __typename?: 'Credential';
    accountId?: number | null;
    credentialType: string;
    source: CredentialSource;
    name?: string | null;
    address?: string | null;
    integrationId?: string | null;
  };
  specIdMatchesAsComponent: Array<{
    __typename?: 'SpecIdMatch';
    componentId: string;
    sellId: string;
    componentQuantity: number;
    componentOrder: number;
  }>;
  specIdMatchesAsSell: Array<{
    __typename?: 'SpecIdMatch';
    componentId: string;
    sellId: string;
    componentQuantity: number;
    componentOrder: number;
  }>;
};

export type UnreconciledTransactionResolutionFragment = {
  __typename?: 'UnreconciledTransactionResolution';
  id: number;
  unreconciledTransactionId: string;
  userId: number;
  credentialType: string;
  blocksvcHash: string;
  category: string;
  edited: boolean;
  appliedAt: any;
  invalidatedAt?: any | null;
  revertedAt?: any | null;
  drafts: Array<{
    __typename?: 'Draft';
    sent?: {
      __typename?: 'TransfersGroup';
      txns: Array<{
        __typename?: 'SelfReconTransfer';
        id?: string | null;
        currency: string;
        tokenId?: string | null;
        quantity: string;
        type: TransferType;
      } | null>;
    } | null;
    received?: {
      __typename?: 'TransfersGroup';
      txns: Array<{
        __typename?: 'SelfReconTransfer';
        id?: string | null;
        currency: string;
        tokenId?: string | null;
        quantity: string;
        type: TransferType;
      } | null>;
    } | null;
  }>;
};

export type UploadFragment = {
  __typename?: 'Upload';
  id: number;
  userId?: number | null;
  name: string;
  url?: string | null;
  createdAt: any;
  updatedAt: any;
  isHidden: boolean;
  uploadType?: string | null;
  credentialId?: number | null;
  credential?: { __typename?: 'Credential'; id: number; name?: string | null; deletedAt?: any | null } | null;
};

export type UserInfoFragment = {
  __typename?: 'User';
  id: number;
  accountYears: Array<number>;
  airtableId?: string | null;
  blocked: boolean;
  createdAt: any;
  customerId?: string | null;
  deletedAt?: any | null;
  email: string;
  emailVerified: boolean;
  firstName?: string | null;
  includeFees?: boolean | null;
  secretMode?: boolean | null;
  isTest?: boolean | null;
  businessUser?: boolean | null;
  lastName?: string | null;
  lastSuccessfulCharge?: any | null;
  lockedTilDate?: any | null;
  lockedThroughYear?: number | null;
  loginCount?: number | null;
  marginTradeAccount?: boolean | null;
  minimizationForAllYears?: boolean | null;
  orgDemoUser?: boolean | null;
  organizationId?: number | null;
  phone?: string | null;
  plan?: string | null;
  recalcByAccount?: boolean | null;
  recalcByAccountStartYear?: number | null;
  reconMode?: boolean | null;
  hideSpam: boolean;
  resetPasswordExpires?: any | null;
  role?: string | null;
  subscriptionId?: string | null;
  twoFactorEnabled: boolean;
  updatedAt: any;
  useHoursMinsComparison?: boolean | null;
  lastMadeEditsAt?: any | null;
  usesGroupsSince?: any | null;
  dataModelV2UpgradeState?: EnumDataModelV2UpgradeState | null;
  v2TransitionProgress?: EnumGenericJobStatus | null;
  orgRoles: Array<{
    __typename?: 'UserOrgRole';
    userId: number;
    roleId: number;
    organizationId: number;
    createdAt: any;
    updatedAt: any;
    organization: {
      __typename?: 'Organization';
      id: number;
      name?: string | null;
      slug?: string | null;
      status?: EnumOrganizationStatus | null;
      includeDemoUser?: boolean | null;
      discount?: number | null;
      logo?: string | null;
      colorPrimary?: string | null;
      colorSecondary?: string | null;
      colorLink?: string | null;
      createdAt: any;
      updatedAt: any;
      deletedAt?: any | null;
    };
    role: { __typename?: 'Role'; name: string };
  }>;
  taxDetails: Array<{
    __typename?: 'UserTaxDetail';
    id: number;
    baseCurrency?: string | null;
    calculateAsMargin?: boolean | null;
    createdAt: any;
    filingStatus?: string | null;
    fullFilingPlan?: string | null;
    grossIncome?: number | null;
    likeKind?: boolean | null;
    longTermCapitalGainsRate?: number | null;
    marginalTaxRate?: number | null;
    method?: string | null;
    needsFbar?: boolean | null;
    plan?: string | null;
    setFilingMethodSkipped?: boolean | null;
    skipped?: boolean | null;
    state?: string | null;
    taxYear: number;
    ukBnbRule?: boolean | null;
    updatedAt: any;
    useHoursMinsComparison?: boolean | null;
    userId: number;
    isEngaged: boolean;
    addons: Array<{
      __typename?: 'UserTaxDetailAddon';
      id: number;
      addon: {
        __typename?: 'Addon';
        createdAt: any;
        displayName: string;
        price?: number | null;
        product: string;
        sku: string;
        updatedAt: any;
      };
    }>;
    country: {
      __typename?: 'Country';
      id: number;
      endDateDay: number;
      endDateMonth: number;
      name: string;
      shorthand: string;
      methods: Array<string>;
      startDateDay: number;
      startDateMonth: number;
      taxMethods: Array<{ __typename?: 'TaxMethod'; id: EnumTaxMethod; label: string }>;
    };
    dateRange?: { __typename?: 'DateRange'; startDate: string; endDate: string } | null;
    taxMethod?: { __typename?: 'TaxMethod'; id: EnumTaxMethod; label: string } | null;
  }>;
};

export type ChangeUserDataMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  secretMode?: InputMaybe<Scalars['Boolean']['input']>;
  reconMode?: InputMaybe<Scalars['Boolean']['input']>;
  hideSpam?: InputMaybe<Scalars['Boolean']['input']>;
  recalcByAccount?: InputMaybe<Scalars['Boolean']['input']>;
  recalcByAccountStartYear?: InputMaybe<Scalars['Int']['input']>;
  removeInvalidatedSpecIdGroups?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ChangeUserDataMutation = { __typename?: 'Mutation'; changeUserData: boolean };

export type CreateAccountMutationVariables = Exact<{
  name: Scalars['String']['input'];
  address?: InputMaybe<Scalars['String']['input']>;
  integrationId?: InputMaybe<Scalars['String']['input']>;
  external?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type CreateAccountMutation = {
  __typename?: 'Mutation';
  createAccount: {
    __typename?: 'Account';
    id: number;
    userId?: number | null;
    name: string;
    address?: string | null;
    createdAt: any;
    updatedAt: any;
    integrationId?: string | null;
    manuallyLinkedCount: number;
  };
};

export type CreateCsvImportMutationVariables = Exact<{
  Bucket: Scalars['String']['input'];
  Key: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  accountId?: InputMaybe<Scalars['Int']['input']>;
  newAccount?: InputMaybe<CsvImportNewAccountInput>;
}>;

export type CreateCsvImportMutation = {
  __typename?: 'Mutation';
  createCsvImport: {
    __typename?: 'CreateCsvImportResponse';
    requestId: string;
    credentialId: number;
    account: {
      __typename?: 'Account';
      id: number;
      userId?: number | null;
      name: string;
      address?: string | null;
      createdAt: any;
      updatedAt: any;
      integrationId?: string | null;
      manuallyLinkedCount: number;
    };
  };
};

export type CreateMovementMutationVariables = Exact<{
  txnIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  date: Scalars['DateTime']['input'];
  toAccountId: Scalars['Int']['input'];
  fromAccountId: Scalars['Int']['input'];
}>;

export type CreateMovementMutation = { __typename?: 'Mutation'; createMovement: boolean };

export type CreateOneSidedMovementMutationVariables = Exact<{
  txnIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  date?: InputMaybe<Scalars['DateTime']['input']>;
  toAccountId: Scalars['Int']['input'];
  fromAccountId: Scalars['Int']['input'];
}>;

export type CreateOneSidedMovementMutation = { __typename?: 'Mutation'; createOneSidedMovement: boolean };

export type CreateOneSidedMovementGroupResultFragment = {
  __typename?: 'TransferGroup';
  contractAddresses: Array<string>;
  id: string;
  userId: number;
  type: EnumTransferGroupType;
  description?: string | null;
  location?: string | null;
  reviewed: boolean;
  bkpVendorId?: number | null;
  bkpAccountDebitId?: number | null;
  bkpAccountCreditId?: number | null;
  hashes: Array<string>;
  currenciesIn: Array<string>;
  currenciesOut: Array<string>;
  currenciesFee: Array<string>;
  valueIn?: string | null;
  valueOut?: string | null;
  valueFee?: string | null;
  value?: string | null;
  timestampMin: any;
  timestampMax: any;
  createdAt: any;
  updatedAt: any;
  deletedAt?: any | null;
  locations: Array<{
    __typename?: 'Location';
    integrationId: string;
    name?: string | null;
    contractAddress?: string | null;
  }>;
  transfers: Array<{
    __typename?: 'Transfer';
    fromAddress?: string | null;
    toAddress?: string | null;
    contractAddress?: string | null;
    methodId?: string | null;
    methodName?: string | null;
    integrationId?: string | null;
    synthetic: boolean;
    id: string;
    userId: number;
    groupId: string;
    direction: EnumTransferDirection;
    type?: EnumTransferType | null;
    taxTreatment?: EnumTaxTreatment | null;
    credentialId: number;
    accountId?: number | null;
    exchangeId?: string | null;
    timestamp: any;
    hash?: string | null;
    inDateRange: boolean;
    currency: string;
    quantity: string;
    tokenAddress?: string | null;
    tokenId?: string | null;
    transactionId?: string | null;
    price?: string | null;
    valueUsd?: string | null;
    createdAt: any;
    updatedAt: any;
    deletedAt?: any | null;
    credential: {
      __typename?: 'Credential';
      integrationId?: string | null;
      credentialType: string;
      source: CredentialSource;
      address?: string | null;
      name?: string | null;
      ensAlias?: string | null;
      integrationName?: string | null;
    };
  }>;
  suggestedInstruction?:
    | {
        __typename?: 'EvmInstruction';
        id: number;
        contractId: number;
        notes?: string | null;
        proba1?: number | null;
        pred1?: number | null;
        publicNotes?: string | null;
        tokenParam1?: Array<string> | null;
        tokenParam2?: Array<string> | null;
        treatment?: { __typename?: 'Treatment'; id: number; description?: string | null } | null;
      }
    | {
        __typename?: 'IdentifierBasedInstruction';
        id: number;
        notes?: string | null;
        publicNotes?: string | null;
        tokenParam1?: Array<string> | null;
        tokenParam2?: Array<string> | null;
        treatment?: { __typename?: 'Treatment'; id: number; description?: string | null } | null;
      }
    | null;
  user: { __typename?: 'User'; id: number; email: string };
};

export type CreateOneSidedMovementGroupMutationVariables = Exact<{
  accountId: Scalars['Int']['input'];
  transferGroupId: Scalars['String']['input'];
}>;

export type CreateOneSidedMovementGroupMutation = {
  __typename?: 'Mutation';
  createOneSidedMovementGroup: {
    __typename?: 'TransferGroup';
    contractAddresses: Array<string>;
    id: string;
    userId: number;
    type: EnumTransferGroupType;
    description?: string | null;
    location?: string | null;
    reviewed: boolean;
    bkpVendorId?: number | null;
    bkpAccountDebitId?: number | null;
    bkpAccountCreditId?: number | null;
    hashes: Array<string>;
    currenciesIn: Array<string>;
    currenciesOut: Array<string>;
    currenciesFee: Array<string>;
    valueIn?: string | null;
    valueOut?: string | null;
    valueFee?: string | null;
    value?: string | null;
    timestampMin: any;
    timestampMax: any;
    createdAt: any;
    updatedAt: any;
    deletedAt?: any | null;
    locations: Array<{
      __typename?: 'Location';
      integrationId: string;
      name?: string | null;
      contractAddress?: string | null;
    }>;
    transfers: Array<{
      __typename?: 'Transfer';
      fromAddress?: string | null;
      toAddress?: string | null;
      contractAddress?: string | null;
      methodId?: string | null;
      methodName?: string | null;
      integrationId?: string | null;
      synthetic: boolean;
      id: string;
      userId: number;
      groupId: string;
      direction: EnumTransferDirection;
      type?: EnumTransferType | null;
      taxTreatment?: EnumTaxTreatment | null;
      credentialId: number;
      accountId?: number | null;
      exchangeId?: string | null;
      timestamp: any;
      hash?: string | null;
      inDateRange: boolean;
      currency: string;
      quantity: string;
      tokenAddress?: string | null;
      tokenId?: string | null;
      transactionId?: string | null;
      price?: string | null;
      valueUsd?: string | null;
      createdAt: any;
      updatedAt: any;
      deletedAt?: any | null;
      credential: {
        __typename?: 'Credential';
        integrationId?: string | null;
        credentialType: string;
        source: CredentialSource;
        address?: string | null;
        name?: string | null;
        ensAlias?: string | null;
        integrationName?: string | null;
      };
    }>;
    suggestedInstruction?:
      | {
          __typename?: 'EvmInstruction';
          id: number;
          contractId: number;
          notes?: string | null;
          proba1?: number | null;
          pred1?: number | null;
          publicNotes?: string | null;
          tokenParam1?: Array<string> | null;
          tokenParam2?: Array<string> | null;
          treatment?: { __typename?: 'Treatment'; id: number; description?: string | null } | null;
        }
      | {
          __typename?: 'IdentifierBasedInstruction';
          id: number;
          notes?: string | null;
          publicNotes?: string | null;
          tokenParam1?: Array<string> | null;
          tokenParam2?: Array<string> | null;
          treatment?: { __typename?: 'Treatment'; id: number; description?: string | null } | null;
        }
      | null;
    user: { __typename?: 'User'; id: number; email: string };
  };
};

export type DelinkSpecIdsMutationVariables = Exact<{
  sellId?: InputMaybe<Scalars['String']['input']>;
  componentId?: InputMaybe<Scalars['String']['input']>;
}>;

export type DelinkSpecIdsMutation = { __typename?: 'Mutation'; delinkSpecIds: boolean };

export type GenerateReportMutationVariables = Exact<{
  report: ReportCreateInput;
}>;

export type GenerateReportMutation = {
  __typename?: 'Mutation';
  generateReport: {
    __typename?: 'GenerateReportResult';
    jobId?: string | null;
    report?: {
      __typename?: 'Report';
      id: number;
      userId?: number | null;
      txnReportId?: number | null;
      reportType: string;
      extraCols?: boolean | null;
      margin?: boolean | null;
      hidden?: boolean | null;
      url?: string | null;
      taxYear?: string | null;
      status: string;
      method?: string | null;
      createdAt: any;
      updatedAt: any;
      errorDetails?: {
        __typename?: 'ReportErrorDetails';
        code: string;
        message: string;
        severity: string;
      } | null;
      txnReport?: { __typename?: 'TxnReport'; id: number } | null;
      user?: { __typename?: 'User'; id: number } | null;
    } | null;
  };
};

export type GetUploadUrlMutationVariables = Exact<{
  fileName: Scalars['String']['input'];
}>;

export type GetUploadUrlMutation = {
  __typename?: 'Mutation';
  getUploadURL: { __typename?: 'UploadUrlData'; Bucket: string; Key: string; url: string };
};

export type AddManualTxnsMutationVariables = Exact<{
  txns: Array<CreatedTxnInput> | CreatedTxnInput;
}>;

export type AddManualTxnsMutation = {
  __typename?: 'Mutation';
  addTransactions: {
    __typename?: 'CreatedCredential';
    credential: { __typename?: 'Credential'; id: number };
    exchangeServiceRequest: {
      __typename?: 'ExchangeServiceRequest';
      status?: EnumExchangeServiceRequestStatus | null;
    };
  };
};

export type ReviewTxnsMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  reviewed: Scalars['Boolean']['input'];
  isAdmin: Scalars['Boolean']['input'];
}>;

export type ReviewTxnsMutation = {
  __typename?: 'Mutation';
  reviewTxns: {
    __typename?: 'UpdatedTxnResponse';
    count: number;
    errors: Array<{ __typename?: 'FailedTransactionUpdate'; transactionId: string; error: string }>;
    updatedTxns: Array<{
      __typename?: 'Txn';
      id: string;
      associatedExchangeAddress?: string | null;
      blocksvcHash?: string | null;
      credentialId?: number | null;
      buyCurrency: string;
      buyTokenId?: string | null;
      buyAddress?: string | null;
      buyNftId?: string | null;
      description?: string | null;
      exchangeId?: string | null;
      exchangeName?: string | null;
      feeCurrency?: string | null;
      feeTokenId?: string | null;
      feeQuantity?: number | null;
      feePrice: string;
      feeAddress?: string | null;
      buyPrice: string;
      sellPrice: string;
      buyQuantity: string;
      sellCurrency: string;
      sellTokenId?: string | null;
      sellAddress?: string | null;
      sellNftId?: string | null;
      sellQuantity: string;
      txnTimestamp: any;
      txnType: TxnType;
      unitPrice?: number | null;
      priceFetchingSide?: PriceFetchingSide | null;
      usdSpotPrice?: number | null;
      blocksvcMethodId?: string | null;
      blocksvcToAddress?: string | null;
      blocksvcFromAddress?: string | null;
      createdAt: any;
      updatedAt: any;
      isEdited?: boolean | null;
      isSpam: boolean;
      reviewed?: boolean | null;
      editedByReconGuideJob: boolean;
      reconIdentifier?: string | null;
      txnTopicFingerprint?: string | null;
      transferTopicFingerprint?: string | null;
      bkpVendorId?: number | null;
      bkpAccountDebitId?: number | null;
      bkpAccountCreditId?: number | null;
      accountId?: number | null;
      toAccountId?: number | null;
      hasMovement?: boolean | null;
      isPricingAnomaly: boolean;
      groupId?: number | null;
      groupComponentType?: TxnGroupComponentType | null;
      bkpVendor?: {
        __typename?: 'BkpVendor';
        id: number;
        bkpIntegrationId?: string | null;
        bkpIntegrationDisplayName?: string | null;
      } | null;
      bkpAccountDebit?: {
        __typename?: 'BkpAccount';
        id: number;
        bkpIntegrationId?: string | null;
        name?: string | null;
      } | null;
      bkpAccountCredit?: {
        __typename?: 'BkpAccount';
        id: number;
        bkpIntegrationId?: string | null;
        name?: string | null;
      } | null;
      credential: {
        __typename?: 'Credential';
        accountId?: number | null;
        credentialType: string;
        source: CredentialSource;
        name?: string | null;
        address?: string | null;
        integrationId?: string | null;
      };
      specIdMatchesAsComponent: Array<{
        __typename?: 'SpecIdMatch';
        componentId: string;
        sellId: string;
        componentQuantity: number;
        componentOrder: number;
      }>;
      specIdMatchesAsSell: Array<{
        __typename?: 'SpecIdMatch';
        componentId: string;
        sellId: string;
        componentQuantity: number;
        componentOrder: number;
      }>;
    }>;
  };
};

export type MarkTxnsSpamMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  isSpam: Scalars['Boolean']['input'];
  isAdmin: Scalars['Boolean']['input'];
}>;

export type MarkTxnsSpamMutation = {
  __typename?: 'Mutation';
  markTxnsSpam: {
    __typename?: 'UpdatedTxnResponse';
    count: number;
    errors: Array<{ __typename?: 'FailedTransactionUpdate'; transactionId: string; error: string }>;
    updatedTxns: Array<{
      __typename?: 'Txn';
      id: string;
      associatedExchangeAddress?: string | null;
      blocksvcHash?: string | null;
      credentialId?: number | null;
      buyCurrency: string;
      buyTokenId?: string | null;
      buyAddress?: string | null;
      buyNftId?: string | null;
      description?: string | null;
      exchangeId?: string | null;
      exchangeName?: string | null;
      feeCurrency?: string | null;
      feeTokenId?: string | null;
      feeQuantity?: number | null;
      feePrice: string;
      feeAddress?: string | null;
      buyPrice: string;
      sellPrice: string;
      buyQuantity: string;
      sellCurrency: string;
      sellTokenId?: string | null;
      sellAddress?: string | null;
      sellNftId?: string | null;
      sellQuantity: string;
      txnTimestamp: any;
      txnType: TxnType;
      unitPrice?: number | null;
      priceFetchingSide?: PriceFetchingSide | null;
      usdSpotPrice?: number | null;
      blocksvcMethodId?: string | null;
      blocksvcToAddress?: string | null;
      blocksvcFromAddress?: string | null;
      createdAt: any;
      updatedAt: any;
      isEdited?: boolean | null;
      isSpam: boolean;
      reviewed?: boolean | null;
      editedByReconGuideJob: boolean;
      reconIdentifier?: string | null;
      txnTopicFingerprint?: string | null;
      transferTopicFingerprint?: string | null;
      bkpVendorId?: number | null;
      bkpAccountDebitId?: number | null;
      bkpAccountCreditId?: number | null;
      accountId?: number | null;
      toAccountId?: number | null;
      hasMovement?: boolean | null;
      isPricingAnomaly: boolean;
      groupId?: number | null;
      groupComponentType?: TxnGroupComponentType | null;
      bkpVendor?: {
        __typename?: 'BkpVendor';
        id: number;
        bkpIntegrationId?: string | null;
        bkpIntegrationDisplayName?: string | null;
      } | null;
      bkpAccountDebit?: {
        __typename?: 'BkpAccount';
        id: number;
        bkpIntegrationId?: string | null;
        name?: string | null;
      } | null;
      bkpAccountCredit?: {
        __typename?: 'BkpAccount';
        id: number;
        bkpIntegrationId?: string | null;
        name?: string | null;
      } | null;
      credential: {
        __typename?: 'Credential';
        accountId?: number | null;
        credentialType: string;
        source: CredentialSource;
        name?: string | null;
        address?: string | null;
        integrationId?: string | null;
      };
      specIdMatchesAsComponent: Array<{
        __typename?: 'SpecIdMatch';
        componentId: string;
        sellId: string;
        componentQuantity: number;
        componentOrder: number;
      }>;
      specIdMatchesAsSell: Array<{
        __typename?: 'SpecIdMatch';
        componentId: string;
        sellId: string;
        componentQuantity: number;
        componentOrder: number;
      }>;
    }>;
  };
};

export type UpdateTxnsMutationVariables = Exact<{
  txns: Array<TxnInput> | TxnInput;
  isAdmin: Scalars['Boolean']['input'];
}>;

export type UpdateTxnsMutation = {
  __typename?: 'Mutation';
  updateTxns: {
    __typename?: 'UpdatedTxnResponse';
    count: number;
    errors: Array<{ __typename?: 'FailedTransactionUpdate'; transactionId: string; error: string }>;
    updatedTxns: Array<{
      __typename?: 'Txn';
      id: string;
      associatedExchangeAddress?: string | null;
      blocksvcHash?: string | null;
      credentialId?: number | null;
      buyCurrency: string;
      buyTokenId?: string | null;
      buyAddress?: string | null;
      buyNftId?: string | null;
      description?: string | null;
      exchangeId?: string | null;
      exchangeName?: string | null;
      feeCurrency?: string | null;
      feeTokenId?: string | null;
      feeQuantity?: number | null;
      feePrice: string;
      feeAddress?: string | null;
      buyPrice: string;
      sellPrice: string;
      buyQuantity: string;
      sellCurrency: string;
      sellTokenId?: string | null;
      sellAddress?: string | null;
      sellNftId?: string | null;
      sellQuantity: string;
      txnTimestamp: any;
      txnType: TxnType;
      unitPrice?: number | null;
      priceFetchingSide?: PriceFetchingSide | null;
      usdSpotPrice?: number | null;
      blocksvcMethodId?: string | null;
      blocksvcToAddress?: string | null;
      blocksvcFromAddress?: string | null;
      createdAt: any;
      updatedAt: any;
      isEdited?: boolean | null;
      isSpam: boolean;
      reviewed?: boolean | null;
      editedByReconGuideJob: boolean;
      reconIdentifier?: string | null;
      txnTopicFingerprint?: string | null;
      transferTopicFingerprint?: string | null;
      bkpVendorId?: number | null;
      bkpAccountDebitId?: number | null;
      bkpAccountCreditId?: number | null;
      accountId?: number | null;
      toAccountId?: number | null;
      hasMovement?: boolean | null;
      isPricingAnomaly: boolean;
      groupId?: number | null;
      groupComponentType?: TxnGroupComponentType | null;
      bkpVendor?: {
        __typename?: 'BkpVendor';
        id: number;
        bkpIntegrationId?: string | null;
        bkpIntegrationDisplayName?: string | null;
      } | null;
      bkpAccountDebit?: {
        __typename?: 'BkpAccount';
        id: number;
        bkpIntegrationId?: string | null;
        name?: string | null;
      } | null;
      bkpAccountCredit?: {
        __typename?: 'BkpAccount';
        id: number;
        bkpIntegrationId?: string | null;
        name?: string | null;
      } | null;
      credential: {
        __typename?: 'Credential';
        accountId?: number | null;
        credentialType: string;
        source: CredentialSource;
        name?: string | null;
        address?: string | null;
        integrationId?: string | null;
      };
      specIdMatchesAsComponent: Array<{
        __typename?: 'SpecIdMatch';
        componentId: string;
        sellId: string;
        componentQuantity: number;
        componentOrder: number;
      }>;
      specIdMatchesAsSell: Array<{
        __typename?: 'SpecIdMatch';
        componentId: string;
        sellId: string;
        componentQuantity: number;
        componentOrder: number;
      }>;
    }>;
  };
};

export type ExportTxnsMutationVariables = Exact<{
  sortBy: TxnSortOptions;
  sortDirection: SortDirectionOptions;
  filterQuery: TxnFilterQuery;
  txnIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type ExportTxnsMutation = { __typename?: 'Mutation'; exportTxns?: string | null };

export type RecalculateMutationVariables = Exact<{
  options?: InputMaybe<RecalculateOptions>;
}>;

export type RecalculateMutation = {
  __typename?: 'Mutation';
  recalculateTxnReports?: { __typename?: 'TxnReportJob'; id: number } | null;
};

export type DeleteCredentialsMutationVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type DeleteCredentialsMutation = { __typename?: 'Mutation'; deleteCredentials: number };

export type UpdateTaxDetailsMutationVariables = Exact<{
  taxDetails: Array<UpdateTaxDetailsInput> | UpdateTaxDetailsInput;
  userId: Scalars['Int']['input'];
}>;

export type UpdateTaxDetailsMutation = { __typename?: 'Mutation'; updateTaxDetails: boolean };

export type LogoutMutationVariables = Exact<{ [key: string]: never }>;

export type LogoutMutation = { __typename?: 'Mutation'; logout: boolean };

export type ApplyReconGuideTreatmentsMutationVariables = Exact<{ [key: string]: never }>;

export type ApplyReconGuideTreatmentsMutation = {
  __typename?: 'Mutation';
  applyReconGuideTreatments: { __typename?: 'ApplyReconGuideTreatmentsResult'; id: string };
};

export type EvmGuideSubmitEditInstructionMutationVariables = Exact<{
  instructionId: Scalars['Int']['input'];
  newTreatmentId: Scalars['Int']['input'];
  newNotes?: InputMaybe<Scalars['String']['input']>;
  newPublicNotes?: InputMaybe<Scalars['String']['input']>;
  newContractPublicName?: InputMaybe<Scalars['String']['input']>;
  newTokenParam1?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  newTokenParam2?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type EvmGuideSubmitEditInstructionMutation = {
  __typename?: 'Mutation';
  evmGuideEditInstruction: boolean;
};

export type SolanaGuideSubmitEditInstructionMutationVariables = Exact<{
  instructionId: Scalars['Int']['input'];
  newTreatmentId: Scalars['Int']['input'];
  newNotes?: InputMaybe<Scalars['String']['input']>;
  newPublicNotes?: InputMaybe<Scalars['String']['input']>;
  newPublicName?: InputMaybe<Scalars['String']['input']>;
  newTokenParam1?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  newTokenParam2?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  transactionHash?: InputMaybe<Scalars['String']['input']>;
}>;

export type SolanaGuideSubmitEditInstructionMutation = {
  __typename?: 'Mutation';
  solanaGuideEditInstruction: boolean;
};

export type IbcGuideSubmitEditInstructionMutationVariables = Exact<{
  instructionId: Scalars['Int']['input'];
  newTreatmentId: Scalars['Int']['input'];
  newNotes?: InputMaybe<Scalars['String']['input']>;
  newPublicNotes?: InputMaybe<Scalars['String']['input']>;
  newPublicName?: InputMaybe<Scalars['String']['input']>;
  newTokenParam1?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  newTokenParam2?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  credentialType: Scalars['String']['input'];
  transactionHash?: InputMaybe<Scalars['String']['input']>;
}>;

export type IbcGuideSubmitEditInstructionMutation = {
  __typename?: 'Mutation';
  ibcGuideEditInstruction: boolean;
};

export type SaveSpecIdV2GroupMutationVariables = Exact<{
  groupId?: InputMaybe<Scalars['String']['input']>;
  outgoingTransferIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  incomingTransferIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type SaveSpecIdV2GroupMutation = {
  __typename?: 'Mutation';
  saveSpecIdV2Group: {
    __typename?: 'SpecIdV2Group';
    id: string;
    userId: number;
    createdAt: any;
    updatedAt: any;
    members: Array<{
      __typename?: 'SpecIdV2Member';
      id: string;
      groupId: string;
      transferId: string;
      direction: string;
      groupIndex: number;
      transfer: {
        __typename?: 'Transfer';
        id: string;
        userId: number;
        groupId: string;
        type?: EnumTransferType | null;
        direction: EnumTransferDirection;
        currency: string;
        tokenId?: string | null;
        tokenAddress?: string | null;
        quantity: string;
        specIdTotalQuantity?: string | null;
        price?: string | null;
        valueUsd?: string | null;
        timestamp: any;
        accountId?: number | null;
        groupTimestampMax: any;
        hash?: string | null;
        createdAt: any;
        credential: {
          __typename?: 'Credential';
          credentialType: string;
          address?: string | null;
          name?: string | null;
          integrationName?: string | null;
        };
      };
    }>;
    matches: Array<{
      __typename?: 'SpecIdV2Match';
      id: string;
      outgoingId: string;
      incomingId: string;
      quantity: string;
    }>;
    parentMatches: Array<{
      __typename?: 'SpecIdV2Match';
      id: string;
      outgoingId: string;
      incomingId: string;
      quantity: string;
    }>;
  };
};

export type DeleteSpecIdV2GroupMutationVariables = Exact<{
  groupId: Scalars['String']['input'];
  deleteChildGroups: Scalars['Boolean']['input'];
}>;

export type DeleteSpecIdV2GroupMutation = { __typename?: 'Mutation'; deleteSpecIdV2Group: boolean };

export type DeleteSpecIdV2MatchesForTransferMutationVariables = Exact<{
  transferId: Scalars['String']['input'];
  deleteChildGroups: Scalars['Boolean']['input'];
}>;

export type DeleteSpecIdV2MatchesForTransferMutation = {
  __typename?: 'Mutation';
  deleteSpecIdV2MatchesForTransfer: Array<{
    __typename?: 'SpecIdV2Group';
    id: string;
    userId: number;
    createdAt: any;
    updatedAt: any;
    members: Array<{
      __typename?: 'SpecIdV2Member';
      id: string;
      groupId: string;
      transferId: string;
      direction: string;
      groupIndex: number;
      transfer: {
        __typename?: 'Transfer';
        id: string;
        userId: number;
        groupId: string;
        type?: EnumTransferType | null;
        direction: EnumTransferDirection;
        currency: string;
        tokenId?: string | null;
        tokenAddress?: string | null;
        quantity: string;
        specIdTotalQuantity?: string | null;
        price?: string | null;
        valueUsd?: string | null;
        timestamp: any;
        accountId?: number | null;
        groupTimestampMax: any;
        hash?: string | null;
        createdAt: any;
        credential: {
          __typename?: 'Credential';
          credentialType: string;
          address?: string | null;
          name?: string | null;
          integrationName?: string | null;
        };
      };
    }>;
    matches: Array<{
      __typename?: 'SpecIdV2Match';
      id: string;
      outgoingId: string;
      incomingId: string;
      quantity: string;
    }>;
    parentMatches: Array<{
      __typename?: 'SpecIdV2Match';
      id: string;
      outgoingId: string;
      incomingId: string;
      quantity: string;
    }>;
  }>;
};

export type ProcessUploadMutationVariables = Exact<{
  Bucket: Scalars['String']['input'];
  Key: Scalars['String']['input'];
  accountId?: InputMaybe<Scalars['Int']['input']>;
  fileName: Scalars['String']['input'];
  integrationId?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
  replacedFileId?: InputMaybe<Scalars['Int']['input']>;
  otherIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  variousIntegrations?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ProcessUploadMutation = {
  __typename?: 'Mutation';
  processUpload: { __typename?: 'ProcessUploadResponse'; requestId: string };
};

export type RestoreVersionMutationVariables = Exact<{
  versionId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  adminNotes?: InputMaybe<Scalars['String']['input']>;
}>;

export type RestoreVersionMutation = { __typename?: 'Mutation'; restoreVersion?: boolean | null };

export type SaveCurrentVersionMutationVariables = Exact<{
  description?: InputMaybe<Scalars['String']['input']>;
  adminNotes?: InputMaybe<Scalars['String']['input']>;
}>;

export type SaveCurrentVersionMutation = { __typename?: 'Mutation'; saveCurrentVersion?: boolean | null };

export type UpdateVersionMutationVariables = Exact<{
  versionId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  adminNotes?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateVersionMutation = {
  __typename?: 'Mutation';
  updateVersion?: {
    __typename?: 'UpdateVersionResponse';
    items: Array<{
      __typename?: 'Version';
      id: string;
      description?: string | null;
      adminNotes?: string | null;
    }>;
  } | null;
};

export type AllCredentialsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['Int']['input']>;
  extended: Scalars['Boolean']['input'];
  credentialsAdmin?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type AllCredentialsQuery = {
  __typename?: 'Query';
  credentials: {
    __typename?: 'Credentials';
    edges: Array<{
      __typename?: 'Credential';
      id: number;
      name?: string | null;
      source: CredentialSource;
      address?: string | null;
      startDate?: any | null;
      endDate?: any | null;
      years?: Array<number> | null;
      filterSpam?: boolean | null;
      credentialType: string;
      integrationId?: string | null;
      isOauth: boolean;
      integrationName?: string | null;
      accountId?: number | null;
      status?: EnumExchangeServiceRequestStatus | null;
      createdAt?: any;
      updatedAt?: any;
      earliestTransaction?: any | null;
      latestTransaction?: any | null;
      txnCount?: number;
      lastRefreshError?: string | null;
      errorRemediation?: string | null;
      requiresCredentialUpdate?: boolean | null;
      credentials?: any | null;
      account?: { __typename?: 'Account'; id: number; name: string; integrationId?: string | null } | null;
      uploads?: Array<{ __typename?: 'Upload'; id: number; name: string; timezone: string }>;
    }>;
  };
};

export type CredentialByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type CredentialByIdQuery = {
  __typename?: 'Query';
  credential: {
    __typename?: 'Credential';
    id: number;
    source: CredentialSource;
    name?: string | null;
    address?: string | null;
    startDate?: any | null;
    endDate?: any | null;
    filterSpam?: boolean | null;
    txnCount: number;
    credentialType: string;
    integrationName?: string | null;
    latestTransaction?: any | null;
    earliestTransaction?: any | null;
    createdAt: any;
    updatedAt: any;
    status?: EnumExchangeServiceRequestStatus | null;
    lastRefreshError?: string | null;
    errorRemediation?: string | null;
    errorType?: string | null;
    requiresCredentialUpdate?: boolean | null;
    integrationId?: string | null;
    isOauth: boolean;
    reconcileOnSync?: boolean | null;
    accountId?: number | null;
    ensAlias?: string | null;
    otherIntegration?: boolean | null;
    variousIntegrations?: boolean | null;
    account?: { __typename?: 'Account'; id: number; name: string } | null;
  };
};

export type CredentialDownloadUrlQueryVariables = Exact<{
  credentialId: Scalars['Int']['input'];
}>;

export type CredentialDownloadUrlQuery = { __typename?: 'Query'; credentialDownloadUrl: string };

export type DetectCsvIntegrationQueryVariables = Exact<{
  Bucket: Scalars['String']['input'];
  Key: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
}>;

export type DetectCsvIntegrationQuery = {
  __typename?: 'Query';
  detectCsvIntegration: {
    __typename?: 'CsvIntegrationDetection';
    integrationId?: string | null;
    sourceName?: string | null;
    unsupportedKnownCsv?: {
      __typename?: 'UnsupportedKnownCsv';
      expectedFile: string;
      message: string;
      exchange: string;
      link?: { __typename?: 'Link'; path: string; text: string } | null;
    } | null;
  };
};

export type EvmGuideChainsQueryVariables = Exact<{ [key: string]: never }>;

export type EvmGuideChainsQuery = {
  __typename?: 'Query';
  evmGuideChains: Array<{
    __typename?: 'Chain';
    id: number;
    shortName: string;
    description?: string | null;
    credentialType: Array<string>;
  }>;
};

export type EvmGuideInstructionQueryVariables = Exact<{
  methodId: Scalars['String']['input'];
  chain: Scalars['String']['input'];
  contractAddress: Scalars['String']['input'];
}>;

export type EvmGuideInstructionQuery = {
  __typename?: 'Query';
  evmGuideInstruction?: {
    __typename?: 'EvmInstruction';
    id: number;
    contractId: number;
    treatmentId: number;
    blockSvcMethodId: number;
    notes?: string | null;
    updatedAt?: any | null;
    chain?: { __typename?: 'Chain'; credentialType: Array<string> } | null;
    evmContract?: { __typename?: 'EvmContract'; address: string } | null;
    evmMethod?: { __typename?: 'EvmMethod'; hash: string } | null;
    treatment?: {
      __typename?: 'Treatment';
      id: number;
      name: string;
      description?: string | null;
      reconOrder?: number | null;
    } | null;
  } | null;
};

export type ExchangeServiceTxnPreviewQueryVariables = Exact<{
  integrationId: Scalars['String']['input'];
  txnHash: Scalars['String']['input'];
  userWallet: Scalars['String']['input'];
}>;

export type ExchangeServiceTxnPreviewQuery = {
  __typename?: 'Query';
  exchangeServiceTxnPreview: {
    __typename?: 'ExchangeServiceTxnPreview';
    transactions: Array<{
      __typename?: 'ExchangeServiceTxnPreviewTransaction';
      requestId: string;
      uniqueId: string;
      transactionTimestamp: string;
      type: string;
      buyAmount: number;
      buyCurrency: string;
      buyAddress?: string | null;
      sellAmount: number;
      sellCurrency: string;
      sellAddress?: string | null;
      feeAmount: number;
      feeCurrency: string;
      exchangeName: string;
      rawTxn: string;
      blockSvcHash: string;
      blockSvcFromAddress?: string | null;
      blockSvcToAddress?: string | null;
      blockSvcGasAmount?: number | null;
      blockSvcGasPrice?: number | null;
      blockSvcMethodID?: string | null;
      txnTopicFingerprint?: string | null;
      transferTopicFingerprint?: string | null;
      sourceLogEventIndex?: number | null;
      relatedLogEventIndices?: Array<number> | null;
    }>;
  };
};

export type FormOptionsQueryVariables = Exact<{ [key: string]: never }>;

export type FormOptionsQuery = {
  __typename?: 'Query';
  countries: Array<{ __typename?: 'Country'; id: number; name: string }>;
  currencies: Array<{ __typename?: 'Currency'; countryId?: number | null; code: string }>;
};

export type IbcGuideInstructionQueryVariables = Exact<{
  identifier: Scalars['String']['input'];
}>;

export type IbcGuideInstructionQuery = {
  __typename?: 'Query';
  ibcGuideInstruction?: {
    __typename?: 'IdentifierBasedInstruction';
    id: number;
    identifier: string;
    treatmentId: number;
    notes?: string | null;
    publicName?: string | null;
    treatment?: {
      __typename?: 'Treatment';
      id: number;
      name: string;
      description?: string | null;
      reconOrder?: number | null;
    } | null;
  } | null;
};

export type InvoiceQueryVariables = Exact<{
  invoiceId: Scalars['String']['input'];
  withProducts: Scalars['Boolean']['input'];
}>;

export type InvoiceQuery = {
  __typename?: 'Query';
  invoice: {
    __typename?: 'Invoice';
    newUser?: boolean | null;
    customerEmail?: string | null;
    amountDue: number;
    paidAt?: number | null;
    hideDefaultCrypto: boolean;
    paymentMethod?: InvoicePaymentMethod | null;
    cryptocurrency?: string | null;
    txnHash?: string | null;
    id: string;
    userId: number;
    number?: string | null;
    created: number;
    dueDate?: number | null;
    currency: string;
    paid: boolean;
    voided: boolean;
    amountRemaining: number;
    description?: string | null;
    createdBy?: string | null;
    lines: Array<{
      __typename?: 'Line';
      id: string;
      amount: number;
      currency: string;
      description?: string | null;
      unitAmount?: number | null;
      quantity?: number | null;
    }>;
    products?: {
      __typename?: 'Products';
      cryptoOnlyPlans?: Array<{ __typename?: 'Plan'; planId: string; year: number }> | null;
      fullFilingPlans?: Array<{ __typename?: 'Plan'; planId: string; year: number }> | null;
      addons?: Array<{ __typename?: 'Plan'; planId: string; year: number }> | null;
    } | null;
  };
};

export type LatestChangeCredentialAccountJobsQueryVariables = Exact<{
  credentialIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;

export type LatestChangeCredentialAccountJobsQuery = {
  __typename?: 'Query';
  latestChangeCredentialAccountJobs: Array<{
    __typename?: 'ChangeCredentialAccountJob';
    id: string;
    credentialId: number;
    status?: EnumGenericJobStatus | null;
    createdAt?: any | null;
  }>;
};

export type LatestTxnReportsQueryVariables = Exact<{ [key: string]: never }>;

export type LatestTxnReportsQuery = {
  __typename?: 'Query';
  latestTxnReports?: {
    __typename?: 'LatestTxnReports';
    hasData: boolean;
    latestTxnReportsByYear: Array<{
      __typename?: 'LatestTxnReportsByYear';
      year: number;
      isOverTxnLimit: boolean;
      hasNoPlan: boolean;
      taxDetail: {
        __typename?: 'UserTaxDetail';
        id: number;
        plan?: string | null;
        fullFilingPlan?: string | null;
        baseCurrency?: string | null;
        filingStatus?: string | null;
        state?: string | null;
        method?: string | null;
        marginalTaxRate?: number | null;
        longTermCapitalGainsRate?: number | null;
        country: {
          __typename?: 'Country';
          id: number;
          shorthand: string;
          name: string;
          taxMethods: Array<{ __typename?: 'TaxMethod'; id: EnumTaxMethod; label: string }>;
        };
        dateRange?: { __typename?: 'DateRange'; startDate: string; endDate: string } | null;
        taxMethod?: { __typename?: 'TaxMethod'; id: EnumTaxMethod; label: string } | null;
      };
      reports?: Array<{
        __typename?: 'LatestTxnReport';
        lineItemCount: number;
        missingCostBasisCount: number;
        zeroProceedsCount: number;
        report: {
          __typename?: 'LatestTxnReportObject';
          id: number;
          year: number;
          startDate?: any | null;
          endDate?: any | null;
          userTaxDetailId: number;
          fiatCurrency?: string | null;
          taxMethod: { __typename?: 'TaxMethod'; id: EnumTaxMethod; label: string };
        };
        values: {
          __typename?: 'TxnReportValues';
          gainLoss: number;
          shortTermGainLoss: number;
          longTermGainLoss: number;
          income: number;
          taxLiability: number;
        };
      }> | null;
    }>;
  } | null;
};

export type MigrationOutSiblingsForTransferQueryVariables = Exact<{
  transferId: Scalars['String']['input'];
}>;

export type MigrationOutSiblingsForTransferQuery = {
  __typename?: 'Query';
  migrationOutSiblingsForTransfer: Array<{
    __typename?: 'Transfer';
    id: string;
    userId: number;
    groupId: string;
    type?: EnumTransferType | null;
    direction: EnumTransferDirection;
    currency: string;
    tokenId?: string | null;
    tokenAddress?: string | null;
    quantity: string;
    price?: string | null;
    valueUsd?: string | null;
    timestamp: any;
    accountId?: number | null;
    groupTimestampMax: any;
    createdAt: any;
  }>;
};

export type SpecIdOriginCostBasisForTransfersQueryVariables = Exact<{
  transferIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type SpecIdOriginCostBasisForTransfersQuery = {
  __typename?: 'Query';
  specIdOriginCostBasisForTransfers: Array<{
    __typename?: 'SpecIdOriginCostBasis';
    transferId: string;
    costBasis?: number | null;
  }>;
};

export type MovementMatchConstraintsQueryVariables = Exact<{ [key: string]: never }>;

export type MovementMatchConstraintsQuery = {
  __typename?: 'Query';
  movementMatchConstraints: {
    __typename?: 'MovementMatchConstraint';
    quantityLeewayPercentage: number;
    timestampLeewayDays: number;
  };
};

export type CheckTxnMovementGroupMembershipQueryVariables = Exact<{
  txnIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type CheckTxnMovementGroupMembershipQuery = {
  __typename?: 'Query';
  txnsInMovementGroups: Array<string>;
};

export type TreatmentsQueryVariables = Exact<{ [key: string]: never }>;

export type TreatmentsQuery = {
  __typename?: 'Query';
  reconGuideTreatments: Array<{
    __typename?: 'Treatment';
    id: number;
    name: string;
    description?: string | null;
    reconOrder?: number | null;
    notes?: string | null;
  }>;
};

export type ReconGuideTreatmentGroupTypesQueryVariables = Exact<{ [key: string]: never }>;

export type ReconGuideTreatmentGroupTypesQuery = {
  __typename?: 'Query';
  reconGuideTreatmentGroupTypes: Array<{
    __typename?: 'TreatmentGroupType';
    treatmentId: number;
    groupType?: EnumTransferGroupType | null;
  }>;
};

export type LatestReconGuideTreatmentsJobQueryVariables = Exact<{ [key: string]: never }>;

export type LatestReconGuideTreatmentsJobQuery = {
  __typename?: 'Query';
  latestReconGuideTreatmentsJob?: {
    __typename?: 'ReconGuideTreatmentsJob';
    id: string;
    status: EnumGenericJobStatus;
    createdAt: any;
    updatedAt?: any | null;
    jobData?: {
      __typename?: 'ReconGuideTreatmentsJobResults';
      appliedTreatments: Array<{
        __typename?: 'ReconGuideTreatmentsJobData';
        treatmentId: number;
        treatmentName: string;
        count: number;
      }>;
      summary?: {
        __typename?: 'ReconGuideTreatmentsJobResultsSummary';
        duration: number;
        txnsReconciled: number;
        txnTotal: number;
      } | null;
    } | null;
  } | null;
};

export type SolanaGuideInstructionQueryVariables = Exact<{
  identifier: Scalars['String']['input'];
}>;

export type SolanaGuideInstructionQuery = {
  __typename?: 'Query';
  solanaGuideInstruction?: {
    __typename?: 'IdentifierBasedInstruction';
    id: number;
    identifier: string;
    treatmentId: number;
    notes?: string | null;
    publicName?: string | null;
    treatment?: {
      __typename?: 'Treatment';
      id: number;
      name: string;
      description?: string | null;
      reconOrder?: number | null;
    } | null;
  } | null;
};

export type SpecIdV2GroupsForTransfersQueryVariables = Exact<{
  transferIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type SpecIdV2GroupsForTransfersQuery = {
  __typename?: 'Query';
  specIdV2GroupsForTransfers: Array<{
    __typename?: 'SpecIdV2Group';
    id: string;
    userId: number;
    createdAt: any;
    updatedAt: any;
    members: Array<{
      __typename?: 'SpecIdV2Member';
      id: string;
      groupId: string;
      transferId: string;
      direction: string;
      groupIndex: number;
      transfer: {
        __typename?: 'Transfer';
        id: string;
        userId: number;
        groupId: string;
        type?: EnumTransferType | null;
        direction: EnumTransferDirection;
        currency: string;
        tokenId?: string | null;
        tokenAddress?: string | null;
        quantity: string;
        specIdTotalQuantity?: string | null;
        price?: string | null;
        valueUsd?: string | null;
        timestamp: any;
        accountId?: number | null;
        groupTimestampMax: any;
        hash?: string | null;
        createdAt: any;
        credential: {
          __typename?: 'Credential';
          credentialType: string;
          address?: string | null;
          name?: string | null;
          integrationName?: string | null;
        };
      };
    }>;
    matches: Array<{
      __typename?: 'SpecIdV2Match';
      id: string;
      outgoingId: string;
      incomingId: string;
      quantity: string;
    }>;
    parentMatches: Array<{
      __typename?: 'SpecIdV2Match';
      id: string;
      outgoingId: string;
      incomingId: string;
      quantity: string;
    }>;
  }>;
};

export type SpecIdV2GroupQueryVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;

export type SpecIdV2GroupQuery = {
  __typename?: 'Query';
  specIdV2Group: {
    __typename?: 'SpecIdV2Group';
    id: string;
    userId: number;
    createdAt: any;
    updatedAt: any;
    members: Array<{
      __typename?: 'SpecIdV2Member';
      id: string;
      groupId: string;
      transferId: string;
      direction: string;
      groupIndex: number;
      transfer: {
        __typename?: 'Transfer';
        id: string;
        userId: number;
        groupId: string;
        type?: EnumTransferType | null;
        direction: EnumTransferDirection;
        currency: string;
        tokenId?: string | null;
        tokenAddress?: string | null;
        quantity: string;
        specIdTotalQuantity?: string | null;
        price?: string | null;
        valueUsd?: string | null;
        timestamp: any;
        accountId?: number | null;
        groupTimestampMax: any;
        hash?: string | null;
        createdAt: any;
        credential: {
          __typename?: 'Credential';
          credentialType: string;
          address?: string | null;
          name?: string | null;
          integrationName?: string | null;
        };
      };
    }>;
    matches: Array<{
      __typename?: 'SpecIdV2Match';
      id: string;
      outgoingId: string;
      incomingId: string;
      quantity: string;
    }>;
    parentMatches: Array<{
      __typename?: 'SpecIdV2Match';
      id: string;
      outgoingId: string;
      incomingId: string;
      quantity: string;
    }>;
  };
};

export type SpecIdGroupsInvalidatedByRecalcByAccountQueryVariables = Exact<{
  recalcByAccount: Scalars['Boolean']['input'];
  recalcByAccountStartYear: Scalars['Int']['input'];
}>;

export type SpecIdGroupsInvalidatedByRecalcByAccountQuery = {
  __typename?: 'Query';
  specIdGroupsInvalidatedByRecalcByAccount: number;
};

export type UploadDownloadUrlQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type UploadDownloadUrlQuery = { __typename?: 'Query'; uploadDownloadUrl: string };

export type GetV2ReportTypesQueryVariables = Exact<{ [key: string]: never }>;

export type GetV2ReportTypesQuery = { __typename?: 'Query'; getV2ReportTypes: Array<string> };

export type VersionsQueryVariables = Exact<{ [key: string]: never }>;

export type VersionsQuery = {
  __typename?: 'Query';
  versions: {
    __typename?: 'VersionsResponse';
    items: Array<{
      __typename?: 'Version';
      description?: string | null;
      adminNotes?: string | null;
      id: string;
      createdAt: any;
      number: number;
      isComplete: boolean;
      txnReportDataFifo?: any | null;
      txnReportDataLifo?: any | null;
      txnReportDataAverageCost?: any | null;
      txnReportDataMinimization?: any | null;
      txnReportDataMinimizationV2?: any | null;
    }>;
    status: {
      __typename?: 'VersionsStatus';
      isSavingCurrentVersion: boolean;
      isRestoringVersion: boolean;
      restoredVersionNumber?: number | null;
      lastRestoredAt?: any | null;
      latestStatus?: EnumGenericJobStatus | null;
      latestType?: VersionJobType | null;
    };
  };
};

export type RefreshTokenMutationVariables = Exact<{ [key: string]: never }>;

export type RefreshTokenMutation = { __typename?: 'Mutation'; refreshToken: boolean };

export type AllAccountsQueryVariables = Exact<{ [key: string]: never }>;

export type AllAccountsQuery = {
  __typename?: 'Query';
  accounts: {
    __typename?: 'AccountsData';
    edges: Array<{
      __typename?: 'Account';
      id: number;
      userId?: number | null;
      name: string;
      address?: string | null;
      createdAt: any;
      updatedAt: any;
      integrationId?: string | null;
      manuallyLinkedCount: number;
    }>;
  };
};

export type SupportedCredentialsQueryVariables = Exact<{ [key: string]: never }>;

export type SupportedCredentialsQuery = {
  __typename?: 'Query';
  supportedCredentials: {
    __typename?: 'SupportedCredentials';
    supportedWallets: Array<string>;
    reconCredentialTypes: Array<string>;
    evmCredentialTypes: Array<string>;
    solanaCredentialTypes: Array<string>;
    exchangeCredentials: Array<{ __typename?: 'ExchangeCredentials'; id: string; schema: any }>;
    metadata: Array<{ __typename?: 'IntegrationMetadata'; integrationId: string; iconUrl?: string | null }>;
  };
};

export type PaymentSourcesQueryVariables = Exact<{ [key: string]: never }>;

export type PaymentSourcesQuery = {
  __typename?: 'Query';
  paymentSources: Array<{
    __typename?: 'CreditCard';
    id: string;
    addressZip?: string | null;
    brand: string;
    expMonth: number;
    expYear: number;
    last4: string;
  }>;
};

export type NeedsRecalcQueryVariables = Exact<{ [key: string]: never }>;

export type NeedsRecalcQuery = { __typename?: 'Query'; needsRecalc: boolean };

export type LatestTxnReportJobQueryVariables = Exact<{ [key: string]: never }>;

export type LatestTxnReportJobQuery = {
  __typename?: 'Query';
  latestTxnReportJob?: {
    __typename?: 'TxnReportJob';
    createdAt: any;
    error?: string | null;
    errorMessage?: string | null;
    finishedAt?: any | null;
    jobStatus: TxnReportJobStatus;
    isV2DataModel: boolean;
  } | null;
};

export type TokenOverridesQueryVariables = Exact<{ [key: string]: never }>;

export type TokenOverridesQuery = {
  __typename?: 'Query';
  tokenOverridesList: Array<{ __typename?: 'TokenOverrideConf'; symbol: string; id: string }>;
};

export type TransferGroupSchemasQueryVariables = Exact<{ [key: string]: never }>;

export type TransferGroupSchemasQuery = {
  __typename?: 'Query';
  transferGroupSchemas: Array<{
    __typename?: 'TransferGroupSchema';
    type: EnumTransferGroupType;
    accountRules: Array<{
      __typename?: 'TransferGroupAccountRule';
      directions: Array<EnumTransferDirection>;
      uniqueCount: number;
    }>;
    rules: Array<
      Array<{
        __typename?: 'TransferGroupSchemaRule';
        min: number;
        max: number;
        direction: string;
        type?: string | null;
      }>
    >;
  }>;
};

export type FetchUserQueryVariables = Exact<{ [key: string]: never }>;

export type FetchUserQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'User';
    id: number;
    accountYears: Array<number>;
    airtableId?: string | null;
    blocked: boolean;
    createdAt: any;
    customerId?: string | null;
    deletedAt?: any | null;
    email: string;
    emailVerified: boolean;
    firstName?: string | null;
    includeFees?: boolean | null;
    secretMode?: boolean | null;
    isTest?: boolean | null;
    businessUser?: boolean | null;
    lastName?: string | null;
    lastSuccessfulCharge?: any | null;
    lockedTilDate?: any | null;
    lockedThroughYear?: number | null;
    loginCount?: number | null;
    marginTradeAccount?: boolean | null;
    minimizationForAllYears?: boolean | null;
    orgDemoUser?: boolean | null;
    organizationId?: number | null;
    phone?: string | null;
    plan?: string | null;
    recalcByAccount?: boolean | null;
    recalcByAccountStartYear?: number | null;
    reconMode?: boolean | null;
    hideSpam: boolean;
    resetPasswordExpires?: any | null;
    role?: string | null;
    subscriptionId?: string | null;
    twoFactorEnabled: boolean;
    updatedAt: any;
    useHoursMinsComparison?: boolean | null;
    lastMadeEditsAt?: any | null;
    usesGroupsSince?: any | null;
    dataModelV2UpgradeState?: EnumDataModelV2UpgradeState | null;
    v2TransitionProgress?: EnumGenericJobStatus | null;
    orgRoles: Array<{
      __typename?: 'UserOrgRole';
      userId: number;
      roleId: number;
      organizationId: number;
      createdAt: any;
      updatedAt: any;
      organization: {
        __typename?: 'Organization';
        id: number;
        name?: string | null;
        slug?: string | null;
        status?: EnumOrganizationStatus | null;
        includeDemoUser?: boolean | null;
        discount?: number | null;
        logo?: string | null;
        colorPrimary?: string | null;
        colorSecondary?: string | null;
        colorLink?: string | null;
        createdAt: any;
        updatedAt: any;
        deletedAt?: any | null;
      };
      role: { __typename?: 'Role'; name: string };
    }>;
    taxDetails: Array<{
      __typename?: 'UserTaxDetail';
      id: number;
      baseCurrency?: string | null;
      calculateAsMargin?: boolean | null;
      createdAt: any;
      filingStatus?: string | null;
      fullFilingPlan?: string | null;
      grossIncome?: number | null;
      likeKind?: boolean | null;
      longTermCapitalGainsRate?: number | null;
      marginalTaxRate?: number | null;
      method?: string | null;
      needsFbar?: boolean | null;
      plan?: string | null;
      setFilingMethodSkipped?: boolean | null;
      skipped?: boolean | null;
      state?: string | null;
      taxYear: number;
      ukBnbRule?: boolean | null;
      updatedAt: any;
      useHoursMinsComparison?: boolean | null;
      userId: number;
      isEngaged: boolean;
      addons: Array<{
        __typename?: 'UserTaxDetailAddon';
        id: number;
        addon: {
          __typename?: 'Addon';
          createdAt: any;
          displayName: string;
          price?: number | null;
          product: string;
          sku: string;
          updatedAt: any;
        };
      }>;
      country: {
        __typename?: 'Country';
        id: number;
        endDateDay: number;
        endDateMonth: number;
        name: string;
        shorthand: string;
        methods: Array<string>;
        startDateDay: number;
        startDateMonth: number;
        taxMethods: Array<{ __typename?: 'TaxMethod'; id: EnumTaxMethod; label: string }>;
      };
      dateRange?: { __typename?: 'DateRange'; startDate: string; endDate: string } | null;
      taxMethod?: { __typename?: 'TaxMethod'; id: EnumTaxMethod; label: string } | null;
    }>;
  } | null;
};

export type LatestBatchUpdateTxnsJobStatusQueryVariables = Exact<{ [key: string]: never }>;

export type LatestBatchUpdateTxnsJobStatusQuery = {
  __typename?: 'Query';
  latestBatchUpdateTxnsJobStatus?: EnumGenericJobStatus | null;
};

export type LatestBatchDeleteTxnsJobStatusQueryVariables = Exact<{ [key: string]: never }>;

export type LatestBatchDeleteTxnsJobStatusQuery = {
  __typename?: 'Query';
  latestBatchDeleteTxnsJobStatus?: EnumGenericJobStatus | null;
};

export type UserTaxMethodsQueryVariables = Exact<{ [key: string]: never }>;

export type UserTaxMethodsQuery = {
  __typename?: 'Query';
  userTaxMethods: {
    __typename?: 'UserTaxMethods';
    methods: Array<{ __typename?: 'TaxMethod'; id: EnumTaxMethod; label: string }>;
  };
};
